let labeltems = {
  modules: {
    pbase: "مدیریت سیستم",
    pacnt: "حسابداری",
    pbank: "خزانه",
    pbdgt: "بودجه",
    paset: "اموال",
    pwhrs: "انبار و کنترل موجودی",
    pordr: "سفارشات",
    psale: "بازرگانی و فروش",
    pcrm: "مدیریت ارتباط با مشتری",
    pmkt: "بازاریابی",
    pmrpAl: "برنامه ریزی تولید آلومینیوم",
    pmnet: "تعمیرات و نگهداری",
    pqc: "کنترل کیفی",
    pbpms: "مدیریت فرآیند های کسب و کار",
    pslry: "جبران خدمت",
    phr: "جذب و استخدام",
    pscms: "تدارکات و خرید",
    pparak: "سفارشات دانه‌بار",
    pmrpValvs: "برنامه ریزی تولید شیرآلات",
    pmrp: "بهای تمام شده",
    phamyar: "همیار",
    pafterSales: "خدمات پس از فروش",
    pparsina: "پشتیبانی پارسینا",
    phamsaz: "همساز",
    advanceReport: "گزارش مساعده",
    ptax: "سامانه مودیان",
    pstore: "فروش فروشگاهی",
  },
  page: {
    storeQuickSale: "فروش سریع",
    storeSaleReturn: "مرجوعی فروش",
    storeCashDesksAndBooths: "صندوق و غرفه‌ها",
    storeDeliveryAndShipping: "تحویل و ارسال",
    storeCustomerClub: "باشگاه مشتریان",
    storeAfterSalesService: "خدمات پس از فروش",
    storeStores: "فروشگاه‌ها",
    storeBooths: "غرفه‌ها",
    storeUsersAndShifts: "کاربران و شیفت‌ها",
    storeCashDesksAndTerminals: "صندوق‌ها و پایانه‌ها",
    storeSalesAgents: "مسئولان فروش",
    storeCommissionPolicies: "سیاست‌های پورسانت",
    storePricesAndDiscounts: "قیمت و تخفیفات",
    storeSalesReports: "گزارش‌های فروش",
    storeSettingsAndAccess: "تنظیمات و دسترسی‌ها",
    storePreOrder: "پیش فاکتور غرفه",
    storeAddPreOrder: "ثبت پیش فاکتور غرفه",
    storeEditPreOrder: "ویرایش پیش فاکتور غرفه",
    storeSaleFactor: "فاکتور فروش",
    storeEditSaleFactor: "ویرایش فاکتور فروش",
    storeSaleFactors: "فاکتورهای فروش فروشگاه",
    storeShopSetting: "تنظیمات فروشگاهی",
    storeBoothSetting: "تنظیمات غرفه",
    storeAddStore: "ثبت فروشگاه",
    storeEditStore: "ویرایش فروشگاه",
    storeAddBooth: "ثبت غرفه",
    storeEditBooth: "ویرایش غرفه",
    storePosTerminalTypes: "انواع دستگاه‌های پوز",
    storeAddPosTerminalType: "ثبت دستگاه پوز",
    storeEditPosTerminalType: "ویرایش دستگاه پوز",
    storeBenefitCards: "معرفی بن کارت",
    storeAddBenefitCard: "ثبت بن کارت",
    storeEditBenefitCard: "ویرایش بن کارت",
    storeBenefitCardTransactions: "تراکنشات بن کارت",
    storeBenefitCardTransfer: "انتقال از کارت به کارت دیگر",
    home: "صفحه اصلی",
    dashboard: "داشبورد",
    aboutUs: "درباره ما",
    contactUs: "تماس با ما",
    baseInformation: "اطلاعات پایه",
    users: "کاربران و پرسنل",
    usersAndRoles: "کاربران و نقش‌ها",
    addUser: "معرفی کاربر جدید",
    products: "محصولات و تولیدات",
    addProduct: "ثبت محصول",
    editProduct: "ویرایش اطلاعات محصول",
    orders: "سفارشات مشتریان",
    addOrder: "ثبت سفارش جدید",
    editOrder: "ویرایش اطلاعات سفارش",
    support: "پشتیبانی",
    tickets: "تیکت پشتیبانی",
    addTicket: "ثبت تیکت پشتیبانی",
    messages: "پیام‌ها",
    profile: "پروفایل کاربری",
    login: "ورود به سامانه",
    register: "عضویت",
    notFound: "راهتان را گم کرده‌اید ؟!",
    notAccess: "متأسفانه دسترسی شما برای مشاهده این قسمت محدود شده است",
    noAccess: "عدم دسترسی",
    serverError: "خطای ارتباط با سرور؛ لطفا به پشتیبانی فنی اطلاع دهید",
    underConstruction: "صفحه مدنظر در حال توسعه و برورسانی می‌باشد",
    workStations: "ایستگاه‌ های کاری",
    workShifts: "شیفت های کاری",
    supplyFeasibility: "اعتبار سنجی تامین",
    feasibility: "اعتبار سنجی فروش / کستر / نورد سرد / فویل",
    bom: "BOM (فرمول تولید)",
    unit: "واحدهای شمارش",
    category: "گروه بندی کالا",
    addCategory: "ثبت گروه‌بندی کالا",
    wares: "انبارها",
    addWare: "ثبت انبار جدید",
    editWare: "ویرایش اطلاعات انبار",
    commodity: "کالاها",
    addCommodity: "ثبت کالا",
    editCommodity: "ویرایش اطلاعات کالا",
    search: "جستجو...",
    visitor: "گزارش بازدید",
    order: "لیست سفارشات",
    accountInfo: "کدینگ حساب ها",
    branches: "لیست شعبه ها",
    addBranch: "ثبت شعبه جدید",
    editBranch: "ویرایش اطلاعات شعبه",
    roles: "نقش‌ های کاربران",
    permissions: "دسترسی و مجوزها",
    fiscalYears: "سال های مالی",
    orderSetting: "تنظیمات سفارشات",
    addOrderSetting: "ثبت تنظیمات سفارشات",
    editOrderSetting: "ویرایش تنظیمات سفارشات",
    addBom: "ثبت فرمول تولید جدید",
    editBom: "ویرایش اطلاعات فرمول تولید",
    foilCartable: "کارتابل واحد فویل",
    financialCartable: "کارتابل مالی",
    casterCartable: "کارتابل کستر",
    coldRollCartable: "کارتابل نورد سرد",
    saleCartable: "کارتابل فروش",
    managerCartable: "کارتابل مدیرعامل",
    productionCartable: "کارتابل تولید",
    supplyAndEquipmentCartable: "کارتابل تامین و تجهیز",
    orderConfirmLog: "گزارشات تاییدیه ها",
    shelf: "لیست انبارک‌ها",
    country: "لیست کشور ها",
    province: "لیست استان ها",
    city: "لیست شهر ها",
    region: "لیست مناطق",
    personGroup: "لیست گروه های اشخاص",
    location: "موقعیت مکانی",
    person: "لیست اشخاص",
    addPerson: "ثبت شخص جدید",
    editPerson: "ویرایش اطلاعات",
    sbu: "واحد ها",
    unitCoefficient: "تبدیل ضرایب واحد شمارش",
    reqProduce: "درخواست تولید",
    addReqProduce: "ثبت درخواست تولید جدید",
    editReqProduce: "ویرایش اطلاعات درخواست تولید",
    productionPlan: "برنامه تولید",
    addProductionPlan: "تعیین فرآیندهای تولید",
    casting: "ریخته‌گری",
    addCasting: "ثبت ریخته‌گری",
    castingQC: "کنترل کیفی ریخته‌گری",
    produceProcess: "دستور تولید",
    addProduceProcess: "فرآیند های تولید کالا",
    userBranches: "شعبه‌های کاربر",
    userGroups: "گروه‌های کاربر",
    userPermissions: "دسترسی‌های کاربر",
    generalInfo: "مشخصات کلی",
    financialInfo: "اطلاعات مالی",
    businessInfo: "اطلاعات بازرگانی",
    taxFiles: "پرونده‌های مالیاتی",
    contacts: "مخاطبین",
    boardOfDirectors: "اعضای هیئت مدیره",
    wareCategory: "مدیریت دسته بندی انبارها",
    updateUser: "ویرایش کاربر",
    manangeSbu: "واحدهای سازمانی",
    wareVoucherType: "انواع سند انبار",
    addWareVoucherType: "ثبت  نوع سند انبار جدید",
    editWareVoucherType: "ویرایش اطلاعات نوع سند انبار",
    receipt: "رسید",
    addSomeWareReceipt: "صدور  رسید مقداری جدید",
    editSomeWareReceipt: "ویرایش اطلاعات رسید مقداری",
    floatAccount: "حساب‌های شناور",
    floatLevels: "عناوین حساب‌های شناور",
    floatAccountGroup: "گروه حساب‌های شناور",
    userWarePermission: "محدودیت انبارها",
    personPermissions: "محدودیت اشخاص",
    floatAccountsPermissons: "دسترسی به حساب شناور ",
    floatAccounts: "محدودیت حساب شناور",
    floatAccountsOne: "1دسترسی به حساب ",
    floatAccountsTwo: "حساب شناور2",
    floatAccountsThree: " حساب شناور3",
    floatAccountsFour: "حساب شناور4",
    floatAccountsFive: " حساب شناور5",
    accountConfig: "تنظیمات کدینگ حساب",
    additionalCommodityParameter: "پارامترهای تکمیلی کالا",
    management: "مدیریت",
    groups: "گروه‌های",
    exceptions: "فهرست دسترسی‌ها",
    accountLimits: "محدودیت‌های حساب",
    usersGroup: "گروه کاربران",
    prefix: "پیشوند اشخاص",
    buyRequest: "لیست درخواست های خرید",
    addBuyRequest: "ثبت درخواست خرید جدید",
    editBuyRequest: "ویرایش اطلاعات درخواست خرید",
    receiptList: "لیست رسیدها",
    addTempReceipt: "صدور رسید موقت جدید",
    editTempReceipt: "ویرایش اطلاعات رسید موقت",
    financialReceipt: "لیست رسیدهای مالی",
    addFinancialReceipt: "صدور رسید مالی جدید",
    editFinancialReceipt: "ویرایش اطلاعات رسید مالی",
    activeSessions: "نشست‌های فعال من",
    accountControlConfig: "تنظیمات کنترلی حساب ها",
    buyRequestCartable: "کارتابل تایید درخواست خرید",
    financialReceiptCartable: "کارتابل رسید مالی",
    confirmReceiptCartable: "کارتابل قطعی سازی رسیدها",
    disconfirmReceiptCartable: "کارتابل غیرقطعی سازی رسیدها",
    tempReceiptCartable: "کارتابل رسید موقت",
    tempReceiptExitCartable: "کارتابل رسیدهای موقت رد شده جهت خروج",
    someWareReceiptCartable: "کارتابل رسید مقداری",
    draftRequest: "لیست درخواست های حواله",
    addDraftRequest: "ثبت درخواست حواله جدید",
    editDraftRequest: "ویرایش اطلاعات درخواست حواله",
    draftRequestCartable: "کارتابل درخواست حواله",
    draftList: "لیست حواله‌ها",
    addFinancialDraft: "صدور حواله مالی جدید",
    editFinancialDraft: "ویرایش اطلاعات حواله مالی",
    financialDraftCartable: "کارتابل حواله مالی",
    confirmDraftCartable: "کارتابل قطعی سازی حواله‌ها",
    disconfirmDraftCartable: "کارتابل غیرقطعی سازی حواله‌ها",
    draft: "حواله",
    addSomeWareDraft: "صدور  حواله مقداری جدید",
    editSomeWareDraft: "ویرایش اطلاعات حواله مقداری",
    someWareDraftCartable: "کارتابل حواله مقداری",
    personPorsitions: "سِمت‌های شخص",
    position: "سِمت‌های سازمانی",
    vehiclesType: "انواع وسیله نقلیه",
    suppliers: "تامین‌کنندگان",
    approvalCartablePriorities: "‌اولویت‌‌بندی تایید کارتابل‌ها",
    wareVouchers: "دفاتر انبار",
    wareSomeVouchers: "دفتر مقداری",
    wareFinancialVouchers: "دفتر مالی",
    circulationCommodity: "گردش کالا",
    someCirculation: "گردش مقداری",
    financialCirculation: "گردش مالی",
    someInventory: "موجودی مقداری",
    financialInventory: "موجودی مالی",
    otherReports: "سایر گزارشات",
    inventoryDeductionReport: "گزارش کسر موجودی",
    inventorySummaryReport: "گزارش خلاصه موجودی",
    wareInventory: "موجودی انبار",
    buyer: "تعیین مأمور خرید",
    sortReceipts: "مرتب سازی رسیدها",
    sortDrafts: "مرتب سازی حواله‌ها",
    commoditySleepReport: "گزارش خواب/موجودی راکد کالا",
    negativeCommodityInventory: "گزارش موجودی کالاهای منفی",
    commodityCirculationReport: "گردش مواد و کالا",
    cardex: "کاردکس",
    someCardex: "کاردکس مقداری",
    financialCardex: "کاردکس مالی",
    transferCommodity: "لیست انتقال بین انبارها",
    addInstantTransfer: "ثبت انتقال بین انبار آنی",
    addProccessTransfer: "ثبت انتقال بین انبار فرآیندی",
    editInstantTransfer: "ویرایش انتقال بین انبار آنی",
    editProccessTransfer: "ویرایش انتقال بین انبار فرآیندی",
    proccessTransferCartable: "کارتابل انتقال بین انبار فرآیندی",
    tempReceipt: "لیست رسیدهای موقت",
    buyers: "مأمورین خرید",
    personManagement: "مدیریت اشخاص",
    settingTransactions: "تنظیم تراکنش‌های سیستم",
    modules: "ماژول‌ها",
    commodityConversion: "تبدیل کالا",
    warehousing: "انبارگردانی",
    addWarehousing: "ثبت انبارگردانی جدید",
    editWarehousing: "ویرایش اطلاعات انبارگردانی",
    customerManagement: "مدیریت مشتریان",
    customerGrouping: "گروه‌بندی مشتریان",
    customerGrade: "سطوح مشتری",
    discountCodes: "کدهای تخفیف",
    addDiscountCode: "ثبت کد تخفیف جدید",
    editDiscountCode: "ویرایش اطلاعات کد تخفیف",
    campaignManagement: "مدیریت کمپین‌ها",
    lead: "سرنخ (لیدها/طرف حساب ها)",
    chance: "فرصت",
    addLead: "ثبت سرنخ (لید/طرف حساب)",
    editLead: "ویرایش سرنخ (لید/طرف حساب)",
    saleTeamAssignment: "اختصاص سرنخ‌ها به مسئول فروش",
    evaluationCartable: "کارتابل ارزیابی سرنخ‌ها",
    feedBackManagement: "مدیریت نظرسنجی",
    autoProcesses: "روندهای خودکار",
    interactivePolicies: "سیاست های تعاملی",
    companyInfo: "اطلاعات سازمان",
    salesChannelsTypes: "انواع کانال‌ فروش",
    introducedType: "انواع روش‌ آشنایی",
    customerTagsTypes: "انواع برچسب‌های مشتری",
    campaignType: "انواع کمپین",
    leadType: "نوع سرنخ (لید)",
    leadProperty: "ویژگی سرنخ (لید)",
    leadSource: "منبع سرنخ (لید)",
    leadEvaluationQuestion: "سوالات ارزیابی سرنخ",
    saleTeam: "تیم فروش",
    saleRegion: "مناطق فروش",
    feedBackType: "انواع نظرسنجی",
    occasionTypes: "انواع مناسبت",
    customerCreditVoucher: "گردش اعتبار مشتری",
    customerScoreVoucher: "دفتر امتیاز مشتری",
    deadlineReminderSettings: "تنظیمات یادآوری مهلت اعتبار",
    deliveryMethod: "روش‌های تحویل",
    paymentMethod: "روش‌های پرداخت",
    blackList: "لیست سیاه",
    saleManagerDiscountLimit: "سطح تخفیف مجاز مسئول فروش",
    saleManagerCredit: "اعتبار مسئول فروش",
    saleOrder: "سفارش",
    addSaleOrder: "ثبت سفارش",
    editSaleOrder: "ویرایش سفارش",
    saleOrderCartable: "کارتابل تایید سفارش",
    congratulationsMessageSettings: "تنظیمات پیام تبریک",
    addCampaign: "ثبت کمپین جدید",
    editCampaign: "ویرایش اطلاعات کمپین",
    addPersonCb: "ثبت مشتری جدید",
    editPersonClub: "ویرایش اطلاعات مشتری",
    addAutoProcess: "ثبت روند خودکار جدید",
    editAutoProcess: "ویرایش اطلاعات روند خودکار",
    feedBack: "نظرسنجی",
    addFeedBackQuestions: "درج سوال نظرسنجی",
    feedBackQuestions: "سوالات نظرسنجی",
    systemSetting: "تنظیمات سامانه",
    feedBackQuestionOption: "پارامترهای اضافی نظرسنجی",
    commodityBatch: "سری ساخت‌ کالاها",
    voucherNoteType: "انواع یادداشت‌های سند",
    defaultVoucherDescription: "شرح‌های استاندارد سند",
    financialRatioSetting: "تنظیم نسبت‌های مالی",
    voucher: "مشاهده اسناد حسابداری",
    addVoucher: "ثبت سند حسابداری",
    addVoucherNew: "ثبت سند حسابداری (آزمایشی)",
    editVoucher: "ویرایش اطلاعات سند حسابداری",
    comprehensiveCustomerReport: "گزارش جامع مشتری",
    banksAndBranches: "بانک‌ها و شعبات",
    bankCashAccountInfo: "صندوق‌ها و حساب‌های بانکی",
    checks: "دسته چک‌ها",
    currencyType: "انواع ارز",
    currencyRate: "نرخ ارزها",
    personCredit: "اعتبار اشخاص",
    scoreSummery: "گزارش تجمیعی امتیاز مشتریان",
    userPerformanceReport: "گزارش عملکرد کاربران",
    chequeStatus: "معرفی وضعیت چک ها",
    profileCompletionSettings: "تنظیمات تکمیل پروفایل",
    bankAccountInfo: "حساب‌های بانکی",
    cashAccount: "صندوق‌ها",
    vehicleTypes: "انواع وسیله نقلیه",
    receiveCash: "دریافت نقد",
    addReceiveCash: "ثبت دریافت نقد",
    editReceiveCash: "ویرایش اطلاعات دریافت نقد",
    addReceiveCashGroup: "ثبت دریافت  نقد به صورت گروهی",
    paymentCash: "پرداخت نقد",
    addPaymentCash: "ثبت پرداخت نقد",
    editPaymentCash: "ویرایش اطلاعات پرداخت نقد",
    addPaymentCashGroup: "ثبت پرداخت  نقد به صورت گروهی",
    paymentRequest: "درخواست پرداخت نقد/چک",
    voucherSort: "مرتب‌ سازی اسناد",
    voucherConfirm: "قطعی کردن اسناد ",
    voucherUnConfirm: "غیرقطعی کردن اسناد",
    receiveCheque: "اسناد دریافتنی",
    addReceiveCheque: "ثبت اسناد دریافتنی جدید",
    editReceiveCheque: "ویرایش اطلاعات سند دریافتنی",
    voucherReview: "مرور اسناد",
    voucherTemplate: "تنظیم شابلون شرح سند",
    bankTransfer: "واگذاری به بانک",
    addBankTransfer: "ثبت واگذاری به بانک",
    editBankTransfer: "ویرایش اطلاعات واگذاری به بانک",
    assignmentPerson: "واگذاری به اشخاص",
    cancellationReceivable: "ابطال اسناد دریافتنی",
    returnGuarantee: "استرداد اسناد ضمانتی",
    returnReceivables: "استرداد اسناد دریافتنی",
    returnAssignment: "استرداد اسناد واگذاری",
    returnTransferred: "برگشت اسناد واگذار شده",
    settlement: "وصول اسناد",
    paymentRequestConfirm: "تایید درخواست پرداخت",
    apiKeyes: "کلیدهای اتصال",
    smsPanelSettings: "تنظیمات پنل پیامکی",
    commodityIntroduction: "معرفی کالا",
    receiveChequeTurn: "گردش اسناد",
    addReceiveChequeTurn: "صدور گردش سند دریافتنی",
    editReceiveChequeTurn: "ویرایش اطلاعات گردش سند دریافتنی",
    deleteEmptyVoucher: "حذف اسناد خالی",
    archiveVoucher: "بایگانی اسناد",
    taxTable: "جدول مالیاتی",
    occupationCategory: "رسته های شغلی",
    employmentType: "انواع استخدام",
    studyFieldType: "رشته تحصیلی",
    degree: "مدرک تحصیلی",
    insuranceType: "انواع بیمه",
    jobGroup: "گروه های شغلی",
    workPlaceStatus: "وضعیت محل خدمت",
    exemptionType: "نوع معافیت",
    unarchiveVoucher: "خروج از حالت بایگانی اسناد",
    feedbackHistories: "سوابق نظرسنجی",
    feedbackReport: "گزارش نظرسنجی",
    feedbackHistoryDetails: "جزئیات سوابق نظرسنجی",
    answerSheets: "پاسخنامه‌‌ها",
    nationalityType: "نوع تابعیت",
    debtorOrCreditorDeclaration: "اعلامیه بدهکار و بستانکار",
    addDebtorOrCreditorDeclaration: "ثبت اعلامیه بدهکار و بستانکار",
    editDebtorOrCreditorDeclaration: "ویرایش اطلاعات اعلامیه بدهکار و بستانکار",
    paymentCheque: "اسناد پرداختنی",
    addPaymentCheque: "ثبت اسناد پرداختنی جدید",
    addPaymentChequeGroup: "ثبت اسناد پرداختنی به صورت گروهی",
    editPaymentCheque: "ویرایش اطلاعات سند پرداختنی",
    cancelPayableDocs: "ابطال/استرداد اسناد پرداختنی",
    congratulationsMsgSettings: "تنظیمات پنل تبریک",
    addCongratulationsMessageSettings: "ثبت تنظیمات پیام تبریک",
    editCongratulationsMessageSettings: "ویرایش تنظیمات پیام تبریک",
    addPaymentRequest: "ثبت درخواست پرداخت",
    editPaymentRequest: "ویرایش درخواست پرداخت",
    historyAllDetails: "ریز سوابق نظرسنجی",
    paymentChequeConfirm: "تایید اسناد پرداختنی",
    passPayDocs: "پاس اسناد پرداختنی",
    receiveChequeConfirm: "تایید اسناد دریافتنی",
    packageTypes: "انواع بسته بندی",
    sampleExcelFiles: "نمونه فایل های اکسل",
    benefitsAndDeduction: "مزایا / کسورات",
    feedBackByQuestion: "سوابق نظرسنجی به تفکیک سوال",
    groupChangeVoucherArticles: "تغییر گروهی آرتیکل‌های سند",
    settings: "تنظیمات",
    processType: "فرایندهای تولید",
    insuranceStudio: "کارگاه های بیمه",
    produceOrder: "مشاهده دستورات تولید",
    addProduceOrder: "صدور دستور تولید",
    sprint: "هفته های کاری",
    receiveAndPaymentCash: "دریافتی ها و پرداختی های نقد",
    bankAccountOperationDetail: "ریزعملیات حساب بانکی",
    monthlyReceiveAndPaymentCashReport:
      "مقایسه ماهانه دریافت‌ها و پرداخت‌های نقد",
    historyReceiveChequeReport: "سابقه اسناد دریافتنی",
    coilCertificate: "شناسنامه کویل",
    addCoilCertificate: "ثبت شناسنامه کویل جدید",
    editCoilCertificate: "ویرایش اطلاعات شناسنامه کویل",
    historyPaymentChequeReport: "سابقه اسناد پرداختنی",
    paymentChequeReport: "گزارش اسناد پرداختنی",
    checksReceivedDueed: "چک‌های دریافتی سررسید شده",
    checksPaymentDueed: "چک‌های پرداختی سررسید شده",
    monthlyComparisonReceiveCheque: "گزارش مقایسه ماهانه اسناد دریافتنی",
    monthlyComparisonPaymentCheque: "گزارش مقایسه ماهانه اسناد پرداختی",
    paymentChequeToPerson: "اسناد پرداخت شده به شخص",
    paymentChequeToAccountInfo: "اسناد پرداخت شده به حساب",
    paymentChequeTurn: "مرور/گردش اسناد پرداختنی",
    accountInventoryReport: "گزارش موجودی",
    summaryReceiveCheque: "خلاصه اسناد دریافتنی",
    summaryPaymentCheque: "خلاصه اسناد پرداختنی",
    bankSummary: "خلاصه اسناد خزانه",
    historyCustomer: "سوابق مشتری",
    receiveChequeTurnReprot: "مرور/ گردش اسناد دریافتنی",
    coldRolling: "نورد سرد",
    coldRollingQC: "کنترل کیفی نورد سرد",
    addColdRolling: "ثبت نورد سرد",
    foilRolling: "نورد فویل",
    foilRollingQC: "کنترل کیفی نورد فویل",
    addFoilRolling: "ثبت نورد فویل",
    productionReports: "گزارشات تولید",
    contractors: "پیمانکاران",
    inspectionLevel: "سطح بازرسی",
    productionGroupSupplier: "تامین‌کنندگان گروه تولید",
    productionGroups: "گروه‌های تولید",
    purchaseContracts: "قراردادهای خرید",
    saleType: "انواع فروش",
    stopStation: "ایستگاه‌های توقف",
    ordeDatasheet: "دیتاشیت سفارشات",
    addDatasheet: "افزودن دیتاشیت",
    editDatasheet: "ویرایش دیتاشیت",
    technicalCartable: "کارتابل فنی مهندسی",
    mapConfirmCartable: "کارتابل بررسی نقشه",
    planCartable: "کارتابل برنامه ریزی",
    deliveryTime: "کارتابل تعیین زمان تحویل",
    deliveryTimeConfirm: "کارتابل تایید زمان تحویل",
    needPlanCartable: "کارتابل نقشه فرآیند",
    commodityAdditionalInfo: "اطلاعات تکمیلی کالا",
    combinedFormula: "فرمول تولید",
    addCombinedBom: "افزودن فرمول تولید",
    editCombinedBom: "ویرایش فرمول تولید",
    production: "تولید",
    addProduction: "ثبت تولید ",
    editProduction: "ویرایش تولید",
    microProductionReport: "گزارش ریز تولید",
    consumablesReport: "گزارش مواد مصرفی",
    productionCostReport: "گزارش هزینه‌های تولید",
    combinedProduction: "تولید ترکیبی",
    addCombinedProduction: "ثبت تولید ترکیبی",
    editCombinedProduction: "ویرایش تولید ترکیبی",
    branchesAndOffices: "شعب و دفاتر",
    dealType: "نوع معامله",
    cottage: "کوتاژ",
    addCottage: "ثبت کوتاژ",
    editCottage: "ویرایش :وتاژ",
    purchase: "خرید (عرضه)",
    addPurchase: "ثبت خرید (عرضه)",
    editPurchase: "ویرایش خرید (عرضه)",
    parakOrder: "سفارش (خرید از بازارگاه)",
    lading: "بارنامه",
    addLading: "ثبت بارنامه",
    editLading: "ویرایش بارنامه",
    cottageReport: "گزارش کوتاژ",
    purchaseReport: "گزارش خرید (عرضه)",
    orderReport: "گزارش سفارش",
    comprehensiveOrder: "گزارش جامع سفارش",
    addPersonClub: "ثبت مشتری جدید",
    salesManager: "مسئولین فروش",
    sellerAgents: "نمایندگان فروش",
    salesAgents: "نمایندگان فروش",
    salePricePolicy: "سیاست های قیمت گذاری",
    addSalePricePolicy: "ثبت سیاست قیمت گذاری",
    editSalePricePolicy: "ویرایش سیاست قیمت گذاری",
    salePricePolicyGroupChange: "تغییر گروهی قیمت",
    saleAddMinus: "اضافات و کسورات فاکتور فروش",
    saleAddAddMinus: "ثبت اضافات و کسورات فاکتور فروش",
    saleEditAddMinus: "ویرایش اضافات و کسورات فاکتور فروش",
    discountPolicy: "سیاست های تخفیف کالا",
    addDiscountPolicy: "ثبت سیاست تخفیف کالا",
    editDiscountPolicy: "ویرایش سیاست تخفیف کالا",
    giftsPolicy: "سیاست هدایا",
    addGiftsPolicy: "ثبت سیاست هدایا",
    editGiftsPolicy: "ویرایش سیاست هدایا",
    service: "خدمات",
    preFactor: "پیش فاکتور",
    addPreFactor: "ثبت پیش فاکتور",
    editPreFactor: "ویرایش پیش فاکتور",
    salesStatisticsByCustomersReport: "گزارش آمار فروش براساس مشتریان",
    salesQuantityReport: "گزارش تعداد فروش",
    customerSalesSingleProductReport: "گزارش فروش مشتریان از یک کالا",
    aggregatedCustomerProductSalesReport: "گزارش فروش مشتری-کالا تجمیعی",
    customerCommoditySalesReport: "گزارش فروش مشتری-کالا",
    basedOnSaleManagerReport: "گزارش براساس مسئولین فروش",
    salesManagerCollaborationPercentageReport: "گزارش درصد همکاری مسئولین فروش",
    creditorsAndDebtorsReport:
      "گزارش بستانکاران و بدهکاران براساس مسئولین فروش",
    customerSalesReport: "گزارش فروش مشتریان براساس مسئولین فروش",
    productProfitReport: "گزارش سود کالا",
    grossProfitReport: "گزارش سود ناویژه",
    productProfitByProductGroupReport: "گزارش سود کالا براساس گروه کالا",
    grossProfitByInvoiceProductCustomerReport:
      "گزارش سود ناویژه فاکتور-کالا-مشتری",
    saleFactor: "فاکتور فروش",
    addSaleFactor: "ثبت فاکتور فروش",
    editSaleFactor: "ویرایش فاکتور فروش",
    returnSaleFactor: "فاکتور مرجوعی فروش",
    editReturnSaleFactor: "ویرایش فاکتور مرجوعی فروش",
    saleReportByProduct: "گزارش فروش بر اساس کالا",
    salesOfficeReport: "گزارش دفتر فروش",
    receiveAndPay: "موضوع دریافت و پرداخت",
    documentTypes: "انواع یادداشت",
    saleByAgentReport: "گزارش فروش براساس نمایندگان",
    buyAddMinus: "اضافات و کسورات فاکتور خرید",
    addBuyAddMinus: "ثبت اضافات و کسورات فاکتور خرید",
    editBuyAddMinus: "ویرایش اطلاعات اضافات و کسورات فاکتور خرید",
    buyType: "انواع فاکتور خرید",
    buyFactor: "فاکتور خرید",
    addBuyFactor: "ثبت فاکتور خرید",
    editBuyFactor: "ویرایش فاکتور خرید",
    addReturnSaleFactor: "ثبت فاکتور مرجوعی فروش",
    comprehensiveFactorReport: "گزارش جامع فاکتور",
    retunSaleFactor: "فاکتور مرجوعی",
    comprehensiveCommodityReport: "گزارش جامع کالا",
    additionsDeductionsReports: "گزارش اضافات و کسورات",
    awardsGivenReport: "گزارش جوایز داده‌شده",
    saleByVisitorReport: "گزارش براساس ویزیتور ",
    customerProfitReport: "گزارش سود مشتری",
    factorProfitReport: "گزارش سود فاکتور",
    latestBuyPriceOfCommodity: "گزارش آخرین قیمت خرید کالا",
    factorComprehensiveReport: "گزارش جامع فاکتور",
    commodityComprehensiveReport: "گزارش جامع کالا",
    monthlyPurchaseReport: "گزارش ماهیانه خرید کالا",
    voucherVerification: "تایید اسناد",
    buyReportBySuppliers: "گزارش خرید براساس تامین‌کنندگان",
    managementCartableReceipt: "کارتابل مدیریتی رسید",
    managementCartableDraft: "کارتابل مدیریتی حواله",
    returnBuyFactor: "فاکتور خرید مرجوعی",
    closeAccounts: "بستن حساب‌ها",
    receiptReceived: "رسید دریافت",
    addReceiptReceived: "ثبت رسید دریافت",
    editReceiptReceived: "ویرایش رسید دریافت",
    officeReports: "گزارش دفاتر",
    journalReport: "دفتر روزنامه",
    operationReports: "دفاتر عملیاتی",
    reviewAccounts: "مرور حساب ها",
    accountOperationDetailReport: "ریزعملیات حساب ها",
    paymentPaper: "اعلامیه پرداخت",
    addPaymentPaper: "ثبت اعلامیه پرداخت",
    editPaymentPaper: "ویرایش اعلامیه پرداخت",
    listPaymentPaper: "لیست اعلامیه های پرداخت",
    commodityReservationList: "لیست کالاهای رزرو شده",
    managementCartableSale: "کارتابل مدیریتی فاکتور فروش",
    managementCartableSaleReturn: "کارتابل مدیریتی مرجوعی فروش",
    managementCartableBuy: "کارتابل مدیریتی فاکتور خرید",
    managementCartableBuyReturn: "کارتابل مدیریتی مرجوعی خرید",
    managementCartableRequestBuy: "کارتابل مدیریتی درخواست خرید",
    managementCartablePaymentCheque: "کارتابل مدیریتی اسناد پرداختنی",
    managementCartablePaymentRequest: "کارتابل مدیریتی درخواست پرداخت",
    managementCartableAdvance: "کارتابل مدیریتی مساعده",
    managementCartableReceiveCheque: "کارتابل مدیریتی اسناد دریافتنی",
    verificationReceiptCartable: "کارتابل تایید رسید",
    verificationDraftCartable: "کارتابل تایید حواله",
    confirmSaleFactorCartable: "کارتابل تایید فاکتور فروش",
    sortSaleFactor: "مرتب سازی فاکتور فروش",
    confirmReturnSaleFactorCartable: "کارتابل تایید مرجوعی فروش",
    buyFactorConfirmCartable: "کارتابل تایید فاکتور خرید",
    sortBuyFactor: "مرتب سازی فاکتور خرید",
    buyReturnConfirmCartable: "کارتابل تایید مرجوعی خرید",
    confirmRewuestBuyFactorCartable: "کارتابل تایید درخواست خرید",
    circulationOfAccounts: "گردش حساب ها",
    reportsOfIndividuals: "گزارش اشخاص",
    trialBalance4ColumnsReport: "تراز های چهار ستونی",
    trialBalance6ColumnsReport: "تراز های شش ستونی",
    trialBalance8ColumnsReport: "تراز های هشت ستونی",
    acountsWithPersonReport: "گزارش حساب ها با اشخاص",
    statusDocumentReport: "گزارش وضعیت اسناد",
    trialBalanceReport: "تراز شناور",
    personWithAccount: "گزارش اشخاص با حساب ها",
    personCreditsReport: "اعتبارات اشخاص",
    personalAccountBalanceReport: "تراز اشخاص",
    electronicLedgerReport: "گزارش دفتر الکترونیک",
    personalFinalVoucherReport: "آخرین گردش حساب اشخاص",
    personOfficeReport: "دفتر اشخاص",
    personMultiLevelLedgerReport: "مانده جامع اشخاص",
    cartableLog: "لاگ گردش کارتابل‌ها",
    monthlyAccountingVoucherReport: "گزارش دوره ای تجمیعی",
    floatAccountOffice: "دفتر حساب شناور",
    accountOffice: "گزارش دفتر حساب",
    balanceSheetReport: "گزارش ترازنامه",
    profitAndLossReport: "گزارش سود و زیان",
    individualOperationDetailReport: "ریزعملیات اشخاص",
    addReceiptReceiveCartable: "کارتابل برگه دریافت نقد/اسناد دریافتنی",
    paymentPapersCartable: "کارتابل برگه پرداخت نقد/اسناد پرداختنی",
    issueTrackingPaymentType: "نوع دریافت و پرداخت",
    typeFinancialTransaction: "نوع تراکنش مالی",
    commodityGroupConfig: "تنظیمات گروه کالا",
    goals: "اهداف",
    goalUser: "کاربران هدف",
    goalSchedule: "زمان‌بندی هدف",
    addGoal: "ثبت هدف جدید",
    editGoal: "ویرایش اطلاعات هدف",
    company: "لیست شرکت‌ها",
    addCompany: "ثبت شرکت جدید",
    editCompany: "ویرایش اطلاعات شرکت",
    hardness: "سختی",
    productSurface: "سطح محصول",
    usageGroup: "گروه کاربردی",
    foilUsage: "کاربرد فویل",
    innerCoreDiameter: "قطر داخلی کور سفارش تحویلی",
    castingManagementCartable: "کارتابل مدیریتی ریخته‌گری",
    coldRollingManagementCartable: "کارتابل مدیریتی نورد سرد",
    foilRollingManagementCartable: "کارتابل مدیریتی نورد فویل",
    castingCartable: "کارتابل ریخته‌گری",
    coldRollingtCartable: "کارتابل نورد سرد",
    foilRollingCartable: "کارتابل نورد فویل",
    castingReport: "گزارش تولید ریخته‌گری",
    addCastingReport: "ثبت گزارش تولید ریخته‌گری",
    chancePriority: "اولویت فرصت",
    failedSaleReason: "دلایل فروش ناموفق",
    competitor: "رقبا",
    strengthWeakness: "نقاط ضعف و قوت",
    coldRollingReport: "گزارش تولید نورد سرد",
    addColdRollingReport: "ثبت گزارش تولید نورد سرد",
    foilRollingReport: "گزارش تولید نورد فویل",
    addFoilRollingReport: "ثبت گزارش تولید نورد فویل",
    furnace: "کوره",
    financialRatioReport: "گزارش نسبت های مالی",
    projectType: "انواع پروژه",
    projects: "پروژه ها",
    addProject: "ثبت پروژه جدید",
    editProject: "ویرایش اطلاعات پروژه",
    workDescription: "شرح کار",
    projectTeam: "تیم پروژه",
    generalEstimate: "برآورد عمومی",
    tasks: "مشاهده فعالیت‌ها و وظایف",
    workCalendar: "تقویم کاری",
    addTask: "ثبت فعالیت و وظیفه جدید",
    editTask: "ویرایش فعالیت و وظیفه",
    taskCategory: "دسته بندی فعالیت و وظیفه",
    addMessage: "ثبت پیام",
    editMessage: "ویرایش پیام",
    calls: "تماس‌ها",
    addCall: "ثبت تماس",
    editCall: "ویرایش تماس",
    noteCategory: "دسته بندی یادداشت",
    noteSubject: "موضوع یادداشت",
    callCategory: "دسته بندی تماس",
    callSubject: "موضوع تماس",
    serviceSupportSubject: "موضوع پشتیبانی",
    hamyarRequestType: "نوع درخواست",
    requests: "درخواست‌ها",
    addRequest: "افزودن درخواست",
    editRequest: "ویرایش درخواست",
    hamyarProjectType: "نوع پروژه",
    notes: "یادداشت ها",
    address: "آدرس",
    meeting: "صورتجسات",
    addMeeting: "ثبت صورت‌جلسه",
    editMeeting: "ویرایش صورت‌جلسه",
    meetingGuests: "مدعوین جلسه",
    meetingApprovals: "مصوبات جلسه",
    addGroupCashPayment: "ثبت گروهی پرداخت نقد",
    addGroupReceiveCash: "ثبت دریافت نقد بصورت گروهی",
    wareSetting: "تنظیمات انبار",
    addReciveChequeGroup: "ثبت اسناد دریافتنی به صورت گروهی",
    addBenefitsAndDeduction: "ثبت مزایا / کسورات",
    editBenefitsAndDeduction: "ویرایش مزایا / کسورات",
    slrySetting: "تنظیمات جبران خدمت",
    workingHours: "ساعت استاندارد کارکرد",
    agreementRow: "ردیف های پیمان",
    accountWithFloatAccount: "حساب - حساب شناور",
    accountWithFloatAccountGroupReport: "گزارش حساب با گروه حساب شناور",
    floatAccountWithAccount: "حساب شناور - حساب",
    personWithFloatAccount: "شخص - حساب شناور",
    floatAccountWithPerson: "حساب شناور - شخص",
    department: "دپارتمان",
    contractType: "انواع حکم کارگزینی",
    contractSample: "نمونه حکم کارگزینی",
    contractsList: "لیست حکم کارگزینی",
    contract: "حکم کارگزینی",
    additionalContractParameter: "پارامترهای تکمیلی حکم کارگزینی",
    leave: "مرخصی",
    addLeave: "ثبت مرخصی",
    editLeave: "ویرایش مرخصی",
    advance: "مساعده",
    addAdvance: "ثبت مساعده",
    editAdvance: "ویرایش مساعده",
    leaveManagementCartable: "کارتابل مدیریتی مرخصی",
    advanceManagementCartable: "کارتابل مدیریتی مساعده",
    addGroupAdvance: "ثبت گروهی مساعده",
    advancesList: "لیست مساعده ها",
    leaveList: "لیست مرخصی ها",
    advanceConfirm: "تایید / عدم تایید مساعده",
    leaveConfirm: "تایید / عدم تایید مرخصی",
    mission: "ماموریت",
    addMission: "ثبت ماموریت",
    editMission: "ویرایش ماموریت",
    missionList: "لیست ماموریت ها",
    missionConfirm: "تایید / عدم تایید ماموریت",
    missionManagementCartable: "کارتابل مدیریتی ماموریت",
    personnel: "پرسنل",
    addPersonnel: "ثبت پرسنل جدید",
    editPersonnel: "ویرایش پرسنل",
    interbankTransfer: "انتقال بین بانکی",
    interbankTransferList: "مشاهده انتقال بین بانکی",
    addInterbankTransfer: "ثبت انتقال بین بانکی",
    editInterbankTransfer: "ویرایش انتقال بین بانکی",
    addContractSample: "ثبت نمونه حکم کارگزینی جدید",
    editContractSample: "ویرایش نمونه حکم کارگزینی",
    voucherNotesReport: "گزارش یادداشت‌های اسناد",
    serviceCenters: "مراکز خدمت",
    formulas: "فرمول ها",
    cashFlowReport: "گزارش گردش نقدینگی",
    addFormula: "ثبت فرمول",
    editFormula: "ویرایش فرمول",
    chequeReceivedByPerson: "گزارش اسناد دریافتنی براساس شخص",
    payrollEmployee: "محاسبه حقوق",
    editPayrollEmployee: "ویرایش اطلاعات فیش حقوق",
    suite: "واحدها",
    participation: "مشارکت‌ها",
    paymentNotification: "اعلام‌ها",
    estimates: "برآوردها",
    rankings: "رتبه‌بندی",
    crimesReward: "پاداش و جریمه",
    transfers: "نقل و انتقالات",
    taxRateType: "انواع نرخ مالیاتی",
    editGroupContract: "ویرایش گروهی حکم کارگزینی",
    addEstimates: "ثبت برآورد",
    editEstimates: "ویرایش برآورد",
    crimesRewardSubject: "موضوع پاداش و جرائم",
    salaryAndBenefitsReport: "گزارش حقوق و مزایا",
    estimationSubject: "موضوع برآورد",
    employeePayrollSummaryPersonnelReport: "گزارش تجمیعی حقوق بر اساس شخص",
    payrollEmployeeSummary: "گزارش تجمیعی حقوق",
    insuranceEmployee: "لیست بیمه",
    blocks: "بلوک‌ها",
    taxEmployee: "لیست مالیات",
    addInsuranceEmployee: "ثبت بیمه",
    editInsuranceEmployee: "ویرایش اطلاعات بیمه",
    addTaxEmployee: "ثبت مالیات",
    editTaxEmployee: "ویرایش اطلاعات مالیات",
    summaryRanking: "خلاصه رتبه‌بندی",
    detailRanking: "جزئیات رتبه‌بندی",
    bankExportTemplate: "قالب فایل بانک",
    addBankExportTemplate: "ثبت قالب فایل بانک",
    payslipSystemControl: "کنترل سامانه فیش حقوقی",
    editBankExportTemplate: "ویرایش قالب فایل بانک",
    bankExport: "صدور فایل بانک",
    bankExportHistory: "تاریخچه صدور فایل بانک",
    messageSetting: "تنظیمات پیامک",
    relationField: "روابط پایگاه داده",
    menuManagement: "مدیریت منوها",
    marketItem: "نمادهای بازار",
    backupImport: "بازیابی بکاپ",
    backupExport: "گرفتن اسکریپت داده",
    winBackupImport: "انتقال بکاپ ویندوزی",
    modiranMapping: "نگاشت مدیران",
    accountCurrencyMonitoringReport: "گزارش پایش ارزی حساب ها",
    accountCurrencyTrialBalanceReport: "گزارش تراز آزمایشی ارزی",
    payslipReport: "گزارش فیش حقوقی",
    managementCartableVoucher: "کارتابل مدیرتی اسناد",
    voucherMerge: "ادغام اسناد",
    serviceGroup: "گروه بندی خدمات",
    saleSetting: "تنظیمات فروش",
    scmsSetting: "تنظیمات خرید و تدارکات",
    addReturnBuyFactor: "ثبت فاکتور خرید مرجوعی",
    editReturnBuyFactor: "ویرایش فاکتور خرید مرجوعی",
    salesPipeline: "خطوط و مراحل فروش",
    followUpCartable: "کارتابل پیگیری",
    activitiesAndCalendar: "فعالیت‌ها و تقویم",
    proposalsAndContracts: "پیشنهادها و قراردادها",
    myFollowUpCartable: "کارتابل پیگیری من",
    leadChanceConversionReport: "فرصت و سرنخ به مشتری",
    serviceSupports: "پشتیبانی و سرویس ها",
    addServiceSupport: "ثبت پشتیبانی و سرویس جدید",
    editServiceSupport: "ویرایش پشتیبانی و سرویس",
    addHamyarContract: "ثبت قرارداد جدید",
    editHamyarContract: "ویرایش قرارداد",
    saleFunnelReport: "قیف فروش",
    saleFactorInvoice: "ارسال فاکتور فروش به سامانه مودیان",
    branchTaxSetting: "تنظیمات سامانه مودیان شعبه",
    taxInvoices: "صورتحساب‌های ارسال شده",
    taxKeys: "کلیدهای سامانه مودیان",
    importExcelTaxInvoice: "ورود صورتحساب از اکسل",
    settlementType: "انواع تسویه",
    saleOrderManagementCartable: "کارتابل مدیریتی سفارش",
    orderPermitCartable: "کارتابل تایید و صدور مجوز",
    orderPermitList: "لیست مجوزهای خروج",
    orderDraftCartable: "کارتابل صدور حواله",
    orderDraftList: "لیست حواله های سفارش",
    saleFactorGroupDraft: "صدور حواله دسته جمعی فاکتور فروش",
    returnSaleFactorGroupReceipt: "صدور رسید دسته جمعی فاکتور مرجوعی فروش",
    returnBuyFactorGroupDraft: "صدور حواله دسته جمعی فاکتور مرجوعی خرید",
    buyFactorGroupReceipt: "صدور رسید دسته جمعی فاکتور خرید",
    issueBuyFactor: "صدور فاکتور خرید",
    issueReturnSaleFactor: "صدور فاکتور مرجوعی فروش",
    issueSaleFactor: "صدور فاکتور فروش",
    issueReturnBuyFactor: "صدور فاکتور مرجوعی خرید",
  },
  menu: {
    storeQuickSale: "فروش سریع",
    storeSaleReturn: "مرجوعی فروش",
    storeCashDesksAndBooths: "صندوق و غرفه‌ها",
    storeDeliveryAndShipping: "تحویل و ارسال",
    storeCustomerClub: "باشگاه مشتریان",
    storeAfterSalesService: "خدمات پس از فروش",
    storeStores: "فروشگاه‌ها",
    storeBooths: "غرفه‌ها",
    storeUsersAndShifts: "کاربران و شیفت‌ها",
    storeCashDesksAndTerminals: "صندوق‌ها و پایانه‌ها",
    storeSalesAgents: "مسئولان فروش",
    storeCommissionPolicies: "سیاست‌های پورسانت",
    storePricesAndDiscounts: "قیمت و تخفیفات",
    storeSalesReports: "گزارش‌های فروش",
    storeSettingsAndAccess: "تنظیمات و دسترسی‌ها",
    storeSaleFactor: "فاکتور فروش",
    storePreOrder: "پیش فاکتور غرفه",
    storeAddPreOrder: "ثبت پیش فاکتور غرفه",
    storeEditPreOrder: "ویرایش پیش فاکتور غرفه",
    storeShopSetting: "تنظیمات فروشگاهی",
    storeBoothSetting: "تنظیمات غرفه",
    storeAddStore: "ثبت فروشگاه",
    storeEditStore: "ویرایش فروشگاه",
    storeAddBooth: "ثبت غرفه",
    storeEditBooth: "ویرایش غرفه",
    storePosTerminalTypes: "انواع دستگاه‌های پوز",
    storeBenefitCard: "بن کارت",
    storeBenefitCards: "معرفی بن کارت",
    storeBenefitCardTransactions: "تراکنشات بن کارت",
    storeBenefitCardTransfer: "انتقال از کارت به کارت دیگر",
    home: "صفحه اصلی",
    dashboard: "داشبورد",
    about: "درباره ما",
    contact: "راه های ارتباطی",
    users: "کاربران و پرسنل",
    manageUsers: "مدیریت کاربران",
    management: "مدیریت",
    messages: "پیام‌ها",
    paymentNotification: "اطلاعیه ها",
    messagesAndNotify: "پیام ها و اطلاعیه ها",
    tickets: "تیکت‌ها",
    support: "پشتیبانی",
    manageProducts: "مدیریت محصولات",
    products: "محصولات",
    order: "سفارشات",
    addOrder: "ثبت سفارش",
    manageOrders: "مدیریت سفارشات",
    cart: "سبد خرید",
    shop: "فروشگاه",
    baseInformation: "اطلاعات پایه",
    operation: "عملیات",
    dataOperation: "داده‌های عملیاتی",
    reports: "گزارشات",
    editProfile: "ویرایش پروفایل",
    notifications: "اعلان و هشدار‌ها",
    allNotifications: "مشاهده همه اعلان‌ها",
    allMessages: "مشاهده همه پیام‌ها",
    logout: "خروج",
    rejectedTemplate: "کاربر مسدود شده",
    companyInfo: "اطلاعات سازمان",
    branches: "شعبه ها",
    manageBranches: "مدیریت شعبه ها",
    newBranch: "ایجاد شعبه جدید",
    fiscalYears: "سال های مالی",
    manageFiscalYears: "مدیریت سال های مالی",
    boardOfDirectors: "اعضای هیئت مدیره",
    settings: "تنظیمات",
    appSettings: "تنظیمات نرم افزار",
    permissions: "دسترسی و مجوزها",
    workStations: "ایستگاه‌ های کاری",
    workShifts: "شیفت های کاری",
    operators: "اپراتورها",
    supplyFeasibilityCartable: "امکان سنجی تامین",
    productionFeasibilityCartable: "امکان سنجی تولید",
    bom: "BOM (فرمول تولید)",
    unit: "واحدهای شمارش",
    category: "گروه بندی کالا",
    wares: "انبارها",
    commodities: "کالاها",
    visitor: "گزارش بازدید",
    orderList: "لیست سفارشات",
    accountInfo: "کدینگ حساب ها",
    roles: "نقش‌ های کاربران",
    orderSetting: "تنظیمات سفارشات",
    foilCartable: "کارتابل واحد فویل",
    financialCartable: "کارتابل مالی",
    casterCartable: "کارتابل کستر",
    coldRollCartable: "کارتابل نورد سرد",
    saleCartable: "کارتابل فروش",
    managerCartable: "کارتابل مدیرعامل",
    productionCartable: "کارتابل تولید",
    supplyAndEquipmentCartable: "کارتابل تامین و تجهیز",
    orderConfirmLog: "گزارشات تاییدیه ها",
    shelf: "انبارک‌ها",
    location: "موقعیت مکانی",
    personGroup: "گروه اشخاص",
    person: "اشخاص",
    sbu: "واحدهای سازمانی",
    unitCoefficient: "تبدیل ضرایب واحد شمارش",
    reqProduce: "درخواست تولید",
    productionPlan: "برنامه تولید",
    casting: "ریخته‌گری",
    castingQC: "کنترل کیفی ریخته‌گری",
    productionOrder: " دستور تولید",
    financial: "مالی",
    manager: "مدیریت",
    produceProcess: "دستور تولید",
    wareCategory: "دسته بندی انبارها",
    wareVoucherType: "انواع سند انبار",
    receipt: "رسید",
    floatLevels: "عناوین حساب‌های شناور",
    floatAccount: "حساب‌های شناور",
    floatAccountOne: "حساب‌های شناور یک",
    floatAccountTwo: "حساب‌های شناور دو",
    floatAccountThree: "حساب‌های شناور سه",
    floatAccountFour: "حساب‌های شناور چهار",
    floatAccountFive: "حساب‌های شناور پنج",
    floatAccountsGroup: "گروه حساب‌های شناور",
    floatAccountGroup: "گروه حساب شناور",
    floatAccountGroupOne: "گروه حساب شناور یک",
    floatAccountGroupTwo: "گروه حساب شناور دو",
    floatAccountGroupThree: "گروه حساب شناور سه",
    floatAccountGroupFour: "گروه حساب شناور چهار",
    floatAccountGroupFive: "گروه حساب شناور پنج",
    floatAccountManagement: "مدیریت حساب‌های شناور",
    floatAccountGroupManagement: "گروه حساب‌های شناور",
    addUserAndRoles: "معرفی کاربران و نقش‌ها",
    accountConfig: "تنظیمات کدینگ حساب",
    additionalCommodityParameter: "پارامترهای تکمیلی کالا",
    usersGroup: "گروه کاربران",
    prefix: "پیشوند اشخاص",
    buyRequest: "درخواست خرید",
    tempReceipt: "رسید موقت",
    tempReceiptList: "لیست رسیدهای موقت",
    cartable: "کارتابل",
    activeSessions: "نشست‌های فعال من",
    accountControlConfig: "تنظیمات کنترلی حساب ها",
    buyRequestList: "لیست درخواست‌های خرید",
    addBuyRequest: "ثبت درخواست خرید",
    buyRequestCartable: "کارتابل تایید درخواست خرید",
    receiptList: "لیست رسیدها",
    addTempReceipt: "صدور رسید موقت",
    tempReceiptCartable: "کارتابل رسیدهای موقت",
    tempReceiptExitCartable: "کارتابل رسیدهای موقت رد شده",
    addFinancialReceipt: "صدور رسید مالی",
    financialReceiptCartable: "کارتابل رسید مالی",
    confirmReceiptCartable: "کارتابل قطعی سازی رسیدها",
    disconfirmReceiptCartable: "کارتابل غیرقطعی سازی رسیدها",
    someWareReceiptList: "لیست رسیدهای مقداری",
    addSomeWareReceipt: "صدور رسید مقداری",
    someWareReceiptCartable: "کارتابل رسید مقداری",
    draftRequest: "درخواست های حواله",
    draftRequestList: "لیست درخواست های حواله",
    addDraftRequest: "ثبت درخواست حواله",
    draftRequestCartable: "کارتابل درخواست حواله",
    draft: "حواله",
    draftList: "لیست حواله‌ ها",
    addFinancialDraft: "صدور حواله مالی",
    financialDraftCartable: "کارتابل حواله مالی",
    confirmDraftCartable: "کارتابل قطعی سازی حواله‌ها",
    disconfirmDraftCartable: "کارتابل غیرقطعی سازی حواله‌ها",
    someWareDraftList: "لیست حواله‌های مقداری",
    addSomeWareDraft: "صدور حواله مقداری",
    someWareDraftCartable: "کارتابل حواله مقداری",
    vehicleTypes: "انواع وسیله نقلیه",
    suppliers: "تامین‌کنندگان",
    approvalCartablePriorities: "‌اولویت‌‌بندی تایید کارتابل‌ها",
    wareVouchers: "دفاتر انبار",
    wareSomeVouchers: "دفتر مقداری",
    wareFinancialVouchers: "دفتر مالی",
    circulationCommodity: "گردش کالا",
    someCirculation: "گردش مقداری",
    financialCirculation: "گردش مالی",
    otherReports: "سایر گزارشات",
    inventoryDeductionReport: "گزارش کسر موجودی",
    inventorySummaryReport: "گزارش خلاصه موجودی",
    wareInventory: "موجودی انبار",
    someInventory: "موجودی مقداری",
    financialInventory: "موجودی مالی",
    position: "سِمت‌های سازمانی",
    buyer: "تعیین مامور خرید",
    sortReceipts: "مرتب سازی رسیدها",
    sortDrafts: "مرتب سازی حواله‌ها",
    commoditySleepReport: "گزارش خواب/موجودی راکد کالا",
    negativeCommodityInventory: "گزارش موجودی کالاهای منفی",
    commodityCirculationReport: "گردش مواد و کالا",
    cardex: "کاردکس",
    someCardex: "کاردکس مقداری",
    financialCardex: "کاردکس مالی",
    transferCommodity: "انتقال بین انبار",
    transferCommodityList: "لیست انتقال بین انبارها",
    proccessTransferCartable: "کارتابل انتقال بین انبار فرآیندی",
    addInstantTransfer: "ثبت انتقال بین انبار آنی",
    addProccessTransfer: "ثبت انتقال بین انبار فرآیندی",
    editInstantTransfer: "ویرایش انتقال بین انبار آنی",
    editProccessTransfer: "ویرایش انتقال بین انبار فرآیندی",
    buyers: "مأمورین خرید",
    personManagement: "مدیریت اشخاص",
    settingTransactions: "تنظیم تراکنش‌های سیستم",
    commodityConversion: "تبدیل کالا",
    warehousing: "انبارگردانی",
    customerManagement: "مدیریت مشتریان",
    customerGrouping: "گروه‌بندی مشتریان",
    customerGrade: "سطوح مشتری",
    discountCodes: "کدهای تخفیف",
    campaignManagement: "مدیریت کمپین‌ها",
    lead: "سرنخ (لیدها/طرف حساب ها)",
    chance: "فرصت",
    feedBackManagement: "مدیریت نظرسنجی",
    autoProcesses: "روندهای خودکار",
    interactivePolicies: "سیاست های تعاملی",
    salesChannelsTypes: "انواع کانال فروش",
    introducedType: "انواع روش‌ آشنایی",
    customerTagsTypes: "انواع برچسب‌های مشتری",
    campaignType: "انواع کمپین",
    leadType: "نوع سرنخ (لید)",
    leadProperty: "ویژگی سرنخ (لید)",
    leadSource: "منبع سرنخ (لید)",
    leadEvaluationQuestion: "سوالات ارزیابی سرنخ",
    saleTeam: "تیم فروش",
    saleRegion: "مناطق فروش",
    feedBackType: "انواع نظرسنجی",
    customerInfo: "اطلاعات مشتریان",
    occasionTypes: "انواع مناسبت",
    customerCreditVoucher: "گردش اعتبار مشتری",
    customerScoreVoucher: "دفتر امتیاز مشتری",
    deadlineReminder: "یادآوری مهلت اعتبار",
    deliveryMethod: "روش‌های تحویل",
    paymentMethod: "روش‌های پرداخت",
    blackList: "لیست سیاه",
    saleManagerDiscountLimit: "سطح تخفیف مجاز مسئول فروش",
    saleManagerCredit: "اعتبار مسئول فروش",
    saleOrder: "سفارش",
    addSaleOrder: "ثبت سفارش",
    saleOrderList: "لیست سفارش‌ها",
    saleOrderCartable: "کارتابل تایید سفارش",
    congratulationsMessage: "پیام تبریک",
    congratulationsMessageSettings: "تنظیمات پیام تبریک",
    feedBack: "نظرسنجی",
    feedBackQuestions: "سوالات نظرسنجی",
    systemSetting: "تنظیمات سامانه",
    feedBackQuestionOption: "پارامترهای اضافی نظرسنجی",
    commodityBatch: "سری ساخت‌ کالاها",
    voucherNoteType: "انواع یادداشت‌های سند",
    defaultVoucherDescription: "شرح‌های استاندارد سند",
    financialRatioSetting: "تنظیم نسبت‌های مالی",
    voucher: "سند حسابداری",
    voucherList: "مشاهده اسناد حسابداری",
    addVoucher: "ثبت سند حسابداری",
    addVoucherNew: "ثبت سند حسابداری (آزمایشی)",
    comprehensiveCustomerReport: "گزارش جامع مشتری",
    banksAndBranches: "بانک‌ها و شعبات",
    bankCashAccountInfo: "صندوق‌ها و حساب‌های بانکی",
    checks: "دسته چک‌ها",
    currencyType: "انواع ارز",
    currencyRate: "نرخ ارزها",
    personCredit: "اعتبار اشخاص",
    scoreSummery: "گزارش تجمیعی امتیاز مشتریان",
    userPerformanceReport: "گزارش عملکرد کاربران",
    chequeStatus: "معرفی وضعیت چک ها",
    profileCompletionSettings: "تنظیمات تکمیل پروفایل",
    bankAccountInfo: "حساب‌های بانکی",
    cashAccount: "صندوق‌ها",
    cashReceiptAndPayment: "دریافت و پرداخت نقد",
    receiveCash: "دریافت نقد",
    receiveCashList: "مشاهده دریافت نقد",
    addReceiveCash: "ثبت دریافت نقد",
    paymentCash: "پرداخت نقد",
    paymentCashList: "مشاهده پرداخت نقد",
    addPaymentCash: "ثبت پرداخت نقد",
    paymentRequest: "درخواست پرداخت نقد/چک",
    paymentRequestCartable: "درخواست پرداخت ",
    paymentRequestList: "مشاهده درخواست پرداخت",
    addPaymentRequest: "ثبت درخواست پرداخت",
    voucherSort: "مرتب‌ سازی اسناد",
    voucherOperation: "عملیات اسناد",
    voucherCartable: "کارتابل اسناد",
    voucherConfirm: "قطعی کردن اسناد ",
    voucherUnConfirm: "غیرقطعی کردن اسناد",
    receiveCheque: "اسناد دریافتنی",
    receiveChequeList: "مشاهده اسناد دریافتنی",
    addReceiveCheque: "ثبت اسناد دریافتنی",
    voucherReview: "مرور اسناد",
    voucherTemplate: "تنظیم شابلون شرح سند",
    showDocuments: "مشاهده اسناد",
    bankTransfer: "واگذاری به بانک",
    assignmentPerson: "واگذاری به اشخاص",
    cancellationReceivable: "ابطال اسناد دریافتنی",
    returnGuarantee: "استرداد اسناد ضمانتی",
    returnReceivables: "استرداد اسناد دریافتنی",
    returnAssignment: "استرداد اسناد واگذاری",
    returnTransferred: "برگشت اسناد واگذار شده",
    settlement: "وصول اسناد",
    paymentRequestConfirm: "تایید درخواست پرداخت",
    smsPanelSettings: "تنظیمات پنل پیامکی",
    commodityIntroduction: "معرفی کالا",
    taxTable: "جدول مالیاتی",
    employmentType: "انواع استخدام",
    studyFieldType: "رشته تحصیلی",
    degree: "مدرک تحصیلی",
    nationalityType: "نوع تابعیت",
    insuranceType: "انواع بیمه",
    jobGroup: "گروه های شغلی",
    workPlaceStatus: "وضعیت محل خدمت",
    receiveChequeTurn: "گردش اسناد",
    deleteEmptyVoucher: "حذف اسناد خالی",
    archiveVoucher: "بایگانی اسناد",
    unarchiveVoucher: "خروج از حالت بایگانی اسناد",
    exemptionType: "نوع معافیت",
    feedbackHistories: "سوابق نظرسنجی",
    feedbackReport: "گزارش نظرسنجی",
    feedbackHistoryDetails: "جزئیات سوابق نظرسنجی",
    answerSheets: "پاسخنامه‌‌ها",
    debtorOrCreditorDeclaration: "اعلامیه بدهکار و بستانکار",
    paymentCheque: "اسناد پرداختنی",
    paymentChequeList: "مشاهده اسناد پرداختنی",
    addPaymentCheque: "ثبت اسناد پرداختنی",
    cancelPayableDocs: "ابطال/استرداد اسناد پرداختنی",
    historyAllDetails: "ریز سوابق نظرسنجی",
    paymentChequeConfirm: "تایید اسناد پرداختنی",
    passPayDocs: "پاس اسناد پرداختنی",
    receiveChequeConfirm: "تایید اسناد دریافتنی",
    packageTypes: "انواع بسته بندی",
    occupationCategory: "رسته های شغلی",
    sampleExcelFiles: "نمونه فایل های اکسل",
    benefitsAndDeduction: "مزایا / کسورات",
    feedBackByQuestion: "سوابق نظرسنجی به تفکیک سوال",
    groupChangeVoucherArticles: "تغییر گروهی آرتیکل‌های سند",
    processType: "فرایندهای تولید",
    insuranceStudio: "کارگاه های بیمه",
    produceOrder: "مشاهده دستورات تولید",
    addProduceOrder: "صدور دستور تولید",
    sprint: "هفته های کاری",
    receiveAndPaymentCash: "دریافتی ها و پرداختی های نقد",
    bankAccountOperationDetail: "ریزعملیات حساب بانکی",
    monthlyReceiveAndPaymentCashReport: "مقایسه ماهانه دریافت‌ها و پرداخت‌های ",
    historyReceiveChequeReport: "سابقه اسناد دریافتنی",
    coilCertificate: "شناسنامه کویل",
    historyPaymentChequeReport: "سابقه اسناد پرداختنی",
    paymentChequeReport: "گزارش اسناد پرداختنی",
    pastDueChecks: "چک‌های سررسید شده",
    monthlyComparisonReceiveCheque: " مقایسه ماهانه اسناد دریافتنی",
    monthlyComparisonPaymentCheque: " مقایسه ماهانه اسناد پرداختی",
    paymentChequeToPerson: "اسناد پرداختی به شخص",
    paymentChequeToAccountInfo: "اسناد پرداختی به حساب",
    paymentChequeTurn: "مرور/گردش اسناد پرداختنی",
    other: "سایر",
    accountInventoryReport: "گزارش موجودی",
    summaryReceiveCheque: "خلاصه اسناد دریافتنی",
    summaryPaymentCheque: "خلاصه اسناد پرداختنی",
    bankSummary: "خلاصه اسناد خزانه",
    receiveChequeTurnReprot: "مرور/ گردش اسناد دریافتنی",
    coldRolling: "نورد سرد",
    coldRollingQC: "کنترل کیفی نورد سرد",
    foilRolling: "نورد فویل",
    foilRollingQC: "کنترل کیفی نورد فویل",
    productionReports: "گزارشات تولید",
    produce: "تولید",
    contractors: "پیمانکاران",
    inspectionLevel: "سطح بازرسی",
    productionGroupSupplier: "تامین‌کنندگان گروه تولید",
    productionGroups: "گروه‌های تولید",
    purchaseContracts: "قراردادهای خرید",
    saleType: "انواع فروش",
    stopStation: "ایستگاه‌های توقف",
    ordeDatasheet: "دیتاشیت سفارشات",
    technicalCartable: "کارتابل فنی مهندسی",
    mapConfirmCartable: "کارتابل بررسی نقشه",
    planCartable: "کارتابل برنامه ریزی",
    deliveryTime: "کارتابل تعیین زمان تحویل",
    deliveryTimeConfirm: "کارتابل تایید زمان تحویل",
    needPlanCartable: "کارتابل نقشه فرآیند",
    commodityAdditionalInfo: "اطلاعات تکمیلی کالا",
    combinedFormula: "فرمول تولید",
    production: "تولید",
    productionList: "مشاهده تولیدات",
    addProduction: "ثبت تولید",
    microProductionReport: "گزارش ریز تولید",
    consumablesReport: "گزارش مواد مصرفی",
    productionCostReport: "گزارش هزینه‌های تولید",
    combinedProduction: "تولید ترکیبی",
    dealType: "نوع معامله",
    cottage: "کوتاژ",
    purchase: "خرید (عرضه)",
    parakOrder: "سفارش (خرید از بازارگاه)",
    lading: "بارنامه",
    cottageReport: "گزارش کوتاژ",
    purchaseReport: "گزارش خرید (عرضه)",
    orderReport: "گزارش سفارش",
    comprehensiveOrder: "گزارش جامع سفارش",
    salesManager: "مسئولین فروش",
    salesAgents: "نمایندگان فروش",
    salePricePolicy: "سیاست های قیمت گذاری",
    saleAddMinus: "اضافات و کسورات فاکتور فروش",
    discountPolicy: "سیاست های تخفیف کالا",
    giftsPolicy: "سیاست هدایا",
    service: "خدمات",
    preFactor: "پیش فاکتور",
    preFactorList: "مشاهده پیش فاکتور",
    addPreFactor: "ثبت پیش فاکتور",
    salesOffice: "دفتر فروش",
    salesOfficeReport: "دفتر فروش",
    commodity: "کالا",
    salesByProductReport: "فروش براساس کالا",
    salesQuantityReport: "گزارش تعداد فروش",
    customerSalesSingleProductReport: "فروش مشتریان از یک کالا",
    customer: "مشتری",
    aggregatedCustomerProductSalesReport: "فروش مشتری-کالا تجمیعی",
    customerCommoditySalesReport: "فروش مشتری-کالا",
    salesStatisticsByCustomers: "آمار فروش براساس مشتریان",
    basedOnSaleManagerReport: "براساس مسئولین فروش",
    commoditySales: "فروش کالا",
    customerSalesReport: "فروش مشتریان",
    creditorsAndDebtorsReport: "بستانکاران و بدهکاران",
    salesManagerCollaborationPercentageReport: "درصد همکاری مسئولین فروش",
    profit: "سود مسئولین فروش",
    salesProfit: "سود فروش",
    productProfitReport: "سود کالا",
    profitSales: "سود فروش",
    grossProfitReport: "سود ناویژه",
    productProfitByProductGroupReport: "سود کالا براساس گروه کالا",
    grossProfitByInvoiceProductCustomerReport: "سود ناویژه فاکتور-کالا-مشتری",
    comprehensiveReport: "گزارش جامع",
    comprehensiveFactorReport: "گزارش جامع فاکتور",
    factor: "فاکتور",
    outstandingSalesFactor: "فاکتور فروش‌های مانده‌دار",
    settledFactor: "فاکتورهای تسویه‌شده",
    additionsDeductions: "اضافات و کسورات",
    discounts: "تخفیفات",
    tax: "مالیات بر ارزش افزوده",
    quarterly: "فصلی",
    awardsGiven: "جوایز داده‌شده",
    salesTimeReport: "گزارش زمانی فروش",
    salesSummary: "خلاصه فروش",
    salesAndInventoryDiscrepancy: "مغایرت فروش و انبار",
    salesAndAccountingDiscrepancySummary: "خلاصه مغایرت فروش و حسابداری",
    monthlyReport: "گزارش ماهیانه",
    legalFactor: "فاکتورهای قانونی",
    trustSalesReport: "گزارش فروش امانی",
    returnSaleFactor: "فاکتور مرجوعی فروش",
    returnSaleFactorList: "مشاهده فاکتور مرجوعی فروش",
    addReturnSaleFactor: "ثبت فاکتور مرجوعی فروش",
    saleReportByProduct: "گزارش فروش بر اساس کالا",
    saleFactor: "فاکتور فروش",
    receiveAndPay: "موضوع دریافت و پرداخت",
    saleFactorList: "مشاهده فاکتور فروش",
    addSaleFactor: "ثبت فاکتور فروش",
    documentTypes: "انواع یادداشت",
    saleByAgentReport: "گزارش فروش براساس نمایندگان",
    buyAddMinus: "اضافات و کسورات فاکتور خرید",
    buyType: "انواع فاکتور خرید",
    buyFactor: "فاکتور خرید",
    buyFactorList: "مشاهده فاکتور خرید",
    addBuyFactor: "ثبت فاکتور خرید",
    saleByVisitorReport: "گزارش براساس ویزیتور ",
    customerProfit: "سود مشتری",
    factorProfit: " سود فاکتور",
    latestBuyPriceOfCommodity: "آخرین قیمت خرید کالا",
    comprehensiveReports: "گزارشات جامع",
    monthlyPurchaseReport: "گزارش ماهیانه خرید کالا",
    buySomeCommodity: "خرید مقداری کالا",
    buyFinancialCommodity: "خرید ریالی کالا",
    buyReportBySuppliers: "گزارش خرید براساس تامین‌کنندگان",
    voucherVerification: "تایید اسناد",
    managementCartable: "کارتابل مدیریتی",
    returnBuyFactor: "فاکتور خرید مرجوعی",
    addReturnBuyFactor: "ثبت فاکتور خرید مرجوعی",
    buyReturnFactorList: "مشاهده فاکتور خرید مرجوعی",
    closeAccounts: "بستن حساب‌ها",
    receiptReceived: "رسید دریافت",
    addReceiptReceived: "ثبت رسید دریافت",
    listReceiptReceived: "مشاهده رسید دریافت",
    officeReports: "گزارش دفاتر",
    journalReport: "دفتر روزنامه",
    operationReports: "دفاتر عملیاتی",
    reviewAccounts: "مرور حساب ها",
    accountOperationDetailReport: "ریزعملیات حساب ها",
    paymentPaper: "اعلامیه پرداخت",
    addPaymentPaper: "ثبت اعلامیه پرداخت",
    editPaymentPaper: "ویرایش اعلامیه پرداخت",
    listPaymentPapers: "مشاهده اعلامیه های پرداخت",
    commodityReservationList: "لیست کالاهای رزرو شده",
    saleReturn: "مرجوعی فروش",
    buyReturn: "مرجوعی خرید",
    verificationReceiptCartable: "کارتابل تایید رسید",
    verificationDraftCartable: "کارتابل تایید حواله",
    confirmSaleFactorCartable: "کارتابل تایید فاکتور فروش",
    sortSaleFactor: "مرتب سازی فاکتور فروش",
    confirmReturnSaleFactorCartable: "کارتابل تایید مرجوعی فروش",
    buyFactorConfirmCartable: "کارتابل تایید فاکتور خرید",
    sortBuyFactor: "مرتب سازی فاکتور خرید",
    buyReturnConfirmCartable: "کارتابل تایید مرجوعی خرید",
    confirmRewuestBuyFactorCartable: "کارتابل تایید درخواست خرید",
    circulationOfAccounts: "گردش حساب ها",
    reportsOfIndividuals: "گزارش اشخاص",
    individualOperationDetailReport: "ریزعملیات اشخاص",
    trialBalances: "تراز های آزمایشی",
    trialBalance4ColumnsReport: "تراز های چهار ستونی",
    trialBalance6ColumnsReport: "تراز های شش ستونی",
    trialBalance8ColumnsReport: "تراز های هشت ستونی",
    acountsWithPersonReport: "گزارش حساب-شخص",
    floatAccountOperationDetail: "ریزعملیات حساب شناور",
    accountWithFloatAccount: "حساب - حساب شناور",
    accountWithFloatAccountGroupReport: "حساب - گروه حساب شناور",
    floatAccountWithPerson: "حساب شناور - شخص",
    floatAccountWithAccount: "حساب شناور - حساب",
    statusDocumentReport: "گزارش وضعیت اسناد",
    trialBalanceReport: "تراز شناور",
    personWithFloatAccount: "شخص - حساب شناور",
    personWithAccount: "گزارش شخص-حساب",
    personCreditsReport: "اعتبارات اشخاص",
    personalAccountBalanceReport: "تراز اشخاص",
    electronicLedgerReport: "دفتر الکترونیک",
    personalFinalVoucherReport: "آخرین گردش حساب اشخاص",
    personOfficeReport: "دفتر اشخاص",
    personMultiLevelLedgerReport: "مانده جامع اشخاص",
    cartableLog: "لاگ گردش کارتابل‌ها",
    floatAccountBalance: "تراز حساب شناور",
    monthlyAccountingVoucherReport: "گزارش دوره ای تجمیعی",
    floatAccountOffice: "دفتر حساب شناور",
    floatAccountReports: "گزارش حساب های شناور",
    account: "حساب",
    person1: "شخص",
    trialBalance: "تراز",
    office: "دفتر",
    operationDetail: "ریزعملیات",
    accountOffice: "دفتر حساب",
    worksheetReports: "گزارشات کاربرگ ها",
    balanceSheet: "ترازنامه",
    profitAndLoss: "سود و زیان",
    addReceiptReceiveCartable: " صدور برگه رسید دریافت",
    addPaymentPapersCartable: "صدور برگه اعلامیه پرداخت",
    floatAccountText: "پارامتر مبنا",
    issueTrackingPaymentType: "نوع دریافت و پرداخت",
    typeFinancialTransaction: "نوع تراکنش مالی",
    goals: "اهداف",
    goalUser: "کاربران هدف",
    goalSchedule: "زمان‌بندی هدف",
    company: "لیست شرکت‌ها",
    hardness: "سختی",
    productSurface: "سطح محصول",
    usageGroup: "گروه کاربردی",
    foilUsage: "کاربرد فویل",
    innerCoreDiameter: "قطر داخلی کور سفارش تحویلی",
    cartables: "کارتابل ها",
    castingReport: "گزارش تولید ریخته‌گری",
    chancePriority: "اولویت فرصت",
    failedSaleReason: "دلایل فروش ناموفق",
    competitor: "رقبا",
    strengthWeakness: "نقاط ضعف و قوت",
    coldRollingReport: "گزارش تولید نورد سرد",
    foilRollingReport: "گزارش تولید نورد فویل",
    furnace: "کوره",
    produceOrdeConfirm: "تایید دستورات تولید",
    productionOrderReport: "گزارش تولیدات",
    qc: "کنترل کیفی",
    financialRatioReport: "گزارش نسبت های مالی",
    phamsaz: "همساز",
    projectType: "انواع پروژه",
    projects: "پروژه ها",
    workDescription: "شرح کار",
    projectTeam: "تیم پروژه",
    generalEstimate: "برآورد عمومی",
    tasks: "فعالیت ها و وظایف",
    workCalendar: "تقویم کاری",
    taskCategory: "دسته بندی فعالیت و وظیفه",
    noteCategory: "دسته بندی یادداشت",
    noteSubject: "موضوع یادداشت",
    callCategory: "دسته بندی تماس",
    callSubject: "موضوع تماس",
    serviceSupportSubject: "موضوع پشتیبانی",
    hamyarRequestType: "نوع درخواست",
    requests: "درخواست‌ها",
    hamyarProjectType: "نوع پروژه",
    notes: "یادداشت ها",
    leadAddress: "آدرس سرنخ (لید)",
    leadContact: "مخاطبین سرنخ (لید)",
    meeting: "صورت‌جلسات",
    calls: "تماس‌ها",
    addGroupCashPayment: "ثبت گروهی پرداخت نقد",
    addGroupReceiveCash: "ثبت گروهی دریافت نقد",
    addPaymentChequeGroup: "ثبت گروهی اسناد پرداختنی",
    addReceiveChequeGroup: "ثبت گروهی اسناد دریافتنی",
    workingHours: "ساعت استاندارد کارکرد",
    agreementRow: "ردیف های پیمان",
    department: "دپارتمان",
    contractType: "انواع حکم کارگزینی",
    contractSample: "نمونه حکم کارگزینی",
    contractsList: "لیست حکم کارگزینی",
    contract: "حکم کارگزینی",
    additionalContractParameter: "پارامترهای تکمیلی حکم کارگزینی",
    leave: "مرخصی",
    advance: "مساعده",
    advanceConfirm: "تایید / عدم تایید مساعده",
    leaveConfirm: "تایید / عدم تایید مرخصی",
    advancesList: "لیست مساعده ها",
    leaveList: "لیست مرخصی ها",
    addGroupAdvance: "ثبت گروهی مساعده",
    advanceCartable: "کارتابل مساعده",
    advanceManagementCartable: "کارتابل مدیریتی مساعده",
    leaveManagementCartable: "کارتابل مدیریتی مرخصی",
    mission: "ماموریت",
    missionList: "لیست ماموریت ها",
    missionConfirm: "تایید / عدم تایید ماموریت",
    missionManagementCartable: "کارتابل مدیریتی ماموریت",
    leaveCartable: "کارتابل مرخصی",
    leaveReport: "گزارش مرخصی",
    leaveMonthlyReport: "گزارش مرخصی ماهانه",
    personnel: "پرسنل",
    interbankTransfer: "انتقال بین بانکی",
    interbankTransferList: "مشاهده انتقال بین بانکی",
    addInterbankTransfer: "ثبت انتقال بین بانکی",
    editInterbankTransfer: "ویرایش انتقال بین بانکی",
    addTask: "ثبت فعالیت‌ها",
    voucherNotesReport: "یادداشت‌های اسناد",
    serviceCenters: "مراکز خدمت",
    formulas: "فرمول ها",
    cashFlowReport: "گردش نقدینگی",
    chequeReceivedByPerson: "اسناد دریافتنی براساس شخص",
    payrollEmployee: "محاسبه حقوق",
    suite: "واحدها",
    participation: "مشارکت‌ها",
    paymentNotifications: "اعلام‌ها",
    estimates: "برآوردها",
    rankings: "رتبه‌بندی",
    crimesReward: "پاداش و جریمه",
    transfers: "نقل و انتقالات",
    taxRateType: "انواع نرخ مالیاتی",
    editGroupContract: "تغییر گروهی حکم کارگزینی",
    crimesRewardSubject: "موضوع پاداش و جرائم",
    salaryAndBenefitsReport: "گزارش حقوق و مزایا",
    estimationSubject: "موضوع برآورد",
    employeePayrollSummaryPersonnelReport: "گزارش تجمیعی حقوق بر اساس شخص",
    payrollEmployeeSummary: "گزارش تجمیعی حقوق",
    insuranceEmployee: "لیست بیمه",
    blocks: "بلوک‌ها",
    taxEmployee: "لیست مالیات",
    advanceReport: "گزارش مساعده",
    bankExportTemplate: "قالب فایل بانک",
    bankExport: "صدور فایل بانک",
    bankExportHistory: "تاریخچه صدور",
    payslipSystemControl: "کنترل سامانه فیش حقوقی",
    messageSetting: "تنظیمات پیامک",
    relationField: "روابط پایگاه داده",
    menuManagement: "مدیریت منوها",
    marketItem: "نمادهای بازار",
    backup: "پشتیبان‌گیری",
    backupImport: "بازیابی بکاپ",
    backupExport: "گرفتن اسکریپت داده",
    winBackupImport: "انتقال بکاپ ویندوزی",
    modiranMapping: "نگاشت مدیران",
    accountCurrencyMonitoringReport: "پایش ارزی حساب ها",
    accountCurrencyTrialBalanceReport: "تراز آزمایشی ارزی",
    payslipReport: "گزارش فیش حقوقی",
    vouchers: "اسناد",
    voucherMerge: "ادغام اسناد",
    serviceGroup: "گروه بندی خدمات",
    salesPipeline: "خطوط و مراحل فروش",
    followUpCartable: "کارتابل پیگیری",
    salesChances: "فرصت‌های فروش",
    leads: "سرنخ (لید)ها",
    leadList: "لیست سرنخ (لید)ها",
    leadDefinition: "معرفی سرنخ (لید) جدید",
    saleTeamAssignment: "اختصاص به مسئول فروش",
    evaluationCartable: "کارتابل ارزیابی سرنخ (لید)ها",
    customersAndContacts: "مشتریان و مخاطبان",
    activitiesAndCalendar: "فعالیت‌ها و تقویم",
    proposalsAndContracts: "پیشنهادها و قراردادها",
    marketingCampaigns: "کمپین‌های بازاریابی",
    leadChanceConversionReport: "فرصت و سرنخ به مشتری",
    serviceSupports: "پشتیبانی و سرویس ها",
    saleFunnelReport: "قیف فروش",
    saleFactorInvoice: "ارسال فاکتور فروش",
    taxInvoices: "صورتحساب‌های ارسال شده",
    taxKeys: "کلیدهای سامانه مودیان",
    importExcelTaxInvoice: "ورود صورتحساب از اکسل",
    settlementType: "انواع تسویه",
    saleOrderManagementCartable: "کارتابل مدیریتی سفارش",
    orderPermitCartable: "کارتابل تایید و صدور مجوز",
    orderPermitList: "لیست مجوزهای خروج",
    orderDraftCartable: "کارتابل صدور حواله",
    orderDraftList: "لیست حواله های سفارش",
    factorGroupDraft: "صدور حواله دسته جمعی",
    factorGroupReceipt: "صدور رسید دسته جمعی",
    issueBuyFactor: "صدور فاکتور خرید",
    issueReturnSaleFactor: "صدور فاکتور مرجوعی فروش",
    issueSaleFactor: "صدور فاکتور فروش",
    issueReturnBuyFactor: "صدور فاکتور مرجوعی خرید",
  },
  button: {
    // فروش فروشگاهی ---------------------------------------------
    addPreOrder: "ثبت پیش فاکتور غرفه",
    addStore: "ثبت فروشگاه",
    addBooth: "ثبت غرفه",
    addPosTerminal: "ثبت دستگاه پوز",
    addBenefitCard: "ثبت بن کارت",
    benefitCardOperations: "عملیات",
    benefitCardActivate: "فعال شدن کارت",
    benefitCardDeactivate: "غیر فعال شدن کارت",
    benefitCardBlock: "مسدود کردن",
    benefitCardUnblock: "رفع مسدودی",
    benefitCardCharge: "شارژ کارت (افزایش / کاهش)",
    benefitCardExtendExpireDate: "افزایش تاریخ اعتبار",
    benefitCardChangeCardNumber: "تعیین شناسه کارت",
    benefitCardChangePassword: "رمز عبور",
    benefitCardAssignOwner: "اختصاص کارت به شخص",
    benefitCardImportCards: "ورود از اکسل کارت‌ها",
    benefitCardImportOwners: "ورود از اکسل دارنده کارت",
    benefitCardImportCharges: "ورود از اکسل شارژ کارت",
    benefitCardTransfer: "انتقال",
    benefitCardShowTransactions: "گردش کارت",
    selectLogo: "انتخاب لوگو",
    removeLogo: "حذف لوگو",
    cancelPreOrder: "انصراف از پیش فاکتور",
    undoCancelPreOrder: "برگشت انصراف پیش فاکتور",
    viewPreOrder: "مشاهده پیش فاکتور",
    directCommissions: "درصد سود مستقیم از فروش",
    subGroupCommissions: "درصد سود از افراد زیرمجموعه",
    changeSaleStage: "تغییر مرحله فروش",
    warehousingNextRound: "ثبت و رفتن به شمارش بعدی",
    warehousingFinishCounting: "پایان شمارش و بررسی مغایرت‌ها",
    warehousingSaveList: "ذخیره لیست",
    warehousingPrevRound: "شمارش قبلی",
    warehousingDownloadSample: "دانلود نمونه فایل اکسل",
    warehousingConfirmContradictions: "تایید مغایرت‌ها و صدور رسید و حواله",
    warehousingSubmitAndCount: "ثبت و ادامه به شمارش",
    warehousingGoToCounting: "ادامه به شمارش کالا",
    warehousingPrintTags: "چاپ تگ‌های انبارگردانی",
    retryUpload: "تلاش مجدد آپلود",
    copyBom: "کپی فرمول",
    completeOrder: "تکمیل سفارش",
    login: "ورود",
    prevMonth: "ماه قبل",
    nextMonth: "ماه بعد",
    register: "ثبت نام در سامانه",
    logout: "خروج از سامانه",
    recoveryEmail: "ارسال ایمیل بازیابی",
    submit: "افزودن",
    submitInfo: "ثبت اطلاعات",
    submitInfoAndNew: "ثبت اطلاعات و جدید",
    submitPersonInfo: "ثبت مشخصات",
    submitPersonInfoAndNew: "ثبت مشخصات و جدید",
    submitFinancialInfo: "ثبت اطلاعات مالی",
    save: "ذخیره",
    saveInfo: "ذخیره اطلاعات",
    saveChanges: "ذخیره تغییرات",
    portalSelectAll: "انتخاب همه",
    portalDeselectAll: "حذف همه",
    portalRevertChanges: "بازگرداندن تغییرات",
    saveChangesAndAddVoucher: "ذخیره و صدور سند ",
    saveChangesAndNew: "ثبت اطلاعات و جدید",
    editInfo: "ویرایش اطلاعات",
    add: "ثبت",
    addUser: "معرفی کاربر جدید",
    edit: "ویرایش",
    delete: "حذف",
    yes: "بله",
    no: "خیر",
    confirmDelete: "بله، حذف شود",
    confirmSave: "بله، ذخیره شود",
    confirmDeleteGroup: "بله، حذف شوند",
    confirmCopy: "بله، کپی شود",
    editProfile: "ویرایش پروفایل",
    editPassword: "ویرایش رمز عبور",
    send: "ارسال",
    back: "بازگشت",
    backToLogin: "بازگشت به صفحه ورود",
    backToHome: "بازگشت به صفحه اصلی",
    home: "صفحه اصلی",
    cancel: "انصراف",
    close: "بستن",
    closeWindow: "بستن پنجره",
    addBase: "ثبت اطلاعات پایه",
    reload: "بارگذاری مجدد",
    print: "چاپ (پرینت)",
    printDetails: "چاپ (پرینت) ریز اقلام",
    addProduct: "ثبت محصول",
    editProduct: "ویرایش محصول",
    addWorkStation: "ثبت ایستگاه کاری",
    addShift: "ثبت شیفت",
    addBom: "ثبت فرمول تولید",
    addUnit: "ثبت واحد شمارش",
    addParentCategory: "ثبت گروه بندی پدر (اصلی)",
    addWare: "ثبت انبار",
    addCommodity: "ثبت کالا",
    defineCommodity: "تعریف کالا",
    addOrder: "ثبت سفارش",
    complete: "تکمیل",
    addPreInvoice: "صدور پیش فاکتور",
    wareConfirm: "تایید انبار",
    financialConfirm: "تایید مالی",
    managerConfirm: "تایید مدیرعامل",
    feasibility: "امکان سنجی",
    foilConfirm: "تایید واحد فویل",
    coldRollingConfirm: "تایید نورد سرد",
    casterConfirm: "تایید کستر",
    saleConfirm: "تایید فروش",
    deleteImage: "حذف تصویر",
    orderComplete: "تکمیل سفارش",
    OrderNotCompleted: "عدم تکمیل",
    confirmComplete: "بله، تکمیل شود",
    addBranch: "ثبت شعبه",
    addRole: "ثبت نقش",
    addFiscalYear: "ثبت سال مالی",
    addOrderSetting: "ثبت تنظیمات سفارشات",
    showMaterials: "مشاهده مواد مصرفی",
    confirm: "تایید",
    returnToCartable: "برگشت به کارتابل",
    shelf: "انبارک‌ها",
    addShelf: "ثبت انبارک",
    addCountry: "ثبت کشور",
    addProvince: "ثبت استان",
    addCity: "ثبت شهر",
    addPersonGroup: "ثبت گروه بندی",
    addPerson: "ثبت شخص",
    addSbu: "ثبت واحد",
    addUnitCoefficient: "ثبت ضریب واحد شمارش",
    addReqProduce: "ثبت درخواست تولید",
    showReqDetails: "مشاهده جزئیات درخواست",
    addProductionPlan: "تعیین فرآیندهای تولید",
    addCasting: "ثبت ریخته‌گری",
    calculateMaterial: "محاسبه مواد مصرفی",
    addMaterial: "ثبت مواد مصرفی",
    search: "جستجو",
    confirmQC: "تایید کنترل کیفی و صدور شناسنامه",
    disconfirmQC: "عدم تایید کنترل کیفی و ریخته‌گری مجدد",
    disconfirm: "عدم تایید",
    removeFilter: "حذف فیلتر",
    clearChanges: "پاک‌کردن تغییرات",
    manageFinancialYears: "مدیریت سال‌های مالی",
    rolePermissions: "دسترسی‌های نقش",
    addWareCategory: "ثبت دسته بندی انبار",
    display: "نمایش",
    addPermission: "اعمال دسترسی‌ها",
    delPermission: "حذف دسترسی‌ها",
    addParentSbu: "ثبت واحد اصلی",
    addParentPosition: "ثبت سِمت اصلی",
    addChildSbu: "ثبت واحد",
    next: "بعدی",
    pre: "قبلی",
    last: "آخرین",
    first: "اولین",
    addWareVoucherType: "ثبت نوع سند انبار",
    addSomeWareReceipt: "صدور رسید مقداری",
    addFloatAccount: "ثبت حساب شناور",
    addCommoditiesToWares: "تعیین انبارهای کالاها به صورت گروهی",
    barcodePrint: "چاپ بارکد",
    closeAll: "بستن همه",
    openAll: "بازکردن همه",
    addChildPosition: "ثبت سِمت ",
    addChildCategory: "درج فرزند",
    addSubGroup: "درج زیرگروه",
    addChildHeader: "ثبت سرفصل فرزند ",
    addParentHeader: "ثبت سرفصل حساب پدر (اصلی)",
    commodityGroupEdit: "تغییر گروهی کالا",
    personnelGroupEdit: "تغییر گروهی پرسنل",
    addAccountConfig: "ثبت تنظیمات کد حساب",
    listManagement: "مدیریت لیست",
    roleDetails: "جزئیات نقش‌ها",
    submitPerson: "درج شخص",
    submitMembersGroup: "درج افراد گروه",
    submitAccount: "درج حساب",
    submitWares: "درج انبارها",
    submitPermissions: "درج دسترسی‌ها",
    submitBusinessInfo: "ثبت اطلاعات بازرگانی",
    addParameter: "ثبت پارامتر",
    addBuyRequest: "ثبت درخواست خرید",
    addTempReceipt: "صدور رسید موقت",
    commodityBatch: "لیست بج های کالا",
    addFinancialReceipt: "صدور رسید مالی",
    closeSession: "خروج از سشن",
    lastLoginTime: "آخرین ورود من",
    showMyActiveLoginTimes: "مشاهده نشست های فعال من",
    displayTree: "نمایش درختی",
    displayTable: "نمایش جدول",
    displayCard: "نمایش کارتی",
    displayChart: "نمایش نموداری",
    importExcel: "ورود اطلاعات از اکسل",
    importExcelReceiveCash: "ورود از اکسل دریافت نقد",
    importExcelPaymentCash: "ورود از اکسل پرداخت نقد",
    importExcelReceivePaymentCash: "ورود از اکسل دریافت و پرداخت نقد تجمیعی",
    addSimilarControls: "اعمال کنترل های مشابه",
    addDraftRequest: "ثبت درخواست حواله جدید",
    addFinancialDraft: "صدور حواله مالی",
    addSomeWareDraft: "صدور حواله مقداری",
    saveAndNew: "ذخیره و ثبت جدید",
    receiptCommodity: "لیست کالاهای رسید",
    delGroup: "حذف گروهی",
    referGroup: "ارجاع گروهی",
    selectForRefer: "انتخاب برای ارجاع گروهی",
    clearSelection: "لغو انتخاب",
    newForm: "فرم جدید",
    addReceipt: "صدور رسید",
    addDraft: "صدور حواله",
    draftCommodity: "لیست کالاهای حواله",
    requestCommodity: "لیست کالاهای درخواست",
    confirmGroup: "بله، فعال شوند",
    disConfirmGroup: " بله، غیرفعال شوند",
    changeStatus: "تغییر وضعیت",
    confirmswitch: "بله، تغییر کند",
    confirmDo: "بله، انجام شود",
    addBuyer: "ثبت مأمور خرید",
    addSupplier: "ثبت تامین‌کننده",
    manageFields: "مدیریت فیلدها",
    actions: "عملیات",
    sortingByCode: " مرتب سازی شماره (براساس کدانبار)",
    sortingBySerial: "مرتب‌سازی براساس سریال ",
    confirmation: "قطعی",
    disconfirmation: "غیرقطعی",
    addVehicleType: "ثبت  نوع وسیله نقیله",
    addInstantTransfer: "ثبت انتقال بین انبار آنی",
    addProccessTransfer: "ثبت انتقال بین انبار فرآیندی",
    commodityList: "لیست کالاها",
    addVoucher: "صدور سند",
    addVoucherGroup: "صدور سند گروهی",
    deleteVoucherGroup: "حذف گروهی اسناد",
    addAccountingVoucher: "صدور سند حسابداری",
    deleteAccountingVoucher: "حذف سند حسابداری",
    issueBuyFactor: "صدور فاکتور خرید",
    deleteBuyFactor: "حذف فاکتور خرید",
    issueReturnSaleFactor: "صدور فاکتور مرجوعی فروش",
    deleteReturnSaleFactor: "حذف فاکتور مرجوعی فروش",
    issueSaleFactor: "صدور فاکتور فروش",
    deleteSaleFactor: "حذف فاکتور فروش",
    issueReturnBuyFactor: "صدور فاکتور مرجوعی خرید",
    deleteReturnBuyFactor: "حذف فاکتور مرجوعی خرید",
    exit: "خروج",
    addSourceCommodity: "ثبت کالای مبدا",
    addDestinationCommodity: "ثبت کالای مقصد",
    editSourceCommodity: "ویرایش کالای مبدا",
    editDestinationCommodity: "ویرایش کالای مقصد",
    importInfo: "ورود اطلاعات",
    addWarehousing: "ثبت انبارگردانی",
    excelExport: "خروجی اکسل",
    addImage: "ثبت تصویر",
    addnNewImage: "ثبت تصویر جدید",
    downloadImage: "بارگیری تصویر",
    closePermissionPanel: "بستن پنل دسترسی",
    closeBranchPanel: "بستن پنل شعبه‌ها",
    submitContact: "درج رابط",
    addCampaignType: "ثبت نوع کمپین",
    addFeedBackType: "ثبت نوع نظرسنجی",
    addDeliveryMethod: "ثبت روش تحویل",
    addPaymentMethod: "ثبت روش پرداخت",
    addBlackList: "ثبت شخص در لیست سیاه",
    addSaleManagerDiscountLimit: "ثبت سطح تخفیف مجاز",
    addSaleManagerCredit: "ثبت اعتبار مسئول فروش",
    addSaleOrder: "ثبت سفارش",
    cancelSaleOrder: "انصراف سفارش",
    undoCancelSaleOrder: "برگرداندن انصراف",
    viewSaleOrder: "مشاهده سفارش",
    addDiscountCodes: "ثبت کد تخفیف",
    zoomImage: "بزرگنمایی",
    fastPrint: "چاپ فوری",
    addNewDesign: "ثبت طرح جدید",
    addCampaign: "ثبت کمپین",
    addPersonClub: "ثبت مشتری",
    addRegion: "ثبت محله",
    addPersonClubGroup: "ثبت گروه مشتری",
    addIntroducedType: "ثبت نحوه آشنایی",
    addSalesChannel: "ثبت کانال فروش",
    showAddress: "مشاهده آدرس ها",
    addAutoProcess: "ثبت روند خودکار",
    addFeedBackQuestion: "معرفی سوال نظرسنجی",
    closeQuestionsPanel: "بستن پنل سوالات",
    addNewFeedBackQuestion: "ثبت سوال جدید",
    submitQuestion: "ثبت سوال",
    addAnswer: "ثبت پاسخ",
    addNewFeedBackAnswer: "ثبت پاسخ",
    answerList: "پاسخ‌ها",
    expireDate: "تاریخ انقضا",
    feedbackTypeTitle: "نوع نظرسنجی",
    addStatus: "ثبت وضعیت",
    addFeedBackQuestionOption: "ثبت پارامتر اضافی نظرسنجی",
    addCommodityBatch: "ثبت سری ساخت‌",
    addNewPersonClub: "ثبت مشتری جدید",
    validatDiscountCode: "اعتبارسنجی کد تخفیف",
    validatCreditCode: "اعتبارسنجی کد اعتبار",
    addOption: "افزودن گزینه",
    nonEditable: "غیرقابل ویرایش",
    addFinancialRatio: "افزودن نسبت مالی",
    addScore: "ثبت امتیاز",
    addCredit: "ثبت اعتبار",
    increaseDecreaseScore: "افزایش/ کاهش امتیاز",
    increaseDecreaseCredit: "افزایش/ کاهش اعتبار",
    customerPurchaseHistory: "سابقه خرید مشتری",
    new: "جدید",
    attachment: "پیوست",
    deleteVoucher: "حذف سند",
    copyReceipt: "کپی رسید",
    copyDraft: "کپی حواله",
    copyOrder: "کپی سفارش",
    copyDraftFromReceipt: "کپی از رسید",
    copyReceiptFromDraft: "کپی از حواله",
    newItem: "برگه جدید",
    readBuyRequest: "بازخوانی از درخواست خرید",
    introWareVoucherType: "معرفی انواع سند انبار",
    introAdditionalParameter: "معرفی پارامترهای تکمیلی",
    introFloatAccount: "معرفی حساب‌های شناور",
    update: "بروز رسانی",
    advancedSearch: "جستجو پیشرفته",
    normal: "عادی",
    notification: "اطلاع رسانی",
    sendSms: "ارسال پیام",
    sendGroupSms: "ارسال گروهی پیامک",
    confirmSendSms: "بله، ارسال شود",
    smsHistory: "تاریخچه پیامک",
    addCustomerCredit: "افزایش اعتبار مشتری",
    decreaseCustomerCredit: "کسر اعتبار مشتری",
    creditCancellation: "ابطال اعتبار",
    addCurrencyType: "ثبت ارز",
    addCurrencyRate: "ثبت نرخ ارز",
    addPersonCredit: "تعیین اعتبار شخص",
    endSearch: "اتمام جستجو",
    downloadAttach: "بارگیری پیوست",
    addChequeStatus: "ثبت وضعیت چک",
    addIssueTrackingType: "نوع دریافت و پرداخت جدید",
    addAccountVoucher: "ثبت سند حسابداری",
    addBank: "ثبت بانک",
    branchesBanch: "شعبه‌های بانک",
    submitChequePaper: "ذخیره و ثبت برگه‌های چک",
    addChequePaper: "ایجاد برگه‌های چک",
    addPaper: "بله، ایجاد شود",
    addPaperManually: "خیر، ایجاد دستی",
    addReceiveCash: "ثبت دریافت نقد",
    addPaymentCash: "ثبت پرداخت نقد",
    addReceiveCashGroup: "ثبت دریافت  نقد گروهی",
    addPaymentCashGroup: "ثبت پرداخت  نقد گروهی",
    addPaymentRequest: "ثبت درخواست پرداخت",
    saveAndaddVoucher: "ثبت و صدور سند",
    saveChangesAndVoucher: "ذخیره تغییرات و صدور سند",
    note: "یاداشت ها",
    addNew: "ثبت جدید",
    voucherSort: "مرتب سازی",
    voucherOperation: "عملیات اسناد",
    sortVouchers: "مرتب سازی اسناد",
    voucherList: "جزئیات سند",
    addReceiveCheque: "ثبت سند دریافتنی",
    addBankTransfer: "ثبت واگذاری به بانک",
    addAssignmentPerson: "ثبت واگذاری به اشخاص",
    addCancellationReceivable: "ثبت ابطال اسناد دریافتنی",
    addReturnGuarantee: "ثبت استرداد اسناد ضمانتی",
    addReturnReceivables: "ثبت استرداد اسناد دریافتنی",
    addReturnAssignment: "ثبت استرداد اسناد واگذاری",
    addReturnTransferred: "ثبت برگشت اسناد واگذار شده",
    addSettlement: "ثبت وصول اسناد",
    copyKey: "کپی کلید",
    addKey: "ساخت کلید اتصال",
    isConfirm: "قطعی کردن",
    unConfirm: "غیرقطعی کردن",
    addTaxTable: "افزودن جدول مالیاتی",
    addDegree: "افزودن مدرک تحصیلی",
    addDepartment: "افزودن دپارتمان",
    addEmploymentType: "افزودن نوع استخدام",
    addInsuranceType: "افزودن نوع بیمه",
    addNationalityType: "افزودن نوع تابعیت",
    addOccupationCategory: "افزودن رسته شغلی",
    addStudyFieldType: "افزودن رشته تحصیلی",
    addWorkPlaceStatus: "افزودن وضعیت محل خدمت",
    nextStep: "مرحله بعد",
    preStep: "مرحله قبل",
    deleteVouchers: "حذف اسناد",
    addExemptionType: "افزودن نوع معافیت",
    archiveVouchers: "بایگانی اسناد",
    archiveUnArchiveVouchers: "بایگانی اسناد/ لغو بایگانی",
    unArchiveVouchers: "لغو بایگانی",
    archived: "بایگانی کردن",
    feedBackDetails: "جزئیات نظرسنجی",
    chequeTurn: "گردش اسناد",
    addDebtorOrCreditorDeclaration: "ثبت اعلامیه بدهکار و بستانکار",
    feedbackLink: "لینک نظرسنجی",
    pieChart: "نمودار دایره‌ای",
    serialMile: "نمودار میله‌ای",
    lineChart: "نمودار خطی",
    addPaymentCheque: "ثبت پرداخت چک",
    confirmVoucher: "قطعی کردن اسناد",
    addPaymentChequeGroup: "ثبت پرداخت چک گروهی",
    addPassPayDocs: "ثبت وصول اسناد",
    addPackageType: "ثبت بسته بندی",
    formula: "فرمول محاسبه",
    feedbackHistories: "سوابق نظرسنجی",
    purchaseHistories: "سوابق خرید",
    orderDetail: "جزئیات سفارش",
    answerSheetLink: "لینک پاسخنامه",
    excelStructure: "ساختار فایل اکسل",
    returnToSampleTable: "بازگشت به جدول نمونه ها",
    addSmaple: "ثبت نمونه",
    detail: "جزئیات",
    excelFile: "فایل اکسل",
    excelDetail: "جزئیات از طریق اکسل",
    addProduceOrder: "ثبت دستور تولید",
    addSprint: "ثبت هفته کاری",
    addCoilCertificate: "ثبت شناسنامه کویل",
    saltCalculation: "راس گیری",
    nextAccount: "حساب بعدی",
    preAccount: "حساب قبلی",
    finalSubmit: "ثبت نهایی",
    addColdRolling: "ثبت نورد سرد",
    addFoilRolling: "ثبت نورد فویل",
    productionOrderList: "لیست دستورات تولید",
    themeConfigurator: "حالت روز/شب",
    addInspectionLevel: "ایجاد سطح بازرسی جدید",
    productionGroup: "گروه‌های تولیدی",
    addPersonGroups: "ثبت گروه اشخاص",
    buyRequest: "درخواست خرید",
    productionFeasibility: "امکان سنجی تولید",
    reservation: "رزرو",
    addReservation: "ثبت رزرو",
    orderDataSheet: "دیتاشیت سفارشات",
    addFeature: "ثبت ویژگی",
    calculation: "محاسبه",
    addDealType: "افزودن نوع معامله",
    editDealType: "ویرایش نوع معامله",
    backToAdd: "بازگشت به ثبت",
    action: "عملیات",
    addLading: "ثبت بارنامه",
    addCottage: "ثبت کوتاژ",
    addParakOrder: "افزودن سفارش (عرضه)",
    addSalesAgent: "افزودن نماینده فروش",
    addSaleManager: "افزودن مسئول فروش",
    assignLeadToSalesManager: "تخصیص به مسئول فروش",
    addDetail: "ثبت جزئیات",
    returnToAdd: "بازگشت به ثبت",
    addGroupPolicy: "درج گروهی سیاست",
    addAdditionsAndDeductions: "ثبت اضافات و کسورات",
    addDiscountPolicy: "ثبت سیاست تخفیف",
    addGiftsPolicy: "ثبت سیاست هدایا",
    showDetails: "مشاهده جزئیات",
    addService: "ثبت خدمات",
    addPreFactor: "ثبت پیش فاکتور",
    addAddMinus: "ثبت اضافات و کسورات",
    showHeader: "نمایش هدر",
    hideHeader: "مخفی کردن هدر",
    addSaleFactor: "ثبت فاکتور فروش",
    saleFactorSortCode: "مرتب سازی شماره‌های فاکتور فروش",
    addSalePricePolicy: "ثبت سیاست قیمت گذاری",
    addReceiveAndPay: "ثبت موضوع دریافت و پرداخت",
    addNoteType: "ثبت یادداشت",
    addAttachment: "ثبت پیوست",
    addBuyType: "ثبت نوع فاکتور خرید",
    addBuyFactor: "ثبت فاکتور خرید",
    newFactor: "فاکتور جدید",
    notes: "یادداشت‌ها",
    addNote: "افزودن یادداشت",
    newNote: "یادداشت جدید",
    show: "نمایش",
    hide: "مخفی کردن",
    addReturnSaleFactor: "ثبت فاکتور مرجوعی فروش",
    returnSaleFactorSortCode: "مرتب سازی شماره‌های فاکتور مرجوعی فروش",
    buyFactorSortCode: "مرتب سازی شماره‌های فاکتور خرید",
    returnBuyFactorSortCode: "مرتب سازی شماره‌های فاکتور مرجوعی خرید",
    returnFactor: "مرجوع کردن فاکتور",
    checkCondition: "برسی شرط ها",
    downloadSmapleDetail: "دانلود فایل نمونه",
    setDefaultCurrency: "تنظیم ارز عملیاتی",
    addCommission: "ثبت ذی نفع",
    sortDocument: "مرتب سازی اسناد",
    rejectDocument: "عدم تایید اسناد",
    finalizationDocument: "قطعی سازی اسناد",
    nonFinalizationDocunemt: "غیر قطعی کردن اسناد",
    closeTemporaryAccounts: "بستن حساب‌های موقت",
    delTemporaryDocAccounts: "حذف سند حساب‌های موقت",
    closePermanentAccount: "بستن حساب‌های دائم",
    delFinalDocument: "حذف سند اختتامیه",
    addReceiptReceived: "ثبت رسید دریافت",
    addPaymentPaper: "ثبت اعلامیه پرداخت",
    attachments: "پیوست‌ها",
    downlaodAttachment: "دانلود پیوست",
    appearanceSetting: "تنظیمات ظاهری",
    returnToBackLevel: "برگشت به سطح قبل",
    approveOrder: "تایید سفارش",
    rejectOrder: "رد سفارش",
    resetPassword: "بازیابی رمز عبور",
    statusLogs: "تاریخچه وضعیت",
    addDeliveryTime: "تعیین زمان تحویل",
    cancelConfirmation: "لغو قطعی سازی",
    definitiveness: "قطعی سازی",
    issuanceClosingVoucher: "صدور سند اختتامیه",
    issuanceOpeningVoucher: "صدور سند افتتاحیه",
    transferInformation: "انتقال اطلاعات",
    columnsManagement: "مدیریت ستون‌ها",
    addBetweenRow: "افزودن ردیف در بین ردیف‌ها",
    addVoucherInventory: "صدور سند موجودی اولیه",
    parsinaSupport: "پشتیبانی پارسینا",
    onlineParsinaSupport: "گفتگوی آنلاین با پشتیبانی",
    exportPaymentPaper: "صدور برگه پرداخت",
    exportReceiptPaper: "صدور برگه دریافت",
    commodityGroupConfig: "تنظیمات گروه کالا",
    addCommodityGroupConfig: "ثبت تنظیمات گروه کالا",
    addGoalUser: "ثبت کاربر هدف",
    addGoalSchedule: "ثبت زمان‌بندی هدف",
    addGoal: "ثبت هدف",
    addRow: "افزودن ردیف",
    editRow: "ویرایش ردیف",
    goalUser: "کاربران هدف",
    goalSchedule: "زمان‌بندی هدف",
    addCompany: "ثبت شرکت",
    log: "تاریخچه",
    addSaleType: "ثبت نوع فروش",
    addHardness: "ثبت سختی",
    addProductSurface: "ثبت سطح محصول",
    addUsageGroup: "ثبت گروه کاربردی",
    addFoilUsage: "ثبت کاربرد فویل",
    addInnerCoreDiameter: "ثبت قطر داخلی کور",
    addCastingProduceOrder: "صدور دستور تولید ریخته‌گری",
    addColdRollingProduceOrder: "صدور دستور تولید نورد سرد",
    addFoilRollingProduceOrder: "صدور دستور تولید نورد فویل",
    accountControl: "کنترل حساب",
    addLeadType: "ثبت نوع سرنخ (لید)",
    addLeadProperty: "ثبت ویژگی سرنخ (لید)",
    addProductionReport: "ثبت گزارش تولید",
    addCashAccount: "ثبت صندوق",
    addBankAccount: "ثبت حساب بانکی",
    addLeadSource: "ثبت منبع سرنخ (لید)",
    addLeadEvaluationQuestion: "ثبت سوال ارزیابی سرنخ",
    addSaleTeam: "ثبت تیم فروش",
    addSaleRegion: "ثبت منطقه فروش",
    addLead: "ثبت سرنخ (لید)",
    addChance: "ثبت فرصت",
    addChancePriority: "ثبت اولویت فرصت",
    addFailedSaleReason: "ثبت دلیل فروش ناموفق",
    addCompetitor: "ثبت رقیب",
    addStrengthWeakness: "ثبت نقاط ضعف و قوت",
    addFurnace: "ثبت کوره",
    furnacePlacement: "جانمایی‌های کوره",
    addProjectType: "ثبت نوع پروژه",
    addProject: "ثبت پروژه",
    addWorkDescription: "ثبت شرح کار",
    addProjectTeam: "ثبت تیم پروژه",
    addGeneralEstimate: "ثبت برآورد عمومی",
    addTask: "ثبت فعالیت و وظیفه جدید",
    editTask: "ویرایش فعالیت و وظیفه",
    addTeam: "ثبت مدعو جدید تیم ",
    addCategory: "ثبت دسته بندی جدید",
    addMessage: "ثبت پیام جدید",
    addCall: "ثبت تماس جدید",
    addNoteSubject: "ثبت موضوع یادداشت",
    addCallCategory: "ثبت دسته بندی تماس",
    addCallSubject: "ثبت موضوع تماس",
    addServiceSupportSubject: "ثبت موضوع پشتیبانی",
    addRequestType: "ثبت نوع درخواست",
    addRequest: "ثبت درخواست",
    copyRow: "کپی ردیف",
    copyVoucher: "کپی سند",
    addLeadAddress: "ثبت آدرس سرنخ (لید)",
    addLeadContact: "ثبت مخاطبین سرنخ (لید)",
    addMeeting: "ثبت صورت‌جلسه",
    addMeetingGuest: "ثبت مدعو",
    addMeetingApproval: "ثبت مصوبه",
    hideFilters: "مخفی کردن فیلتر",
    showFilters: "نمایش فیلتر",
    addReciveChequeGroup: "ثبت دریافت چک گروهی",
    backToList: "بازگشت به لیست",
    addWorkingHour: "ثبت ساعت استاندارد کارکرد",
    downloadSmapleExcel: "دانلود فایل اکسل",
    downloadExcelWithData: "دانلود فایل اکسل با اطلاعات",
    addAddMinusFromBase: "درج اضافات و کسورات به فاکتور از اطلاعات پایه",
    submitInfoAndPrint: "ثبت اطلاعات و چاپ",
    addAgreementRow: "افزودن ردیف پیمان",
    addJobGroup: "افزودن گروه های شغلی",
    addContractType: "افزودن نوع حکم کارگزینی",
    addInterbankTransfer: "ثبت انتقال بین بانکی",
    addContractSample: "افزودن نمونه حکم کارگزینی",
    addContractDetail: "ثبت مزایا و کسورات",
    addContract: "صدور حکم کارگزینی",
    addLeave: "ثبت مرخصی",
    addMission: "ثبت ماموریت",
    addAdvance: "ثبت مساعده",
    addGroupAdvance: "ثبت گروهی مساعده",
    confirmOperation: "عملیات تایید",
    sendToConfirm: "ارسال جهت تأیید",
    confirmLeave: "تأیید مرخصی",
    rejectLeave: "رد مرخصی",
    copy: "کپی",
    copyColor: "کپی رنگ",
    pasteColor: "چسباندن رنگ",
    addServiceCenter: "ثبت مرکز خدمت",
    swapPrice: "جابه‌جایی مبالغ",
    addFormula: "ثبت فرمول",
    confirmAndSubmitInfo: "تایید و ثبت اطلاعات",
    editSalaryList: "بروزرسانی لیست حقوق",
    editSalaryList2: "بروزرسانی حقوق با حکم",
    copyContractForDiffrentPeople: "کپی حکم برای اشخاص مختلف",
    copyContractWithSpecifiedTime: "کپی حکم در بازه زمانی مشخص",
    submitAndShow: "ثبت و مشاهده",
    errorControlList: "لیست کنترل خطا",
    editGroupContract: "ویرایش گروهی حکم کارگزینی ",
    workCalendar: "تقویم کاری",
    addPayrollEmployeeVoucher: "صدور سند حقوق",
    delPayrollEmployeeVoucher: "حذف سند حقوق",
    addPayrollEmployeePaymentCash: "صدور سند پرداخت حقوق",
    delPayrollEmployeePaymentCash: "حذف سند پرداخت حقوق",
    addDirectVoucher: "صدور سند مستقیم",
    delDirectVoucher: "حذف سند مستقیم",
    confirmPayrollEmployeeRows: "قطعی‌کردن سطرهای حقوق",
    disconfirmPayrollEmployeeRows: "غیرقطعی‌کردن سطرهای حقوق",
    costs: "هزینه ها",
    getInsuranceFile: "تهیه فایل بیمه",
    addInInsuranceList: "درج در لیست بیمه",
    addInsuranceEmployee: "ثبت بیمه",
    addTaxEmployee: "ثبت مالیات",
    addInTaxList: "درج در لیست مالیات",
    getTaxFile: "تهیه و دریافت فایل مالیاتی",
    addRelationField: "ثبت رابطه جدید",
    discoverRelation: "کشف خودکار روابط",
    initializeRelation: "ثبت خودکار همه روابط",
    editDeleteBehavior: "ویرایش رفتار حذف",
    clearForm: "پاک‌سازی فرم",
    process: "پردازش",
    observation: "مشاهده",
    cancelProcess: "لغو پردازش",
    canceling: "در حال لغو...",

    startImport: "شروع بازیابی",
    startRealImport: "اجرای واقعی",
    newImport: "بازیابی جدید",
    downloadFullBackup: "دانلود بکاپ همه‌ی دیتابیس‌ها",
    getBackupScript: "گرفتن اسکریپت",
    showErrorDetails: "نمایش جزئیات خطا",
    hideErrorDetails: "بستن جزئیات خطا",
    winBackupStart: "شروع انتقال",
    winBackupCancel: "لغو ایمپورت",
    winBackupCanceling: "در حال لغو...",
    winBackupDeleteBranches: "حذف شعبه‌های ساخته‌شده",
    winBackupAddBranch: "افزودن شعبه",
    winBackupGoReal: "اجرای واقعی",
    winBackupCopyError: "کپی متن خطا",
    winBackupShowTables: "نمایش جدول‌ها",
    winBackupHideTables: "بستن جدول‌ها",
    winBackupConfirm: "تأیید",
    bankExportHistory: "تاریخچه صدور",
    cloneTemplate: "کپی قالب",
    addFirstRow: "افزودن سطر اول",
    addLastRow: "افزودن سطر آخر",
    addEmployeeRow: "افزودن گروه سطر پرسنل",
    removeRecord: "حذف این سطر",
    addField: "افزودن فیلد",
    duplicateField: "تکثیر فیلد",
    deleteField: "حذف فیلد",
    advancedEditor: "ویرایشگر پیشرفته",
    insertToken: "افزودن توکن",
    addText: "افزودن متن",
    insertVariable: "درج متغیر",
    addRecordType: "افزودن رکورد",
    moveUp: "انتقال به بالا",
    moveDown: "انتقال به پایین",
    preview: "پیش‌نمایش",
    exportFile: "صدور فایل",
    testExport: "صدور آزمایشی",
    deactivateTemplate: "غیرفعال کردن قالب",
    addMapping: "ثبت نگاشت جدید",
    editMapping: "ویرایش نگاشت",
    retry: "تلاش مجدد",
    merge: "ادغام",
    showRawMaterials: "مشاهده مواد اولیه",
    showKeyboardHelp: "نمایش راهنمای کیبورد",
    closeKeyboardHelp: "بستن راهنمای کیبورد",
    savedDescription: "ذخیره توضیحات",
    newSalesPipeline: "خط فروش جدید",
    sorting: "مرتب‌سازی",
    newStage: "مرحله",
    addTemplateActivity: "افزودن فعالیت قالب",
    addActivityTemplate: "افزودن الگوی فعالیت",
    saveActivityTemplate: "ثبت الگو",
    editStageRules: "ویرایش قواعد",
    newActivity: "فعالیت جدید",
    calendarView: "نمای تقویم",
    noAnswer: "پاسخ نداد",
    callAgain: "تماس مجدد",
    negotiationDone: "مذاکره انجام شد",
    newChance: "فرصت جدید",
    kanbanView: "کانبان",
    listView: "فهرست",
    chanceAddActivity: "ثبت فعالیت",
    chanceAddMeeting: "ثبت جلسه",
    chanceAddCall: "ثبت تماس",
    chanceRegister: "ثبت",
    chanceIssue: "صدور",
    chanceIssuePreFactor: "صدور پیش فاکتور",
    chanceIssueOrder: "صدور سفارش",
    chanceIssueFactor: "صدور فاکتور",
    chanceIssueContract: "صدور قرارداد",
    moreActions: "عملیات بیشتر",
    newLead: "سرنخ جدید",
    submitAndContinue: "ثبت و ادامه",
    newCampaign: "کمپین جدید",
    addSignatureTitles: "تعریف عناوین امضا",
    evaluate: "ارزیابی",
    submitEvaluation: "ثبت ارزیابی",
    newQuestion: "سوال جدید",
    addServiceSupport: "ثبت پشتیبانی و سرویس",
    newHamyarContract: "قرارداد جدید",
    newFeedBack: "نظرسنجی جدید",
    feedBackQuestions: "سوالات",
    activateFeedBack: "فعال کردن",
    deactivateFeedBack: "غیرفعال کردن",
    getList: "دریافت لیست",
    sendToTaxSystem: "ارسال به سامانه مودیان",
    taxInquiry: "استعلام",
    taxImportExcel: "بارگذاری و ارسال به سامانه مودیان",
    downloadTaxExcelTemplate: "دانلود فایل نمونه",
    showExcelInvoices: "مشاهده در صورتحساب‌ها",
    downloadTaxExcelErrors: "دریافت خطاها",
    taxSetting: "تنظیمات سامانه مودیان",
    uploadTaxCertificate: "آپلود گواهی امضا",
    moreFilters: "فیلترهای بیشتر",
    showTaxInvoices: "صورتحساب‌های این فاکتور",
    createTaxKey: "ساخت کلید",
    showTaxKeys: "کلیدها",
    download: "دانلود",
    addSettlementType: "ثبت نوع تسویه",
    orderSettlement: "تسویه",
    generateSettlement: "درج اقساط و تسویه",
    finalizeSettlement: "ثبت نهایی تسویه",
    deleteOrderSettlement: "حذف تسویه",
    sendThanksSms: "ارسال پیامک قدردانی",
    issueVoucher: "صدور سند",
    view: "مشاهده",
    markComplete: "تکمیل",
    markIncomplete: "برداشتن تکمیل",
    referTask: "ارجاع",
    startTimer: "شروع فعالیت",
    stopTimer: "توقف فعالیت",
    minimize: "کوچک کردن",
    submitReferral: "ثبت ارجاع",
    lessFilters: "فیلترهای کمتر",
    addCommissionStep: "افزودن پله",
    issuePermit: "صدور مجوز",
    issueDraft: "صدور حواله",
    organizationChart: "چارت سازمانی",
  },
  table: {
    booth: "غرفه",
    cancelReason: "دلیل انصراف",
    store: "فروشگاه",
    workTime: "ساعت کاری",
    username: "نام کاربری",
    storeSupervisor: "سرپرست فروشگاه",
    boothSupervisor: "سرپرست فروش",
    defaultPerson: "شخص طرف حساب",
    isAllCommodityGroup: "همه گروه‌های کالا",
    storeUsersCount: "تعداد کاربران",
    posTerminalType: "نوع دستگاه",
    connectionType: "نوع اتصال",
    port: "پورت",
    deviceModel: "مدل",
    terminalNumber: "شماره ترمینال",
    merchantId: "شماره پذیرنده",
    benefitCardUId: "شناسه کارت",
    benefitCardNumber: "شماره کارت",
    benefitCardExpireDate: "تاریخ اعتبار",
    benefitCardIssueDate: "تاریخ صدور",
    benefitCardIsBlock: "مسدود",
    benefitCardIsLocked: "قفل شده",
    benefitCardIsPinRequired: "رمز خرید",
    benefitCardOwner: "دارنده",
    benefitCardOwnerMobile: "موبایل دارنده",
    benefitCardType: "نوع",
    benefitCardBalance: "مانده",
    benefitCardInitialBalance: "اعتبار اولیه",
    benefitCardTransactionType: "نوع گردش",
    benefitCardDebt: "بدهکار",
    benefitCardCredit: "بستانکار",
    benefitCardCreated: "زمان ثبت",
    preOrderConverted: "تبدیل به فاکتور",
    preOrderStatus: "وضعیت",
    subUnitCount: "تعداد فرعی",
    directCommissionPercentage: "درصد مستقیم از فروش",
    subGroupCommissionPercentage: "درصد از فعالیت زیرمجموعه",
    warehousingNo: "شماره انبارگردانی",
    attachmentKind: "نوع پیوست",
    attachmentCount: "تعداد پیوست",
    hasAttachment: "پیوست",
    baseDate: "تاریخ مبنا",
    distanceDay: "فاصله (روز)",
    timeWeight: "وزن زمانی",
    debtMinusCredit: "بدهکار - بستانکار",
    row: "ردیف",
    actions: "عملیات",
    title: "عنوان",
    qty: "تعداد",
    grouping: "گروه بندی",
    category: "دسته بندی",
    subject: "موضوع",
    status: "وضعیت",
    firstName: "نام",
    lastName: "نام خانوادگی",
    name: "نام و نام خانوادگی",
    userName: "نام کاربری",
    userFullName: "نام کاربر",
    fullName: "نام کامل",
    brandName: "نام تجاری",
    role: "نقش کاربر",
    active: "فعال",
    inActive: "غیرفعال",
    id: "شناسه",
    workStation: "ایستگاه کاری",
    usage: "کاربرد",
    description: "توضیحات",
    isActive: "فعال",
    isUsed: "استفاده شده",
    healthy: "سالم",
    broken: "خراب",
    code: "شماره",
    sheetNumber: "شماره برگه",
    codeB: "کد", // code in base information
    creator: "کاربر ثبت",
    created: "زمان ثبت",
    editUser: "کاربر ویرایش",
    editDate: "زمان ویرایش",
    product: "محصول",
    material: "ماده اولیه",
    unit: "واحد",
    unitCount: "واحد شمارش",
    main: "اصلی",
    sub: "فرعی",
    count: "مقدار",
    mainBranch: "شاخه اصلی",
    taxId: "شناسه مالیاتی",
    ip: "Ip",
    link: "لینک",
    referralLink: "لینک ارجاع",
    browser: "مرورگر",
    os: "سیستم عامل",
    creepy: "خزنده؟",
    time: "زمان",
    userId: "شناسه کاربر",
    orderNo: "شماره سفارش",
    date: "تاریخ",
    customer: "مشتری",
    totalPrice: "مبلغ کل",
    tax: "ارزش افزوده",
    lastPrice: "مبلغ قابل پرداخت",
    commodity: "کالا",
    commodityTitle: "نام کالا",
    commodityCode: "کد کالا",
    nationalCommodityCode: "کدملی کالا",
    commodityBarcode: "بارکد کالا",
    commodityNationalCode: "شناسه ملی کالا",
    taxPercent: "درصد ارزش افزوده",
    taxPercent2: "درصد مالیات",
    offPercent: "درصد تخفیف",
    taxPrice: "مبلغ ارزش افزوده",
    deliveryDate: "تاریخ تحویل",
    productionDeliveryDate: "تاریخ تحویل تولید",
    discountPercentage: "درصد تخفیف",
    discountPrice: "مبلغ تخفیف",
    discountValue: "مقدار تخفیف",
    discountPricePercent: "مبلغ/درصد تخفیف",
    creditValue: "مقدار اعتبار",
    thickness: "ضخامت",
    alloy: "آلیاژ",
    hardness: "سختی",
    width: "عرض",
    internalDiameterCore: "قطر کور داخلی",
    minRollWeight: "حداقل وزن رول",
    maxRollWeight: " حداکثر وزن رول",
    weight: "وزن",
    importanceFactor: "ضریب اهمیت",
    weightCapacity: "وزن قابل حمل",
    volumeCapacity: "حجم قابل بارگیری",
    usefulLength: "طول مفید",
    usefulWidth: "عرض مفید",
    usefulHeight: "ارتفاع مفید",
    vehicleTitle: "عنوان وسیله نقلیه",
    to: "جهت شماره دستور تولید",
    for: "بابت",
    company: "شرکت",
    employer: "کارفرما",
    economicCode: "کد اقتصادی",
    nationalId: "شناسه ملی",
    registerNo: "شماره ثبت",
    registerPlace: "محل ثبت",
    taxArea: "حوزه مالیاتی",
    taxBranchCode: "کدشعبه مالیاتی",
    isMainBranch: "شعبه اصلی",
    actionField: "زمینه فعالیت",
    registerDate: "تاریخ ثبت",
    branch: "شعبه",
    bankBranch: "شعبه بانک",
    financialYear: "سال مالی",
    branchAndfinancialYear: "شعبه و سال مالی",
    startDate: "تاریخ شروع",
    endDate: "تاریخ پایان",
    branchTitle: "نام شعبه",
    tel: "شماره تماس",
    address: "آدرس",
    zipCode: "کد پستی",
    email: "پست الکترونیک",
    commodityCategory: "گروه کالا",
    commodityFullName: "نام کامل کالا",
    technicalId: "شناسه فنی",
    orderPoint: "نقطه سفارش",
    minInventory: "حداقل موجودی",
    maxInventory: "حداکثر موجودی",
    commodityInventory: "موجودی کالا",
    waresInventory: "موجودی کل انبارها",
    remain: "مانده",
    creditReferenceType: "منشا / محل مصرف",
    creditTransactionType: "نوع تراکنش",
    averageConsumptionPeriod: "بازه متوسط مصرف",
    timeToGetGoods: " زمان تحصیل کالا",
    maxNegativeInventory: "سقف موجودی منفی",
    commodityTaxId: "شناسه مالیاتی",
    commodityTaxTitle: "عنوان مالیاتی",
    discountPercent: "درصد تخفیف",
    height: "ارتفاع",
    length: "طول",
    volume: "حجم",
    power: "توان",
    buyPrice: "مبلغ خرید",
    salePrice: "مبلغ فروش",
    consumerPrice: "قیمت مصرف کننده",
    specialFeature: "مشخصه ویژه",
    asset: "اموال",
    service: "خدماتی",
    allWare: "فعال در همه ی انبارها",
    negativeInventory: "امکان ثبت با موجودی منفی",
    fromThickness: "از ضخامت",
    toThickness: "تا ضخامت",
    isFoilFeasibility: "تایید واحد فویل؟",
    isFinancialFeasibility: "تایید مالی؟",
    isCasterFeasibility: "تایید کستر؟",
    isColdRollFeasibility: "تایید نورد سرد؟",
    isSaleFeasibility: "تایید فروش؟",
    isManagerFeasibility: "تایید مدیرعامل؟",
    validationType: "نوع اعتبار سنجی",
    isCancel: "برگشت به کارتابل؟",
    isComplete: "تکمیل سفارش؟",
    isComplete2: "نکمیل شده",
    value: "مقدار",
    country: "کشور",
    province: "استان",
    city: "شهر",
    region: "منطقه",
    personType: "نوع شخص",
    birthCertificateNo: "شماره شناسنامه",
    fatherName: "نام پدر",
    birthDate: "تاریخ تولد",
    gender: "جنسیت",
    maritalStatus: "وضعیت تاهل",
    mobile: "تلفن همراه",
    phone: "تلفن",
    postalCode: "کد پستی",
    managerNationalCode: "کدملی مدیرعامل",
    nationalCode: "کدملی ",
    registrationNumber: "شماره ثبت",
    sbu: "مرکز هزینه",
    coefficient: "ضریب تبدیل",
    unitCoefficient: "ضریب تبدیل واحد",
    financialDes: "توضیحات مالی",
    inventoryDes: "توضیحات کنترل موجودی",
    logisticDes: "توضیحات لجستیک",
    productionDes: "توضیحات تولید",
    otherDes: "توضیحات سایر",
    orderWeight: "وزن سفارش",
    produceOrderNo: "شماره دستور تولید",
    productionNo: "شماره تولید",
    coilNo: "شماره کویل",
    program: "برنامه",
    inputNo: "شماره ورودی",
    inputWeight: "وزن ورودی",
    outputWeight: "وزن خروجی",
    ra: "RA",
    mark: "علامت",
    startTime: "زمان شروع",
    endTime: "زمان پایان",
    deadline: "مهلت انجام",
    wastage: "ضایعات",
    draftType: "نوع حواله",
    wareReceiptType: "نوع رسید",
    totalWeight: "وزن کل",
    order: "سفارش",
    isConfirmFinancial: "تایید مالی؟",
    isConfirmManager: "تایید مدیریت؟",
    estimateDoneDate: "تاریخ تقریبی انجام",
    priority: "اولویت",
    showInSalePanel: "نمایش در پنل فروش",
    codeWorkshop: "کدگارگاهی",
    superAdmin: "مدیرکل",
    superdirector: "راهبر کل",
    director: "مدیر شعبه",
    position: "سِمت",
    positionTitle: "عنوان سِمت",
    sharePercentage: "درصد سهام",
    parentUnit: "واحد شمارش مبنا",
    subUnitCountTitle: "واحد شمارش فرعی",
    mainUnitCountTitle: "واحد شمارش اصلی",
    wareCategory: "دسته بندی انبار",
    accountHeader: "سرفصل‌ حساب",
    systemType: "نوع سیستم",
    insuranceWorkshopCode: "کدکارگاهی بیمه",
    isAdmin: "مدیر سیستم",
    group: "گروه",
    supervisor: "سرپرست گروه",
    isPermission: "وضعیت دسترسی",
    permissionTitle: "عنوان دسترسی",
    roles: "نقش‌ها",
    sbuType: "نوع واحد",
    sbuTitle: "عنوان واحد",
    expenseCenter: "مرکز هزینه",
    isLegal: "حقیقی/ حقوقی",
    bank: "بانک",
    accountNumber: "شماره حساب",
    bankCardNumber: "شماره کارت بانکی",
    shabaNumber: "شماره شبا",
    fax: "فکس",
    barcode: "بارکد",
    voucherType: "نوع سند",
    creditAccount: "حساب بستانکار",
    debtAccount: "حساب بدهکار",
    debtAccountCode: "کد حساب بدهکار",
    debtAccountTitle: "عنوان حساب بدهکار",
    isTemporery: "موقت؟",
    isInternalUse: "مصرف داخلی؟",
    receiptType: "نوع رسید/حواله",
    parentCode: "کد گروه والد",
    mainCategoryTitle: "عنوان گروه اصلی",
    mainCategory: "گروه اصلی",
    commoditySerial: "سریال کالا",
    commoditySubTitle: "عنوان فرعی کالا",
    subCategory: "گروه فرعی",
    day: "روز",
    density: "چگالی",
    buyHeader: "سرفصل‌ خرید کالا",
    saleHeader: "سرفصل‌ فروش کالا",
    additionalParameter: "پارامتر تکمیلی",
    subSystemTitle: "زیرسیستم",
    floatAccountTypeTitle: "نوع حساب شناور",
    floatAccountGroupTitle: "گروه حساب شناور",
    webSite: "وبسایت",
    capital: "پایتخت",
    population: "جمعیت",
    insuranceId: "کد بیمه",
    area: "مساحت",
    distance: "فاصله زمانی",
    fileTitle: "عنوان پرونده",
    factorType: "نوع فاکتور",
    floatLevelType: "نوع سطح شناور",
    floatLevelTitle: "عنوان سطح شناور",
    floatGroupTitle: "عنوان گروه",
    wareCode: "کدانبار",
    wareNumber: "شماره انبار",
    wareTitle: "نام انبار",
    receiptCount: "تعداد رسید شده",
    draftCount: "تعداد حواله شده",
    remainCount: "تعداد باقیمانده",
    personGroupTitle: "گروه شخص",
    customerGroup: "گروه مشتری",
    personFullName: "نام شخص",
    floatAccountTitle: "نام حساب ",
    floatAccountCode: "کد حساب ",
    account: "عنوان حساب",
    accountCode: "کد حساب",
    mainAccount: "نام حساب اصلی",
    actionType: "نحوه اقدام",
    accountType: "ماهیت حساب",
    personControl: "الزام شخص",
    floatAccControl: "الزام حساب شناور",
    isCurrency: "حساب ارزی؟",
    isExchange: "تسعیر شود؟",
    isAlign: "تراز باشد؟",
    nodeCaption: "عنوان سطح",
    digit: "تعداد ارقام کد",
    nodeDepth: "سطح حساب",
    type: "نوع",
    personCode: "کد شخص",
    groupMembers: "اعضای گروه",
    defaultBank: "حساب پیش‌فرض",
    prefixTitle: "عنوان (پیشوند)",
    prefix: "پیشوند",
    consumptionPlace: "محل مصرف",
    requester: "درخواست کننده",
    wareVoucherType: "نوع سند انبار",
    supplier: "تامین کننده",
    buyer: "مأمور خرید",
    receiptId: "شناسه رسید",
    singlePrice: "فی واحد",
    totalCount: "مقدار کل",
    batchNumber: "سری ساخت",
    trackingCode: "کد رهگیری",
    validityDate: "تاریخ اعتبار",
    mainCount: "مقدار اصلی",
    subCount: "مقدار فرعی",
    loginTimeLocal: "زمان ورود",
    logoutTimeLocal: "زمان خروج",
    groupCode: "کد گروه",
    permissionCode: "کد دسترسی",
    requirement: "الزام",
    draftNo: "شماره حواله",
    issuedDraftNo: "شماره حواله صادر شده",
    receiptNo: "شماره رسید",
    saller: "مأمور فروش",
    serial: "سریال",
    saleFactor: "فاکتور فروش",
    returnBuyFactor: "فاکتور مرجوعی خرید",
    tempDraft: "حواله موقت",
    transferReceiptNo: "شماره رسید انتقال",
    draftStatus: "وضعیت حواله",
    receiver: "گیرنده",
    isConfirm: "قطعی",
    driverName: "نام راننده",
    vehicleType: "نوع وسیله نقلیه",
    vehicleNumber: "شماره وسیله نقلیه",
    activePosition: "سِمت فعال",
    defaultPosition: "سِمت پیش‌فرض",
    positionCode: "کد سِمت",
    formName: "نام فرم",
    approvalPriority: "اولویت تایید",
    number: "شماره",
    voucherNo: "شماره سند",
    voucherPaymentNo: "شماره سند پرداخت",
    directVoucherNo: "شماره سند مستقیم",
    exitSheetNo: "شماره برگه خروج",
    delivererReceiver: "تحویل دهنده/ گیرنده",
    singleValue: "ارزش جزء",
    singlePriceTitle: "فی جز",
    singleNumberIn: "مقدار جز ورودی",
    totalNumberIn: "مقدار کل ورودی",
    singleNumberOut: "مقدار جز خروجی",
    totalNumberOut: "مقدار کل خروجی",
    singleRemain: "مانده جز",
    totalRemain: "مانده کل",
    totalValue: "ارزش کل",
    totalValueOfEntry: "ارزش ورودی کل",
    totalValueOfOutput: "ارزش خروجی کل",
    remainMainCount: "مقدار جز مانده",
    remainTotalCount: "مقدار کل مانده",
    remainSinglePrice: "فی جز مانده",
    remainTotalPrice: "مبلغ کل مانده",
    remainSingleValue: "ارزش جز مانده",
    remainTotalValue: "ارزش کل مانده",
    draft: "حواله",
    byWareCode: "(براساس کدانبار)",
    confirmMainCount: "مقدار تایید اصلی",
    confirmSubCount: "مقدار تایید فرعی",
    confirmTotalCount: "مقدار تایید کل",
    requestNo: "شماره درخواست",
    driverMobileNumber: "شماره همراه راننده",
    remainCommodity: "مانده کالا",
    firstEntryDate: "تاریخ اولین ورود کالا",
    dayCountToBaseDate: "فاصله اولین ورود تا تاریخ مبنا (روز)",
    sleepStock: "موجودی راکد کالا",
    averageRemain: "میانگین مانده",
    averageDraft: "میانگین خروج",
    numberReceiptDrafts: "شماره رسید/حواله",
    receiptTotalDays: "تعداد کل روزهای خواب رسید",
    sender: "فرستنده",
    sourceWare: "انبار مبدا",
    destinationWare: "انبار مقصد",
    sendDate: "تاریخ ارسال",
    sendType: "نوع ارسال",
    smsTemplateMessage: "متن قالب پیامک",
    smsTotalCount: "تعداد کل",
    smsSentCount: "تعداد ارسال شده",
    smsSent: "تعداد ارسال",
    receiveDate: "تاریخ دریافت",
    instant: "آنی",
    process: "فرآیندی",
    commodityInfo: "اطلاعات کالا",
    requestInfo: "اطلاعات درخواست",
    confirmCount: "مقدار تایید",
    transactionName: "نام تراکنش",
    debtHeading: "سرفصل بدهکار",
    creditHeading: "سرفصل بستانکار",
    heading: "سرفصل حسابداری",
    currentSessions: "نشست جاری",
    ipSystem: "آی پی",
    device: "نام سیستم",
    completeCode: "کد کامل",
    total: "کل",
    batchInfo: "اطلاعات بچ",
    rejectCount: "تعداد رد شده",
    conditionalConfirmCount: "تعداد تایید مشروط",
    confirmNumber: "تعداد تایید",
    exitCount: "تعداد خروج",
    countType: "نوع شمارش",
    storekeeper: "انباردار",
    receiptInfo: "اطلاعات رسید",
    draftInfo: "اطلاعات حواله",
    inputSinglePrice: "مبلغ جز ورودی",
    inputTotalPrice: "مبلغ کل ورودی",
    inputSingleValue: "ارزش جز ورودی",
    inputTotalValue: "ارزش کل ورودی",
    outputSinglePrice: "مبلغ جز خروجی",
    outputTotalPrice: "مبلغ کل خروجی",
    outputSingleValue: "ارزش جز خروجی",
    outputTotalValue: "ارزش کل خروجی",
    image: "تصویر",
    ware: "انبار",
    wareShelfInfo: "انبارک",
    isTemporary: "رسید موقت",
    inputCount: "تعداد ورودی",
    outPutCount: "تعداد خروجی",
    beforeRemainInput: "مانده از قبل ورودی",
    beforeRemainOutPut: "مانده از قبل خروجی",
    beforeRemain: "مانده از قبل",
    brand: "برند",
    machine: "دستگاه",
    averageValue: "ارزش میانگین",
    salesChannelsTitle: "عنوان کانال فروش",
    stock: "موجودی",
    needCount: "مقدار مورد نیاز",
    message: "متن پیام",
    defaultImage: "تصویر پیش فرض",
    saleChannelTitle: "عنوان کانال فروش",
    timeIntervalCreditExpires: "فاصله زمانی قبل از انقضای اعتبار(روز)",
    shippingTime: "زمان ارسال",
    discountCode: "کد تخفیف",
    discountType: "نوع تخفیف",
    discountQuantity: "مقدار تخفیف",
    useType: "نوع استفاده",
    limited: "محدود",
    unlimited: "نامحدود",
    maxUsed: "تعداد مجاز استفاده",
    fromDate: "از تاریخ",
    toDate: "تا تاریخ",
    deliveryMethod: "روش تحویل",
    occasionType: "نوع مناسبت",
    timeIntervalBeforeOccasion: "فاصله زمانی قبل از مناسبت",
    scoreType: "نوع امتیاز",
    creditType: "نوع اعتبار",
    debtor: "بدهکار",
    creditor: "بستانکار",
    creditCancellation: "ابطال اعتبار",
    cancellationDate: "تاریخ ابطال",
    credit: "اعتبار",
    creditGift: "اعتبار هدیه",
    discountAmountPercent: "مقدار/درصد تخفیف",
    rowNumber: "شماره سطر",
    rowNumber2: "ردیف دفتر",
    errorDescription: "شرح خطا",
    warningDescription: "شرح هشدار",
    importRowStatus: "وضعیت ردیف",
    discountTitle: "عنوان تخفیف",
    campaignType: "نوع کمپین",
    personClubGroup: "گروه مشتری",
    isByCustomerLocation: "براساس محدوده مشتریان فعلی",
    isByZipCode: "براساس منطقه کشوری",
    executeDate: "تاریخ اجرا",
    expireDate: "تاریخ انقضا",
    executeTime: "ساعت اجرا",
    neighborhood: "محله",
    marriageDate: "تاریخ ازدواج",
    feedBackTitle: "عنوان نظرسنجی",
    feedbackTypeTitle: "نوع نظرسنجی",
    viewCount: "تعداد بازدید",
    question: "سوال",
    // maxCountAnswer: "حداکثر تعداد پاسخ",
    // minCountAnswer: "حداقل تعداد پاسخ",
    discount: "تخفیف",
    textMessage: "پیامک",
    feedback: "نظرسنجی",
    score: "امتیاز",
    processType: "نوع فرآیند",
    processTitle: "عنوان فرآیند",
    discountLimit: "مدت اعتبار تخفیف",
    serviceType: "نوع خدمت",
    feedbackTitle: "عنوان نظرسنجی",
    minPriceOfCredit: "به ازای هربار خرید",
    price: "مبلغ",
    maxCountAnswer: "حداکثر پاسخ",
    minCountAnswer: "حداقل پاسخ",
    paymentMethod: "روش پرداخت",
    netPrice: "خالص قابل پرداخت",
    purchasesPrice: "مبلغ خرید",
    creditCode: "کد اعتبار",
    creditPrice: "مبلغ اعتبار",
    questionOptionTitle: "عنوان پارامتر اضافی",
    productionDate: "تاریخ تولید",
    customerGrade: "سطح مشتری",
    introducedType: "نحوه آشنایی",
    referrerFullName: "نام معرف",
    salesChannel: "کانال فروش",
    color: "رنگ",
    questionOptionAnswer: "گزینه های پارامتر",
    tagNo: "شماره تگ",
    counting: "شمارش",
    stockInSystem: "موجودی در سیستم",
    contradiction: "مغایرت",
    finalCount: "شمارش نهایی",
    explanation: "شرح",
    minBuyPrice: "حداقل مبلغ خرید",
    maxBuyPrice: "حداکثر مبلغ خرید",
    minCount: "حداقل تعداد خرید",
    maxCount: "حداکثر تعداد خرید",
    duration: "بازه زمانی (روز)",
    determiningDiscountLimit: "حداکثر مقدار تخفیف",
    sorting: "مرتب سازی",
    rowDescription: "شرح ردیف",
    debtCount: "بدهکار",
    creditCount: "بستانکار",
    effectiveDate: "تاریخ موثر",
    effectiveDuration: "مدت موثر",
    floatAccountText: "پارامتر مبنا",
    turnFloatAccountText: "پارامتر مبنای گردش",
    currencyType: "عنوان ارز",
    baseCurrencyType: "ارز مبنا",
    currencyRate: "نرخ ارز",
    sumPurchaseCount: "جمع خرید",
    lastPurchase: "آخرین خرید",
    distanceLastPurchasePrePurchase: "فاصله آخرین خرید تا خرید قبلی",
    totalPurchases: "تعداد دفعات خرید",
    lastPurchasePrice: "مبلغ آخرین خرید",
    personClubName: "نام مشتری",
    lastPurchaseDate: "تاریخ آخرین خرید",
    sumPurchasePrice: "جمع کل خریدها",
    sumScore: "جمع امتیاز",
    sign: "کد ایزو",
    alphabeticCode: "علامت اختصاری",
    validityPeriod: "مدت اعتبار",
    creditAmount: "میزان اعتبار",
    personClubFullName: "عضو باشگاه مشتریان",
    installmentCount: "تعداد اقساط",
    isExpired: "منقضی",
    isSettled: "تسویه شده",
    orderCancel: "انصراف",
    orderCancelDate: "تاریخ انصراف",
    orderConfirmStatus: "وضعیت تایید",
    cancelDescription: "شرح ابطال اعتبار",
    scoreRemain: "باقی‌مانده امتیاز",
    accountNo: "شماره حساب",
    ownerName: "نام صاحب حساب",
    statusType: "نوع وضعیت",
    turnType: "نوع گردش",
    voucherDescription: "شرح سند",
    voucherDate: "تاریخ سند",
    branchManager: "رییس شعبه",
    bankTitle: "نام بانک",
    firstAmount: "موجودی اولیه",
    cashier: "صندوقدار",
    templateTitle: "قالب چک",
    paperCount: "تعداد برگه",
    series: "سری چک",
    bankAccountInfoTitle: "نام حساب بانکی",
    startSerial: "شروع از شماره",
    paymentDate: "تاریخ پرداخت",
    toBankCashAccount: "صندوق/بانک دریافت کننده",
    bankCashAccount: "صندوق/بانک",
    payer: "شخص پرداخت کننده",
    personReceiver: "شخص دریافت کننده",
    fromBankCashAccount: "صندوق/بانک پرداخت کننده",
    fromBankAccount: "بانک پرداخت کننده",
    fromAccount: "حساب پرداخت کننده",
    fromPayment: " پرداخت کننده",
    toAccount: "حساب دریافت کننده",
    bankWage: "کارمزد بانک",
    requestPayment: "شماره درخواست",
    paymentPrice: "مبلغ پرداختی",
    requestPaymentCode: "شماره درخواست",
    issueDate: "تاریخ سررسید چک",
    requestDate: "تاریخ درخواست",
    requesterUser: "درخواست‌دهنده",
    referredTo: "ارجاع به",
    requestType: "نوع درخواست",
    chequeNumber: "شماره چک",
    trackingNumber: "شماره صیادی",
    chequeBatchSeries: "سری دسته چک",
    receivePrice: "مبلغ دریافتی",
    noteType: "نوع یادداشت",
    archive: "بایگانی",
    confirm: "تایید",
    chequeBackNumber: "پشت نمره چک",
    chequeStatus: "وضعیت چک",
    dueDate: "تاریخ سررسید چک",
    fromBank: "صادره از بانک",
    currencyCredit: "بستانکار ارزی",
    currencyDebt: "بدهکار ارزی",
    durationCheque: "مدت",
    checkStatus: "وضعیت تایید",
    signedStatus: "وضعیت امضا",
    referenceNumber: "شماره مرجع",
    subReferenceNumber: "شماره مرجع فرعی",
    voucherCode: "شماره عطف",
    voucherDateChangeStatus: "تاریخ تغییر وضعیت سند",
    voucherPrintCount: "تعداد چاپ سند",
    voucherRowTypeTitle: "نوع ردیف سند",
    voucherTemplateTitle: "عنوان شابلون ",
    dateChangeStatus: "تاریخ تغییر وضعیت",
    priceRequest: "مبلغ درخواستی",
    person: "شخص",
    key: "کلید",
    expireTime: "زمان انقضا",
    confirmPrice: "مبلغ تایید شده",
    linenNumber: "شماره خط",
    password: "رمز عبور",
    defaultPanel: "پنل پیش فرض",
    templateId: "شناسه الگوی کد پیامکی",
    panelType: "نوع پنل",
    countryDefault: "کشور پیش‌فرض",
    personClubMobile: "شماره همراه مشتری",
    rank: "رتبه",
    commodityGroup: "گروه کالا",
    fromPrice: "از مبلغ",
    toPrice: "تا مبلغ",
    totalTaxPrice: "مبلغ ارزش افزوده کل",
    taxAmount: "مبلغ مالیات متعلقه",
    totalTaxAmount: "جمع مالیات متعلقه تا این سطح",
    percent: "درصد",
    insuranceCode: "کد بیمه",
    taxCode: "کد مالیاتی",
    archiveDate: "تاریخ بایگانی",
    fromNumber: "از شماره",
    toNumber: "تا شماره",
    totalQuestions: "مجموع سوالات",
    multipleChoiceQuestionCount: "تعداد سوالات چندگزینه‌ای",
    descriptiveQuestionCount: "تعداد سوالات تشریحی",
    totalAnswers: "مجموع پاسخ داده شده",
    creditPerson: "شخص بستانکار",
    debtPerson: "شخص بدهکار",
    payTo: "در وجه",
    bearer: "حامل",
    paymentRequest: "درخواست پرداخت",
    deadlineUseDiscount: "مهلت استفاده از تخفیف (روز)",
    deadlineUseGiftCredit: "مهلت استفاده از اعتبار (روز)",
    reasonFeedback: "ارسال نظرسنجی بابت",
    answerCount: "تعداد پاسخ داده شده",
    answered: "پاسخ داده شده",
    answerDate: "زمان پاسخ‌دهی",
    answerDateLocal: "تاریخ پاسخ‌دهی",
    questionType: "نوع سوال",
    answerType: "نوع پاسخ",
    answerTitle: "عنوان پاسخ",
    answer: "پاسخ",
    chequeBatchNo: "شماره دسته چک",
    isTax: "مشمول مالیات",
    isInsurance: "مشمول بیمه",
    isPersonInVoucher: "شخص در سند",
    isContinuous: "مستمر",
    isCash: "نقدی",
    basePrice: "مبلغ پایه",
    minPrice: "حداقل مبلغ",
    maxPrice: "حداکثر مبلغ",
    isDisplayInInsurance: "نمایش در خروجی بیمه",
    formula: "فرمول محاسبه",
    includeFunctionColumn: "مشمول ستون کارکرد",
    isRelatedToFunction: "وابسته با کارکرد",
    unitWeight: "وزن واحد",
    materialAlloy: "متریال (آلیاژ)",
    packageType: "نوع بسته بندی",
    grade: "سطح",
    parent: "والد",
    offPrice: "مبلغ تخفیف",
    typeTitle: "عنوان ستون",
    sortOrder: "ترتیب",
    informationType: "نوع اطلاعات",
    convertTo: "تبدیل به",
    managerName: "مدیر عامل",
    agreementRow: "ردیف پیمان",
    storagePlace: "محل نگهداری",
    lastUpdatedDate: "زمان آخرین ویرایش",
    userChangeStatus: "کاربر تغییر وضعیت",
    lastChequeStatus: "آخرین وضعیت چک",
    chequePrice: "مبلغ چک",
    turnDate: "تاریخ گردش",
    m1: "فروردین",
    m2: "اردیبهشت",
    m3: "خرداد",
    m4: "تیر",
    m5: "مرداد",
    m6: "شهریور",
    m7: "مهر",
    m8: "آبان",
    m9: "آذر",
    m10: "دی",
    m11: "بهمن",
    m12: "اسفند",
    cutColdRollingType: "نوع کات نورد سرد",
    cutFoilRollingType: "نوع کات نورد فویل",
    cuttingCount: "تعداد کات کاتولنت و اسلیتر",
    instruction: "دستورالعمل های وِیژه",
    isCoil: "کویل/شیت",
    produceOrder: "دستور تولید",
    qcDescription: "توضیحات کنترل کیفی",
    rollDiameter: "قطر رول",
    sprint: "هفته ساخت",
    source: "مبدا",
    receiptSerial: "سریال رسید انبار",
    parentCoilCertificate: "شماره کویل مبنا",
    feedbackAnswerPercentage: "درصد پاسخ",
    feedbackActiveCount: "تعداد بار ارسال شده",
    turn: "دارای گردش",
    turnNumber: "شماره گردش",
    turnBankCashAccount: "صندوق/بانک گردش",
    turnAccount: "سرفصل گردش",
    turnDescription: "شرح گردش",
    firstChequeStatus: "وضعیت ابتدایی چک",
    lastDueDate: "آخرین سررسید",
    head: "رأس‌ (روز)",
    headDate: "تاریخ رأس",
    sumCount: "تعداد کل",
    receiveCash: "دریافت نقد",
    paymentCashe: "پرداخت نقد",
    cashBalance: "مانده نقد",
    balanceBeginningPeriod: "مانده ابتدای دوره",
    feedbackCode: "کدنظرسنجی",
    chequeCount: "تعداد چک‌ها",
    chequetotalPrice: "جمع مبلغ چک‌ها",
    chequeDate: "تاریخ چک",
    grossCoilWeight: "وزن ناخالص کویل",
    commodityDescription: "شرح کالا",
    mainProcess: "فرایند اصلی",
    finalProductCode: "کد محصول نهایی",
    finalProduct: "محصول نهایی",
    produceOrderCount: "مقدار دستور تولید",
    coreCoilWeight: "وزن core کویل",
    netWeight: "وزن خالص",
    finalThickness: "ضخامت نهایی",
    finalWidth: "عرض نهایی",
    operator: "اپراتور",
    workedTime: "مدت زمان انجام",
    innerDiameter: "قطر داخلی",
    outerDiameter: "قطر خارجی",
    materialDraftType: "نوع حواله مواد مصرفی",
    draftMaterialWare: "انبار حواله مواد مصرفی",
    rejectedReceiptWare: "انبار عدم انطباق",
    rejectedReceiptType: "نوع رسید عدم انطباق",
    rejectedDraftType: "نوع حواله عدم انطباق",
    qcStatus: "وضعیت کنترل کیفی",
    materialDraft: "حواله مواد مصرفی",
    nextProcessType: "نوع فرآیند بعدی",
    subProcessType: "نوع فرآیند فرعی",
    nextSubProcessType: "نوع فرآیند فرعی بعدی",
    inputType: "نوع ورودی",
    productionReport: "گزارش تولید",
    bom: "فرمول تولید",
    orderCommodity: "کالای سفارش",
    approximateDateOfCompletion: "تاریخ تقریبی انجام",
    additionalPrice: "مبلغ اضافه خطی",
    additionalPercent: "درصد اضافه خطی",
    afterOffPrice: "مبلغ بعد از تخفیف",
    deductionPercent: "درصد کسورات خطی",
    deductionPrice: "مبلغ کسورات خطی",
    bomCode: "کد فرمول تولید",
    bomCount: "مقدار فرمول تولید",
    confirmDate: "تاریخ تایید",
    completeDate: "تاریخ تکمیل",
    completeUserName: "نام کاربری تکمیل کننده",
    productionGroups: "گروه‌های تولیدی",
    customerName: "نام مشتری",
    agreedPrice: "مبلغ توافقی",
    contractor: "پیمانکار",
    controllerThird: "بازرس ثالث",
    inspection: "عنوان بازرسی",
    project: "پروژه",
    projectManager: "مدیر پروژه",
    saleType: "نوع فروش",
    size: "سایز",
    fileName: "نام فایل",
    filePath: "مسیر فایل",
    isMaterial: "مواد اولیه",
    isProduct: "محصول",
    isService: "خدماتی",
    isAsset: "اموال",
    maxReservationDate: "حداکثر مهلت رزرو",
    reservation: "رزرو شده؟",
    isProduction: "تولید داخل؟",
    isSupplier: "تامین‌کننده دارد؟",
    sppliers: "تامین‌کنندگان",
    productionGroupSupplier: "تامین‌کنندگان گروه تولید",
    isNecessary: "اجباری",
    defaultValue: "مقدار پیش‌فرض",
    productionCoefficient: "ضریب تولید",
    marketCode: "کد بازارگاه",
    percentageSharing: "درصد تسهیم",
    accountInfo: "سرفصل حساب",
    mainCommodity: "کالای اصلی",
    settlementType: "نوع تسویه",
    amount: "مقدار",
    seller: "فروشنده",
    allocationNumber: "شماره تخصیص",
    cottageNumber: "شماره کوتاژ",
    purchaseAllocationNumber: "شماره تخصیص عرضه",
    purchaseCottageNumber: "شماره کوتاژ عرضه",
    average: "میانگین",
    orderType: "نوع سفارش",
    dealer: "خریدار فرعی",
    purchaseDuration: "مدت خرید",
    saleDuration: "مدت فروش",
    trailer: "تریلی",
    singleTruck: "تک محور",
    doubleTruck: "جفت محور",
    otherTruck: "سایر",
    dumpTruck: "کمپرسی",
    vehicle: "وسیله نقلیه",
    taxExempt: "معاف از مالیات",
    tax2: "مالیات",
    orderStatus: "وضعیت سفارش",
    complete: "تکمیل",
    completeDesc: "توضیحات تکمیل",
    cancel: "ابطال",
    cancelDate: "تاریخ ابطال",
    cancelDesc: "توضیحات ابطال",
    settlement: "تسویه",
    settlementDesc: "توضیحات تسویه",
    settlementDate: "تاریخ تسویه",
    orderNumber: "شماره سفارش",
    shippingPrice: "هزینه حمل",
    sellerDescription: "توضیحات فروشنده",
    buyerDescription: "توضیحات خریدار",
    ladingAmount: "مقدار بارنامه",
    progressPercentage: "درصد پیشرفت",
    carPlate: "پلاک وسیله نقلیه",
    commodityWare: "انبار کالا",
    draftWare: "انبار حواله",
    receiptWare: "انبار رسید",
    materialCount: "مقدار مواداولیه",
    materialDescription: "توضیحات مواد اولیه",
    materialTotalPrice: " ارزش کل مواد اولیه",
    materialUnitPrice: "ارزش واحد مواداولیه",
    materialUnitCount: "واحدشمارش مواد اولیه",
    costTitle: "عنوان هزینه",
    productCode: "کد محصول",
    productTitle: "نام محصول",
    totalNumberProduced: "تعداد کل تولید شده",
    materialCommodityCode: "کد مواد مصرفی",
    materialCommodity: " ماده مصرفی",
    pn: "pn/فشار",
    percentageOfFactor: "درصد از فاکتور",
    percentageOfGroup: "درصد از گروه",
    minusPercentage: "درصد کسورات",
    addPercentage: "درصد اضافات",
    percentage: "درصد",
    fromCount: "از تعداد",
    toCount: "تا تعداد",
    giftCount: "تعداد هدیه",
    salePricePolicy: "سیاست قیمت گذاری",
    netTotalPrice: "جمع مبلغ خالص",
    addTotlaPrice: "جمع اضافات",
    customerCode: "کد مشتری",
    totalSaleFactor: "تعداد فاکتورها",
    totalGrossAmount: "جمع ناخالص",
    totalDiscountPrice: "جمع تخفیف",
    totalAddPrice: "جمع اضافات خطی",
    totalMinusPrice: "جمع کسورات خطی",
    totalPayablePrice: "خالص نهایی",
    mainQty: "تعداد اصلی",
    subQty: "تعداد فرعی",
    totalLinear: "خالص خطی",
    totalLinearTax: "ارزش افزوده خطی",
    totalLinearDiscount: "تخفیف خطی",
    averageUnitPrice: "فی متوسط",
    totalAmount: "مبلغ خالص",
    factorNo: "شماره فاکتور",
    factorDate: "تاریخ فاکتور",
    void: "باطل",
    saleManagerCode: "کد مسئول فروش",
    saleManagerName: "نام مسئول فروش",
    totalFactor: "جمع فاکتور",
    totalAmountFactor: "خالص نهایی فاکتور",
    returnPrice: "مبلغ مرجوعی",
    totalSalePrice: "مبلغ فروش کل",
    totalCostPrice: "مبلغ بهای تمام شده کل",
    totalProfit: "مبلغ سود کل",
    unitProfit: "مبلغ سود واحد",
    profitPercentage: "درصد سود",
    saleCount: "تعداد فروش",
    totalSalesAmountFactorDate: "جمع ریالی فروش به تاریخ فاکتور",
    averageSalesAmountFactorDate: "متوسط ریالی فروش به تاریخ فاکتور",
    totalFactorAmountToday: "جمع ریالی فاکتور به تاریخ روز",
    averageSalesAmountToday: "متوسط ریالی فروش به تاریخ روز",
    totalValueGoods: "جمع ارزش کالا",
    averageValueGoods: "متوسط ارزش کالا",
    grossProfitFactorDate: "سود ناویژه به تاریخ فاکتور",
    grossProfitToday: "سود ناویژه به تاریخ روز",
    totalProfitFactorDate: "سود کل به تاریخ فاکتور",
    totalProfitToday: "سود کل به تاریخ روز",
    profitAmount: "مبلغ سود",
    unitPrice: "مبلغ واحد",
    unitValueGoods: "ارزش واحد کالا",
    grossProfitGoods: "سود ناویژه کالا",
    totalGrossProfit: "سود ناویژه کل",
    ratioOfProduct: "نسبت سود ناویژه کالا به کل",
    profitPercentageRelativeValue: "درصد سود به ارزش",
    giftCommodityTitle: "نام کالا هدیه",
    saleManager: "مسئول فروش",
    allowedDiscountPercentage: "سطح تخفیف مجاز (درصد)",
    conditionsOfSale: "شرایط فروش",
    cashPrice: "قیمت نقدی",
    isCredit: "اعتباری",
    creditDuration: "مدت اعتبار",
    isCheque: "پرداخت چک",
    chequeDuration: "مدت چک",
    taxPercentage: "درصد ارزش افزوده",
    addPrice: "مبلغ اضافات",
    minusPrice: "مبلغ کسورات",
    floatAccountInfo: "اطلاعات حساب‌های شناور",
    isGift: "هدیه",
    addMinusType: "نوع اضافات کسورات",
    additionalParameters: "پارامتر های تکمیلی",
    averageFee: "فی متوسط ",
    cancelUserTitle: "شخص ابطال کننده",
    paymentStatus: "وضعیت پرداخت",
    confirmUserTitle: "شخص تایید کننده",
    addTotalPrice: "جمع مبلغ اضافات",
    minusTotalPrice: "جمع مبلغ کسورات",
    payablePrice: "مبلغ قابل پرداخت",
    paymentConditions: "شرایط پرداخت",
    requesterSubject: "موضوع دریافت",
    requesterUnit: "واحد درخواست کننده",
    singleCurrencyType: "ارز",
    currencyPrice: "نرخ ارز",
    isSharing: "تسهیم",
    intermediary: "واسط",
    agent: "نماینده فروش",
    minusTotalPrcie: "جمع کسورات",
    refrence: "مرجع صدور",
    visitor: "ویزیتور",
    totalLineNetAmount: "جمع خالص خطی",
    taxIdNumber: "شماره مالیاتی",
    saleDescription: "توضیحات فروش",
    isCancelFactor: "باطل",
    isReturn: "مرجوعی",
    factorFormat: "نوع فاکتور",
    columnTitle: "عنوان ستون",
    socialInsuranceJobId: "شناسه شغل تامین اجتماعی",
    assetJobId: "شناسه شغل دارایی",
    registrationCode: "کد ثبت",
    groupVolumeDiscount: "تخیف حجمی گروه",
    specialGroupDiscount: "تخیف ویژه گروه",
    specialCustomerDiscount: "تخیف ویژه مشتری",
    lineDiscountPercent: "درصد تخفیف خطی",
    lineDiscountAmount: "مقدار تخفیف خطی",
    lineVATPercent: "درصد ارزش افزوده خطی",
    lineVATAmount: "مقدار ارزش افزوده خطی",
    productDescription: "توضیحات کالا",
    giveAllRewards: "تعداد کل جوایز گرفته شده",
    commodityCount: "تعداد کالا",
    visitorCode: "کد ویزیتور",
    visitorName: "نام ویزیتور",
    netTotal: "جمع خالص",
    additionsDeductionsTitle: "عنوان اضافات/کسورات",
    netInvoice: "خالص فاکتور",
    addMinusPercentage: "درصد کسر/ اضافه",
    addMinusPrice: "مبلغ کسر/ اضافه",
    averageProfit: "میانگین سود",
    isDefault: "پیش فرض",
    archiveDateLocal: "تاریخ بایگانی",
    tempNumber: "شماره موقت",
    articleNumber: "ردیف ثبت",
    isArchive: "بایگانی",
    currencyValue: "مقدار ارز",
    preFactorNo: "شماره پیش فاکتور",
    supplierPhone: "تلفن تامین کننده",
    buyManager: "مسئول خرید",
    returnFactorNo: "شماره فاکتور مرجوعی",
    finalFactorTotal: "جمع نهایی فاکتور",
    lineTotalAmount: "مبلغ خالص خطی",
    buyerEconomicNumber: "شماره اقتصادی خریدار",
    buyerNationalCode: "کدملی خریدار",
    buyType: "نوع خرید",
    baseNumber: "شماره عطف",
    totalLinerDiscount: "جمع تخفیف خطی",
    totalTax: "جمع ارزش افزوده",
    totalMinus: "جمع کسورات",
    provinceCode: "کداستان",
    cityCode: "کدشهر",
    farvardin: "فروردین",
    ordibehesht: "اردیبهشت",
    khordad: "خرداد",
    tir: "تیر",
    mordad: "مرداد",
    shahrivar: "شهریور",
    mehr: "مهر",
    aban: "آبان",
    azar: "آذر",
    dey: "دی",
    bahman: "بهمن",
    esfand: "اسفند",
    accountKind: "نوع حساب",
    effectOnInventory: "موثر در موجودی",
    isEffectOnPrice: "پارامترها بر قیمت موثر هستند؟ ",
    registrationRow: "ردیف ثبت",
    currencyValue1: "ارزش ارز",
    accountControl: "کنترل حساب",
    currencyBalance: "مانده ارزی",
    currencyBeforeBalance: "مانده از قبل ارزی",
    currencyType1: "نوع ارز",
    voucher: "سند حسابداری",
    factorCancel: "باطل شده",
    inspectionLevel: "سطح بازرسی",
    reservationCount: "مقدار رزرو شده",
    orderCount: "مقدار سفارش",
    attachmentFile: "فایل پیوست",
    confirmPlan: "نیاز به تایید نقشه توسط مشتری",
    cashCode: "کد صندوق",
    cashName: "نام صندوق",
    checkbookCode: "کد دسته‌چک",
    statusCode: "کد وضعیت",
    turnoverBed: "جمع بدهکار طی دوره",
    turnoverBes: "جمع بستانکار طی دوره",
    circulationDuringTheCourse: "گردش طی دوره",
    account2: "حساب",
    remainCredit: "مانده اعتبار",
    mobileNumber: "شماره موبایل",
    balanceAtTheEndOfThePeriod: "مانده انتهای دوره",
    currencyBalanceAtTheEndOfThePeriod: "مانده انتهای دوره ارزی",
    isSendSmsOff: "ارسال پیام تخفیف",
    timeSendSmsOff: "زمان ارسال تخفیف",
    isFeedBack: "دارای نظرسنجی",
    timeSendSmsfeedback: "زمان ارسال نظرسنجی",
    isSendSmsCredit: "ارسال پیام اعتبار",
    timeSendSmsCredit: "زمان ارسال پیام اعتبار",
    isSendSmsScore: "ارسال پیام امتیاز",
    timeSendSmsScore: "زمان ارسال پیام امتیاز",
    purchaseCode: "شماره عرضه",
    purchaseAmount: "مقدار عرضه",
    sumCottage: "جمع کوتاژ",
    remainCottage: "مانده کوتاژ",
    remainOrder: "مانده سفارش",
    sumOrder: "جمع سفارش",
    cottageAmount: "مقدار کوتاژ",
    amountOrder: "مقدار سفارش",
    sumLading: "جمع بارنامه",
    remainLading: "مانده بارنامه",
    receiptQuantity: "مقدار رسید شده",
    subUnitCountCoefficient: "ضریب واحد شمارش فرعی",
    totalDebt: "جمع بدهکار",
    totalCredit: "جمع بستانکار",
    remainder: "باقی مانده",
    rowCount: "تعداد سطر",
    withoutRow: "بدون سطر",
    balance: "تراز",
    openingDebitBalance: "مانده بدهکار قبل دوره",
    openingCreditBalance: "مانده بستانکار قبل دوره",
    debitBalanceDuringPeriod: "مانده بدهکار طی دوره",
    creditBalanceDuringPeriod: "مانده بستانکار طی دوره",
    endingDebitBalance: "مانده بدهکار انتهای دوره",
    endingCreditBalance: "مانده بستانکار انتهای دوره",
    closingDebitBalance: "مانده بدهکار نهایی",
    closingCreditBalance: "مانده بستانکار نهایی",
    turnoverBedCirculation: "گردش بدهکار طی دوره",
    turnoverBesCirculation: "گردش بستانکار طی دوره",
    beginCirculation: "گردش ابتدای دوره",
    endBed: "مانده بدهکار",
    endBes: "مانده بستانکار",
    circulationDuring: "جمع کل گردش",
    endAccount: "مانده حساب",
    initialCreditAmount: "مبلغ اولیه اعتبار",
    creditTerm: "مدت اعتبار",
    dateLastSalesFactor: "تاریخ آخرین فاکتور فروش",
    termDiscrepancy: "مغایرت مدت",
    t: "ت",
    generalInfo: "اطلاعات عمومی",
    cartableId: "شماره کارتابل",
    lastVoucherDateLocal: "تاریخ آخرین گردش",
    duringDebt: "بدهکار طی دوره",
    duringCredit: "بستانکار طی دوره",
    aliasCode: "نام مستعار",
    processCode: "کد روند",
    orderDateLocal: "تاریخ سفارش",
    orderProjectManager: "مسئول پروژه",
    previousStatus: "وضعیت قبلی",
    cartableTitle: "عنوان کارتابل",
    needByDate: "تاریخ مورد نیاز",
    shortage: "کسری",
    quantityInTransit: "مقدار در راه",
    finalBalance: "مقدار درخواست",
    inventory: "موجودی",
    exchangeRate: "نرخ ارز",
    radif: "ردیف",
    registerType: "نوع ثبت",
    productSurface: "سطح محصول",
    usageGroup: "گروه کاربردی",
    foilUsage: "کاربرد فویل",
    innerCoreDiameter: "قطر داخلی کور سفارش تحویلی",
    minWeight: "حداقل وزن",
    maxWeight: "حداکثر وزن",
    finance: "دارایی‌ها",
    debts: "بدهی‌ها",
    fund: "سرمایه",
    debtsAndFund: "بدهی‌ها + سرمایه",
    totalAccountCode: "کد حساب کل",
    totalAccountTitle: "عنوان حساب کل",
    moinAccountCode: "کد حساب معین",
    moinAccountTitle: "عنوان حساب معین",
    totalBefore: "مانده از قبل کل",
    totalBeforeCurrency: "مانده از قبل ارزی",
    totalCreditCurrency: "جمع بستانکار ارزی",
    totalDebtCurrency: "جمع بدهکار ارزی",
    personAddress: "آدرس شخص",
    beforeDebt: "مانده از قبل بدهکار",
    beforeCredit: "مانده از قبل بستانکار",
    currencyBeforeDebt: "مانده از قبل بدهکار ارزی",
    currencyBeforeCredit: "مانده از قبل بستانکار ارزی",
    currencyBeforeRemain: "مانده از قبل ارزی",
    currencyDuringDebt: "بدهکار طی دوره ارزی",
    currencyDuringCredit: "بستانکار طی دوره ارزی",
    afterDebt: "مانده بعد دوره بدهکار",
    afterCredit: "مانده بعد دوره بستانکار",
    currencyAfterDebt: "مانده بعد دوره بدهکار ارزی",
    currencyAfterCredit: "مانده بعد دوره بستانکار ارزی",
    finalRemain: "مانده نهایی",
    currencyFinalRemain: "مانده نهایی ارزی",
    accCode: "کد کامل (کد حساب)",
    operationalCurrency: "ارز عملیاتی",
    documentRow: "ردیف سند",
    voucherStatus: "وضعیت سند",
    paymentSubject: "موضوع پرداخت",
    turnCash: "گردش وجوه نقد",
    billNumber: "شناسه قبض",
    paymentNumber: "شناسه پرداخت",
    issueTracking: "شماره پیگیری",
    issueTrackingType: "نوع واریز",
    fromBranch: "صادره از شعبه",
    percentOrPrice: "درصد/مبلغ",
    commodityGroupNodeDepth: "سطح گروه کالا",
    goal: "هدف",
    goalCount: "مقدار هدف",
    goalPercent: "درصد هدف",
    goalUser: "کاربر هدف",
    doneDate: "تاریخ انجام",
    achievementDate: "تاریخ دستیابی",
    doneTime: "ساعت انجام",
    doneDescription: "شرح انجام",
    predictionDate: "تاریخ پیش‌بینی",
    achievementPercentage: "درصد پیشرفت کل",
    achievementPercentagePrediction: "پیش‌بینی درصد پیشرفت",
    indicator: "شاخص اندازه‌گیری",
    companyName: "نام شرکت",
    businessTitle: "عنوان تجاری",
    companyType: "نوع شرکت",
    managerFirstName: "نام مدیر",
    managerLastName: "نام خانوادگی مدیر",
    managerMobile: "شماره همراه مدیر",
    branchCount: "تعداد شعب",
    userCount: "تعداد کاربران",
    route: "مسیر دسترسی",
    clubUrl: "آدرس سیستم باشگاه مشتریان",
    slogan: "شعار",
    statusTitle: "نوع اقدام",
    statusUser: "کاربر اقدام",
    minWeightCoil: "حداقل وزن هر کویل",
    maxWeightCoil: "حداکثر وزن هر کویل",
    approxCastingStartDate: "تاریخ تقریبی شروع تولید کستر",
    approxDeliveryDate: "تاریخ تقریبی تحویل سفارش",
    campaign: "کمپین",
    furnaceOperator: "اپراتور (کوره‌دار)",
    workShift: "شیفت کاری",
    semiBuiltProduct: "محصول نیمه‌ساخته",
    year: "سال",
    stopTime: "زمان توقف",
    outerRadius: "شعاع خارجی",
    grainSize: "دانه بندی",
    thicknessIncrease: "ازدیاد ضخامت",
    thicknessTolerance: "تلرانس ضخامت",
    thicknessVariation: "ناهماهنگی  ضخامت",
    edgeTolerance: "تلرانس دو سر",
    crownTolerance: "تلرانس کرون",
    crown: "کرون",
    rollerRunout: "ناهماهنگی یک دور غلطک",
    grossWeight: "وزن ناخالص",
    titaniumPercent: "درصد ti",
    zincPercent: "درصد zn",
    siliconPercent: "درصد si",
    magnesiumPercent: "درصد mg",
    manganesePercent: "درصد mn",
    chromiumPercent: "درصد cr",
    copperPercent: "درصد cu",
    ironPercent: "درصد fe",
    productUsage: "کاربرد محصول",
    lead: "سرنخ (لید)",
    leadProperty: "ویژگی سرنخ (لید)",
    leadSource: "منبع سرنخ (لید)",
    questionText: "متن سوال",
    answerRequirement: "الزام پاسخ",
    saleRegion: "منطقه فروش",
    saleTeamSupervisor: "سرپرست تیم",
    teamMembers: "اعضای تیم",
    saleStatus: "وضعیت مرحله فروش",
    expectedAmount: "مبلغ مورد انتظار",
    probabilitySuccessPercentage: "درصد احتمال موفقیت",
    strengthWeakness: "نقاط ضعف و قوت",
    coldRollingPassCount: "تعداد کات نورد سرد",
    cutToLengthPassCount: "تعداد کات کاتولنت",
    finalCutToLengthWidth: "عرض نهایی کاتولنت",
    finalColdRollingThickness: "ضخامت نهایی نورد سرد",
    requiredThicknessForCutToLength: "ضخامت مورد نیاز جهت کاتولنت",
    requiredThicknessForAnnealing: "ضخامت مورد نیاز جهت آنیل",
    coreType: "نوع کور",
    roughness: "رافنس",
    speed: "سرعت",
    previousCoilNumber: "شماره کویل قبلی",
    furnacePlacement: "جانمایی کوره",
    coreWeight: "وزن کور",
    temperature: "درجه حرارت",
    completedProduceOrder: "نمایش دستور تولیدهای تکمیل شده",
    slitterCutCount: "تعداد کات اسلیتر/سپراتور",
    foilRollingCutCount: "تعداد کات نورد فویل",
    palletType: "نوع پالت",
    dopplerWidth: "عرض داپلر",
    productType: "نوع محصول",
    totalAlloyingElements: "مجموع عناصر",
    commodityWareReceiptType: "نوع رسید انبار محصول در جریان ساخت",
    commodityReceiptWare: "انبار رسید محصول در جریان ساخت",
    denominator: "مخرج کسر",
    numerator: "صورت کسر",
    ratio: "نسبت محاسبه شده",
    paletteNumber: "شماره پالت",
    paletteWeight: "وزن پالت",
    rollCount: "تعداد رول",
    projectExecutionPhase: "مرحله اجرای پروژه",
    calculatedAmount: "مبلغ محاسباتی",
    totalJobDescription: "جمع شرح کار",
    totalWorkDecimal: "جمع شرح کار",
    totalAdditions: "جمع اضافات",
    totalFractions: "جمع کسورات",
    netProjectPrice: "خالص مبلغ پروژه",
    projectType: "نوع پروژه",
    effectiveFactor: "عامل مؤثر",
    fee: "فی",
    totalSum: "جمع کل",
    fileType: "نوع فایل",
    filePathName: "مسیر/نام فایل",
    isDone: "انجام شد",
    createDate: "تاریخ ایجاد",
    floatAccount: "حساب شناور",
    user: "کاربر",
    projectCode: "کد پروژه",
    projectTitle: "عنوان پروژه",
    workDescription: "شرح کار",
    residentialSuite: "واحد",
    contract: "حکم کارگزینی",
    leaveType: "نوع مرخصی",
    leaveDuration: "مدت مرخصی",
    missionDuration: "مدت ماموریت",
    descriptionFor: "بابت",
    paymentChequeCode: "شماره برگه پرداخت چک",
    confirmed: "تأیید شده",
    definitived: "قطعی شده",
    errorText: "خطا",
    dailyDuration: "مدت (روز)",
    hourlyDuration: "مدت (ساعت)",
    isDaily: "روزانه / ساعتی",
    confirmStatus: "وضعیت گردش تأیید",
    confirmUser: "کاربر تأییدکننده",
    meeting: "صورت‌جلسه",
    serviceSupport: "سرویس",
    call: "تماس",
    callDate: "تاریخ تماس",
    callTime: "زمان تماس",
    callDuration: "مدت تماس",
    callNature: "ماهیت تماس",
    currentUserReminder: "یادآوری کاربر",
    teamReminder: "یادآوری تیم",
    responsibility: "مسئولیت",
    messageAction: "نوع اقدام",
    seenDate: "تاریخ مشاهده",
    seenTime: "زمان مشاهده",
    task: "فعالیت و وظیفه",
    reminder: "یادآوری",
    socialNetwork: "شبکه اجتماعی",
    attachmentType: "نوع پیوست",
    responsibleForPerson: "مسئول انجام",
    meetingTitle: "عنوان جلسه",
    meetingDuration: "مدت زمان جلسه",
    meetingPlace: "محل برگزاری جلسه",
    fromTime: "از ساعت",
    toTime: "تا ساعت",
    mainUser: "کاربر اصلی",
    meetingStatus: "وضعیت جلسه",
    isPresent: "حضور",
    productOrService: "محصول / خدمت",
    estimateTime: "زمان صرف شده",
    responsible: "مسئول",
    receiveNumber: "شناسه دریافت",
    paymentType: "نوع پرداخت",
    hasAttach: "دارای پیوست",
    taxRatePercentage: "درصد مالیات",
    taxFreeShare: "کسر معافیت از 12",
    benefits: "مزایا",
    deduction: "کسورات",
    isPending: "معوقه",
    isTaxFree: "معاف از مالیات",
    isTaxTableType: "پلکانی",
    taxRateType: "نوع نرخ مالیات",
    addOrMinusTaxType: "نوع مالیاتی",
    relatedToFunction: "وابسته به کارکرد",
    cashBenefits: "مزایای نقدی؟",
    accountParty: "طرف حساب",
    personnel: "پرسنل",
    actionDate: "تاریخ عملیات",
    month: "ماه",
    monthDays: "تعداد روزهای ماه",
    mandatoryFunctionDay: "کارکرد موظفی در ماه به روز",
    mandatoryFunctionHour: "کارکرد موظفی در ماه به ساعت",
    mandatoryFunctionHourTimespan: "کارکرد موظفی در ماه به ساعت و دقیقه",
    addMinus: "اضافات و کسورات",
    isTiered: "پلکانی",
    requestRemain: "مانده‌ی درخواست",
    subsidiaryAccountCode: "تفضیلی",
    subAccountCode: "جز",
    ledgerAccountCode: "معین",
    groupType: "نوع گروه",
    groupTypeCode: "کد نوع گروه",
    buyFactorWithoutReceiptTotalCount: "تعداد رسید نشده‌ها",
    propertySystemCode: "کد سیستم دارایی",
    mainDepartment: "دپارتمان اصلی",
    interest: "بهره",
    paymentCashCode: "شماره برگه پرداخت",
    receiveCashCode: "شماره برگه دریافت",
    bankTransferCode: "شماره برگه انتقال",
    dependentsCount: "تعداد افراد تحت تکفل",
    girlCount: "تعداد فرزند دختر",
    boyCount: "تعداد فرزند پسر",
    studyFieldType: "رشته تحصیلی",
    personnelNumber: "شماره پرسنلی",
    personnelCardNumber: "شماره کارت پرسنلی",
    employmentDate: "تاریخ استخدام",
    leaveDate: "تاریخ ترک کار",
    salaryDepositBank: "بانک واریز حقوق",
    isLeaveWork: "این فرد ترک کار کرده است؟",
    blockingSalary: "مسدود شدن حقوق",
    employmentType: "نوع استخدام",
    placeOfService: "محل خدمت",
    serviceStatus: "وضعیت محل خدمت",
    insuranceName: "نام بیمه",
    insuranceType: "نوع بیمه",
    insuranceNumber: "شماره بیمه",
    retirementDate: "تاریخ بازنشستگی",
    nationalityType: "نوع تابعیت",
    nationalityCountry: "کشور تابعیت",
    occupationCategory: "رسته",
    positionInfo: "سمت/شغل (بیمه)",
    taxHousing: "مسکن",
    sbuOrg: "واحد سازمانی (sbu)",
    isDiscount: "تخفیف",
    saleAddMinus: "اضافات و کسورات فاکتور فروش",
    calculateType: "نوع محاسبه",
    benefitsAndDeduction: "مزایا یا کسورات",
    contractType: "نوع حکم کارگزینی",
    jobGroup: "گروه های شغلی",
    insuranceWorkplace: "کارگاه بیمه",
    functionType: "نوع کارکرد",
    legalTaxException: "استثنائات قانون بودجه",
    monthlyWage: "دستمزد ماهانه",
    approvedWage: "حقوق مصوب",
    insuranceWage: "دستمزد بیمه",
    insuranceBaseWageYears: "پایه سنوات بیمه",
    workerShareInsurancePercentage: "درصد سهم بیمه کارگر",
    employerShareInsurancePercentage: "درصد بیمه سهم کارفرما",
    unemploymentSharePercentage: "درصد بیمه بیکاری",
    isExemptionEmployerShare: "مشمول معافیت سهم کارفرما",
    isAdditionalInsurance: "بیمه تکمیلی",
    additionalInsurance: "مبلغ پایه بیمه تکمیلی",
    calculateTaxType: "نوع محاسبه مالیات",
    taxExemptionPercent: "درصد معافیت مالیاتی",
    calculateTaxForHourly: "مالیات ساعتی براساس",
    isOverTime: "مجاز به اضافه کار",
    overtimeRate: "ضریب محاسبه اضافه کار",
    isOffOvertime: "مجاز به اضافه کار تعطیل",
    calculateOffOverTimeType: "محاسبه اضافه کار روز تعطیل",
    offOverTimeRate: "ضریب اضافه کار روز تعطیل",
    remainVacationDays: "ذخیره یا بدهی مرخصی از قبل",
    remainServiceDays: "مانده سنوات از قبل به روز",
    isShiftWork: "محاسبه نوبتکاری",
    shiftWorkRate: "ضریب یا نرخ نوبتکاری",
    isFriday: "محاسبه جمعه کاری",
    fridayRate: "ضریب جمعه کاری",
    isMission: "محاسبه ماموریت",
    missionRate: "ضریب ماموریت",
    isDeduction: "محاسبه کسرکار",
    calculateDeductionRateType: "نوع نرخ کسرکار",
    deductionRate: "ضریب کسر کار",
    deductionFormula: "فرمول محاسبه ی کسر کار",
    exemptionType: "نوع معافیت",
    department: "دپارتمان",
    otherTaxSubject: "موضوع سایر مالیات و عوارض",
    otherTaxPercentage: "درصد سایر مالیات و عوارض",
    otherTaxPrice: "مبلغ سایر مالیات و عوارض",
    legalSubject: "موضوع سایر وجوه قانونی",
    legalPercentage: "درصد سایر وجوه قانونی",
    legalPrice: "مبلغ سایر وجوه قانونی",
    voucherNoteType: "نوع یادداشت‌ سند",
    cashDeposit: "واریز",
    withdrawal: "برداشت",
    currencyCashDeposit: "واریز ارزی",
    currencyWithdrawal: "برداشت ارزی",
    paymentCashPrice: "جمع پرداخت‌های نقد",
    paymentChequePrice: "جمع اسناد پرداختی پاس شده",
    sumPaymentChequePrice: "جمع اسناد پرداخت شده",
    expression: "فرمول",
    wares: "انبارها",
    paperNumber: "شماره برگه",
    lastTurnDate: "تاریخ آخرین گردش",
    lastTurnUser: "آخرین کاربر گردش",
    isChildAllowance: "حق اولاد",
    childAllowanceRate: "مبلغ حق اولاد",
    isMarriageAllowance: "حق تاهل",
    marriageAllowanceRate: "مبلغ حق تاهل",
    isLaborAllowance: "بن",
    laborAllowanceRate: "مبلغ بن",
    isHousingAllowance: "حق مسکن",
    housingAllowanceRate: "مبلغ حق مسکن",
    requestPaymentCashCode: "شماره درخواست پرداخت",
    placeOfIssue: "محل صدور شناسنامه",
    sumReceivedReceivables: "جمع اسناد دریافتنی وصول شده",
    sumReceiveCashPrice: "جمع دریافت‌های نقد",
    beginPaymentCashPrice: "مانده از قبل پرداخت‌های نقد",
    beginReceiveCashPrice: "مانده از قبل دریافت‌های نقد",
    beginPaymentChequePrice: "مانده از قبل اسناد پرداختنی",
    beginReceiveChequePrice: "مانده از قبل اسناد دریافتنی",
    endSumPrice: "جمع بعد از دوره",
    endPaymentCashPrice: "جمع بعد از دوره پرداخت‌های نقد",
    endReceiveCashPrice: "جمع بعد از دوره دریافت‌های نقد",
    endPaymentChequePrice: "جمع بعد از دوره اسناد پرداختنی",
    endReceiveChequePrice: "جمع بعد از دوره اسناد دریافتنی",
    receiveCashGroup: "دریافت‌های نقد",
    paymentCashGroup: "پرداخت‌های نقد",
    receiveChequeGroup: "اسناد دریافتنی",
    paymentChequeGroup: "اسناد پرداختنی",
    duringPeriod: "طی دوره",
    afterPeriod: "بعد از دوره",
    accountPersonInfo: "مشخصات حساب و شخص",
    married: "متاهل",
    presentDays: "ایام حضور",
    workedDays: "ایام کارکرد",
    isTaxChanged: "مالیات تغییر کرده‌است",
    calculatedTax: "مالیات محاسبه‌شده توسط سیستم",
    isInsuranceCostByWorkedDays: "محاسبه هزینه بیمه براساس کارکرد بیمه",
    insuranceWorkedDays: "ایام کارکرد بیمه",
    workedTotalHour: "کارکرد به ساعت",
    workedHourly: "کارکرد ساعتی",
    absentDays: "غیبت",
    vacation: "مرخصی استحقاقی(روز)",
    vacationHourly: "مرخصی ساعتی",
    vacationTotalHour: "مرخصی به ساعت",
    vacationDaily: "مرخصی روزانه",
    vacationWithoutSalaryHourly: "مرخصی بدون حقوق ساعتی",
    vacationWithoutSalaryTotalHour: "مرخصی بدون حقوق به ساعت",
    vacationWithoutSalaryDaily: "مرخصی بدون حقوق روزانه",
    vacationWithoutSalary: "مرخصی بدون حقوق(روز)",
    sickVacationHourly: "استعلاجی ساعتی",
    sickVacationTotalHour: "استعلاجی به ساعت",
    sickVacationDaily: "استعلاجی روزانه",
    sickVacationDays: "استعلاجی(روز)",
    deductionHourly: "کسر کار ساعتی",
    deductionTotalHour: "کسر کار به ساعت",
    deductionDaily: "کسر کار روزانه",
    deductionDays: "کسرکار(روز)",
    shiftWorkDays: "نوبتکاری(روز)",
    fridayworkhourly: "جمعه کاری ساعتی",
    fridayWorkTotalHour: "جمعه کاری به ساعت",
    fridayWorkDays: "جمعه کاری (روز)",
    friday: "جمع کاری به روز",
    missionHourly: "ماموریت ساعتی",
    missionTotalHour: "ماموریت به ساعت",
    missionDays: "ماموریت (روز)",
    mission: "ماموریت به روز",
    commonOverTimeHourly: "اضافه کار عادی ساعتی",
    commonOverTimeTotalHour: "اضافه کار عادی به ساعت",
    commonOverTimeTotal: "اضافه کار(مجموع عادی و تعطیلی)",
    commonOverTimePrice: "مبلغ اضافه کار عادی",
    offOverTimePrice: "مبلغ اضافه کار تعطیل",
    overTimePrice: "مبلغ اضافه کار",
    offOverTimeHourly: "اضافه کار تعطیلی ساعتی",
    offOverTimeTotalHour: "اضافه کار تعطیلی به ساعت",
    vacationSettlementDays: "تسویه مرخصی(روز)",
    occasionalVacation: "مرخصی مناسبتی(روز)",
    benefitAndDeduction: "مزایا و کسورات",
    chequeDescription: "شرح چک",
    areaSuite: "متراژ واحد",
    areaCount: "تعداد واحد",
    shareCount: "مقدار سهم هر واحد",
    shareNumber: "تعداد سهم",
    areaShare: "متراژ هر سهم",
    contractCode: "کد حکم کارگزینی",
    wage: "دستمزد",
    baseWageYears: "پایه سنوات",
    totalBenefits: "جمع مزایای حقوق",
    totalInsuranceBenefits: "جمع مزایای مشمول بیمه",
    totalTaxBenefits: "جمع مزایای مشمول مالیات",
    totalSalaryAndBenefits: "جمع حقوق و مزایا",
    totalInsuranceSalaryAndBenefits: "جمع حقوق و مزایای مشمول بیمه",
    totalInsuranceDisplaySalary: "جمع حقوق و مزایای مشمول و غیر مشمول بیمه",
    totalTaxSalaryAndBenefits: "جمع حقوق و مزایای مشمول مالیات",
    insuranceEmployeeShare: "حق بیمه سهم کارگر",
    insuranceEmployerShare: "حق بیمه سهم کارفرما",
    unemploymentInsurance: "بیمه بیکاری",
    supplementaryInsurance: "بیمه تکمیلی - سایر بیمه ها",
    totalDeductions: "جمع کسورات",
    netSalary: "خالص حقوق",
    netSalaryText: "خالص حقوق به حرف",
    approvedSalaryDifference: "مابه التفاوت مصوب",
    totalPayable: "جمع کل قابل پرداخت",
    roundAmount: "رند حقوق",
    finalSalary: "خالص پرداختی",
    finalSalaryToWord: "خالص پرداختنی به حرف",
    lastConfirmUser: "کاربر تایید/قطعی سازی",
    lastConfirmDate: "زمان تایید/قطعی سازی",
    isCashPayment: "پرداخت نقد",
    announcementDate: "تاریخ اعلام",
    announcementTyps: "نوع اعلام",
    calculationDateScore: "تاریخ محاسبه امتیاز",
    participation: "مشارکت",
    benefitAmount: "مبلغ مزایا",
    deductionAmount: "مبلغ کسورات",
    insuranceAmount: "مبلغ بیمه",
    bankAccount: "حساب بانکی",
    participationCode: "کد مشارکت",
    needDate: "تاریخ نیاز",
    estimationSubject: "موضوع برآورد",
    crimesRewardSubject: "موضوع پاداش و جرائم",
    usefulArea: "متراژ مفید",
    bankingFacilities: "تسهیلات بانکی",
    endDateCalculationOfScore: "تاریخ پایان محاسبه امتیاز",
    fineRate: "نرخ جریمه",
    finePercentage: "درصد جریمه",
    fineCriterion: "معیار جریمه",
    rewardRate: "نرخ پاداش",
    rewardPercentage: "درصد پاداش",
    rewardCriterion: "معیار پاداش",
    forecastPricePerMeter: "پیش بینی بهای هر متر",
    suiteCount: "تعداد واحد",
    impactRankings: "تاثیر در رتبه‌بندی",
    paymentDeadline: "مهلت پرداخت",
    totalArea: "متراژ کل",
    hasPayroll: "حقوق و دستمزد",
    bon: "بن",
    childAllowancePrice: "حق اولاد",
    housingAllowancePrice: "حق مسکن",
    insuranceMonthlyWage: "جمع دستمزد ماهانه",
    marriageAllowancePrice: "حق تاهل",
    receiveAndPaySubject: "موضوع دریافت و پرداخت",
    pointsCalculationRate: "نرخ محاسبه امتیاز",
    percentageRate: "پورسانتاژ",
    shopper: "خریدار",
    annualBonus: "عیدی سالانه",
    bonus: "پاداش",
    businessTripAllowance: "فوق‌العاده ماموریت",
    calculatedTaxAmount: "مالیات محاسبه‌شده",
    consultingAttendanceTechnicalFees: "حق الزحمه/حق مشاوره/حق حضور",
    currentGrossSalaryAndRecurringCashBenefits:
      "جمع ناخالص حقوق و مزایای مستمر نقدی",
    currentNonRecurringCashBenefits: "سایر حقوق و مزایای غیرمستمر نقدی",
    currentNonRecurringNonCashBenefits: "مزایای غیرمستمر غیرنقدی",
    deferredNonRecurringCashBenefits: "حقوق و مزایای غیرمستمر نقدی معوق",
    deferredNonRecurringNonCashBenefits: "مزایای غیرمستمر غیرنقدی معوق",
    deferredRecurringCashBenefits: "حقوق و مزایای مستمر نقدی معوق",
    deferredRecurringNonCashBenefits: "حقوق و مزایای مستمر غیرنقدی معوق",
    recurringNonCashBenefits: "مزایای غیر مستمر غیر نقدی",
    dismissalCompensation: "خسارت اخراج",
    endOfServiceBonus: "پاداش پایان خدمت",
    housingDeduction: "کسر مسکن",
    insuranceWageDays: "دستمزد روزانه بیمه",
    laborCompensation: "حق السعی",
    lifeInsurancePremium: "حق بیمه عمر",
    medicalInsurancePremium: "حق بیمه درمان",
    onCallPrice: "حق کشیک",
    paidTaxAmount: "مالیات پرداختی",
    performancePrice: "کارانه",
    researchContractAmount: "مبلغ قراردادهای پژوهشی",
    seniorityPrice: "حق سنوات",
    serviceBuyback: "بازخرید خدمت",
    taxVehicle: "وسیله نقلیه",
    teachingResearchPrice: "حق التدریس/حق التحقیق/ حق پژوهش",
    travelExpense: "هزینه سفر",
    unusedLeaveCompensation: "حقوق ایام مرخصی استفاده‌نشده",
    vehicleDeduction: "کسر وسیله نقلیه",
    welfareIncentiveProductivityPrice: "رفاهی و انگیزشی و بهره‌وری",
    workPlaceStatus: "وضعیت محل خدمت",
    yearEndBonus: "پاداش پایان سال",
    projectTotalScore: "امتیاز در پروژه",
    rankInProject: "رتبه در پروژه",
    rankInSuite: "رتبه در واحد",
    suiteTotalScore: "امتیاز در واحد",
    percentageOfProject: "درصد در پروژه",
    percentageOfSuite: "درصد در واحد",
    depositPrice: "مبلغ واریزی",
    adjustedScore: "امتیاز تعدیل شده",
    advanceTotalPrice: "مبلغ کل مساعده",
    advance: "مساعده",
    confirmDisconformDate: "تاریخ تایید/عدم‌تایید",
    parentDb: "پایگاه داده والد",
    parentSchema: "شمای والد",
    parentTable: "جدول والد",
    parentPk: "کلید اصلی والد",
    childDb: "پایگاه داده فرزند",
    childSchema: "شمای فرزند",
    childTable: "جدول فرزند",
    childPk: "کلید اصلی فرزند",
    foreignKey: "کلید خارجی",
    deleteBehavior: "رفتار حذف",
    childHasColumnLog: "ستون لاگ در فرزند",
    moduleKey: "ماژول",
    databaseName: "پایگاه داده",
    tempDatabaseName: "پایگاه داده موقت",
    rowsCopied: "ردیف‌های کپی‌شده",
    sourceFiscalYear: "سال مالی مبدأ",
    targetFiscalYear: "سال مالی مقصد",
    fiscalYearTitle: "عنوان سال مالی",
    createdInTarget: "ایجاد در مقصد",
    winBackupFiscalYear: "سال",
    winBackupTargetFiscalYearId: "شناسه‌ی مقصد",
    winBackupSourceBranch: "شعبه‌ی مبدأ",
    winBackupTargetBranch: "شعبه‌ی مقصد",
    mainGroupTitle: "گروه اصلی",
    subGroupTitle: "فرعی",
    openingInventory: "موجودی ابتدای دوره",
    buyReceipt: "رسید خرید",
    sellReturnReceipt: "رسید مرجوعی فروش",
    productionReceipt: "رسید تولید",
    adjustmentReceipt: "رسید تعدیلات (انبارگردانی)",
    otherReceipt: "سایر رسیدها",
    totalReceipt: "جمع رسید",
    sellDraft: "حواله فروش",
    buyReturnDraft: "حواله مرجوعی خرید",
    productionDraft: "حواله تولید",
    adjustmentDraft: "حواله تعدیلات",
    otherDraft: "سایر حواله‌ها",
    totalDraft: "جمع حواله‌ها",
    keyTypeTitle: "نوع کلید",
    tempReceiptNumber: "شماره رسید موقت",
    buyFactorCode: "شماره فاکتور خرید",
    returnSaleFactorCode: "شماره فاکتور مرجوعی فروش",
    productionCode: "شماره کارت تولید",
    articleCount: "تعداد آرتیکل",
    currencyRateDate: "تاریخ نرخ",
    currencyRemain: "مانده ارزی",
    openingBalance: "مانده اول دوره",
    turnoverDuringPeriod: "گردش طی دوره",
    turnoverToDate: "گردش لغایت پایان دوره",
    endingBalance: "مانده پایان دوره",
    archiveUser: "کاربر بایگانی",
    registerAndBirthDate: "تاریخ ثبت/تولد",
    fileNamePattern: "الگوی نام فایل",
    recordTypeCount: "تعداد رکورد",
    fieldCount: "تعداد فیلد",
    rulesCount: "قواعد",
    parameter: "پارامتر",
    severity: "شدت",
    messageKey: "کلید پیام",
    recordCount: "تعداد رکورد",
    employeeCount: "تعداد پرسنل",
    sumAmount: "جمع مبلغ",
    fieldName: "فیلد",
    fileSize: "حجم فایل",
    fileHash: "اثر انگشت فایل",
    errorMessage: "پیام خطا",
    cardNumber: "شماره کارت",
    mitaTitle: "عنوان در میتا",
    modiranTitle: "معادل در مدیران",
    direction: "جهت",
    isMergeable: "قابل ادغام",
    notMergeableReason: "دلیل ادغام ناپذیر",
    baseVoucher: "سند مبنا",
    sourceVouchers: "اسناد مبدا",
    movedDetailCount: "تعداد ردیف منتقل شده",
    isNewVoucher: "جدید",
    serviceCategory: "گروه خدمات",
    serviceCode: "کد خدمات",
    serviceTitle: "عنوان خدمات",
    cashInventoryBeginningPeriod: "موجودی نقد ابتدای دوره",
    transportationInfo: "اطلاعات ترابری",
    additionalInfo: "اطلاعات تکمیلی",
    leadSourceCode: "کد منبع سرنخ",
    leadPropertyCode: "کد ویژگی سرنخ",
    leadType: "نوع سرنخ",
    leadTypeCode: "کد نوع سرنخ",
    responsibleUserName: "نام کاربری مسئول",
    responsibleFirstName: "نام مسئول",
    responsibleLastName: "نام خانوادگی مسئول",
    responsibleFullName: "نام کامل مسئول",
    assignDate: "تاریخ تخصیص",
    isQualified: "واجد شرایط",
    leadEvaluationResult: "نتیجه ارزیابی",
    evaluationDate: "تاریخ ارزیابی",
    evaluationDescription: "شرح ارزیابی",
    isChance: "تبدیل به فرصت",
    chanceCount: "تعداد فرصت",
    sourceWareShelf: "انبارک مبدا",
    destinationWareShelf: "انبارک مقصد",
    leadCode: "کد سرنخ",
    leadName: "نام سرنخ",
    leadBrand: "برند سرنخ",
    saleStageTitle: "مرحله فروش",
    saleLineTitle: "خط فروش",
    successChanceCount: "فرصت موفق",
    conversionRatePercent: "نرخ تبدیل (٪)",
    serviceSupportSubjectTitle: "موضوع پشتیبانی",
    announcementType: "نوع اعلام",
    serviceContact: "راه ارتباطی",
    serviceContract: "قرارداد",
    contractParty: "طرف قرارداد",
    saleChance: "فرصت فروش",
    linkedServiceSupport: "پشتیبانی و سرویس",
    companySignatureDate: "تاریخ امضای شرکت",
    customerSignatureDate: "تاریخ امضای مشتری",
    commodityTotalPrice: "جمع کالا و خدمات",
    contractTotalPrice: "مبلغ نهایی",
    parentService: "پشتیبانی والد",
    doneUser: "انجام‌دهنده",
    doneDuration: "مدت انجام (دقیقه)",
    customerDescription: "شرح مشتری",
    customerSolution: "راه‌حل ارائه‌شده",
    stageOrder: "ترتیب",
    clearingMethod: "روش تسویه",
    factorConfirmStatus: "وضعیت تایید",
    result: "نتیجه",
    taxBuyer: "خریدار",
    taxDocument: "پرونده مالیاتی",
    taxInvoicePattern: "الگوی صورتحساب",
    taxInvoiceType: "نوع صورتحساب",
    taxMessage: "پیام سامانه مودیان",
    taxStatus: "وضعیت سامانه مودیان",
    taxExcelRowStatus: "وضعیت ارسال",
    taxUniqueId: "شماره منحصر به فرد مالیاتی",
    buyerBranchCode: "کد شعبه خریدار",
    buyerEconomicCode: "شناسه/شماره اقتصادی خریدار",
    buyerNationalId: "شناسه ملی/کد فراگیر خریدار",
    buyerPostalCode: "کد پستی خریدار",
    cashPayablePrice: "مبلغ نقد",
    cashShare: "سهم نقد",
    clubMember: "نام مشتری در باشگاه",
    commodityName: "شرح کالا",
    cottageDate: "تاریخ کوتاژ",
    createUser: "کاربر ثبت",
    customsCode: "کد گمرک",
    customsLicenseNumber: "شماره پروانه گمرکی",
    isLastInvoice: "آخرین صورتحساب",
    isReturned: "مرجوعی",
    priceWithDiscount: "قیمت بعد از تخفیف",
    priceWithoutDiscount: "قیمت کل",
    referenceTaxId: "شماره مالیاتی مرجع",
    sellerContractNumber: "شناسه یکتای ثبت قرارداد",
    taxBuyerType: "نوع خریدار",
    taxCommodityId: "شناسه کالای مالیاتی",
    taxConfirmedReferenceNumber: "شماره مرجع نهایی",
    taxInvoiceId: "شناسه صورتحساب در سامانه مالیات",
    taxInvoiceSubject: "موضوع صورتحساب",
    taxRate: "نرخ ارزش افزوده",
    taxReferenceNumber: "شماره مرجع موقت",
    taxSandBox: "آزمایشی",
    taxShare: "سهم ارزش افزوده",
    taxUId: "شناسه یکتای ارسال",
    excelName: "فایل اکسل",
    totalCurrencyValue: "جمع ارزش ارزی",
    totalLinePrice: "خالص خطی",
    totalOtherTaxPrice: "مجموع سایر عوارض",
    totalRialValue: "جمع ارزش ریالی",
    totalTaxShare: "سهم ارزش افزوده از پرداخت",
    applicantPosition: "نقش/سمت متقاضی",
    guildUnitTitle: "عنوان واحد صنفی",
    keyTitle: "عنوان کلید",
    mltType: "نوع شخص متقاضی",
    organizationNameEn: "نام سازمان (انگلیسی)",
    organizationTitle: "نام سازمان (فارسی)",
    organizationType: "نوع سازمان",
    unitTitle1: "نام واحد سازمانی ۱",
    unitTitle2: "نام واحد سازمانی ۲",
    debitAccount: "حساب بدهکار",
    issuingBank: "بانک صادر کننده",
    commodityComplete: "تکمیل",
    documentCount: "تعداد",
    overDueCount: "تعداد سررسید گذشته",
    overDuePrice: "مبلغ سررسید گذشته",
    accountTitle: "عنوان حساب",
    personClubMobileNumber: "موبایل عضو باشگاه",
    referralSeenStatus: "مشاهده ارجاع",
    transferCommodityNo: "شماره انتقال بین انبار",
    orderCode: "شماره سفارش",
    orderDate: "تاریخ سفارش",
    customerFullName: "نام مشتری",
    subUnitCoefficient: "ضریب واحد فرعی",
    orderMainCount: "تعداد جزء سفارش",
    orderSubUnitCount: "تعداد فرعی سفارش",
    orderTotalCount: "تعداد کل سفارش",
    orderExpireDate: "تاریخ اعتبار سفارش",
    orderWare: "انبار سفارش",
    orderCommodityDescription: "توضیحات سطر کالا",
    orderDescription: "توضیحات سفارش",
    permittedTotalCount: "تعداد کل تایید شده",
    permittedSubUnitCount: "تعداد تایید شده فرعی",
    permittedMainCount: "تعداد تایید شده جزء",
    remainingPermitCount: "باقی مانده",
    remainingPermitSubUnitCount: "باقی مانده فرعی",
    draftedTotalCount: "تعداد کل حواله شده",
    remainingPermitWithoutDraftCount: "مانده مجوز بدون حواله",
    currentPermitMainCount: "تعداد تایید جاری جزء",
    currentPermitSubUnitCount: "تعداد تایید جاری فرعی",
    currentPermitTotalCount: "تعداد تایید جاری کل",
    permitDate: "تاریخ مجوز",
    permitMainCount: "تعداد جزء مجوز",
    permitSubUnitCount: "تعداد فرعی مجوز",
    permitTotalCount: "تعداد کل مجوز",
    permitDescription: "توضیحات مجوز",
    canDelete: "قابل حذف",
    draftedSubUnitCount: "تعداد ارسال فرعی",
    draftedMainCount: "تعداد ارسال جزء",
    sentTotalCount: "تعداد کل ارسال ها",
    remainingDraftCount: "مانده ارسال",
    remainingDraftSubUnitCount: "مانده ارسال فرعی",
    draftPermittedTotalCount: "تعداد مجوز کل",
    draftPermittedSubUnitCount: "تعداد مجوز فرعی",
    draftPermittedMainCount: "تعداد مجوز جزء",
    remainingPermitWithoutDraftSubUnitCount: "باقی مانده مجوز فرعی",
    currentDraftMainCount: "تعداد حواله جزء",
    currentDraftSubUnitCount: "تعداد حواله فرعی",
    currentDraftTotalCount: "تعداد حواله کل",
    draftWareVoucherType: "نوع حواله",
    draftCode: "شماره حواله",
    draftDate: "تاریخ حواله",
    draftMainCount: "تعداد جزء حواله",
    draftSubUnitCount: "تعداد فرعی حواله",
    draftTotalCount: "تعداد کل حواله",
    saleFactorCode: "شماره فاکتور فروش",
    factorInfo: "اطلاعات فاکتور",
  },
  form: {
    stockInWare: "موجودی در انبار",
    booth: "غرفه",
    personClub: "عضو باشگاه مشتریان",
    store: "فروشگاه",
    workTime: "ساعت کاری",
    storeSupervisor: "سرپرست فروشگاه",
    boothSupervisor: "سرپرست فروش",
    posTerminalType: "نوع دستگاه",
    connectionType: "نوع اتصال",
    ip: "IP",
    port: "پورت",
    deviceModel: "مدل",
    terminalNumber: "شماره ترمینال",
    merchantId: "شماره پذیرنده",
    benefitCardUId: "شناسه کارت",
    benefitCardNumber: "شماره کارت",
    benefitCardExpireDate: "تاریخ اعتبار",
    benefitCardIssueDate: "تاریخ صدور",
    benefitCardType: "نوع بن کارت",
    benefitCardOwner: "صاحب کارت (عضو باشگاه)",
    benefitCardInitialBalance: "اعتبار اولیه",
    benefitCardIsBlock: "مسدود",
    benefitCardBlockStatus: "مسدودی",
    benefitCardIsPinRequired: "رمز برای خرید لازم است",
    benefitCardPassword: "رمز عبور",
    benefitCardNewExpireDate: "تاریخ اعتبار جدید",
    benefitCardChargeAmount: "مبلغ شارژ (منفی = کاهش)",
    benefitCardAccountingPerson: "شخص حسابداری",
    benefitCardFromCard: "کارت مبدأ",
    benefitCardToCard: "کارت مقصد",
    benefitCardFromBalance: "موجودی کارت",
    benefitCardAmount: "مبلغ",
    benefitCardUpdateIfExist:
      "در صورت وجود شماره کارت، اطلاعات تکمیلی به‌روز شود",
    benefitCardTransactionType: "نوع گردش",
    benefitCardCard: "بن کارت",
    defaultPerson: "شخص طرف حساب",
    isRemainCheck: "بررسی موجودی هنگام ثبت فاکتور فروش",
    isAllCommodityGroup: "شامل همه گروه‌های کالا",
    commodityGroups: "گروه‌های کالا",
    storeLogo: "لوگو فروشگاه",
    cancelReason: "دلیل انصراف",
    unitCount: "واحد شمارش",
    subUnitCountId: "واحد فرعی",
    preOrderCancelStatus: "وضعیت انصراف",
    feedBackStatus: "وضعیت نظرسنجی",
    portalAccess: "دسترسی به پرتال",
    feedBackSort: "مرتب‌سازی",
    feedBackImage: "تصویر نظرسنجی",
    firstName: "نام",
    lastName: "نام خانوادگی",
    fullName: "نام کامل",
    brandName: "نام تجاری",
    userName: "نام کاربری",
    password: "رمز عبور",
    user: "کاربر",
    repeatPassword: "تکرار رمز عبور",
    currentPassword: "رمز عبور فعلی",
    newPassword: "رمز عبور جدید",
    email: "پست الکترونیک",
    mobile: "تلفن همراه",
    tel: "شماره تماس",
    phone: "تلفن ثابت",
    address: "آدرس",
    zipCode: "کد پستی",
    otpCode: "کد احراز هویت (کد تأیید)",
    image: "تصویر",
    file: "فایل",
    fileSize: "حداکثر حجم مجاز",
    fileType: "پسوندهای مجاز",
    fileRatio: "تصویر در ابعاد مربعی انتخاب کنید",
    department: "دپارتمان",
    birthDate: "تاریخ تولد",
    description: "توضیحات",
    content: "متن و محتوا",
    message: "متن پیام",
    subjectMessage: "موضوع پیام",
    sms: "متن پیامک",
    subject: "موضوع",
    title: "عنوان",
    qty: "تعداد",
    category: "دسته بندی",
    role: "نقش کاربر",
    productName: "نام / عنوان محصول",
    annualDemand: "مقدار نیاز سالانه",
    resell: "فروش مجدد",
    sendDate: "تاریخ ارسال",
    productDate: "تاریخ تولید",
    cashOption: "پرداخت نقدی",
    chequeOption: "چک بانکی",
    bank: "بانک",
    accountNumber: "شماره حساب",
    bankCardNumber: "شماره کارت بانکی",
    shabaNumber: "شماره شبا",
    attachment: "فایل پیوست",
    dropzoneTxt: "کلیک و یا فایل را در اینجا رها کنید",
    workStation: "ایستگاه کاری",
    usage: "کاربرد",
    isActive: "فعال",
    status: "وضعیت",
    healthy: "سالم",
    broken: "خراب",
    active: "فعال",
    inActive: "غیرفعال",
    code: "شماره",
    codeB: "کد", // code in base information
    personCode: "کد شخص",
    personName: "نام شخص",
    branchCode: "کدشعبه",
    product: "محصول",
    material: "ماده اولیه",
    unit: "واحد شمارش",
    main: "اصلی",
    sub: "فرعی",
    count: "مقدار",
    nationalCode: "کدملی",
    national: "کدملی/ شناسه ملی",
    taxId: "شناسه مالیاتی",
    fromDate: "از تاریخ",
    toDate: "تا تاریخ",
    orderNo: "شماره سفارش",
    date: "تاریخ",
    baseDate: "تاریخ مبنا",
    customer: "مشتری",
    totalPrice: "مبلغ کل",
    tax: "ارزش افزوده",
    lastPrice: "مبلغ قابل پرداخت",
    taxPercent: "درصد ارزش افزوده",
    taxPercent2: "درصد مالیات",
    taxPrice: "مبلغ ارزش افزوده",
    commodity: "کالا",
    commodityTitle: "نام کالا",
    commodityCode: "کد کالا",
    deliveryDate: "تاریخ تحویل",
    discountPercentage: "درصد تخفیف",
    offPrice: "مبلغ تخفیف",
    discountValue: "مقدار تخفیف",
    thickness: "ضخامت",
    alloy: "آلیاژ",
    hardness: "سختی",
    width: "عرض",
    internalDiameterCore: "قطر کور داخلی",
    minRollWeight: "حداقل وزن رول",
    maxRollWeight: " حداکثر وزن رول",
    weight: "وزن",
    importanceFactor: "ضریب اهمیت",
    nodeDepth: "سطح حساب",
    floatAccountLevel: "سطح حساب شناور",
    floatAccountGroups: "گروه‌های حساب شناور",
    accounts: "حساب‌ها",
    articleAccount: "حساب آرتیکل",
    accountPerson: "انتخاب حساب",
    accountTitle: "عنوان حساب",
    accountCode: "کد حساب",
    isCurrency: "حساب ارزی",
    isExchange: "تسعیر شود",
    accountIsActive: "وضعیت حساب",
    accountType: "ماهیت حساب",
    personControl: "الزام شخص",
    project: "پروژه",
    car: "خودرو ها",
    costCenter: "مراکز هزینه",
    operation: "عملیات",
    operationalClassification: "طبقه بندی عملیاتی",
    isFoilFeasibility: "تایید واحد فویل؟",
    isFinancialFeasibility: "تایید مالی؟",
    isCasterFeasibility: "تایید کستر؟",
    isColdRollFeasibility: "تایید نورد سرد؟",
    isSaleFeasibility: "تایید فروش؟",
    isManagerFeasibility: "تایید مدیرعامل؟",
    company: "شرکت",
    employer: "کارفرما",
    economicCode: "کد اقتصادی",
    nationalId: "شناسه ملی",
    registerNo: "شماره ثبت",
    registerPlace: "محل ثبت",
    taxArea: "حوزه مالیاتی",
    taxBranchCode: "کدشعبه مالیاتی",
    isMainBranch: "شعبه اصلی",
    actionField: "زمینه فعالیت",
    registerDate: "تاریخ ثبت",
    registerAndBirthDate: "تاریخ ثبت/تولد",
    branch: "شعبه",
    financialYear: "سال مالی",
    startDate: "تاریخ شروع",
    endDate: "تاریخ پایان",
    branchTitle: "نام شعبه",
    commodityCategory: "گروه کالا",
    commodityFullName: "نام کامل کالا",
    commodityOrginalTitle: "عنوان اصلی کالا",
    commoditySubTitle: "عنوان فرعی کالا",
    technicalId: "شناسه فنی",
    orderPoint: "نقطه سفارش",
    minInventory: "حداقل موجودی",
    maxInventory: "حداکثر موجودی",
    averageConsumptionPeriod: "بازه متوسط مصرف",
    timeToGetGoods: " زمان تحصیل کالا",
    maxNegativeInventory: "سقف موجودی منفی",
    commodityTaxId: "شناسه مالیاتی",
    commodityTaxTitle: "عنوان مالیاتی",
    offPercent: "درصد تخفیف",
    height: "ارتفاع",
    length: "طول",
    volume: "حجم",
    power: "توان",
    buyPrice: "قیمت پایه خرید",
    salePrice: "قیمت پایه فروش",
    consumerPrice: "قیمت مصرف کننده",
    specialFeature: "مشخصه ویژه",
    service: "خدمات",
    isService: "صرفا به عنوان خدمت مورد استفاده قرار می گیرد.",
    allWare: "فعال در همه انبارها",
    negativeInventory: "امکان ثبت موجودی منفی",
    categoryHeader: "سرگروه",
    percent: "درصد",
    meter: "متر",
    fromThickness: "از ضخامت",
    toThickness: "تا ضخامت",
    ware: "انبار",
    wareShelfInfo: "انبارک",
    value: "مقدار",
    country: "کشور",
    province: "استان",
    city: "شهر",
    personType: "نوع شخص",
    birthCertificateNo: "شماره شناسنامه",
    fatherName: "نام پدر",
    gender: "جنسیت",
    maritalStatus: "وضعیت تاهل",
    postalCode: "کد پستی",
    managerNationalCode: "کدملی مدیرعامل",
    registrationNumber: "شماره ثبت",
    personGroup: "گروه اشخاص",
    signatureImage: "تصویر امضا",
    personImage: "تصویر شخص",
    nationality: "تابعیت",
    universalCode: "کد فراگیر اتباع",
    iranian: "ایرانی",
    nonIranian: "غیر ایرانی",
    issuedAt: "صادره از",
    sbu: "مرکز هزینه",
    coefficient: "ضریب تبدیل",
    isMaterial:
      "این کالا به عنوان ماده اولیه کالای دیگر در سیستم بهای تمام شده مورد استفاده قرار می گیرد.",
    isProduct:
      "این کالا به عنوان کالای قابل فروش یا محصول در سایر سیستم ها مورد استفاده قرار می گیرد.",
    isAsset:
      "این کالا به عنوان دارایی ثابت در سیستم اموال و دارایی های ثابت مورد استفاده قرار می گیرد.",
    unitCoefficient: "ضریب تبدیل واحد",
    order: "سفارش",
    estimateDoneDate: "تاریخ تقریبی انجام",
    process: "فرآیند",
    program: "برنامه",
    inputNo: "شماره ورودی",
    inputWeight: "وزن ورودی",
    outputWeight: "وزن خروجی",
    ra: "RA",
    mark: "علامت",
    startTime: "زمان شروع",
    endTime: "زمان پایان",
    produceOrderNo: "شماره دستور تولید",
    bom: "فرمول تولید",
    wareReceiptType: "نوع رسید",
    wastage: "ضایعات",
    draftType: "نوع حواله",
    wareReceiptNo: "شماره رسید انبار",
    accountingDocumentNo: "شماره سند حسابداری",
    productionNo: "شماره تولید",
    coilNo: "شماره کویل",
    totalWeight: "وزن کل",
    priority: "اولویت",
    showInSalePanel: "دسترسی سریع در پنل فروش",
    commodityGroupImage: "تصویر گروه کالا",
    branchOrigin: "شعبه‌ی مبدا",
    financialYearOrigin: "سال مالی مبدا",
    insuranceWorkshopCode: "کدکارگاهی بیمه",
    superAdmin: "مدیرکل",
    superdirector: "راهبر کل",
    director: "مدیر شعبه",
    supervisor: "سرپرست گروه",
    roles: "نقش‌ های کاربران",
    isAdmin: "مدیر سیستم",
    group: "گروه",
    graid: "گرید",
    factorType: "نوع فاکتور",
    commission: "کمیسیون",
    maxCountOrder: "حداکثر تعداد سفارش",
    score: "امتیاز",
    position: "سمت",
    positionTitle: "عنوان سِمت",
    parentUnit: "واحد شمارش مبنا",
    wareCategory: "دسته بندی انبار",
    accountHeader: "سرفصل‌ حساب",
    systemType: "نوع سیستم",
    rfidTag: "تگ rfid",
    sbuType: "نوع واحد",
    floatLevelType: "نوع سطح شناور",
    floatAccountTypeTitle: "نوع حساب شناور",
    floatAccountGroupTitle: "گروه حساب شناور",
    sharePercentage: "درصد سهام",
    id: "شناسه سیستمی",
    commoditySerial: "سریال کالا",
    barcode: "بارکد",
    density: "چگالی",
    storagePlace: "محل نگهداری",
    buyHeader: "سرفصل‌ خرید کالا",
    saleHeader: "سرفصل‌ فروش کالا",
    additionalParameter: "پارامتر تکمیلی",
    voucherType: "نوع سند",
    input: "ورودی",
    output: "خروجی",
    creditAccount: "حساب بستانکار",
    debtAccount: "حساب بدهکار",
    isTemporery: "موقت",
    isInternalUse: "مصرف داخلی",
    receiptType: "نوع رسید/حواله",
    digit: "تعداد ارقام کد",
    parentCode: "کد گروه والد",
    mainCategory: "عنوان گروه اصلی",
    type: "نوع",
    receiptNo: "شماره رسید",
    isGeneral: "فعال در همه‌ی گروه‌ها",
    isCustomerClubMember: "عضویت در باشگاه مشتریان",
    region: "منطقه",
    real: "حقیقی",
    legal: "حقوقی",
    faxNumber: "شماره فکس",
    webSite: "وبسایت",
    capital: "پایتخت",
    population: "جمعیت",
    insuranceId: "کد بیمه",
    area: "مساحت",
    distance: "فاصله زمانی",
    floatGroupTitle: "عنوان گروه",
    actionType: "نحوه اقدام",
    floatAccControl: "الزام حساب شناور",
    isAlign: "تراز",
    mainAccount: "نام حساب اصلی",
    account: "عنوان حساب",
    parentAccountCode: "کد حساب والد",
    socialNetwork: "شبکه اجتماعی",
    prefixTitle: "عنوان (پیشوند)",
    prefix: "پیشوند",
    groupMembers: "افراد گروه",
    defaultBank: "حساب پیش‌فرض",
    permissionTitle: "عنوان دسترسی",
    parameterType: "نوع پارامتر",
    fieldType: "نوع فیلد",
    consumptionPlace: "محل مصرف",
    requester: "درخواست کننده",
    wareVoucherType: "نوع سند انبار",
    supplier: "تامین کننده",
    buyer: "مأمور خرید",
    receiptId: "شناسه رسید",
    draftRequestNo: "شماره درخواست حواله",
    draftSerial: "سریال حواله",
    serial: "سریال",
    totalCount: "مقدار کل",
    singlePrice: "فی واحد",
    floatAccount: "حساب شناور",
    confirmMainCount: "تعداد تایید اصلی",
    confirmSubCount: "تعداد تایید فرعی",
    confirmTotalCount: "تعداد تایید کل",
    search: "جستجو",
    creator: "کاربر ثبت",
    mainCount: "مقدار اصلی",
    subCount: "مقدار فرعی",
    batchNumber: "سری ساخت",
    batchNumberSelect: "انتخاب سری ساخت",
    trackingCode: "کد رهگیری",
    validityDate: "تاریخ اعتبار",
    voucher: "سند حسابداری",
    buyFactor: "فاکتور خرید",
    returnSaleFactor: "فاکتور مرجوعی فروش",
    production: "کارت تولید",
    tempReceipt: "شماره رسید موقت",
    draft: "شماره حواله انتقال",
    inventory: "شماره انبارگردانی",
    receiptStatus: "وضعیت رسید",
    subSystemTitle: "زیرسیستم",
    sheetName: "نام شیت",
    sheetName2: "نام شیت 2",
    sheetNameReceipt: "نام شیت رسید",
    sheetNameTempReceipt: "نام شیت رسیدموقت",
    sheetNameDraft: "نام شیت حواله",
    sheetNameBatch: "نام شیت بچ‌ها",
    requirement: "الزام",
    draftNo: "شماره حواله",
    saller: "مأمور فروش",
    saleFactor: "فاکتور فروش",
    returnBuyFactor: "فاکتور مرجوعی خرید",
    tempDraft: "حواله موقت",
    transferReceiptNo: "شماره رسید انتقال",
    draftStatus: "وضعیت حواله",
    receiver: "گیرنده",
    basedOnReceiver: "تحویل گیرنده",
    isConfirm: "قطعی",
    unConfirm: "غیرقطعی",
    driverName: "نام راننده",
    vehicleType: "نوع وسیله نقلیه",
    vehicleNumber: "شماره وسیله نقلیه",
    activePosition: "سِمت فعال",
    defaultPosition: "سِمت پیش‌فرض",
    weightCapacity: "وزن قابل حمل",
    volumeCapacity: "حجم قابل بارگیری",
    usefulLength: "طول مفید",
    usefulWidth: "عرض مفید",
    usefulHeight: "ارتفاع مفید",
    formName: "نام فرم",
    approvalPriority: "اولویت تایید",
    wareTitle: "نام انبار",
    delivererReceiver: "تحویل دهنده/ گیرنده",
    viewCommodityCirculation: "مشاهده کالاها با گردش",
    commodityId: "کد شناسه کالا",
    property: "(دارایی)",
    requestNo: "شماره درخواست",
    roundValue: "رند ارزش",
    sender: "فرستنده",
    sourceWare: "انبار مبدا",
    destinationWare: "انبار مقصد",
    transferIsSource: "درج اطلاعات حساب‌های شناور مبدا در مقصد",
    source: "مبدا",
    destination: "مقصد",
    number: "شماره",
    sendFromDate: "از تاریخ ارسال",
    sendToDate: "تا تاریخ ارسال",
    receiveFromDate: "از تاریخ دریافت",
    receiveToDate: "تا تاریخ دریافت",
    editCommodityBarcode: "بارکد برابر با کد کالای محاسباتی شود",
    countType: "نوع شمارش",
    storekeeper: "انباردار",
    groupCode: "کد گروه",
    warehousingType1: "درج شمارش کالا به کالا به صورت دستی",
    warehousingType2: "درج شمارش کالا از طریق فایل اکسل",
    warehousingType3: "درج شمارش کالا بر اساس سری ساخت",
    warehousingType4: "درج شمارش کالا بر اساس سری ساخت از طریق فایل اکسل",
    warehousingType5: "درج شمارش کالا به صورت لیستی",
    warehousingType6: "درج شمارش کالا از طریق فایل دستگاه جمع‌آوری اطلاعات",
    warehousingType7:
      "درج شمارش کالا از طریق دستگاه جمع‌آوری اطلاعات به صورت زنده",
    companyTitle: "عنوان تجاری کسب و کار",
    companyCode: "کد سازمان",
    companySlogan: "شعار سازمان",
    aboutCompany: "درباره سازمان",
    responsibleManager: "نام مدیر مسئول",
    neighborhood: "محله",
    contactName: "نام رابط",
    contactLastName: "نام خانوادگی رابط",
    defaultImage: "تصویر پیش فرض",
    gradeTitle: "عنوان سطح",
    fromScore: "از امتیاز",
    toScore: "تا امتیاز",
    color: "رنگ",
    timeIntervalCreditExpires: "فاصله زمانی قبل از انقضای اعتبار",
    shippingTime: "زمان ارسال",
    discountCode: "کد تخفیف",
    occasionType: "نوع مناسبت",
    timeIntervalBeforeOccasion: "فاصله زمانی قبل از مناسبت",
    assignGiftCredit: "تخصیص اعتبار هدیه",
    assignDiscountCode: "تخصیص کد تخفیف",
    price: "مبلغ",
    discountType: "نوع تخفیف",
    discountQuantity: "مقدار تخفیف",
    determiningDiscountLimit: "حداکثر مقدار تخفیف",
    useType: "نوع استفاده",
    limited: "محدود",
    unlimited: "نامحدود",
    maxUsed: "تعداد مجاز استفاده",
    deliveryMethod: "روش تحویل",
    fromSerial: "از سریال",
    toSerial: "تا سریال",
    defaultDesign: "طرح پیش فرض",
    design: "طرح",
    credit: "اعتبار",
    discountTitle: "عنوان تخفیف",
    campaignType: "نوع کمپین",
    personClubGroup: "گروه مشتری",
    isByCustomerLocation: "براساس محدوده مشتریان فعلی",
    isByZipCode: "براساس منطقه کشوری",
    ageGroup: "گروه سنی",
    campaignExecutionPhase: "فاز اجرا",
    isSendEmail: "ارسال ایمیل",
    isShowSlider: "نمایش در اسلایدر",
    expectedCost: "هزینه پیش‌بینی‌شده",
    expectedRevenue: "درآمد پیش‌بینی‌شده",
    executeDate: "تاریخ اجرا",
    expireDate: "تاریخ انقضا",
    executeTime: "ساعت اجرا",
    marriageDate: "تاریخ ازدواج",
    introducedType: "نحوه آشنایی",
    referrerMobileNumber: "شماره همراه معرف",
    salesChannel: "کانال فروش",
    tag: "برچسب ها",
    processType: "نوع فرآیند",
    feedbackTypeTitle: "نوع نظرسنجی",
    feedBackTitle: "عنوان نظرسنجی",
    viewCount: "تعداد بازدید",
    question: "سوال",
    maxCountAnswer: "حداکثر تعداد پاسخ",
    minCountAnswer: "حداقل تعداد پاسخ",
    answer: "پاسخ",
    serviceType: "نوع خدمت",
    feedback: "نظرسنجی",
    isEveryBuy: "به ازای هربار خرید",
    forEach: "به ازای هر",
    shop: "خرید",
    processTitle: "عنوان روند",
    discountLimit: "مدت اعتبار تخفیف",
    fromCode: "از کد",
    toCode: "تا کد",
    purchaseDate: "تاریخ سفارش/خرید",
    personClubMobile: "شماره همراه مشتری",
    personClubName: "نام مشتری",
    paymentMethod: "روش پرداخت",
    netPrice: "خالص قابل پرداخت",
    purchasesPrice: "مبلغ خرید",
    creditCode: "کد اعتبار",
    creditPrice: "مقدار اعتبار",
    feedbackAnswer: "پاسخ نظرسنجی",
    questionOptionTitle: "عنوان پارامتر اضافی",
    questionOptionAnswer: "گزینه های پارامتر اضافی",
    questionOption: "پارامترهای اضافی",
    productionDate: "تاریخ تولید",
    customerGrade: "سطح مشتری",
    optionTitle: "عنوان گزینه",
    addWarehousingTag: "صدور تگ انبارگردانی",
    withoutAddTag: "بدون صدور تگ",
    allCommodity: "همه کالاها",
    selectedCommodity: "کالاهای انتخابی",
    tagNo: "شماره تگ",
    questionType: "نوع سوال",
    multipleChoice: "چندگزینه‌ای",
    expositive: "تشریحی",
    firstMode: "حالت اول",
    secondMode: "حالت دوم",
    levelDeterminationConditions: "شرایط تعیین سطح ",
    minPurchasePrice: "حداقل مبلغ خرید",
    maxPurchasePrice: "حداکثر مبلغ خرید",
    purchasesCount: "تعداد خرید",
    minPurchasesCount: "حداقل تعداد خرید",
    maxPurchasesCount: "حداکثر تعداد خرید",
    select: "انتخاب",
    rial: "ریال",
    timeInterval: "بازه زمانی",
    scoreValue: "مقدار امتیاز",
    creditValue: "مقدار اعتبار",
    financialRatioTitle: "عنوان نسبت‌های مالی",
    voucherNo: "شماره سند",
    voucherDate: "تاریخ سند",
    voucherDescription: "شرح سند",
    reference: "رفرنس",
    voucherKey: "کلید سند",
    difference: "اختلاف (ریالی)",
    accountDescription: "شرح حساب",
    sendSms: "ارسال پیام",
    bankTitle: "عنوان بانک",
    increaseScore: "افزایش امتیاز",
    decreaseScore: "کاهش امتیاز",
    increaseCredit: "افزایش اعتبار",
    decreaseCredit: "کاهش اعتبار",
    addScoreType: "نوع ثبت امتیاز",
    addCreditType: "نوع ثبت اعتبار",
    decrease: "کاهش",
    increase: "افزایش",
    decreaseScoreValue: "مقدار کسر امتیاز",
    increaseScoreValue: "مقدار افزایش امتیاز",
    decreaseCreditValue: "مقدار کسر اعتبار",
    increaseCreditValue: "مقدار افزایش اعتبار",
    creditBalance: "مانده اعتبار",
    creditReferenceType: "منشا اعتبار",
    creditTransactionType: "نوع تراکنش",
    sign: "کد ایزو",
    alphabeticCode: "علامت اختصاری",
    baseCurrencyType: "ارز مبنا",
    currencyType: "ارز",
    currencyRate: "نرخ ارز",
    creditType: "نوع اعتبار",
    debtor: "بدهکار",
    creditor: "بستانکار",
    validityPeriod: "مدت اعتبار",
    creditAmount: "میزان اعتبار",
    personClubMember: "عضو باشگاه مشتریان",
    installmentCount: "تعداد اقساط",
    orderCancel: "انصراف",
    orderConfirmStatus: "وضعیت تایید",
    branchManager: "رییس شعبه",
    statusType: "نوع وضعیت",
    turnType: "نوع گردش",
    bankAccount: "حساب بانکی",
    cashRegister: "صندوق",
    accountHolderName: "نام صاحب حساب",
    firstAmount: "موجودی اولیه",
    accountInfo: "کدینگ حساب‌ها",
    immediately: "بلافاصله",
    setSendingTime: "تعیین زمان ارسال",
    sendAfter: "ارسال بعد از",
    firstNameField: "فیلد نام",
    lastNameField: "فیلد نام خانوادگی",
    nationalCodeField: "فیلد کدملی ",
    birthDateField: "فیلد تاریخ تولد ",
    maritalStatusField: "فیلد وضعیت تاهل ",
    marriageDateField: "فیلد تاریخ تاهل ",
    countryField: "فیلد انتخاب کشور ",
    provinceField: "فیلد انتخاب استان ",
    cityField: "فیلد انتخاب شهر ",
    regionField: "فیلد انتخاب محله ",
    genderField: "فیلد انتخاب جنسیت ",
    adderssField: "فیلد آدرس ",
    cashier: "صندوقدار",
    templateTitle: "قالب چک",
    paperCount: "تعداد برگه",
    bankAccountInfoTitle: "نام حساب بانکی",
    startSerial: "شروع از شماره",
    series: "سری چک",
    toBankCashAccount: "صندوق/بانک دریافت کننده",
    receivePrice: "مبلغ دریافتی",
    payer: "شخص پرداخت کننده",
    reciver: "شخص دریافت کننده",
    fromBankCashAccount: "صندوق/بانک پرداخت کننده",
    fromBankAccount: "بانک پرداخت کننده",
    fromAccount: "حساب پرداخت کننده",
    bankWage: "کارمزد بانک",
    receiveDate: "تاریخ دریافت",
    paymentDate: "تاریخ پرداخت",
    for: "بابت",
    floatAccountText: "پارامتر مبنا",
    requestPayment: "شماره درخواست",
    paymentPrice: "مبلغ پرداختی",
    toAccount: "حساب دریافت کننده",
    requestType: "نوع درخواست",
    fromBankCash: "از بانک/صندوق",
    requestDate: "تاریخ درخواست",
    requesterUser: "درخواست‌دهنده",
    referredTo: "ارجاع به",
    requestDescription: "شرح درخواست",
    priceRequest: "مبلغ درخواست",
    issueDate: "تاریخ سررسید چک",
    trackingNumber: "شماره صیادی",
    chequeNumber: "شماره چک",
    noteType: "نوع یادداشت",
    deleteEmptyVoucher: "حذف اسناد خالی و بدون ضمیمه",
    sortVouchers: "مرتب سازی اسناد",
    sorting: "مرتب سازی",
    chequeBackNumber: "پشت نمره چک",
    chequeStatus: "وضعیت چک",
    dueDate: "تاریخ سررسید چک",
    fromBank: "صادره از بانک",
    chequePrice: "مبلغ چک",
    searchBy: "جستجو براساس",
    fromCredit: "از مبلغ بستانکار",
    toCredit: "تا مبلغ بستانکار",
    fromDebt: "از مبلغ بدهکار",
    toDebt: "تا مبلغ بدهکار",
    fromPrice: "از مبلغ",
    toPrice: "تا مبلغ",
    voucherTemplateTitle: "عنوان شابلون ",
    debtPerson: "شخص بدهکار",
    newVoucher: "سند جدید",
    addLastVoucher: "اضافه به آخرین سند",
    addToVoucherNumber: "اضافه به سند شماره",
    explanation: "شرح",
    key: "کلید",
    linenNumber: "شماره خط",
    apikey: "کلید اتصال",
    defaultPanel: "پنل پیش فرض",
    templateId: "شناسه الگوی کد پیامکی",
    panelType: "نوع پنل",
    countryDefault: "کشور پیش‌فرض",
    rank: "رتبه",
    commodityGroup: "گروه کالا",
    buyCreditAccount: "سرفصل بستانکار خرید",
    buyDebtAccount: "سرفصل بدهکار خرید",
    saleCreditAccount: "سرفصل بستانکار فروش",
    saleDebtAccount: "سرفصل بدهکار فروش",
    whrsCommodity: "کالا در انبار",
    totalTaxPrice: "مبلغ ارزش افزوده کل",
    taxAmount: "مبلغ مالیات متعلقه",
    insuranceCode: "کد بیمه",
    countryCodeInsurance: "کد کشور در سامانه بیمه",
    taxCode: "کد مالیاتی",
    countryCodeTax: "کد کشور در سامانه امورمالیاتی",
    transferringBank: "بانک واگذاری",
    isDebtBankCashAccount: "حساب بانک واگذاری، بدهکار شود.",
    isLastDebtToCredit: "حساب بدهکار، وضعیت قبل بستانکار شود.",
    isCreditNowPerson: "شخص وضعیت جاری، بستانکار شود.",
    isDebtNowPerson: "شخص وضعیت جاری، بدهکار شود.",
    effectiveDate: "تاریخ موثر",
    isNewVoucher: "سند جدید",
    addToVoucher: "اضافه به سند",
    addToList: "اضافه به لیست",
    isToLastVoucher: "اضافه به سند آخر",
    durationCheque: "مدت",
    responseDeadline: "مهلت پاسخگویی",
    fromNumber: "از شماره",
    toNumber: "تا شماره",
    voucherCover: "روکش سند",
    creditPerson: "شخص بستانکار",
    creditHeading: "سرفصل بستانکار",
    debtHeading: "سرفصل بدهکار",
    deadlineUse: "مهلت استفاده",
    maxDiscountPrice: "حداکثر تخفیف",
    chequeBatchNo: "شماره دسته چک",
    payTo: "در وجه",
    bearer: "حامل",
    creditFloatAccountId: "گردش قبل بستانکار شود",
    basePrice: "مبلغ پایه",
    minPrice: "حداقل مبلغ",
    maxPrice: "حداکثر مبلغ",
    formula: "فرمول محاسبه",
    isTax: "مشمول مالیات",
    isInsurance: "مشمول بیمه",
    isContinuous: "مستمر",
    isCash: "نقد",
    isDisplayInInsurance: "نمایش در خروجی بیمه",
    isPersonInVoucher: "شخص در سند",
    includeFunctionColumn: "مشمول ستون کارکرد",
    isRelatedToFunction: "وابسته به کارکرد",
    sourceHeader: "سرفصل مبدا",
    destinationHeader: "سرفصل مقصد",
    ByAccountHeading: "بر اساس سرفصل حساب",
    ByPerson: "بر اساس شخص",
    sourcePerson: "شخص مبدا",
    destinationPerson: "شخص مقصد",
    unitWeight: "وزن واحد",
    materialAlloy: "متریال (آلیاژ)",
    packageType: "نوع بسته بندی",
    additionalPrice: "مبلغ اضافه خطی",
    additionalPercent: "درصد اضافه خطی",
    deductionPercent: "درصد کسورات خطی",
    deductionPrice: "مبلغ کسورات خطی",
    parent: "والد",
    fromChequeBackNumber: "از پشت نمره",
    toChequeBackNumber: "تا پشت نمره",
    titleRow: "سطر عناوین",
    startingRow: "سطر شروع",
    informationType: "نوع اطلاعات",
    convertTo: "تبدیل به",
    managerName: "مدیر عامل",
    insuranceStudioCode: "کد کارگاهی بیمه",
    studioAddress: "آدرس کارگاه",
    fax: "فکس",
    agreementRow: "ردیف پیمان",
    approximateDateOfCompletion: "تاریخ تقریبی انجام",
    cashAccount: "صندوق/حساب",
    payments: "پرداخت ها",
    receives: "دریافت ها",
    both: "هر دو",
    reportType: "نوع گزارش",
    bankCashAccount: "حساب/صندوق",
    cutColdRollingType: "نوع کات نورد سرد",
    cutFoilRollingType: "نوع کات نورد فویل",
    cuttingCount: "تعداد کات کاتولنت و اسلیتر",
    instruction: "دستورالعمل های وِیژه",
    isCoil: "کویل/شیت",
    produceOrder: "دستور تولید",
    qcDescription: "توضیحات کنترل کیفی",
    rollDiameter: "قطر رول",
    sprint: "هفته ساخت",
    receiptSerial: "سریال رسید",
    parentCoilCertificate: "شماره کویل مبنا",
    year: "سال",
    dateOfBaseHead: "تاریخ مبنای رأس‌گیری ",
    cashBankAccount: "حساب بانکی/صندوق",
    cashInventoryBeginningPeriod: "موجودی نقد ابتدای دوره",
    receiveCashDuringPeriod: "دریافت نقد طی دوره",
    cashPaymentDuringPeriod: "پرداخت نقد طی دوره",
    receiveChequeDuringPeriod: "دریافت اسناد طی دوره",
    paymentChequeDuringPeriod: "پرداخت اسناد طی دوره",
    cashBalance: "مانده نقد",
    receiveChequeBalance: "مانده اسناد  دریافتنی",
    paymentChequeBalance: "مانده اسناد پرداختنی",
    totalBalance: "مانده کل",
    displayUnTurnCheque: "نمایش چک‌های بدون گردش",
    grossCoilWeight: "وزن ناخالص کویل",
    finalProductCode: "کد محصول نهایی",
    finalProduct: "نام محصول نهایی",
    produceOrderCount: "مقدار دستور تولید",
    coreCoilWeight: "وزن core کویل",
    netWeight: "وزن خالص",
    finalThickness: "ضخامت نهایی",
    finalWidth: "عرض نهایی",
    operator: "اپراتور",
    deadline: "مهلت انجام",
    machine: "دستگاه",
    commodityDescription: "شرح کالا",
    workedTime: "مدت زمان انجام",
    innerDiameter: "قطر داخلی",
    outerDiameter: "قطر خارجی",
    mainProcess: "فرایند اصلی",
    subProcess: "فرایند فرعی",
    materialDraftType: "نوع حواله مواد مصرفی",
    draftMaterialWare: "انبار حواله مواد مصرفی",
    rejectedReceiptWare: "انبار رسید عدم انطباق",
    rejectedReceiptType: "نوع رسید عدم انطباق",
    rejectedDraftType: "نوع حواله عدم انطباق",
    draftWare: "انبار حواله",
    receiptWare: "انبار رسید",
    cataluntCuttingCount: "تعداد کات کاتولنت",
    coldRollingCuttingCount: "تعداد کات نورد سرد",
    foilRollingCuttingCount: "تعداد کات نورد فویل",
    sliterCuttingCount: "تعداد کات اسلیتر",
    temperature: "درجه حرارت",
    paletteNumber: "شماره پالت",
    paletteWeight: "وزن پالت",
    rollCount: "تعداد رول",
    nextMainProcess: "فرایند اصلی بعدی",
    nextSubProcess: "فرایند فرعی یعدی",
    orderCommodity: "کالای سفارش",
    nonConformityWare: "انبار عدم انطباق",
    commodityProgressWare: "انبار کالای در جریان ساخت",
    completedOrders: "نمایش سفارشات تکمیل شده",
    produceOrderFrom: "شروع تولید از",
    semiProduct: "کالای نیمه ساخته",
    semiProductWeight: "وزن کالای نیمه ساخته",
    coreWeight: "وزن کور",
    customerName: "مشتری",
    productionGroup: "گروه تولیدی",
    agreedPrice: "مبلغ توافقی",
    contractor: "پیمانکار",
    controllerThird: "بازرس ثالث",
    saleType: "نوع فروش",
    projectManager: "مدیر پروژه",
    inspection: "عنوان بازرسی",
    maxReservationDate: "حداکثر مهلت رزرو",
    size: "سایز",
    projectTitle: "عنوان پروژه",
    isRawMaterials: "مواد اولیه",
    isProduction: "محصول",
    isServices: "خدماتی",
    isAssets: "اموال",
    necessary: "مهم است",
    notNecessary: "مهم نیست",
    confirm: "تایید",
    comment: "نظر",
    requestCount: "تعداد درخواست",
    isNeedPlan: "نیاز به نقشه دارد؟",
    isInternalProduction: "تولید داخل",
    isSupplier: "تامین‌کننده",
    suppliers: "تامین‌کنندگان",
    isNecessary: "اجباری",
    defaultValue: "مقدار پیش‌فرض",
    productionWare: "انبار تولید",
    percentageSharing: "درصد تسهیم",
    inputType: "نوع ورودی",
    outputType: "نوع خروجی",
    rawMaterialWare: "انبار مواداولیه",
    singleValue: "ارزش جزء",
    totalValue: "ارزش کل",
    productionCoefficient: "ضریب تولید",
    allMaterials: "همه‌ی مواد اولیه",
    marketCode: "کد بازارگاه",
    mainCommodity: "کالای اصلی",
    amount: "مقدار",
    seller: "فروشنده",
    cottage: "کوتاژ",
    settlementType: "نوع تسویه",
    duration: "مدت",
    ladingNumber: "شماره بارنامه",
    isCancelOrder: "سفارش های ابطال شده",
    isCancelLading: "بارنامه های ابطال شده",
    isHaveLading: "دارای بارنامه",
    allocationNumber: "شماره تخصیص",
    dealer: "خریدار فرعی",
    purchasePrice: "قیمت خرید",
    purchaseDuration: "مدت خرید",
    saleDuration: "مدت فروش",
    trailer: "تریلی",
    singleTruck: "تک محور",
    doubleTruck: "جفت محور",
    otherTruck: "سایر",
    dumpTruck: "کمپرسی",
    branchAddress: "ادرس شعبه",
    brnachPhone: "تلفن شعبه",
    average: "میانگین",
    purchases: "عرضه",
    vehiclePlate: "پلاک وسیله نقلیه",
    shippingPrice: "هزینه حمل",
    sellerDescription: "توضیحات فروشنده",
    buyerDescription: "توضیحات خریدار",
    cancelStatus: "وضعیت ابطال",
    fromAmount: "از مقدار",
    toAmount: "تا مقدار",
    cottageNumber: "شماره کوتاژ",
    fromDuration: "از زمان (روز)",
    toDuration: "تا زمان (روز)",
    ladingAmount: "مقدار بارنامه",
    fromPurchasePrice: "از قیمت خرید",
    toPurchasePrice: "تا قیمت خرید",
    fromSalePrice: "از قیمت فروش",
    toSalePrice: "تا قیمت فروش",
    fromPurchaseDuration: "از زمان خرید (روز)",
    toPurchaseDuration: "تا زمان خرید (روز)",
    fromSaleDuration: "از زمان فروش (روز)",
    toSaleDuration: "تا زمان فروش (روز)",
    isComplete: "نکمیل شده",
    isSettlement: "تسویه شده",
    hasVoucher: "دارای بارنامه",
    subUnitCountTitle: "واحد شمارش فرعی",
    mainUnitCountTitle: "واحد شمارش اصلی",
    desiredMessage: "متن دلخواه پیامک",
    customerConfirmPlan: "نیاز به تایید نقشه توسط مشتری",
    mapFile: "فایل نقشه",
    customerComment: "نظر مشتری",
    mapTitle: "عنوان نقشه",
    attachmentKind: "نوع پیوست",
    hasAttachment: "پیوست دارد",
    customerConfirm: "تایید مشتری",
    needModifyMap: "نیاز به اصلاح نقشه",
    percentageOfFactor: "درصد از فاکتور",
    percentageOfGroup: "درصد از گروه",
    personFullName: "نام شخص",
    minusPercentage: "درصد کسورات",
    addPercentage: "درصد اضافات",
    commodityCategotyService: "خدمات",
    commodityCategotyAsset: "اموال",
    percentage: "درصد",
    giftCommodity: "کالای هدیه",
    returnedFactorType: "احتساب فاکتور مرجوعی",
    fromCount: "از تعداد",
    toCount: "تا تعداد",
    giftCount: "تعداد هدیه",
    saleManager: "مسئول فروش",
    allowedDiscountPercentage: "سطح تخفیف مجاز (درصد)",
    conditionsOfSale: "شرایط فروش",
    day: "روز",
    salePricePolicy: "سیاست قیمت گذاری",
    subUnitCount: "تعداد فرعی",
    unitPrice: "مبلغ واحد",
    discountPrice: "مبلغ تخفیف",
    taxPercentage: "درصد ارزش افزوده",
    addPrice: "مبلغ اضافات",
    minusPrice: "مبلغ کسورات",
    isGift: "هدیه",
    addMinusType: "نوع اضافات کسورات",
    settlementDate: "تاریخ تسویه",
    paymentConditions: "شرایط پرداخت",
    voucherStatus: "وضعیت سند",
    isCredit: "اعتباری",
    isCheque: "پرداخت چک",
    requesterSubject: "موضوع دریافت",
    requesterUnit: "واحد درخواست کننده",
    singleCurrencyType: "ارز",
    currencyPrice: "نرخ ارز",
    isSharing: "تسهیم",
    intermediary: "واسط",
    agent: "نماینده فروش",
    refrence: "مرجع صدور",
    cashPrice: "قیمت نقدی",
    creditDuration: "مدت اعتبار",
    chequeDuration: "مدت چک",
    visitor: "ویزیتور",
    ir: "IR",
    socialInsuranceJobId: "شناسه شغل تامین اجتماعی",
    factorFormat: "نوع فاکتور",
    columnTitle: "عنوان ستون",
    justCoefficient: "ضریب",
    isDefault: "پیش فرض",
    beneficiary: "ذی نفع",
    buyType: "نوع خرید",
    baseNumber: "شماره مبنا",
    finalizationDate: "تاریخ قطعی ساری",
    profitAndLossAccount: "حساب سود و زیان",
    isEffectOnPrice: "پارامترها بر قیمت موثر هستند؟ ",
    fromBranch: "صادره از شعبه",
    horizontal: "افقی",
    menuType: "نوع منو",
    vertical: "عمودی",
    paymentSubject: "موضوع پرداخت",
    approveOrder: "تایید سفارش",
    rejectOrder: "رد سفارش",
    attachmentTitle: "عنوان پیوست",
    language: "زبان",
    fa: "فارسی",
    en: "انگلیسی",
    colorSelection: "انتخاب رنگ",
    reservationDate: "تاریخ رزرو",
    url: "آدرس (URL)",
    slim: "باریک",
    font: "فونت",
    iranyekan: "ایران‌یکان",
    shabnam: "شبنم",
    cashName: "نام صندوق",
    cashCode: "کد صندوق",
    checkbookCode: "کد دسته‌چک",
    statusCode: "کد وضعیت",
    person: "شخص",
    accountsWithZeroTurnover: "حساب های با گردش صفر",
    accountHasTurnover: "فقط حساب های دارای گردش",
    excludeOpeningEntry: "بدون احتساب سندافتتاحیه",
    coil: "کویل",
    sheet: "شیت",
    accountHasRemain: "فقط حساب های مانده دار",
    notIncludingNoteVoucher: "بدون احتساب سند های یادداشت",
    accountswithOpeningBalance: "اشخاص مانده دار",
    accountswithActivityDuringPeriod: "اشخاص با گردش طی دوره",
    totalDepth: "سطح کل",
    certainDepth: "سطح معین",
    plateNumber: "شماره پلاک",
    inspectionLevel: "سطح بازرسی",
    groupByAccount: "بر اساس حساب",
    groupBy: "بر اساس",
    withoutTemporaryVoucher: "بدون احتساب سند بستن حسابهای موقت",
    withoutFinalVoucher: "بدون احتساب سند های اختتامیه",
    voucherConfirmType: "فقط اسناد تایید شده",
    dateType: "نوع تاریخ",
    dateTimeFormat: "فرمت تاریخ نمایشی",
    groupByPerson: "بر اساس شخص",
    groupByDuration: "بر اساس مدت",
    aliasCode: "نام مستعار",
    provinceCodeInsurance: "کد استان در سامانه بیمه",
    provinceCodeTax: "کد استان در سامانه امورمالیاتی",
    cityCodeInsurance: "کد شهر در سامانه بیمه",
    cityCodeTax: "کد شهر در سامانه امورمالیاتی",
    isoCode: "کد ایزو",
    countryUnit: "واحد کشور",
    pn: "pn/فشار",
    needByDate: "تاریخ مورد نیاز",
    productSurface: "سطح محصول",
    usageGroup: "گروه کاربردی",
    foilUsage: "کاربرد فویل",
    innerCoreDiameter: "قطر داخلی کور سفارش تحویلی",
    minWeight: "حداقل وزن",
    maxWeight: "حداکثر وزن",
    voucherCount: "تعداد اسناد",
    voucherConfirmCount: "تعداد اسناد قطعی شده",
    rowCount: "تعداد سطر",
    totalDebt: "جمع بدهکار",
    totalCredit: "جمع بستانکار",
    balance: "مانده",
    totalIncomes: "جمع درآمدها",
    totalCosts: "جمع هزینه‌ها",
    profitAndLoss: "سود/ زیان",
    openingVoucherNumber: "شماره سند افتتاحیه",
    closingVoucherDate: "تاریخ سند اختتامیه",
    closingVoucherNumber: "شماره سند اختتامیه",
    selectedRowsCount: "ردیف انتخاب‌شده",
    activeChangesCount: "تغییر فعال",
    selectRowsHint: "برای ثبت، ردیف‌های موردنظر را از جدول بالا انتخاب کنید",
    selectChangeHint: "حداقل یک مورد را برای تغییر تیک بزنید",
    transferByrowDescription: "براساس شرح ردیف سند",
    rowDescription: "شرح ردیف",
    sourceRowDescription: "شرح ردیف مبدا",
    destinationRowDescription: "شرح ردیف مقصد",
    inVoucher: "در سند",
    monthly: "ماهانه",
    daily: "روزانه",
    cumulativeByAccount: "تجمیع براساس حساب",
    level: "سطح",
    showRowsRemainders: "نمایش ردیف‌های دارای باقی‌مانده",
    showRowsCirculationDuringPeriod: "نمایش ردیف‌های دارای گردش طی دوره",
    balanceBeginningPeriod: "مانده ابتدای دوره",
    operationTurnDuringPeriod: "گردش عملیات طی دوره",
    temporaryAccountsVoucherNumber: "شماره سند حساب‌های موقت",
    temporaryVoucherNumber: "شماره سند موقت",
    byFloatAccountText: "براساس پارامتر مبنا",
    voucherNoBaseed: "براساس شماره سند",
    persons: "اشخاص",
    groupByCurrency: "به تفکیک ارز",
    notDisplayingWithoutRotation: "عدم نمایش ردیف های بدون گردش",
    exportFileFormatType: "نوع فایل خروجی",
    operationalCurrency: "ارز عملیاتی",
    tempNumber: "شماره موقت",
    documentRow: "ردیف سند",
    effectiveDuration: "مدت موثر",
    archive: "بایگانی",
    noArchive: "لغو بایگانی",
    turnCash: "گردش وجوه نقد",
    billNumber: "شناسه قبض",
    paymentNumber: "شناسه پرداخت",
    issueTracking: "شماره پیگیری",
    issueTrackingType: "نوع واریز",
    fromBirthDate: "از تاریخ تولد",
    toBirthDate: "تا تاریخ تولد",
    fromMarriageDate: "از تاریخ ازدواج",
    toMarriageDate: "تا تاریخ ازدواج",
    percentOrPrice: "درصد/مبلغ",
    process2: "روند",
    commodityGroupNodeDepth: "سطح گروه کالا",
    goal: "هدف",
    goalCount: "مقدار هدف",
    goalPercent: "درصد هدف",
    goalUser: "کاربر هدف",
    doneDate: "تاریخ انجام",
    achievementDate: "تاریخ دستیابی",
    doneTime: "ساعت انجام",
    doneDescription: "شرح انجام",
    predictionDate: "تاریخ پیش‌بینی",
    achievementPercentage: "درصد پیشرفت کل",
    achievementPercentagePrediction: "پیش‌بینی درصد پیشرفت",
    indicator: "شاخص اندازه‌گیری",
    companyName: "نام شرکت",
    businessTitle: "عنوان تجاری",
    companyType: "نوع شرکت",
    managerFirstName: "نام مدیر",
    managerLastName: "نام خانوادگی مدیر",
    managerMobile: "شماره همراه مدیر",
    branchCount: "تعداد شعب",
    userCount: "تعداد کاربران",
    route: "مسیر دسترسی",
    clubUrl: "آدرس سیستم باشگاه مشتریان",
    clubBanner: "بنر اپلیکیشن باشگاه مشتریان",
    clubLogo: "لوگو اپلیکیشن باشگاه مشتریان",
    clubFavIcon: "آیکون اپلیکیشن باشگاه مشتریان(Favicon)",
    companyFavIcon: "آیکون شرکت(Favicon)",
    logo: "لوگو شرکت",
    slogan: "شعار",
    addInfoType: "نحوه ورود اطلاعات",
    baseFinancialYear: "سال مالی اطلاعات پایه",
    minWeightCoil: "حداقل وزن هر کویل",
    maxWeightCoil: "حداکثر وزن هر کویل",
    approxCastingStartDate: "تاریخ تقریبی شروع تولید کستر",
    approxDeliveryDate: "تاریخ تقریبی تحویل سفارش",
    finalCommodity: "محصول نهایی سفارش",
    leadSource: "منبع سرنخ",
    questionText: "متن سوال",
    answerRequirement: "پاسخ به این سوال",
    brand: "برند",
    campaign: "کمپین",
    leadStatus: "وضعیت سرنخ",
    leadProperty: "ویژگی سرنخ",
    leadType: "نوع سرنخ",
    furnaceOperator: "اپراتور (کوره‌دار)",
    workShift: "شیفت کاری",
    semiBuiltProduct: "محصول نیمه‌ساخته",
    stopTime: "زمان توقف",
    outerRadius: "شعاع خارجی",
    grainSize: "دانه بندی",
    thicknessIncrease: "ازدیاد ضخامت",
    thicknessTolerance: "تلرانس ضخامت",
    thicknessVariation: "ناهماهنگی  ضخامت",
    edgeTolerance: "تلرانس دو سر",
    crownTolerance: "تلرانس کرون",
    crown: "کرون",
    rollerRunout: "ناهماهنگی یک دور غلطک",
    grossWeight: "وزن ناخالص",
    titaniumPercent: "درصد ti",
    zincPercent: "درصد zn",
    siliconPercent: "درصد si",
    magnesiumPercent: "درصد mg",
    manganesePercent: "درصد mn",
    chromiumPercent: "درصد cr",
    copperPercent: "درصد cu",
    ironPercent: "درصد fe",
    productUsage: "کاربرد محصول",
    saleStatus: "وضعیت مرحله فروش",
    lead: "سرنخ (لید)",
    expectedAmount: "مبلغ مورد انتظار",
    probabilitySuccessPercentage: "درصد احتمال موفقیت",
    chanceStatus: "وضعیت فرصت",
    chanceResult: "نتیجه فرصت",
    resultDescription: "شرح نتیجه",
    saleLine: "خط فروش",
    strengthWeakness: "نقاط ضعف و قوت",
    coldRollingPassCount: "تعداد کات نورد سرد",
    cutToLengthPassCount: "تعداد کات کاتولنت",
    finalCutToLengthWidth: "عرض نهایی کاتولنت",
    finalColdRollingThickness: "ضخامت نهایی نورد سرد",
    requiredThicknessForCutToLength: "ضخامت مورد نیاز جهت کاتولنت",
    requiredThicknessForAnnealing: "ضخامت مورد نیاز جهت آنیل",
    coreType: "نوع کور",
    productionReport: "گزارش تولید",
    roughness: "رافنس",
    speed: "سرعت",
    previousCoilNumber: "شماره کویل قبلی",
    furnace: "کوره",
    furnacePlacement: "جانمایی کوره",
    nextProcessType: "نوع فرآیند بعدی",
    subProcessType: "نوع فرآیند فرعی",
    nextSubProcessType: "نوع فرآیند فرعی بعدی",
    completedProduceOrder: "نمایش دستور تولیدهای تکمیل شده",
    slitterCutCount: "تعداد کات اسلیتر/سپراتور",
    foilRollingCutCount: "تعداد کات نورد فویل",
    palletType: "نوع پالت",
    dopplerWidth: "عرض داپلر",
    productType: "نوع محصول",
    fromDeliveryDate: "از تاریخ تحویل",
    toDeliveryDate: "تا تاریخ تحویل",
    commodityWareReceiptType: "نوع رسید انبار محصول در جریان ساخت",
    commodityReceiptWare: "انبار رسید محصول در جریان ساخت",
    projectExecutionPhase: "مرحله اجرای پروژه",
    calculatedAmount: "مبلغ محاسباتی",
    totalJobDescription: "جمع شرح کار",
    totalWorkDecimal: "جمع شرح کار",
    totalAdditions: "جمع اضافات",
    totalFractions: "جمع کسورات",
    netProjectPrice: "خالص مبلغ پروژه",
    estimateTableSum: "جمع جدول برآورد",
    effectiveFactor: "عامل مؤثر",
    addition: "اضافات",
    fee: "فی",
    totalSum: "جمع کل",
    filePathName: "مسیر/نام فایل",
    isDone: "انجام شد",
    createDate: "تاریخ ایجاد",
    projectType: "نوع پروژه",
    projectCode: "کد پروژه",
    workDescription: "شرح کار",
    residentialSuite: "واحد",
    usefulArea: "متراژ مفید",
    bankingFacilities: "تسهیلات بانکی",
    endDateCalculationOfScore: "تاریخ پایان محاسبه امتیاز",
    fineRate: "نرخ جریمه",
    finePercentage: "درصد جریمه",
    fineCriterion: "معیار جریمه",
    rewardRate: "نرخ پاداش",
    rewardPercentage: "درصد پاداش",
    rewardCriterion: "معیار پاداش",
    forecastPricePerMeter: "پیش بینی بهای هر متر",
    suiteCount: "تعداد واحد",
    contract: "حکم کارگزینی",
    leaveType: "نوع مرخصی",
    leaveDuration: "مدت مرخصی",
    missionDuration: "مدت ماموریت",
    descriptionFor: "بابت",
    chequeBatch: "دسته چک",
    isDailyLeave: "مرخصی روزانه",
    confirmStatus: "وضعیت گردش تأیید",
    confirmUser: "کاربر تأییدکننده",
    confirmDate: "تاریخ تایید",
    meeting: "صورت‌جلسه",
    serviceSupport: "سرویس",
    call: "تماس",
    callDate: "تاریخ تماس",
    callTime: "زمان تماس",
    callDuration: "مدت تماس",
    isNoAnswer: "عدم پاسخگویی",
    callNature: "ماهیت تماس",
    currentUserReminder: "یادآوری کاربر",
    teamReminder: "یادآوری تیم",
    responsibility: "مسئولیت",
    messageAction: "نوع اقدام",
    seenDate: "تاریخ مشاهده",
    seenTime: "زمان مشاهده",
    task: "فعالیت و وظیفه",
    reminder: "یادآوری",
    reminderTime: "ساعت یادآوری",
    reminderDays: "تعداد روز",
    reminderNotification: "نوتیفیکیشن",
    reminderSms: "پیامک",
    reminderExecutionDate: "تاریخ یادآوری",
    reminderEndDate: "تاریخ اتمام",
    reminderWeekDays: "یادآوری چه روزهایی انجام شود ؟",
    reminderEveryNDays: "هر چند روز",
    reminderMessage: "متن یادآوری",
    reminderActive: "فعال",
    reminderSchedule: "زمان‌بندی",
    reminderChannels: "روش اطلاع‌رسانی",
    isIncludePreviousYear: "با احتساب سال‌های مالی قبل",
    responsibleForPerson: "مسئول انجام",
    meetingTitle: "عنوان جلسه",
    meetingNumber: "شماره جلسه",
    meetingDate: "تاریخ جلسه",
    meetingLength: "مدت جلسه",
    meetingLocation: "مکان جلسه",
    parentMeeting: "جلسه والد",
    parentCall: "تماس والد",
    parentMessage: "پیام والد",
    mainUserReminderTitle: "یادآوری برای کاربر اصلی",
    guestReminderTitle: "یادآوری پیامکی برای مدعوین",
    attendanceType: "نوع شرکت",
    approvalDescription: "شرح مصوبه",
    responsibleUser: "کاربر مسئول",
    responsibleName: "نام مسئول",
    emailShort: "ایمیل",
    saleContract: "قرارداد",
    meetingDuration: "مدت زمان جلسه",
    meetingPlace: "محل برگزاری جلسه",
    fromTime: "از ساعت",
    toTime: "تا ساعت",
    mainUser: "کاربر اصلی",
    meetingStatus: "وضعیت جلسه",
    isPresent: "حضور",
    productOrService: "محصول / خدمت",
    estimateTime: "زمان صرف شده",
    responsible: "مسئول",
    receiveNumber: "شناسه دریافت",
    paymentType: "نوع پرداخت",
    taxRatePercentage: "درصد مالیات",
    taxFreeShare: "کسر معافیت از 12",
    benefits: "مزایا",
    deduction: "کسورات",
    isPending: "معوقه",
    isTaxFree: "معاف از مالیات",
    isTaxTableType: "پلکانی",
    taxRateType: "نوع نرخ مالیات",
    addOrMinusTaxType: "نوع مالیاتی",
    isMinPriceRelatedToFunction: "حداقل مبلغ وابسته به کارکرد است؟",
    isMaxPriceRelatedToFunction: "حداکثر مبلغ وابسته به کارکرد است؟",
    cashBenefits: "مزایای نقدی؟",
    personnel: "پرسنل",
    totalAmount: "مبلغ خالص",
    month: "ماه",
    monthDays: "تعداد روزهای ماه",
    mandatoryFunctionDay: "کارکرد موظفی در ماه به روز",
    mandatoryFunctionHour: "کارکرد موظفی در ماه به ساعت",
    addMinus: "اضافات و کسورات",
    isTiered: "پلکانی",
    accountParty: "طرف حساب",
    smapleFile: "نمونه فایل",
    sortOrder: "ترتیب",
    propertySystemCode: "کد سیستم دارایی",
    interest: "بهره",
    dependentsCount: "تعداد افراد تحت تکفل",
    girlCount: "تعداد فرزند دختر",
    boyCount: "تعداد فرزند پسر",
    studyFieldType: "رشته تحصیلی",
    degree: "مدرک تحصیلی",
    personnelNumber: "شماره پرسنلی",
    personnelCardNumber: "شماره کارت پرسنلی",
    employmentDate: "تاریخ استخدام",
    leaveDate: "تاریخ ترک کار",
    salaryDepositBank: "بانک واریز حقوق",
    isLeaveWork: "این فرد ترک کار کرده است؟",
    blockingSalary: "مسدود شدن حقوق",
    employmentType: "نوع استخدام",
    placeOfService: "محل خدمت",
    serviceStatus: "وضعیت محل خدمت",
    insuranceName: "نام بیمه",
    insuranceType: "نوع بیمه",
    insuranceNumber: "شماره بیمه",
    retirementDate: "تاریخ بازنشستگی",
    nationalityType: "نوع تابعیت",
    nationalityCountry: "کشور تابعیت",
    occupationCategory: "رسته",
    positionInfo: "سمت/شغل (بیمه)",
    taxHousing: "مسکن",
    vehicle: "وسیله نقلیه",
    sbuOrg: "واحد سازمانی (sbu)",
    contractType: "نوع حکم کارگزینی",
    jobGroup: "گروه های شغلی",
    insuranceWorkplace: "کارگاه بیمه",
    isDiscount: "تخفیف",
    calculateType: "نوع محاسبه",
    functionType: "نوع کارکرد",
    legalTaxException: "استثنائات قانون بودجه",
    monthlyWage: "دستمزد ماهانه",
    approvedWage: "دستمزد ماهانه مصوب",
    insuranceWage: "دستمزد بیمه",
    insuranceBaseWageYears: "پایه سنوات بیمه",
    workerShareInsurancePercentage: "درصد سهم بیمه کارگر",
    employerShareInsurancePercentage: "درصد بیمه سهم کارفرما",
    unemploymentSharePercentage: "درصد بیمه بیکاری",
    isExemptionEmployerShare: "مشمول معافیت سهم کارفرما",
    isAdditionalInsurance: "بیمه تکمیلی",
    additionalInsurance: "مبلغ پایه بیمه تکمیلی",
    calculateTaxType: "نوع محاسبه مالیات",
    taxExemptionPercent: "درصد معافیت مالیاتی",
    calculateTaxForHourly: "مالیات ساعتی براساس",
    isOverTime: "مجاز به اضافه کار",
    overtimeRate: "ضریب محاسبه اضافه کار",
    isOffOvertime: "مجاز به اضافه کار تعطیل",
    calculateOffOverTimeType: "محاسبه اضافه کار روز تعطیل",
    offOverTimeRate: "ضریب اضافه کار روز تعطیل",
    remainVacationDays: "ذخیره یا بدهی مرخصی از قبل",
    remainServiceDays: "مانده سنوات از قبل به روز",
    isShiftWork: "محاسبه نوبتکاری",
    shiftWorkRate: "ضریب یا نرخ نوبتکاری",
    isFriday: "محاسبه جمعه کاری",
    fridayRate: "ضریب جمعه کاری",
    isMission: "محاسبه ماموریت",
    missionRate: "ضریب ماموریت",
    isDeduction: "محاسبه کسرکار",
    calculateDeductionRateType: "نوع نرخ کسرکار",
    deductionRate: "ضریب کسر کار",
    deductionFormula: "فرمول محاسبه ی کسر کار",
    exemptionType: "نوع معافیت",
    codeActivationTimeSMSSendingTime: "زمان فعال‌سازی کد / ارسال پیام",
    otherTaxSubject: "موضوع سایر مالیات و عوارض",
    otherTaxPercentage: "درصد سایر مالیات و عوارض",
    otherTaxPrice: "مبلغ سایر مالیات و عوارض",
    legalSubject: "موضوع سایر وجوه قانونی",
    legalPercentage: "درصد سایر وجوه قانونی",
    legalPrice: "مبلغ سایر وجوه قانونی",
    codeAndChequeNumber: "شماره برگه یا شماره چک",
    paperNumber: "شماره برگه ",
    isDebtAssignBankCashAccount: "حساب بانک واگذاری، بدهکار شود",
    benefitsAndDeductionType: "نوع مزایا یا کسورات",
    openingEntry: "سند افتتاحیه",
    temporaryVoucher: "بستن سند حساب‌های موقت",
    closingEntry: "سند اختتامیه",
    expression: "فرمول",
    isChildAllowance: "حق اولاد",
    childAllowanceRate: "مبلغ حق اولاد",
    isMarriageAllowance: "حق تاهل",
    marriageAllowanceRate: "مبلغ حق تاهل",
    isLaborAllowance: "بن",
    laborAllowanceRate: "مبلغ بن",
    isHousingAllowance: "حق مسکن",
    housingAllowanceRate: "مبلغ حق مسکن",
    placeOfIssue: "محل صدور شناسنامه",
    byUser: "توسط کاربر",
    auto: "اتوماتیک",
    byExcel: "از طریق اکسل",
    presentDays: "ایام حضور",
    workedDays: "ایام کارکرد",
    isTaxChanged: "مالیات تغییر کرده‌است",
    calculatedTax: "مالیات محاسبه‌شده توسط سیستم",
    isInsuranceCostByWorkedDays: "محاسبه هزینه بیمه براساس کارکرد بیمه",
    insuranceWorkedDays: "ایام کارکرد بیمه",
    workedTotalHour: "کارکرد به ساعت",
    workedHourly: "کارکرد ساعتی",
    absentDays: "غیبت",
    vacation: "مرخصی استحقاقی",
    vacationHourly: "مرخصی ساعتی",
    vacationTotalHour: "مرخصی به ساعت",
    vacationDaily: "مرخصی روزانه",
    vacationWithoutSalaryHourly: "مرخصی بدون حقوق ساعتی",
    vacationWithoutSalaryTotalHour: "مرخصی بدون حقوق به ساعت",
    vacationWithoutSalaryDaily: "مرخصی بدون حقوق روزانه",
    vacationWithoutSalary: "مرخصی بدون حقوق",
    sickVacationHourly: "استعلاجی ساعتی",
    sickVacationTotalHour: "استعلاجی به ساعت",
    sickVacationDaily: "استعلاجی روزانه",
    sickVacationDays: "استعلاجی",
    deductionHourly: "کسر کار ساعتی",
    deductionTotalHour: "کسر کار به ساعت",
    deductionDaily: "کسر کار روزانه",
    deductionDays: "کسرکار",
    shiftWorkDays: "نوبت‌کاری",
    fridayworkhourly: "جمعه کاری ساعتی",
    fridayWorkTotalHour: "جمعه کاری به ساعت",
    fridayWorkDays: "جمعه کاری",
    friday: "جمع کاری به روز",
    missionHourly: "ماموریت ساعتی",
    missionTotalHour: "ماموریت به ساعت",
    missionDays: "ماموریت",
    mission: "ماموریت به روز",
    commonOverTimeHourly: "اضافه کار عادی ساعتی",
    commonOverTimeTotalHour: "اضافه کار عادی ",
    commonOverTimeTotal: "اضافه کار(مجموع ساعت اضافه کار عادی و تعطیلی )",
    commonOverTimePrice: "مبلغ اضافه کار عادی",
    offOverTimePrice: "مبلغ اضافه کار تعطیل",
    overTimePrice: "مبلغ اضافه کار",
    offOverTimeHourly: "اضافه کار تعطیلی ساعتی",
    offOverTimeTotalHour: "اضافه کار تعطیلی",
    vacationSettlementDays: "تسویه مرخصی",
    occasionalVacation: "مرخصی مناسبتی",
    benefitAndDeduction: "مزایا و کسورات",
    tax2: "مالیات",
    contractCode: "کد حکم کارگزینی",
    contractCode2: "کد حکم",
    wage: "دستمزد",
    baseWageYears: "پایه سنوات حقوق",
    totalBenefits: "جمع مزایای حقوق",
    totalBenefits2: "جمع مزایا",
    totalInsuranceBenefits: "جمع مزایای مشمول بیمه",
    totalTaxBenefits: "جمع مزایای مشمول مالیات",
    totalSalaryAndBenefits: "جمع حقوق و مزایا",
    totalInsuranceSalaryAndBenefits: "جمع حقوق و مزایای مشمول بیمه",
    totalInsuranceDisplaySalary: "جمع حقوق و مزایای مشمول و غیر مشمول بیمه",
    totalTaxSalaryAndBenefits: "جمع حقوق و مزایای مشمول مالیات",
    insuranceEmployeeShare: "حق بیمه سهم کارگر",
    insuranceEmployerShare: "حق بیمه سهم کارفرما",
    unemploymentInsurance: "بیمه بیکاری",
    supplementaryInsurance: "بیمه تکمیلی - سایر بیمه ها",
    totalDeductions: "جمع کسورات",
    netSalary: "خالص حقوق",
    approvedSalaryDifference: "مابه التفاوت مصوب",
    totalPayable: "جمع کل قابل پرداخت",
    roundAmount: "رند حقوق",
    finalSalary: "خالص پرداختی",
    lastConfirmUser: "کاربر تایید/قطعی سازی",
    lastConfirmDate: "زمان تایید/قطعی سازی",
    isCashPayment: "پرداخت نقد",
    isWage: "دستمزد",
    isInsuranceWage: "دستمزد بیمه",
    isInsurance2: "بیمه",
    isVacation: "مرخصی",
    isSickVacation: "استعلاجی",
    isVacationWithoutSalary: "مرخصی بدون حقوق",
    isWorkedDays: "ایام حضور",
    isInsuranceWorkedDays: "کارکرد بیمه",
    isAbsent: "غیبت",
    areaSuite: "متراژ واحد",
    areaCount: "تعداد واحد",
    shareCount: "مقدار سهم هر واحد",
    isMission2: "ماموریت",
    isVacationSettlementDays: "تسویه مرخصی",
    isOccasionalVacation: "مرخصی مناسبتی",
    announcementTyps: "نوع اعلام",
    groups: "گروهی",
    individual: "فردی",
    announcementDate: "تاریخ اعلام",
    calculationDateScore: "تاریخ محاسبه امتیاز",
    dateNeed: "تاریخ نیاز",
    reward: "پاداش",
    crimes: "جریمه",
    areaShare: "متراژ هر سهم",
    participation: "مشارکت",
    fromMonth: "از ماه",
    toMonth: "تا ماه",
    shareNumber: "تعداد سهم",
    byBenefitsAndDeductions: "صدور سند به تفکیک مزایا و کسورات",
    byDebitAndCredit: "تجمیع به تفکیک بدهکار/بستانکار",
    debitCreditBalance: "مانده بدهکار و بستانکار",
    isPersonInDescription: "شخص در شرح",
    cheque: "چک",
    setVoucherIssueType: "نحوه صدور سند",
    impactRankings: "تاثیر در رتبه‌بندی",
    paymentDeadline: "مهلت پرداخت",
    totalArea: "متراژ کل",
    receiveAndPaySubject: "موضوع دریافت و پرداخت",
    pointsCalculationRate: "نرخ محاسبه امتیاز",
    scoreAdjustmentIndex: "شاخص تعدیل امتیاز",
    insuranceMonthlyWage: "جمع دستمزد ماهانه",
    housingAllowancePrice: "حق مسکن",
    bon: "بن",
    childAllowancePrice: "حق اولاد",
    marriageAllowancePrice: "حق تاهل",
    percentageRate: "پورسانتاژ",
    positionCode: "کد سِمت",
    totalInsuranceBenefits2: "جمع مزایای مشمول و غیرمشمول",
    annualBonus: "عیدی سالانه",
    bonus: "پاداش",
    businessTripAllowance: "فوق‌العاده ماموریت",
    calculatedTaxAmount: "مالیات محاسبه‌شده",
    consultingAttendanceTechnicalFees: "حق الزحمه/حق مشاوره/حق حضور",
    currentGrossSalaryAndRecurringCashBenefits:
      "جمع ناخالص حقوق و مزایای مستمر نقدی",
    currentNonRecurringCashBenefits: "سایر حقوق و مزایای غیرمستمر نقدی",
    currentNonRecurringNonCashBenefits: "مزایای غیرمستمر غیرنقدی",
    deferredNonRecurringCashBenefits: "حقوق و مزایای غیرمستمر نقدی معوق",
    deferredNonRecurringNonCashBenefits: "مزایای غیرمستمر غیرنقدی معوق",
    deferredRecurringCashBenefits: "حقوق و مزایای مستمر نقدی معوق",
    deferredRecurringNonCashBenefits: "حقوق و مزایای مستمر غیرنقدی معوق",
    recurringNonCashBenefits: "مزایای غیر مستمر غیر نقدی",
    dismissalCompensation: "خسارت اخراج",
    endOfServiceBonus: "پاداش پایان خدمت",
    housingDeduction: "کسر مسکن",
    insuranceWageDays: "دستمزد روزانه بیمه",
    laborCompensation: "حق السعی",
    lifeInsurancePremium: "حق بیمه عمر",
    medicalInsurancePremium: "حق بیمه درمان",
    onCallPrice: "حق کشیک",
    paidTaxAmount: "مالیات پرداختی",
    performancePrice: "کارانه",
    researchContractAmount: "مبلغ قراردادهای پژوهشی",
    seniorityPrice: "حق سنوات",
    serviceBuyback: "بازخرید خدمت",
    taxVehicle: "وسیله نقلیه",
    teachingResearchPrice: "حق التدریس/حق التحقیق/ حق پژوهش",
    travelExpense: "هزینه سفر",
    unusedLeaveCompensation: "حقوق ایام مرخصی استفاده‌نشده",
    vehicleDeduction: "کسر وسیله نقلیه",
    welfareIncentiveProductivityPrice: "رفاهی و انگیزشی و بهره‌وری",
    workPlaceStatus: "وضعیت محل خدمت",
    yearEndBonus: "پاداش پایان سال",
    listKind: "نوع لیست",
    listNo: "شماره لیست",
    listDescription: "شرح لیست",
    insuranceWorkplaceRate: "نرخ حق بیمه کارگاه",
    corrective: "اصلاحی",
    calculationDate: "تاریخ محاسبه",
    calculationBasisBenefit: "نحوه محاسبه ی مزایا",
    parentDb: "پایگاه داده والد",
    parentSchema: "شمای والد",
    parentTable: "جدول والد",
    childDb: "پایگاه داده فرزند",
    childSchema: "شمای فرزند",
    childTable: "جدول فرزند",
    foreignKey: "کلید خارجی",
    foreignKeys: "کلیدهای خارجی",
    deleteBehavior: "رفتار حذف",
    profit: "سود",
    loss: "زیان",
    account2: "حساب",
    keyTypeTitle: "نوع کلید",

    backupArchive: "آرشیو بکاپ",
    exportCompanies: "شرکت‌ها",
    exportBranches: "شعبه‌ها",
    exportFiscalYears: "شناسه‌ی سال‌های مالی",
    targetCompany: "شرکت مقصد",
    targetBranch: "شعبه‌ی مقصد",
    sourceCompany: "شرکت مبدأ",
    sourceBranch: "شعبه‌ی مبدأ",
    dryRun: "اجرای آزمایشی",
    winBackupMode: "حالت انتقال",
    winBackupModeAll: "همه‌ی شعبه‌های آرشیو، با ساخت شعبه‌ی جدید",
    winBackupModeSelect: "انتخاب شعبه‌ها",
    winBackupSourceBranch: "شعبه‌ی مبدأ (ویندوزی)",
    winBackupTargetBranch: "شعبه‌ی مقصد",
    searchVariable: "جستجوی متغیر",
    bankKey: "کلید بانک",
    bankFileType: "نوع فایل",
    fileExtension: "پسوند فایل",
    encoding: "انکدینگ",
    delimiter: "جداکننده",
    customDelimiter: "جداکننده دلخواه",
    lineEnding: "پایان سطر",
    hasColumnTitleRow: "سطر عنوان ستون‌ها",
    recordKind: "نقش رکورد",
    marker: "نشانه",
    repeatMode: "تکرار",
    conditionExpression: "شرط رکورد",
    technicalName: "نام فنی",
    startPosition: "موقعیت شروع",
    isFixedLength: "طول ثابت",
    isRequired: "الزامی",
    alignment: "تراز",
    padCharacter: "کاراکتر پرکننده",
    isTrim: "حذف فاصله",
    isNullable: "پذیرش تهی",
    formatString: "قالب",
    dataType: "نوع داده",
    sourceKind: "منبع",
    sourceKey: "متغیر",
    constantValue: "مقدار ثابت",
    expressionValue: "عبارت",
    ruleType: "نوع قاعده",
    padChar: "کاراکتر",
    substringStart: "شروع (صفرپایه)",
    substringLength: "طول (اختیاری)",
    replaceOld: "مقدار قدیم",
    replaceNew: "مقدار جدید",
    expressionName: "نام در عبارت",
    scope: "دامنه",
    payroll: "لیست حقوق",
    template: "قالب",
    companyBankAccount: "شماره حساب شرکت",
    maxLines: "حداکثر سطر پیش‌نمایش",
    testExport: "صدور آزمایشی",
    mitaWare: "انبار میتا",
    modiranWare: "انبار مدیران",
    mitaVoucherType: "نوع سند میتا",
    modiranVoucherType: "نوع سند مدیران",
    voucherDirection: "جهت سند",
    isOccasion: "مناسبتی",
    applyPosition: "محل اعمال",
    applyToInvoiceRows: "سطرهای کالاهای فاکتور",
    applyToInvoiceEnd: "انتهای فاکتور",
    deductionType: "نوع کسورات",
    serviceCategory: "گروه خدمات",
    serviceCode: "کد خدمات",
    serviceTitle: "عنوان خدمات",
    mergeType: "نوع ادغام",
    mergeInVoucherByNumber: "ادغام در سند با شماره",
    mergeInNewVoucher: "ادغام در سند جدید",
    mergeInFirstVoucherOfDate: "ادغام در اولین سند همان تاریخ",
    mergeInLastVoucherOfDate: "ادغام در آخرین سند همان تاریخ",
    mergeInNewVoucherPerDate: "ادغام در سند جدید به تاریخ همان روز",
    baseVoucherNumber: "شماره سند مبنا",
    excelSample: "نمونه فایل اکسل",
    saltBase: "مبنای راس گیری",
    showType: "نحوه نمایش",
    salesPipelineTitle: "عنوان خط فروش",
    saleTeam: "تیم فروش",
    saleRegion: "منطقه فروش",
    saleTeamSupervisor: "سرپرست تیم",
    teamMembers: "اعضای تیم",
    customerType: "نوع مشتری",
    targetProduct: "محصول هدف",
    salesPipelineUsage: "شرح کاربرد خط فروش",
    saleStage: "مرحله فروش",
    saleStageTitle: "عنوان مرحله",
    probabilityPercentage: "درصد احتمال",
    isLastStage: "مرحله پایانی",
    saleStageType: "نوع مرحله",
    sourceWareShelf: "انبارک مبدا",
    destinationWareShelf: "انبارک مقصد",
    serviceSupportSubjectTitle: "موضوع پشتیبانی",
    announcementType: "نوع اعلام",
    serviceContact: "راه ارتباطی",
    serviceContract: "قرارداد",
    contractParty: "طرف قرارداد",
    saleChance: "فرصت فروش",
    linkedServiceSupport: "پشتیبانی و سرویس",
    companySignatureDate: "تاریخ امضای شرکت",
    customerSignatureDate: "تاریخ امضای مشتری",
    parentService: "پشتیبانی والد",
    doneUser: "انجام‌دهنده",
    doneDuration: "مدت انجام (دقیقه)",
    customerDescription: "شرح مشتری",
    customerSolution: "راه‌حل ارائه‌شده",
    time: "زمان",
    severity: "شدت",
    productLevel: "سطح کالا",
    clearingMethod: "روش تسویه",
    includeSentInvoices: "نمایش صورتحساب‌های قبلا ارسال شده",
    isUsingSignedSdk: "استفاده از نسخه با گواهی امضاء",
    isUsingTrustedCompanyToken: "استفاده از کلید شرکت معتمد",
    memoryTaxId: "شناسه حافظه مالیاتی",
    memoryTaxIdTest: "شناسه حافظه مالیاتی آزمایشی",
    privateKey: "کلید خصوصی",
    privateKeyFile: "فایل پیوست کلید خصوصی",
    publicKey: "کلید عمومی",
    publicKeyFile: "فایل پیوست کلید عمومی",
    taxCertificateFile: "فایل گواهی امضا",
    taxCompanyTitle: "عنوان و یا نام شرکت/سازمان",
    taxInvoicePattern: "الگوی صورتحساب",
    taxInvoiceType: "نوع صورتحساب",
    taxSandBox: "ارسال آزمایشی",
    trustedCompany: "شرکت معتمد",
    buyerEconomicCode: "کد اقتصادی خریدار",
    buyerName: "نام خریدار",
    buyerNationalId: "شناسه ملی خریدار",
    exchangeRate: "نرخ برابری ارز با ریال",
    fromFactorNo: "از شماره فاکتور",
    toFactorNo: "تا شماره فاکتور",
    fromIssueDate: "از تاریخ صدور",
    toIssueDate: "تا تاریخ صدور",
    fromSendDate: "از تاریخ ارسال",
    toSendDate: "تا تاریخ ارسال",
    fromTotalPrice: "از مبلغ کل",
    toTotalPrice: "تا مبلغ کل",
    isBuyerTypeFromPerson: "خواندن نوع خریدار از فیلد حقیقی/حقوقی",
    isWeightFromCount: "خواندن مقدار وزن از روی تعداد در الگوی صادرات",
    onlyLastInvoice: "فقط آخرین صورتحساب هر فاکتور",
    referenceNumber: "شماره مرجع",
    taxBuyerType: "نوع خریدار",
    taxInvoiceSubject: "موضوع صورتحساب",
    taxStatuses: "وضعیت‌ها",
    taxUId: "شناسه یکتای ارسال",
    taxUniqueId: "شماره منحصر به فرد مالیاتی",
    taxExcelFile: "فایل اکسل صورتحساب‌ها",
    taxInvoiceSource: "منبع صورتحساب",
    applicantPosition: "نقش/سمت متقاضی",
    fullNameEn: "نام کامل (انگلیسی)",
    guildUnitTitle: "عنوان واحد صنفی",
    mltType: "نوع شخص متقاضی",
    nationalIdOrNationalCode: "شناسه ملی / کد ملی",
    organizationNameEn: "نام سازمان به انگلیسی",
    organizationTitle: "نام سازمان (فارسی)",
    organizationType: "نوع سازمان",
    unitTitle1: "نام واحد سازمانی ۱",
    unitTitle2: "نام واحد سازمانی ۲",
    settlementDiscount: "تخفیف",
    prepaymentAmount: "مبلغ پیش پرداخت",
    prepaymentBankCashAccount: "بانک / صندوق نقد",
    settlementCredit: "اعتبار",
    installableAmount: "مبلغ قابل تقسیط",
    settlementInstallmentCount: "تعداد قسط",
    installmentInterval: "فاصله قسط (ماه)",
    installmentAmount: "مبلغ هر قسط",
    lastInstallmentAmount: "مبلغ قسط آخر",
    firstInstallmentDate: "تاریخ اولین قسط",
    receiverBankCashAccount: "بانک / صندوق دریافت کننده",
    issuingBank: "بانک صادر کننده",
    bankBranchName: "شعبه",
    fromChequeNumber: "از شماره چک",
    toChequeNumber: "تا شماره چک",
    chequeDueDate: "سررسید",
    debitAccount: "حساب بدهکار",
    issueVoucher: "صدور سند",
    voucherNumber: "شماره سند",
    voucherIssuePreview: "پیش نمایش صدور سند",
    reminderCreateTask: "کپی فعالیت در بازه‌ی یادآوری و نمایش در تقویم کاری",
    followUpFromOthers: "پیگیری از دیگران",
    taskTeamUser: "عضو تیم",
    referToUser: "ارجاع به",
    referDescription: "شرح ارجاع",
    send: "ارسال",
    receive: "دریافت",
    voucherRowAmount: "مبلغ ردیف سند",
    notesTotalPrice: "جمع یادداشت‌ها",
    sourceFloatAccountText: "پارامتر مبنا مبدا",
    destinationFloatAccountText: "پارامتر مبنا مقصد",
    tempReceiptNo: "شماره رسید موقت",
    preFactorNo: "شماره پیش فاکتور",
    saleFactorCode: "شماره فاکتور فروش",
  },
  caption: {
    quickRegisterForLead: "برای سرنخ",
    quickRegisterForChance: "برای فرصت",
    quickRegisterForProject: "برای پروژه",
    quickRegisterForTask: "برای فعالیت",
    quickRegisterForCall: "برای تماس",
    quickRegisterForMeeting: "در ادامهٔ جلسه",
    quickRegisterForContract: "برای قرارداد",
    timerRunning: "زمان‌سنج فعال",
    // فروش فروشگاهی ---------------------------------------------
    storeOperations: "عملیات فروشگاه",
    storeCustomers: "مشتریان",
    storeDefinitionsAndManagement: "تعاریف و مدیریت",
    benefitCardNotFound: "کارت یافت نشد",
    benefitCardBlocked: "مسدود",
    benefitCardNotBlocked: "عادی",
    benefitCardSelectOne: "برای تعیین شناسه کارت فقط یک کارت انتخاب کنید",
    benefitCardSelectedCount: "تعداد کارت‌های انتخاب‌شده",
    benefitCardPreview: "پیش‌نمایش",
    benefitCardNoOwner: "بدون دارنده",
    benefitCardPinShort: "رمز خرید",
    benefitCardKeepPassword:
      "رمز فعلی حفظ می‌شود؛ برای تغییر، رمز جدید وارد کنید",
    benefitCardExcelNumberHint:
      "ستون شماره کارت را در اکسل از نوع متنی وارد کنید؛ وگرنه اکسل عدد ۱۶ رقمی را گرد می‌کند.",
    benefitCardEmptyOwnerHint:
      "خالی گذاشتن صاحب کارت، کارت‌ها را بدون دارنده می‌کند.",
    benefitCardEmptyPasswordHint:
      "بدون تیک «رمز الزامی» و با رمز خالی، کارت‌ها بی‌رمز می‌شوند.",
    benefitCardChargeHint:
      "برای هر کارت انتخاب‌شده یک ردیف با همین مبلغ ثبت می‌شود.",
    benefitCardRunningBalanceHint:
      "ستون مانده فقط وقتی گرید روی یک کارت فیلتر شده باشد محاسبه می‌شود.",
    storeInfo: "اطلاعات فروشگاه",
    boothInfo: "اطلاعات غرفه",
    storeDefaultValues: "مقادیر پیش‌فرض فروش",
    storeUsers: "کاربران فروشگاه",
    storeUserPersonHint:
      "با ذخیره فروشگاه، شخص هر کاربر در «کاربران شعبه» هم به همین شخص تغییر می‌کند.",
    storeUserDuplicate: "این کاربر قبلاً به فروشگاه اضافه شده است",
    invalidTimeRange: "بازه ساعت کامل یا معتبر نیست (مثلاً 08:00 تا 20:00)",
    storeUserPersonRequired: "کاربر و شخص الزامی است",
    boothForm: {
      basicInfoDesc: "فروشگاه، کد و مشخصات اصلی غرفه",
      defaultValuesDesc:
        "فیلدهای خالی با انتخاب فروشگاه از پیش‌فرض‌های آن پر می‌شوند",
      commodityGroups: "گروه‌های کالای غرفه",
      commodityGroupsDesc: "کالاهای کدام گروه‌ها در این غرفه فروخته شوند",
      allGroups: "همه گروه‌های کالا",
      allGroupsDesc: "همه کالاها در این غرفه قابل فروش هستند",
      selectedGroups: "گروه‌های انتخابی",
      selectedGroupsDesc: "فقط کالاهای گروه‌های مشخص‌شده",
      summary: "خلاصه غرفه",
      summaryDesc: "وضعیت و مشخصات کلی",
      active: "فعال",
      inactive: "غیرفعال",
      groupsCount: "گروه انتخاب‌شده",
    },
    // کامپوننت مشترک تسویه (components/settlement/SettlementDialog.vue)
    settlementDialog: {
      title: "تسویه فاکتور فروش",
      metaCode: "فاکتور",
      metaDate: "تاریخ",
      metaBuyer: "مشتری",
      metaClub: "عضو باشگاه",
      metaStore: "فروشگاه",
      metaSeller: "مسئول فروش",
      settled: "تسویه شده",
      pending: "تسویه ناقص",
      pendingHint:
        "تسویه کامل نشده است؛ سطر مشکل‌دار را اصلاح کنید یا دوباره «ثبت» را بزنید.",
      // خلاصه
      summary: "خلاصه تسویه",
      payable: "مبلغ فاکتور",
      discount: "تخفیف",
      totalSettled: "جمع تسویه",
      remain: "مانده",
      statusUnpaid: "تسویه نشده",
      statusPartial: "تسویه ناقص",
      statusDone: "تسویه کامل",
      statusOver: "پرداخت اضافه — مبلغ برگشتی به مشتری:",
      currency: "ریال",
      pieces: "فقره",
      // روش‌ها
      addMethod: "افزودن روش تسویه:",
      edit: "ویرایش",
      collapse: "بستن",
      removeMethod: "حذف روش",
      addRow: "سطر دیگر",
      noRows: "روش تسویه را انتخاب کنید",
      noRowsHint: "از دکمه‌های «افزودن روش تسویه» یک یا چند روش اضافه کنید",
      singleRowType: "این نوع تسویه فقط یک سطر می‌گیرد",
      amount: "مبلغ (ریال)",
      fillRemain: "مانده",
      fillRemainTitle: "تکمیل مانده",
      overLimit: "مبلغ بیشتر از مبلغ قابل استفاده ({0} ریال) است",
      cashBox: "صندوق / بانک دریافت کننده",
      posTerminal: "دستگاه کارتخوان",
      posServerHint:
        "با ثبت، مبلغ هر سطر کارتخوان به دستگاه ارسال می‌شود و کارت روی دستگاه کشیده می‌شود.",
      benefitCard: "بن کارت",
      benefitCardPassword: "رمز بن کارت",
      cardBalance: "قابل استفاده",
      cardOwner: "دارنده",
      creditorAccount: "حساب",
      creditorBalance: "بستانکاری قابل استفاده",
      debtorPerson: "شخص بدهکار",
      // اعتباری (اعتبار باشگاه)
      clubCreditBalance: "مانده اعتبار باشگاه",
      noClubCredit: "مشتری عضو باشگاه نیست یا اعتبار ندارد",
      // تخفیف
      discountCode: "کد تخفیف",
      apply: "اعمال",
      customerDiscounts: "کدهای تخفیف قابل استفاده",
      noDiscountCode: "کد تخفیفی برای این فاکتور نیست",
      discountNotFound: "کد تخفیف نامعتبر است",
      oneDiscountCode: "فقط یک کد تخفیف مجاز است",
      manualDiscount: "تخفیف دستی",
      manualDiscountAmount: "مبلغ تخفیف دستی (ریال)",
      // چک
      chequeRemain: "مانده قابل تسویه با چک",
      chequeCount: "تعداد چک",
      fromChequeNumber: "شماره چک از",
      toChequeNumber: "تا شماره",
      firstDueDate: "اولین سررسید",
      interval: "فاصله (ماه)",
      defaultBank: "بانک پیش‌فرض",
      defaultStatus: "وضعیت پیش‌فرض",
      defaultBranch: "شعبه پیش‌فرض",
      autoCheques: "ایجاد خودکار چک‌ها",
      equalSplit: "توزیع مساوی",
      addCheque: "افزودن چک",
      noCheques:
        "هنوز چکی ثبت نشده است. تعداد را وارد و «ایجاد خودکار چک‌ها» را بزنید.",
      noRemainForCheque: "مانده‌ای برای تسویه با چک وجود ندارد",
      chequeFormRequired: "تعداد چک و اولین سررسید را وارد کنید",
      chequeNumber: "شماره چک",
      dueDate: "سررسید",
      bank: "بانک",
      branch: "شعبه",
      chequeStatus: "وضعیت",
      sayadNumber: "شماره صیادی",
      chequesTotal: "جمع {0} فقره چک",
      duplicateCheque: "شماره چک {0} تکراری است",
      // کارتخوان سمت سرور
      posSwipeWaiting: "لطفاً کارت را روی دستگاه بکشید…",
      posSwipeWaitingHint:
        "تا آمدن جواب دستگاه صبر کنید؛ صفحه را نبندید و دوباره کلیک نکنید.",
      posLockedRow:
        "این پرداخت کارتخوان انجام شده یا در انتظار نتیجه دستگاه است و باید با همین دستگاه و مبلغ در تسویه بماند",
      posPendingNoDelete:
        "پرداخت کارتخوان در انتظار نتیجه دستگاه است؛ تا مشخص شدن نتیجه، تسویه قابل حذف نیست",
      posUnknownHint:
        "نتیجه نهایی دستگاه ثبت نشد و ممکن است مبلغ از کارت کسر شده باشد؛ با رسید دستگاه بررسی کنید.",
      posReferenceNumber: "شماره مرجع",
      posIssueTracking: "شماره پیگیری",
      posCardNumber: "کارت",
      posStatusTitles: {
        0: "در انتظار نتیجه دستگاه",
        1: "موفق",
        2: "ناموفق",
        3: "بدون پاسخ از دستگاه",
        4: "خطا",
        5: "نامشخص",
      },
      // فوتر
      autoPrint: "چاپ اتوماتیک فاکتور",
      submit: "ثبت",
      submitPos: "ثبت و ارسال به کارتخوان",
      submitShortcut: "ثبت سریع",
      rowsInvalid: "فیلدهای الزامی سطرهای مشخص‌شده را کامل کنید",
      remainMustBeZero: "تسویه فقط با مانده صفر ثبت می‌شود",
      deleteSettlement: "حذف تسویه",
      deleteSettlementConfirm:
        "تسویه حذف شود؟ سند، اسناد خزانه، تخفیف، خرید باشگاه و برداشت بن کارت برگردانده می‌شوند.",
      typeTitles: {
        1: "نقد",
        2: "کارتخوان",
        3: "چک",
        4: "تخفیف",
        5: "اعتباری",
        6: "بن کارت",
        7: "کالابرگ",
        8: "بستانکاری",
        9: "سایر حساب‌ها",
      },
      // جایگزین برچسب‌ها در تسویه سفارش
      order: {
        title: "تسویه سفارش",
        metaCode: "سفارش",
        payable: "مبلغ سفارش",
        noDiscountCode: "کد تخفیفی برای این سفارش نیست",
        deleteSettlementConfirm:
          "تسویه و سند حسابداری آن حذف می‌شود. ادامه می‌دهید؟",
        voucherSettings: "تنظیمات سند",
        deleteVoucherConfirm:
          "فقط سند حسابداری تسویه حذف می‌شود و تسویه باقی می‌ماند. ادامه می‌دهید؟",
        emptyAccountInfo:
          "سرفصل بعضی از سطرهای سند خالی است؛ سرفصل‌های خالی را در پیش‌نمایش سند تکمیل کنید",
      },
    },
    // فاکتور فروش فروشگاه (صفحه فروش سریع) و تسویه آن
    storeSaleFactor: {
      newCustomer: "مشتری جدید",
      cashier: "کاربر صندوق",
      catalogTitle: "کالاها و خدمات",
      catalogTab: "انتخاب از کالاها",
      barcodeTab: "ثبت با بارکد",
      catalogShort: "کاتالوگ",
      barcodeShort: "بارکد",
      pickCustomer: "انتخاب مشتری",
      allGroups: "همه",
      moreBySearch: "برای دیدن کالاهای بیشتر، نام یا کد کالا را جستجو کنید",
      scanHint: "بارکد را اسکن کنید یا کد کالا را بزنید و Enter",
      scanPlaceholder: "بارکد / کد کالا",
      scanQtyHint: "برای چند عدد: 3*بارکد",
      scanNotFound: "یافت نشد:",
      recentScans: "آخرین اسکن‌ها",
      noScans: "هنوز کالایی اسکن نشده است",
      currentFactor: "فاکتور جاری",
      changeCustomer: "تغییر مشتری",
      moreShort: "سایر اطلاعات",
      realPrice: "قیمت واقعی کالاها",
      customerSaving: "سود مشتری از خرید",
      saveOnly: "فقط ثبت فاکتور",
      settleAndFinish: "تسویه و نهایی‌سازی",
      unitsShort: "عدد",
      shortcutLine: "F2 جستجو · F4 مشتری · F9 ثبت · F10 تسویه",
      store: "فروشگاه",
      noStore: "فروشگاهی به کاربر شما تخصیص داده نشده است",
      storeRequired: "ابتدا فروشگاه را انتخاب کنید",
      newFactor: "فاکتور جدید",
      newShort: "جدید",
      factorNo: "فاکتور",
      searchCode: "شماره فاکتور",
      list: "فاکتورها",
      operations: "عملیات",
      settle: "تسویه",
      viewSettlement: "مشاهده تسویه",
      copy: "کپی فاکتور",
      returnFactor: "مرجوعی",
      delete: "حذف فاکتور",
      settled: "تسویه شده",
      notSettled: "تسویه نشده",
      lockedSettled:
        "این فاکتور تسویه شده و قابل ویرایش یا حذف نیست؛ برای تغییر، اول تسویه را حذف کنید.",
      notFound: "فاکتور یافت نشد",
      noMoreFactor: "فاکتور دیگری در این جهت وجود ندارد",
      savedOk: "فاکتور ثبت شد",
      lastFactorSettled: "فاکتور {code} ثبت و تسویه شد",
      openLastFactor: "مشاهده فاکتور",
      copyConfirm: "از این فاکتور یک فاکتور تازه با تاریخ امروز ساخته شود؟",
      returnConfirm: "از کل این فاکتور، فاکتور مرجوعی صادر شود؟",
      deleteConfirm: "فاکتور به همراه حواله و سند آن حذف شود؟",
      unsavedConfirm: "سبد خرید ثبت نشده است. آیا می‌خواهید فاکتور ذخیره شود؟",
      // کاتالوگ
      searchPlaceholder:
        "نام، کد یا بارکد کالا را بزنید و Enter — برای چند عدد: 3*کد",
      searchResults: "نتایج جستجو",
      noCommodity: "کالایی یافت نشد",
      groupEmpty: "این گروه کالای فعالی ندارد",
      typeToSearch:
        "یک گروه را انتخاب کنید یا نام، کد یا بارکد کالا را جستجو کنید",
      typeToSearchNoGroup: "نام، کد یا بارکد کالا را جستجو کنید",
      // مشتری
      clubMember: "عضو باشگاه (نام یا موبایل)",
      clubMemberShort: "عضو باشگاه",
      quickAddClub: "عضو جدید باشگاه",
      quickClubTitle: "ثبت شخص جدید",
      mobileNumber: "شماره موبایل",
      mobileInvalid: "شماره موبایل معتبر نیست",
      firstName: "نام",
      lastName: "نام خانوادگی",
      nationalCode: "کد ملی",
      nationalCodeInvalid: "کد ملی باید ۱۰ رقم باشد",
      gender: "جنسیت",
      birthDate: "تاریخ تولد",
      introducerMobile: "شماره معرف",
      buyer: "خریدار",
      seller: "مسئول فروش",
      moreInfo: "خریدار، مسئول فروش و سایر اطلاعات",
      kbSearch: "جستجوی کالا",
      kbClub: "عضو باشگاه",
      // سبد خرید
      cart: "سبد خرید",
      items: "قلم",
      cartEmpty: "سبد خرید خالی است",
      cartEmptyHint: "کالا را اسکن یا جستجو کنید، یا از گروه‌ها انتخاب کنید",
      clearCart: "خالی کردن",
      clearCartConfirm: "همه اقلام سبد خرید حذف شوند؟",
      lineDetails: "قیمت، تخفیف و توضیحات سطر",
      unitPrice: "فی",
      lineDiscount: "تخفیف",
      lineDescription: "توضیحات سطر",
      priceMissing: "قیمت ندارد؛ برای ورود قیمت کلیک کنید",
      calculating: "در حال محاسبه...",
      linePriceRequired: "قیمت این کالا مشخص نیست: ",
      lineQtyRequired: "تعداد این کالا باید بیشتر از صفر باشد: ",
      total: "جمع کل",
      discount: "تخفیف",
      tax: "مالیات و عوارض",
      factorAddMinus: "اضافات و کسورات فاکتور",
      payable: "قابل پرداخت",
      currency: "ریال",
      save: "ثبت",
      savePay: "ثبت و پرداخت",
      pay: "پرداخت",
      // لیست
      fromCode: "از شماره",
      toCode: "تا شماره",
      // تسویه (بقیه برچسب‌ها در settlementDialog)
      settlementPending: "تسویه ناقص",
    },
    boothCommodityGroupsRequired:
      "برای غرفه‌ای که شامل همه گروه‌های کالا نیست، حداقل یک گروه کالا انتخاب کنید",
    directCommissions: "درصد سود مستقیم از فروش",
    subGroupCommissions: "درصد سود از افراد زیرمجموعه",
    commissionStepsHint:
      "بازه‌ها نباید هم‌پوشانی داشته باشند؛ دو پله‌ای که فقط در مرز به هم می‌رسند مجازند و مبلغ روی مرز در پله بالاتر حساب می‌شود.",
    commissionEmpty: "پله‌ای ثبت نشده است",
    commissionToPriceError: "مبلغ «تا» باید بزرگتر از مبلغ «از» باشد",
    commissionPercentError: "درصد کمیسیون باید بین 0 تا 100 باشد",
    commissionOverlapError: "این بازه با بازه دیگری تداخل دارد",
    preOrderCanceled: "انصراف داده شده",
    preOrderConverted: "تبدیل شده به فاکتور",
    preOrderNormal: "عادی",
    preOrderLocked:
      "پیش فاکتور تبدیل شده به فاکتور قابل ویرایش، حذف یا انصراف نیست",
    preOrderCanceledNotEditable: "پیش فاکتور انصراف داده شده قابل ویرایش نیست",
    cancelPreOrderConfirm: "از انصراف این پیش فاکتور مطمئن هستید؟",
    undoCancelPreOrderConfirm: "انصراف این پیش فاکتور برگردانده شود؟",
    preOrderHeader: "اطلاعات پیش فاکتور",
    preOrderCommodities: "اقلام پیش فاکتور",
    preOrderGiftHint:
      "هدیه خودکار در پیش فاکتور محاسبه نمی‌شود و در فاکتور صندوق حساب خواهد شد.",
    netTotalPrice: "جمع خالص",
    portalAccessSelectPersonnel:
      "برای مشاهده و تنظیم دسترسی‌های پرتال «میتای من»، ابتدا پرسنل را انتخاب کنید.",
    portalAccessMobileHint: "عضو پرتال با این شماره وارد می‌شود.",
    portalAccessInactiveHint:
      "با غیرفعال کردن دسترسی به پرتال، همه دسترسی‌های کارمندی این شخص در شعبه جاری گرفته می‌شود.",
    portalAccessReloginHint:
      "پس از ذخیره، کارمند باید در پرتال دوباره شعبه را انتخاب کند یا دوباره وارد شود تا منوی جدید را ببیند.",
    portalAccessPermissions: "دسترسی‌ها",
    portalAccessNoPermissions: "دسترسی‌ای برای انتخاب وجود ندارد.",
    portalAccessEmptyTitle: "پرسنلی انتخاب نشده است",
    portalAccessActiveStatus: "دسترسی به پرتال فعال",
    portalAccessInactiveStatus: "بدون دسترسی به پرتال",
    portalAccessSwitchDesc:
      "با فعال بودن این گزینه، پرسنل می‌تواند با شماره موبایل خود وارد پرتال «میتای من» شود.",
    portalAccessPermissionsDesc:
      "مشخص کنید این پرسنل در پرتال به کدام بخش‌ها دسترسی داشته باشد.",
    portalAccessSelected: "انتخاب‌شده",
    portalAccessOf: "از",
    portalAccessUnsaved: "تغییرات ذخیره نشده",
    portalAccessNoMobile: "شماره موبایل ثبت نشده",
    portalAccessDeactivateTitle: "غیرفعال کردن دسترسی پرتال",
    portalAccessDeactivateConfirm:
      "آیا از غیرفعال کردن دسترسی این پرسنل اطمینان دارید؟",
    companyForm: {
      basicInfo: "اطلاعات پایه شرکت",
      basicInfoDesc: "نام، نوع و حوزه فعالیت شرکت",
      managerInfo: "اطلاعات مدیر",
      managerInfoDesc: "مشخصات مدیرعامل یا مسئول شرکت",
      registerInfo: "اطلاعات ثبتی و مالیاتی",
      registerInfoDesc: "کد اقتصادی، شناسه ملی و مشخصات ثبت",
      subscriptionInfo: "اشتراک و دسترسی",
      subscriptionInfoDesc: "اعتبار، ظرفیت، مسیر ورود و زیرسیستم‌ها",
      contactInfo: "اطلاعات تماس",
      contactInfoDesc: "راه‌های ارتباطی و نشانی شرکت",
      images: "تصاویر",
      imagesDesc: "لوگو و آیکون نمایش داده‌شده در سامانه",
      logoHint: "PNG یا JPG، ترجیحاً مربعی",
      faviconHint: "PNG یا ICO، ابعاد ۶۴×۶۴ پیکسل",
      selectImage: "انتخاب یا رها کردن تصویر",
      changeImage: "تغییر تصویر",
      removeImage: "حذف تصویر",
      uploading: "در حال بارگذاری...",
    },
    warehousingMethodManual: "کالا به کالا",
    warehousingMethodExcel: "فایل اکسل",
    warehousingMethodBatch: "سری ساخت",
    warehousingMethodBatchExcel: "سری ساخت از اکسل",
    warehousingMethodList: "لیستی",
    warehousingMethodDevice: "فایل دستگاه",
    warehousingMethodLive: "دستگاه (زنده)",
    warehousingRound1: "شمارش اول",
    warehousingRound2: "شمارش دوم",
    warehousingRound3: "شمارش سوم",
    warehousingEntryMethod: "روش ورود اطلاعات شمارش",
    warehousingComingSoon: "به‌زودی",
    warehousingTotalItems: "کل اقلام",
    warehousingCountedItems: "دارای مقدار شمارش",
    warehousingCountedList: "اقلام شمارش‌شده",
    warehousingBatchList: "سری‌های ساخت ثبت‌شده",
    warehousingListHint:
      "مقدار شمارش هر کالا را مستقیماً در جدول وارد کنید و در پایان ذخیره کنید",
    warehousingExcelStep1: "نمونه فایل اکسل را دانلود و تکمیل کنید",
    warehousingExcelStep2:
      "فایل تکمیل‌شده را انتخاب و نام شیت را وارد کنید؛ نام شیت باید دقیقاً با نام شیت داخل فایل یکسان باشد",
    warehousingExcelFormat: "فرمت فایل اکسل",
    warehousingExcelErrors: "خطاهای موجود در فایل اکسل",
    warehousingAddExcelFile: "افزودن فایل اکسل",
    warehousingMatched: "بدون مغایرت",
    warehousingShortage: "کسری",
    warehousingSurplus: "مازاد",
    warehousingAll: "همه",
    warehousingConfirmHint:
      "پس از بررسی، با تایید مغایرت‌ها رسید و حواله انبار برای اصلاح موجودی صادر می‌شود",
    warehousingBasicInfo: "مشخصات انبارگردانی",
    warehousingCountMethod: "روش شمارش",
    warehousingByTagHint:
      "برای کالاها تگ انبارگردانی چاپ می‌شود و شمارش با ورود شماره تگ انجام می‌شود",
    warehousingWithoutTagHint:
      "شمارش مستقیم با انتخاب کالا و بدون چاپ تگ انجام می‌شود",
    warehousingInventoryParams: "پارامترهای موثر در موجودی",
    warehousingInventoryParamsHint:
      "بر اساس تنظیمات پارامترهای تکمیلی کالا تعیین می‌شود (فقط نمایشی)",
    warehousingNoParams: "پارامتر تکمیلی برای کالاها تعریف نشده است",
    warehousingCommodities: "کالاهای مورد شمارش",
    warehousingAllCommodityHint: "همه کالاهای موجود در انبار شمارش می‌شوند",
    warehousingSelectedCommodityHint:
      "فقط کالاهایی که از جدول انتخاب می‌کنید شمارش می‌شوند",
    warehousingSelectWareFirst: "برای مشاهده کالاها ابتدا انبار را انتخاب کنید",
    warehousingSelectedCount: "کالای انتخاب شده",
    warehousingCommodityCount: "کالا",
    warehousingCodeAfterSubmit: "پس از ثبت تخصیص داده می‌شود",
    warehousingLockedAfterSubmit: "پس از ثبت انبارگردانی قابل تغییر نیست",
    warehousingRegisterFirst: "ابتدا اطلاعات انبارگردانی را ثبت کنید",
    warehousingNoContradictionYet:
      "پس از ثبت شمارش، مغایرت‌ها در این مرحله نمایش داده می‌شوند",
    warehousingStepInfoHint: "مشخصات و دامنه شمارش",
    warehousingStepCountingHint: "ورود مقادیر شمارش‌شده",
    warehousingStepContradictionHint: "بررسی و ثبت مغایرت‌ها",
    attachmentKindMap: "نقشه",
    attachmentKindDataSheet: "دیتاشیت",
    attachmentKindQc: "QC",
    noMapUploaded: "برای این نوبت هنوز فایل نقشه‌ای بارگذاری نشده است",
    copyBom: "کپی فرمول تولید",
    yes: "بله",
    no: "خیر",
    has: "دارد",
    hasNot: "ندارد",
    confirm: "تایید",
    disconfirm: "عدم تایید",
    unConfirmReceipt: "غیرقطعی کردن رسید انبار",
    receiptOperations: "عملیات رسید",
    tempReceiptOperations: "عملیات رسید موقت",
    draftRequestOperations: "عملیات درخواست حواله",
    draftOperations: "عملیات حواله",
    copyDraftFromReceipt: "کپی حواله از رسید",
    copyReceiptFromDraft: "کپی رسید از حواله",
    signatures: "امضاها",
    receiptConfirmed: "این رسید قطعی شده است",
    receiptUnConfirmed: "این رسید غیرقطعی شده است",
    unConfirmDraft: "غیرقطعی کردن حواله انبار",
    draftConfirmed: "این حواله قطعی شده است",
    draftUnConfirmed: "این حواله غیرقطعی شده است",
    paymentRequestConfirmed: "این درخواست پرداخت تایید شده است",
    dashboard: "داشبورد مدیریتی",
    profile: "ویرایش اطلاعات و رمز عبور حساب کاربری",
    password: "تغییر رمز عبور",
    avatar: "تصویر پروفایل کاربری",
    baseInformation: "اطلاعات و تنظیمات ابتدایی سامانه",
    addBaseInformation: "ثبت اطلاعات پایه جدید",
    editBaseInformation: "ویرایش اطلاعات پایه",
    users: "مدیریت کاربران سامانه",
    addUser: "ثبت کاربر جدید",
    editUser: "ویرایش اطلاعات کاربر",
    products: "مدیریت محصولات و تولیدات",
    orders: "مدیریت و بررسی سفارشات",
    messages: "پیام‌ها و چت کاربران",
    tickets: "پیام‌ها و درخواست‌های مشتریان",
    loading: "در حال بارگذاری ...",
    singIn: "ورود به سامانه",
    singUp: "عضویت در سامانه",
    haveAccount: "حساب کاربری دارید؟",
    haveNotAccount: "حساب کاربری ندارید؟",
    forgotPassword: "رمز عبور را فراموش کرده‌اید؟",
    emptyItem: "موردی جهت نمایش یافت نشد",
    emptyMessage: "لیست پیام‌های شما خالی می‌باشد",
    emptyTicket: "لیست تیکت‌های شما خالی می‌باشد",
    emptyNotify: "لیست اعلان‌ و هشدارها خالی می‌باشد",
    noMessage: "پیام جدیدی دریافت نکردید",
    noNotify: "اعلان جدیدی وجود ندارد",
    underConstruction:
      "این قسمت در حال توسعه می‌باشد و بزودی در دسترس قرار خواهد گرفت",
    rejectedTitle: "عدم دسترسی به سامانه",
    rejectedText: "حساب کاربری شما در این سامانه مسدود شده است",
    search: "جستجو",
    searchTable: "جستجو در جدول",
    searchAllColumns: "جستجو در همه‌ ستون‌ها...",
    delConfirm: "از حذف این مورد مطمئن هستید؟",
    copyConfirm: "از کپی کردن این مورد مطمئن هستید؟",
    resell: "آیا محصول برای فروش مجدد هست؟",
    workStationManagement: "اطلاعات و تنظیمات دستگاه‌ ها یا ایستگاه های کاری",
    addWorkStation: "ثبت ایستگاه کاری جدید",
    editWorkStation: "ویرایش اطلاعات ایستگاه کاری",
    workShift: "مدیریت و تنظیمات شیفت های کاری",
    addShift: "ثبت شیفت جدید",
    editShift: "ویرایش اطلاعات شیفت",
    bom: "اطلاعات و تنظیمات فرمول تولید",
    consumingMaterials: "مواد مصرفی",
    editConsumingMaterials: "ویرایش مواد مصرفی",
    addUnit: "ثبت واحد شمارش جدید",
    editUnit: "ویرایش واحد شمارش",
    unit: "اطلاعات و تنظیمات واحدهای شمارش",
    addParentCategory: "ثبت گروه بندی پدر (اصلی)",
    addChildCategory: "درج فرزند",
    addSubGroup: "درج زیرگروه",
    editCategory: "ویرایش اطلاعات گروه بندی",
    category: "اطلاعات و تنظیمات گروه بندی کالا",
    addWare: "ثبت انبار جدید",
    editWare: "ویرایش اطلاعات انبار",
    ware: "اطلاعات و تنظیمات انبارها",
    commodity: "اطلاعات و تنظیمات کالاها",
    module: "ماژول",
    modules: "ماژول ها",
    menu: "منو",
    changeModule: "تغییر ماژول",
    visitor: "آمار امروز و آمار کل بازدید",
    totalPageViews: "آمار روز",
    todayStatistics: "آمار امروز",
    totalVisitors: "تعداد بازید کنندگان",
    pageViewPerVisitor: "بازدید از صفحه در هر بازدید",
    totalVisitStatistics: "آمار کل بازدید",
    lastVisits: "آخرین بازدید ها",
    visitPerHour: "بازدید براساس ساعات شبانه روز",
    visitPerDay: "بازدید براساس تاریخ روز",
    visitCount: "تعداد بازدید",
    order: "اطلاعات و تنظیمات سفارشات",
    orderCommodities: "کالاهای سفارش",
    editCommodity: "ویرایش اطلاعات کالا",
    addPreAccount: "اضافه کردن سرفصل حساب جدید ( زیرمجموعه حساب )",
    completeConfirm: "از تکمیل این مورد مطمئن هستید؟",
    branch: "اطلاعات و تنظیمات شعبه ها",
    roles: "اطلاعات و تنظیمات نقش‌ های کاربران و دسترسی‌ ها",
    addRole: "ثبت نقش جدید",
    editRole: "ویرایش اطلاعات نقش",
    rolePermission: "مدیریت و ویرایش دسترسی‌های نقش",
    rolePermissionInfo:
      " با تغییر نقش لیست دسترسی‌ها نیز بروزرسانی خواهد شد و می‌توانید دسترسی‌های مدنظر را انتخاب و یا حذف کنید.",
    addFiscalYear: "ثبت سال مالی جدید",
    editFiscalYear: "ویرایش اطلاعات سال مالی",
    manageFinancialYears: "مدیریت سال‌های مالی",
    commodityCategory: "مدیریت گروه‌بندی کالا",
    subCount: "تعداد زیردسته",
    showMaterials: "مشاهده مواد مصرفی",
    foilConfirm: "تایید واحد فویل",
    financialConfirm: "تایید واحد مالی",
    casterConfirm: "تایید واحد کستر",
    coldRollConfirm: "تایید واحد نورد سرد",
    saleConfirm: "تایید واحد فروش",
    managerConfirm: "تایید مدیرعامل",
    productionConfirm: "تایید واحد تولید",
    supplyAndEquipmentConfirm: "تایید واحد تامین و تجهیز",
    returnToCartableConfirm: "تایید برگشت به کارتابل",
    shelf: "اطلاعات و تنظیمات انبارک‌ها",
    addShelf: "ثبت انبارک جدید",
    editShelf: "ویرایش اطلاعات انبارک",
    addCountry: "ثبت کشور جدید",
    editCountry: "ویرایش اطلاعات کشور",
    addProvince: "ثبت استان جدید",
    editProvince: "ویرایش اطلاعات استان",
    addCity: "ثبت شهر جدید",
    editCity: "ویرایش اطلاعات شهر",
    addPersonGroup: "ثبت گروه جدید",
    editPersonGroup: "ویرایش اطلاعات گروه",
    editCustomerGroup: "ویرایش اطلاعات گروه مشتری",
    person: "اطلاعات و تنظیمات اشخاص",
    sbuCategory: "مدیریت واحد ها",
    addSbu: "ثبت واحد جدید",
    addUnitCoefficient: "ثبت ضریب واحد شمارش جدید",
    editUnitCoefficient: "ویرایش ضریب واحد شمارش",
    unitCoefficient: "اطلاعات و تنظیمات تبدیل ضرایب واحد شمارش",
    commodityGeneralInfo: "اطلاعات عمومی کالا",
    commodityAdditionalInfo: "اطلاعات تکمیلی کالا",
    financialInfo: "اطلاعات مالی",
    inventoryInfo: "کنترل موجودی",
    logisticInfo: "اطلاعات لجستیک",
    productionInfo: "تولید",
    otherInfo: "سایر",
    reqProduce: "اطلاعات و تنظیمات درخواست تولید",
    showReqDetails: "مشاهده جزئیات درخواست (کالاها)",
    productionPlan: "برنامه تولید و تعیین فرآیندهای تولید",
    addMaterial: "ثبت مواد مصرفی جدید",
    editMaterial: "ویرایش اطلاعات مواد مصرفی",
    editProductionPlan: "ویرایش اطلاعات فرآیند تولید",
    castingQC: "کنترل کیفی ریخته‌گری های انجام شده",
    disconfirmQC: "عدم تایید کنترل کیفی",
    confirmQC: "تایید کنترل کیفی",
    produceProcess: "دستور های تولید و تعیین فرآیندهای تولید",
    otherInformation: "سایر اطلاعات",
    editable: "قابل ویرایش",
    nonEditable: "غیرقابل ویرایش",
    closeUnsavedTab:
      "اطلاعات این تب ذخیره نشده است و با بستن آن از بین می‌رود. تب بسته شود؟",
    wareCategory: "اطلاعات و تنظیمات دسته بندی انبارها",
    addWareCategory: "ثبت دسته بندی انبار جدید",
    editWareCategory: "ویرایش اطلاعات دسته بندی انبار",
    subSystem: "زیرسیستم",
    treeSbu: "نمایش درختی واحدهای سازمانی",
    sbuTitle: "واحد سازمانی",
    addParentSbu: "ثبت واحد اصلی",
    addChildSbu: "ثبت واحد ",
    addParentPosition: "ثبت سِمت اصلی",
    addChildPosition: "ثبت سِمت ",
    addMember: "ثبت عضو جدید",
    editMember: "ویرایش عضو",
    editFloatLevel: "ویرایش سطح شناور",
    floatAccountLevel: "سطح شناور",
    day: "روز",
    unitInfo: "واحدهای شمارش",
    wareInfo: "انبارهای کالا",
    sunBarcodeInfo: "بارکد های فرعی کالا",
    productAdditionalParamInfo: "پارامترهای تکمیلی کالا",
    imageInfo: "تصاویر کالا",
    commodityCategoryTree: "نمایش درختی گروه‌های کالا",
    wareVoucherType: "مدیریت و تنظیمات انواع سند انبار",
    parentCode: "کد گروه والد",
    mainCategory: "عنوان گروه اصلی",
    code: "شماره",
    codeB: "کد", // code in base information
    addFloatAccount: "ثبت حساب شناور جدید",
    editFloatAccount: "ویرایش حساب شناور",
    addContact: "ثبت مخاطب جدید",
    editContact: "ویرایش مخاطب",
    addRegion: "ثبت منطقه جدید",
    editRegion: "ویرایش منطقه",
    addFloatAccountGroup: "ثبت گروه حساب جدید",
    editFloatAccountGroup: "ویرایش گروه حساب",
    editBarcode: "ویرایش بارکد کالا",
    addCommoditiesToWares: "تعیین انبارهای کالاها به صورت گروهی",
    addParentHeader: "ثبت سرفصل حساب پدر (اصلی)",
    addChildHeader: "درج فرزند ",
    editHeader: "ویرایش اطلاعات",
    addCommodityHeaders: "معرفی سرفصل های کالاها به صورت گروهی",
    accountConfig: "اطلاعات و تنظیمات کد سرفصل های حساب",
    addAccountConfig: "ثبت تنظیمات کد حساب",
    editAccountConfig: "ویرایش تنظیمات کد حساب",
    addPrefix: "ثبت پیشوند جدید",
    addGraid: "ثبت گرید جدید",
    editPrefix: "ویرایش اطلاعات پیشوند ",
    editSbu: "ویرایش واحد سازمانی",
    editPosition: "ویرایش سِمت",
    additionalCommodityParameter: "اطلاعات و تنظیمات پارامترهای تکمیلی کالا",
    list: "لیست",
    addParameter: "ثبت پارامتر جدید",
    editParameter: "ویرایش پارامتر",
    buyRequest: "اطلاعات و تنظیمات درخواست های خرید",
    addBuyRequest: "ثبت درخواست خرید جدید",
    editBuyRequest: "ویرایش اطلاعات درخواست خرید",
    tempReceipt: "اطلاعات و تنظیمات رسیدهای موقت",
    commodityInfo: "اطلاعات کالاها",
    commodityBatch: "بچ‌های کالای",
    financialReceipt: "اطلاعات و تنظیمات رسیدهای مالی (ریالی)",
    importExcel: "ورود اطلاعات از اکسل",
    importExcelReceiveCash: "ورود اطلاعات از اکسل دریافت نقد",
    importExcelPaymentCash: "ورود اطلاعات از اکسل پرداخت نقد",
    importExcelReceivePaymentCash:
      "ورود اطلاعات از اکسل دریافت و پرداخت نقد تجمیعی",
    receipt: "اطلاعات و تنظیمات رسیدهای مقداری و مالی",
    accountControlConfig: "اطلاعات و تنظیمات کنترلی حساب ها",
    editAccountControlConfig: "اعمال کنترل های مشابه برای سطرهای انتخاب شده",
    draftReques: "اطلاعات و تنظیمات درخواست های حواله",
    draft: "اطلاعات و تنظیمات حواله‌های مقداری و مالی",
    receiptInfo: "اطلاعات رسید",
    receipts: "رسیدها",
    receiptDetails: "جزئیات رسید",
    drafts: "لیست حواله‌ها",
    draftDetails: "جزئیات حواله‌ها",
    draftInfo: "اطلاعات حواله",
    driverInfo: "اطلاعات راننده",
    additionalInfo: "اطلاعات تکمیلی",
    delGroup: "از حذف موارد انتخابی مطمئن هستید؟",
    insuranceId: "کد بیمه",
    positionTitle: "عنوان سِمت",
    addVehicleType: "ثبت  نوع وسیله نقلیه",
    editVehicleType: "ویرایش اطلاعات نوع وسیله نقیله",
    addSupplier: "ثبت تامین‌کننده جدید",
    editSupplier: "ویرایش اطلاعات تامین‌کننده",
    addApprovalCartablePriority: "ثبت اولویت تایید کارتابل",
    editApprovaCartablePriority: "ویرایش اولویت تایید کارتابل",
    searchBy: "جستجو براساس",
    remainCalculationBy: "محاسبه مانده براساس",
    draftRequest: "اطلاعات و تنظیمات درخواست های حواله",
    confirmGroup: "آیا از فعال کردن موارد انتخابی مطمئن هستید؟",
    disConfirmGroup: "آیا از غیرفعال کردن موارد انتخابی مطمئن هستید؟",
    editTaxGroup: "تغییر گروهی شناسه یا نام مالیاتی",
    editCodeGroup: "مرتب سازی و تغییر گروهی کد کالا براساس گروه کالا",
    editParameterGroup: "تغییر گروهی پارامترهای تکمیلی کالا",
    tempReceiptConfirm: "تایید/عدم تایید رسیدهای موقت",
    tempReceiptExitConfirm: "تایید رسیدهای موقت رد شده جهت خروج",
    addBuyer: "ثبت مأمور خرید جدید",
    editBuyer: "ویرایش اطلاعات مأمور خرید",
    receiptConfirm: "تایید رسیدهای مالی",
    draftConfirm: "تایید حواله‌های مالی",
    requestConfirm: "تایید درخواست ها",
    requestDisonfirm: "رد درخواست ها",
    searchItems: "جستجوی آیتم‌ها",
    searchNotePlaceholder: "جستجو در عنوان یادداشت…",
    noSearchResult: "یادداشتی با این جستجو پیدا نشد",
    noteUnit: "یادداشت",
    dragToReorder: "برای جابه‌جایی، کارت را بکشید و روی جای دلخواه رها کنید",
    sortSerial:
      "با انجام این عملیات، در صورت استفاده از سریال در شرح اسناد(انبار، مالی و...) شرح اسناد تغییر نخواهد کرد",
    sortWaresCodeReceipts: "در صورت مرتب‌سازی، شماره رسیدها تغییر خواهد کرد.",
    doSort: "آیا مایل به انجام مرتب‌سازی هستید؟",
    sortSaleFactorCode:
      "در صورت مرتب‌سازی، شماره فاکتورهای فروش در بازه انتخاب‌شده تغییر خواهد کرد.",
    sortBuyFactorCode:
      "در صورت مرتب‌سازی، شماره فاکتورهای خرید در بازه انتخاب‌شده تغییر خواهد کرد.",
    sortWaresCodeDrafts: "درصورت مرتب‌سازی، شماره حواله ها تغییر خواهد کرد.",
    sortReceipts:
      "با انجام این عملیات تمامی رسیدهای مربوط به تمامی انبارها، مرتب‌سازی می‌شوند آیا مایل به مرتب‌سازی هستید؟",
    sortDrafts:
      " انجام این عملیات از ابتدای حواله‌ها صورت خواهد گرفت و در اثر این عملیات شماره حواله‌ها تغییر خواهد کرد، آیا مایل به مرتب‌سازی هستید؟ ",
    requestNo: "شماره درخواست مورد نظر را وارد کنید",
    viewCommoditycirculationHelp:
      "کالاهای با گردش، کالاهایی هستند که رسید یا حواله برای آن‌ها ثبت شده است",
    dblCommodity: "برای مشاهده گردش کالا، بر روی کالای موردنظر دوبار کلیک کنید",
    dblConsumables:
      "برای مشاهده مواد مصرفی کالای تولیدشده، بر روی کالای موردنظر دوبار کلیک کنید",
    input: "ورود کالا",
    output: "خروج کالا",
    receiptConfirmation: "قطعی سازی رسیدها",
    receiptDisconfirmation: "غیرقطعی سازی رسیدها",
    draftConfirmation: "قطعی سازی حواله‌ها",
    draftDisconfirmation: "غیرقطعی سازی حواله‌ها",
    transferCommodity: "اطلاعات و تنظیمات انتقال بین انبارها",
    transerNo: "برگه انتقال شماره",
    sendProccessTransfer: "اطلاعات و تنظیمات انتقال بین انبار فرآیندی (ارسال)",
    transferCommodityDelConfirm: "در صورت حذف، رسید و حواله مربوطه حذف می‌شوند",
    manageFields: "مدیریت فیلدهای کالا",
    manageFormFields: "مدیریت فیلدهای برگه",
    manageFieldsHint:
      "فیلدهای موردنیاز خود را انتخاب کنید. تغییرات به‌صورت خودکار ذخیره می‌شوند.",
    generalFields: "فیلدهای عمومی",
    floatAccountFields: "فیلدهای شناور",
    sourceFloatAccountFields: "شناور مبدا",
    destinationFloatAccountFields: "شناور مقصد",
    parameterFields: "پارامترها",
    searchFields: "جستجوی فیلد...",
    noFieldFound: "فیلدی با این عنوان یافت نشد",
    transferConfirm: "از تایید انتقال بین انبار موارد انتخابی مطمئن هستید؟",
    addVoucher: "صدور سند",
    positionCode: "کد سِمت",
    signatureImage: "تصویر امضا",
    contactInformation: "اطلاعات تماس",
    socialNetwork: "فضای مجازی",
    sourceCommodityList: "لیست کالاهای مبدا",
    destinationCommodityList: "لیست کالاهای مقصد",
    addSourceCommodity: "ثبت کالای مبدا",
    addDestinationCommodity: "ثبت کالای مقصد",
    editSourceCommodity: "ویرایش کالای مبدا",
    editDestinationCommodity: "ویرایش کالای مقصد",
    signatureTitles: "تعریف عناوین امضا",
    warehousing: "اطلاعات و تنظیمات انبارگردانی",
    addWarehousing: "ثبت انبارگردانی جدید",
    editWarehousing: "ویرایش اطلاعات انبارگردانی",
    doDelete: "آیا مایل به حذف می باشید؟",
    doEdit: "آیا مایل به ویرایش می باشید؟",
    addImage: "ثبت تصویر جدید",
    beforeRemain: "مانده از قبل",
    remain: "مانده نهایی",
    gallery: "گالری تصاویر",
    contacts: "مخاطبین",
    addSaleChannelType: "ثبت نوع کانال فروش",
    editSaleChannelType: "ویرایش نوع کانال فروش",
    errorList: "لیست خطاها",
    addNewGrade: "ثبت سطح مشتری",
    editGrade: "ویرایش سطح",
    campaignType: "اطلاعات و تنظیمات انواع کمپین",
    addCampaignType: "ثبت نوع کمپین جدید",
    editCampaignType: "ویرایش اطلاعات نوع کمپین",
    feedBackType: "اطلاعات و تنظیمات انواع نظرسنجی",
    addFeedBackType: "ثبت نوع نظرسنجی جدید",
    editFeedBackType: "ویرایش اطلاعات نوع نظرسنجی",
    addIntroducedType: "ثبت نوع روش آشنایی",
    editIntroducedType: "ویرایش نوع روش آشنایی",
    addCustomerTag: "ثبت برچسب فروش",
    editCustomerTag: "ویرایش برچسب فروش",
    addOccasionType: "ثبت نوع مناسبت",
    editOccasionType: "ویرایش نوع مناسبت",
    addCreditDeadlineReminder: "ثبت یادآور مهلت اعتبار",
    editCreditDeadlineReminder: "ویرایش یادآور مهلت اعتبار",
    deliveryMethod: "اطلاعات و تنظیمات انواع روش‌های تحویل",
    addDeliveryMethod: "ثبت روش تحویل جدید",
    editDeliveryMethod: "ویرایش اطلاعات روش تحویل",
    paymentMethod: "اطلاعات و تنظیمات انواع روش‌های پرداخت",
    addPaymentMethod: "ثبت روش پرداخت جدید",
    editPaymentMethod: "ویرایش اطلاعات روش پرداخت",
    blackList: "اطلاعات و تنظیمات لیست سیاه",
    addBlackList: "ثبت شخص در لیست سیاه",
    editBlackList: "ویرایش اطلاعات لیست سیاه",
    saleManagerDiscountLimit: "اطلاعات و تنظیمات سطح تخفیف مجاز مسئول فروش",
    addSaleManagerDiscountLimit: "ثبت سطح تخفیف مجاز",
    editSaleManagerDiscountLimit: "ویرایش سطح تخفیف مجاز",
    saleManagerCredit: "اطلاعات و تنظیمات اعتبار مسئول فروش",
    addSaleManagerCredit: "ثبت اعتبار مسئول فروش",
    editSaleManagerCredit: "ویرایش اعتبار مسئول فروش",
    saleOrderInfo: "اطلاعات سفارش",
    addSaleOrder: "ثبت سفارش",
    customerCredit: "اعتبار مشتری",
    saleManagerCreditInfo: "اعتبار مسئول فروش",
    openOrders: "سفارشات باز",
    saleManagerRemain: "مانده",
    noCreditLimit: "بدون محدودیت",
    creditFinished: "اعتبار تمام شده است",
    saleOrderReadOnly: "این فرم غیرقابل ویرایش است",
    periodicDiscount: "تخفیف دوره‌ای",
    cancelSaleOrderConfirm: "آیا از انصراف سفارش‌های انتخاب‌شده اطمینان دارید؟",
    undoCancelSaleOrderConfirm:
      "آیا انصراف سفارش‌های انتخاب‌شده برگردانده شود؟",
    orderConfirmed: "تکمیل",
    orderRejected: "رد شده",
    discountCodes: "اطلاعات و تنظیمات کدهای تخفیف",
    addPattern: "کپی از طرح",
    toman: "تومان",
    buy: "خرید",
    congratulationsMessageSetting: "تنظیمات پیام تبریک",
    editCongratulationsMessageSetting: "ویرایش تنظیمات پیام تبریک",
    noImageForCompany: "تصویری برای سازمان ثبت نشده است.",
    companyContacts: "رابط‌های سازمان",
    reportInfo: "اطلاعات چاپ",
    campaign: "اطلاعات و تنظیمات کمپین‌ها",
    chooseProvince: "استان مدنظر را انتخاب کنید",
    chooseCity: "شهر مدنظر را انتخاب کنید",
    chooseCountry: "کشور مدنظر را انتخاب کنید",
    isByZipCode: "براساس منطقه کشوری",
    personClub: "اطلاعات و تنظیمات مشتریان",
    addresses: "آدرس ها",
    editAddress: "ویرایش آدرس",
    autoProcess: "اطلاعات و تنظیمات روندهای خودکار",
    interactivePolicies: "سیاست‌های تعاملی",
    addNewFeedBackQuestion: "ثبت سوال",
    addNewFeedBackAnswer: "ثبت پاسخ",
    discount: "تخفیف",
    textMessage: "پیامک",
    feedback: "نظرسنجی",
    credit: "اعتبار",
    score: "امتیاز",
    active: "فعال",
    deactive: "غیرفعال",
    addNewFeedBack: "ثبت نظرسنجی جدید",
    editSetting: "ویرایش تنظیمات",
    addStatus: "ثبت وضعیت جدید",
    addFeedBackQuestionOption: "ثبت پارامتر اضافی جدید",
    editFeedBackQuestionOption: "ویرایش اطلاعات پارامتر اضافی",
    batch: "اطلاعات و تنظیمات سری ساخت های کالاها",
    addCommodityBatch: "ثبت سری ساخت‌ جدید",
    editCommodityBatch: "ویرایش اطلاعات سری ساخت‌",
    addPersonClub: "ثبت مشتری جدید",
    addQuestionOption: "ثبت گزینه",
    editFeedBackAnswer: "ویرایش پاسخ",
    inventoryBased: "موجودی براساس",
    contradictions: "مغایرت ها",
    contradictionConfirm: "تایید مغایرت",
    enterTag: "شماره تگ را وارد کرده سپس اینتر را بزنید",
    batchNumber: "سری ساخت ها",
    commodityCounting: "شمارش کالاها",
    shoppingIntervalAnd:
      "هم مبلغ خرید و هم تعداد خرید باید در بازه تعریف شده باشند.",
    shoppingIntervalOr:
      "یا مبلغ خرید و یا تعداد خرید باید در بازه تعریف شده باشند.",
    percent: "درصد",
    addVoucherNoteType: "معرفی انواع یادداشت‌های سند",
    editVoucherNoteType: "ویرایش یادداشت‌",
    addDefaultVoucherDescription: "معرفی شرح پیش فرض سند",
    editDefaultVoucherDescription: "ویرایش شرح پیش فرض سند",
    denominator: "مخرج کسر",
    numerator: "صورت کسر",
    headingAccounts: "سرفصل حساب‌ها",
    addNewFinancialRatio: "ثبت نسبت مالی جدید",
    editFinancialRatio: "ویرایش نسبت مالی",
    purchaseHistoryList: "لیست سابقه خرید مشتری",
    answeredList: "لیست پاسخ‌دهندگان",
    voucher: "اطلاعات و تنظیمات اسناد حسابداری",
    addBank: "ثبت بانک",
    editBank: "ویرایش بانک",
    sumPurchaseCount: "جمع خرید",
    lastPurchase: "آخرین خرید",
    distanceLastPurchasePrePurchase: "فاصله آخرین خرید تا خرید قبلی",
    totalPurchases: "تعداد دفعات خرید",
    lastPurchasePrice: "مبلغ آخرین خرید",
    personClubName: "نام مشتری",
    lastPurchaseDate: "تاریخ آخرین خرید",
    sumPurchasePrice: "جمع کل خریدها",
    addScore: "ثبت امتیاز",
    increaseDecreaseScore: "افزایش/ کاهش امتیاز",
    increaseDecreaseCredit: "افزایش/ کاهش اعتبار",
    notificationWithSms: "اطلاع رسانی با پیامک",
    addCredit: "افزایش اعتبار",
    decreaseCredit: "کسر اعتبار",
    cancelCredit: "ابطال اعتبار",
    editbank: "ویرایش اطلاعات بانک",
    addBranch: "ثبت شعبه جدید",
    addBankCashAccountInfo: "ثبت صندوق و حساب بانکی",
    hour: "ساعت",
    dailyLeave: "روزانه",
    hourlyLeave: "ساعتی",
    leaveInfo: "اطلاعات مرخصی",
    cashPaymentType: "نقدی",
    chequePaymentType: "چکی",
    advancePersons: "اطلاعات دریافت کننده ها",
    after: "بعد از",
    currencyType: "اطلاعات و تنظیمات انواع ارز",
    addCurrencyType: "ثبت ارز جدید",
    editCurrencyType: "ویرایش اطلاعات ارز",
    currencyRate: "اطلاعات و تنظیمات نرخ ارز",
    addCurrencyRate: "ثبت نرخ ارز جدید",
    editCurrencyRate: "ویرایش اطلاعات نرخ ارز",
    personCredit: "اطلاعات و تنظیمات اعتبار اشخاص",
    addPersonCredit: "تعیین اعتبار شخص",
    editPersonCredit: "ویرایش اطلاعات اعتبار شخص",
    attachments: "پیوست ها",
    chequeStatus: "اطلاعات و تنظیمات وضعیت چک ها",
    addChequeStatus: "ثبت وضعیت چک جدید",
    editChequeStatus: "ویرایش اطلاعات وضعیت چک",
    addBankAccountInfo: "ثبت حساب بانکی جدید",
    editBankAccountInfo: "ویرایش اطلاعات حساب بانکی",
    editBranch: "ویرایش اطلاعات شعبه",
    addNewCash: "ثبت صندوق جدید",
    editCashInfo: "ویرایش اطلاعات صندوق",
    addNewCheckbook: "ثبت دسته چک جدید",
    editCheckbook: "ویرایش دسته چک",
    addPapers: "ایجاد برگه‌های چک",
    editChequePapers: "ویرایش برگه‌ چک",
    addChequePaper: "ثبت برگه‌ چک",
    detailPaper: "جزئیات برگه چک",
    notes: "یاداشت‌های آرتیکل",
    voucherSort: "مرتب سازی اسناد",
    unConfirmVoucher: "غیرقطعی کردن اسناد",
    receiveCash: "اطلاعات و تنظیمات دریافت نقد",
    paymentCash: "اطلاعات و تنظیمات پرداخت نقد",
    receiveCheque: "اطلاعات و تنظیمات اسناد دریافتنی",
    confirmReceiveCheque: "قطعی کردن اسناد دریافتنی",
    reciver: "دریافت کننده",
    addApiKey: "افزدون کلید جدید",
    changeStatusApiKey: "تغییر وضعیت کلید",
    smsPanelSettings: "تنظیمات پنل پیامکی",
    voucherConfirm: "قطعی کردن اسناد",
    editVoucherTemplate: "ویرایش شابلون سند",
    addOccupationCategory: "افزودن رسته شغلی",
    editOccupationCategory: "ویرایش رسته شغلی",
    addEmploymentType: "افزودن نوع استخدام",
    editEmploymentType: "ویرایش نوع استخدام",
    addStudyFieldType: "افزودن رشته تحصیلی",
    editStudyFieldType: "ویرایش رشته تحصیلی",
    addDegree: "افزودن مدرک تحصیلی",
    editDegree: "ویرایش مدرک تحصیلی",
    addNationalityType: "افزودن نوع تابعیت",
    editNationalityType: "ویرایش نوع تابعیت",
    addBankTransfer: "ثبت واگذاری به بانک",
    addAssignmentPerson: "ثبت واگذاری به شخص",
    chequeList: "لیست چک ها",
    addVoucherMethod: "نحوه صدور سند",
    addSettlement: "ثبت وصول اسناد",
    addReturnTransferred: "ثبت برگشت اسناد واگذار شده",
    addCancellationReceivable: "ثبت ابطال اسناد دریافتنی",
    addReturnReceivables: "ثبت استرداد اسناد دریافتنی",
    addReturnGuarantee: "ثبت استرداد اسناد ضمانتی",
    addReturnAssignment: "ثبت استرداد اسناد واگذاری",
    voucherInfo: "اطلاعات سند",
    addTaxTable: "افزودن جدول مالیاتی",
    editTaxTable: "ویرایش جدول مالیاتی",
    addInsuranceType: "افزودن نوع بیمه",
    editInsuranceType: "ویرایش نوع بیمه",
    addWorkPlaceStatus: "افزودن وضعیت محل خدمت",
    editWorkPlaceStatus: "ویرایش وضعیت محل خدمت",
    addExemptionType: "افزودن نوع معافیت",
    editExemptionType: "ویرایش نوع معافیت",
    voucherArchive: "بایگانی اسناد",
    voucherUnArchiveArchive: "بایگانی/ لغو بایگانی",
    voucherUnArchive: "خروج از حالت بایگانی",
    receiveChequeTurn: "گردش سند دریافتنی",
    debtorOrCreditorDeclaration: "اطلاعات و تنظیمات اعلامیه بدهکار و بستانکار",
    paymentCheque: "اطلاعات و تنظیمات اسناد پرداختنی",
    price: "مبلغ",
    answerDetails: "جزئیات پاسخ",
    answer: "پاسخ",
    total: "مجموع",
    qty: "تعداد",
    answerCount: "تعداد پاسخ داده شده",
    confirmPaymentCheque: "تایید اسناد پرداختنی",
    paymentChequeTurn: "گردش سند پرداختنی",
    addCancelPayableDocs: "ثبت ابطال اسناد پرداختنی",
    addReturnGuaranteeDocs: "ثبت استرداد اسناد ضمانتی",
    packageTypes: "اطلاعات و تنظیمات انواع  بسته بندی",
    addPackageType: "ثبت بسته بندی جدید",
    editPackageType: "ویرایش اطلاعات بسته بندی",
    edit: "ویرایش",
    add: "ثبت",
    turnList: "لیست گردش‌های سند",
    changeVoucherArticles: "تغییر ردیف‌های سند ",
    editProcessType: "ویرایش اطلاعات فرایند تولید",
    addExcelSample: "ثبت نمونه فایل اکسل جدید",
    editExcelSample: "ویرایش اطلاعات نمونه فایل اکسل",
    inactive: "غیر فعال",
    addInsuranceStudio: "افزودن کارگاه بیمه",
    editInsuranceStudio: "ویرایش کارگاه بیمه",
    produceOrder: "اطلاعات و تنظیمات دستور تولید",
    sprint: "اطلاعات و تنظیمات هفته های کاری",
    addSprint: "ثبت هفته کاری جدید",
    editSprint: "ویرایش اطلاعات هفته کاری",
    circulationCheque: "گردش چک",
    vouchersList: "لیست اسناد",
    chequeDetails: "ریز چک‌ها",
    minutes: "دقیقه",
    degree: "درجه",
    addProduceOrder: "ثبت دستور تولید",
    produceOrderReports: "دستور تولیدهای ثبت شده",
    currentCoilStatus: "وضعیت فعلی کویل",
    productionOrderList: "لیست دستورات تولید",
    addContractor: "ثبت پیمانکار جدید",
    editContractor: "ویرایش اطلاعات پیمانکار",
    commodityAttachment: "پیوست‌های کالا",
    addAttachment: "ثبت پیوست",
    addAttach: "افزودن پیوست",
    editAttach: "ویرایش پیوست",
    addInspectionLevel: "ثبت سطح بازرسی",
    editInspectionLevel: "ویرایش سطح بازرسی",
    addProductionGroupSupplier: "ثبت تامین‌کننده گروه تولیدی",
    editProductionGroupSupplier: "ویرایش تامین‌کننده گروه تولیدی",
    addProductionGroup: "ثبت گروه تولیدی",
    editProductionGroup: "ویرایش گروه تولیدی",
    addPurchaseContract: "ثبت قرارداد خرید",
    editPurchaseContract: "ویرایش قرارداد خرید",
    addSaleType: "ثبت نوع فروش",
    editSaleType: "ویرایش نوع فروش",
    addStopStation: "ثبت ایستگاه توقف",
    editStopStation: "ویرایش ایستگاه توقف",
    necessary: "مهم است",
    notNecessary: "مهم نیست",
    addDataSheet: "افزودن دیتا شیت",
    technicalConfirm: "تایید واحد فنی مهندسی",
    planConfirm: "تایید واحد برنامه ریزی",
    mapConfirm: "تایید نقشه",
    productionFeasibility: "امکان سنجی تولید",
    addDeliveryDate: "تعیین زمان تحویل",
    deliveryDateConfirm: "تایید زمان تحویل",
    addNeedPlan: "افزودن نقشه فرآیند",
    addCommodityAdditionalInfo: "افزودن اطلاعات تکمیلی",
    editCommodityAdditionalInfo: "ویرایش اطلاعات تکمیلی",
    orderDataSheets: "دیتاشیت‌های سفارش",
    editDataSheet: "ویرایش دیتاشیت",
    commodityFeature: "ویژگی کالا",
    addFeature: "ثبت ویژگی جدید",
    editFeature: "ویرایش اطلاعات ویژگی",
    bomCost: "هزینه‌های سربار",
    bomMaterial: "مواد اولیه",
    manufacturingOverhead: "هزینه‌های سربار",
    rawMaterials: "مواد اولیه",
    selectCountry: "لطفا کشور را انتخاب کنید",
    selectProvince: "لطفا استان را انتخاب کنید",
    delGroupConfirm: "آیا از حذف این موارد اطمینان دارید؟",
    addCottage: "ثبت کوتاژ",
    editCottage: "ویرایش کوتاژ",
    addDealType: "افزودن نوع معامله",
    taxable: "مشمول مالیت",
    taxExempt: "معاف از مالیات",
    buyerInfo: "اطلاعات خریدار",
    selectBuyer: "ابتدا خریدار را وارد کنید",
    addressAndContactInfo: "نشانی و اطلاعات تماس",
    orderOperation: "عملیات سفارش",
    ladingOperation: "عملیات بارنامه",
    detail: "جزئیات",
    groupPolicy: "سیاست گروهی",
    editSeller: "ویرایش مسئول فروش",
    paymentInfo: "اطلاعات پرداخت",
    floatAccountInfo: "اطلاعات حساب‌های شناور",
    preFactorInfo: "اطلاعات پیش فاکتور",
    floatAccount: "حساب‌های شناور",
    addMinus: "اضافات و کسورات",
    firstSelectCommodity: "ابتدا کالا را انتخاب کنید",
    customerCommodity:
      "برای مشاهده لیست کالاهای خریداری شده، روی مشتری مورد نظر کلیک کنید",
    customerFactorList: "لیست فاکتورهای مشتری",
    saleManagerFactor:
      "برای مشاهده لیست فاکتورها، روی مسئول فروش مورد نظر کلیک کنید",
    saleManagerFactorList: "لیست فاکتورهای مسئول فروش",
    saleManagerDetails:
      "برای مشاهده جزئیات، مسئولین فروش را انتخاب و روی دکمه جستجو کلیک کنید",
    selectSaleManager: "برای مشاهده جزئیات، روی مسئول فروش مورد نظر کلیک کنید",
    aggregate: "تجمیعی",
    single: "تکی",
    addSeller: "ثبت مسئول فروش",
    editAttachment: "ویرایش پیوست کالا",
    addReceiveAndPay: "ثبت موضوع دریافت و پرداخت",
    editReceiveAndPay: "ویرایش موضوع دریافت و پرداخت",
    addIssueTrackingType: "ثبت نوع دریافت و پرداخت",
    editIssueTrackingType: "ویرایش نوع دریافت و پرداخت",
    transportationInfo: "اطلاعات ترابری",
    addBuyType: "ثبت نوع فاکتور خرید جدید",
    editBuyType: "ویرایش اطلاعات نوع فاکتور خرید",
    saleFactorInfo: "اطلاعات فاکتور فروش",
    note: "یادداشت‌های",
    addNote: "افزودن یادداشت",
    editNote: "ویرایش یادداشت",
    reminders: "یادآوری‌ها",
    noColor: "بدون رنگ",
    reminderOnce: "یک‌بار",
    reminderDaily: "روزانه",
    reminderWeekly: "هفتگی",
    reminderEveryNDays: "هر n روز",
    reminderInactive: "غیرفعال",
    reminderNone: "بدون یادآوری",
    weekDayAll: "همه روزها",
    weekDaySaturday: "شنبه",
    weekDaySunday: "یک‌شنبه",
    weekDayMonday: "دوشنبه",
    weekDayTuesday: "سه‌شنبه",
    weekDayWednesday: "چهارشنبه",
    weekDayThursday: "پنج‌شنبه",
    weekDayFriday: "جمعه",
    before: "قبل",
    attendancePresent: "حاضر",
    attendanceAbsent: "غایب",
    returnSaleFactorInfo: "اطلاعات فاکتور مرجوعی",
    buyFactorInfo: "اطلاعات فاکتور خرید",
    confirmReturnFactor: "آیا از مرجوع کردن این فاکتور اطمینان دارید؟",
    editPersonPosition: "ویرایش سمت شخص",
    awardsList: "لیست جوایز",
    saleFactorsList: "لیست فاکتورهای فروش",
    setDefaultCurrecy: "تنظیم ارز عملیاتی",
    commission: "دی نفعان",
    addCommission: "افزودن ذی نفع",
    editCommission: "ویرایش ذی نفع",
    voucherOperation: " عملیات اسناد",
    returnBuyFactorInfo: "اطلاعات فاکتور مرجوعی",
    nextStepCartable: "ارسال به مرحله بعدی",
    backStepCartable: "بازگشت به مرحله قبلی",
    cancelAllRequest: "رد درخواست‌ها",
    sortingDocuments: "مرتب سازی اسناد",
    step: "مرحله",
    closeAccountsHint:
      "مراحل را به ترتیب کامل کنید، مراحل انجام‌شده قابل مرور هستند",
    sortingDocumentsDesc:
      "شماره‌گذاری مجدد اسناد بر اساس تاریخ و حذف اسناد بدون محتوا",
    definitivenessDesc: "قطعی کردن اسناد تا تاریخ انتخاب‌شده",
    closeTemporaryAccountDesc:
      "انتقال مانده حساب‌های درآمد و هزینه به حساب سود و زیان",
    closePermanentAccountDesc: "بستن مانده حساب‌های دائم دوره",
    issuanceOpeningVoucherNextPeriodDesc:
      "انتقال مانده حساب‌های دائم به سال مالی بعد",
    definitiveness: "قطعی سازی",
    cancelConfirmation: "لغو قطعی سازی",
    closeTemporaryAccount: "بستن حساب‌های موقت",
    closePermanentAccount: "بستن حساب‌های دائم",
    closingDocument: "صدور سند اختتامیه",
    receiveDetail: "جزئیات دریافت",
    paymentPaperDetail: "جزئیات اعلامیه پرداخت",
    unitSaleConfirm: "تایید واحد فروش",
    commodityAttachments: "پیوست های",
    editReservationDate: "ویرایش تاریخ رزرو",

    multipleSort:
      "برای مرتب سازی چندتایی کلید Shift را نگه دارید و روی ستون های مدنظر کلیک نمایید.",
    debtFloatAccount: "حساب‌های شناور بدهکار",
    creditFloatAccount: "حساب‌های شناور بستانکار",
    circulationOfAccounts: "گردش حساب ها",
    accountCiculationDetails: "ریز گردش حساب",
    account: "حساب",
    delConfirmPartOne: "آیا از حذف",
    areYouSure: "مطمئن هستید؟",
    deleteVoucherNumberSheet: "آیا از حذف سند برگه شماره",
    accountInfo: "کدینگ حساب",
    isVoucherArchive: " آیا مایل به بایگانی کردن اسناد انتخاب شده هستید؟",
    isVoucherUnArchive:
      "آیا مابل به خروج اسناد مورد نظر از حالت بایگانی هستید؟",
    generalInfo: "اطلاعات کلی",
    debtorInfo: "اطلاعات بدهکار",
    creditorInfo: "اطلاعات بستانکار",
    addDocumentType: "ثبت نوع یادداشت",
    editDocumentType: "ویرایش نوع یادداشت",
    floatAccountGroup: "گروه حساب شناور",
    group: "گروه",
    permissionInfo:
      "در نظر داشته باشید که با فعال‌کردن هر محدودیت، امکانات و اطلاعاتی که کاربر هنگام ثبت، مشاهده یا ویرایش داده‌ها در اختیار دارد، مطابق با همین تنظیمات کنترل می‌شود.",
    submitAccount: "درج حساب",
    submitDepartment: "درج دپارتمان",
    resetPassword: "بازیابی رمز عبور",
    submitConfirmCount: "ثبت مقدار تایید/رد",
    submitConfirmCountDescription:
      "سطرهای موردنظر را انتخاب نمایید و مقدار تایید را در قسمت « ثبت مقدار تایید » وارد و از دکمه عملیات تایید/عدم‌تایید را کلیک نمایید.",
    commodityStatusLogs: "تاریخچه وضعیت‌ ها",
    archiveVouchers: "بایگانی اسناد",
    issuanceOpeningVoucherNextPeriod: "صدور سند افتتاحیه دوره‌ی بعد ",
    selectedRows: "سطرهای انتخاب‌شده",
    clickHereForAdvancedSearch: "برای جستجوی پیشرفته اینجا کلیک کنید",
    balanceAtTheEndOfThePeriod: "مانده انتهای دوره",
    operationTurnDuringPeriod: "گردش عملیات طی دوره",
    balanceBeginningPeriod: "مانده ابتدای دوره",
    totalReceiveDuringPeriod: "جمع دریافت طی دوره",
    totalPaymentDuringPeriod: "جمع پرداخت طی دوره",
    exportFile: "خروجی فایل",
    rial: "ریال",
    noNotesRecorded: "هیچ یادداشتی ثبت نشده است.",
    totalDebt: "جمع بدهکار",
    totalCredit: "جمع بستانکار",
    remaining: "مانده",
    dragDesiredColumnToThisAreaToGroup:
      "برای گروه بندی ستون مدنظر را به این قسمت بکشید",
    searchByVoucherNumber: "جستجو بر اساس شماره اسناد",
    searchByVoucherDate: "جستجو بر اساس تاریخ اسناد",
    anotherCase: "مورد دیگر...",
    aggregationByAccount: "تجمیعی براساس حساب",
    aggregationBy: "تجمیعی براساس",
    eightColumnLevel: " تراز هشت ستونی سطح",
    showLevel: "نمایش سطح",
    relatedTo: "مربوط به",
    accountRelatedTo: "حساب مربوط به",
    notesRelatedTo: "یادداشت‌های مربوط به",
    filterBasedOn: "فیلتر بر اساس",
    sixColumnLevel: " تراز شش ستونی سطح",
    fourColumnLevel: " تراز چهار ستونی سطح",
    noCountry: "کشوری ثبت نشده است",
    incomes: "درآمدها",
    costs: "هزینه ها",
    assets: "دارایی ها",
    fundAndDebts: "بدهی ها و سرمایه ها",
    autoBalance: "تراز اتوماتیک",
    addBetweenRow: "افزودن ردیف در بین ردیف‌های موجود",
    debtor: "بدهکار",
    creditor: "بستانکار",
    remainder: "باقی‌مانده",
    remainChart: "مانده",
    asset: "دارایی",
    equity: "حقوق مالکانه",
    liability: "بدهی",
    expense: "هزینه",
    revenue: "درآمد",
    bankAccountInfo: "اطلاعات حساب بانکی",
    selectBank: "ابتدا بانک را انتخاب کنید",
    notFoundBranch: "شعبه‌ای برای این بانک تعریف نشده است",
    noData: "هیچ داده‌ای وجود ندارد",
    receiptReceivedDetail: "جزئیات رسید دریافت",
    nocashierDefined: "برای این صندوق، صندوق‌داری تعرف نشده است",
    descriptionForCheque: "توضیحات چک",
    firstSelectCash: "ابتدا صندوق را انتخاب نمایید",
    explainedInAppendices: "به شرح ضمائم",
    accountTrend: "روند گردش حساب",
    noAccountSelected: "هنوز سرفصلی انتخاب نشده است",
    pacntDashboardHelp:
      "جهت مشاهده جزئیات به صورت نمودار خطی، پس از تعیین بازه زمانی، روی سرفصل حساب موردنظر در نمودارهای دایره‌ای کلیک نمایید.",
    itemNoVoucher:
      "این مورد دارای سند حسابداری است و امکان حذف آن وجود ندارد.\nلطفا ابتدا سند حسابداری مربوطه را حذف کرده و سپس مجددا تلاش کنید",
    page: "صفحه",
    num: "عدد",
    all: "همه",
    returnPreviousCartable: "بازگشت به کارتابل قبل",
    addCommodityGroupConfig: "ثبت تنظیمات گروه کالا جدید",
    editCommodityGroupConfig: "ویرایش اطلاعات تنظیمات گروه کالا",
    addGoalUser: "ثبت کاربر هدف جدید",
    editGoalUser: "ویرایش اطلاعات کاربر هدف",
    addGoalSchedule: "ثبت زمان‌بندی هدف جدید",
    editGoalSchedule: "ویرایش اطلاعات زمان‌بندی هدف",
    inReview: "در حال بررسی",
    approved: "تایید شده",
    rejected: "رد شده",
    allFactors: "همه فاکتورها",
    cancelledInvoices: "فاکتورهای باطل شده",
    cancel: "ابطال",
    cancelCancellation: "لغو ابطال",
    cancelApproved: "لغو تایید",
    addPercentageSellingPrice: "اضافه کردن درصد به قیمت سیاست مبنا",
    addPriceTypeSellingPrice: "اضافه کردن مبلغ به قیمت سیاست مبنا",
    addPercentageCurrentPrice: "اضافه کردن درصد به قیمت فعلی",
    addPiceCurrentPrice: "اضافه کردن مبلغ به قیمت فعلی",
    paymentDate: "تاریخ پرداخت",
    issueDate: "تاریخ سررسید",
    turnDate: "تاریخ گردش",
    receiveDate: "تاریخ دریافت",
    yesHas: "بله / دارد",
    noHaveNot: "خیر / ندارد",
    caseOne: "مورد یک",
    caseTwo: "مورد دو",
    caseThree: "مورد سه",
    bankBalances: "موجودی بانک‌ها",
    receiveCheques: "اسناد دریافتنی",
    paymentCheques: "اسناد پرداختنی",
    liquidity: "نقدینگی",
    cashFlowFunds: "جریان وجوه نقد",
    documentsCommitments: "اسناد و تعهدات",
    today: "امروز",
    untilToday: "تا امروز",
    workCalendarSubtitle: "نمای تقویمی فعالیت‌ها، جلسات و تماس‌ها",
    calendarTaskItem: "فعالیت / وظیفه",
    calendarTaskChip: "فعالیت",
    calendarMeetingItem: "جلسه",
    calendarCallItem: "تماس",
    currentMonth: "ماه جاری",
    chartTheLastDays: "نمودار 30 روز گذشته",
    noItemSelected: "هنوز موردی انتخاب نشده است",
    pbankDashboardHelp:
      "برای مشاهده روند 30 روز گذشته، روی بخش موردنظر در نمودارهای دایره‌ای کلیک نمایید.",
    lastDefinitiveness: "آخرین قطعی سازی",
    withBaseInformation: "همراه با اطلاعات پایه از سال مالی دیگر",
    withoutBaseInformation: "بدون اطلاعات پایه از سال های مالی دیگر",
    log: "تاریخچه",
    addHardness: "ثبت سختی جدید",
    editHardness: "ویرایش اطلاعات سختی",
    addProductSurface: "ثبت سطح محصول جدید",
    editProductSurface: "ویرایش اطلاعات سطح محصول",
    addUsageGroup: "ثبت گروه کاربردی جدید",
    editUsageGroup: "ویرایش اطلاعات گروه کاربردی",
    addFoilUsage: "ثبت کاربرد فویل جدید",
    editFoilUsage: "ویرایش اطلاعات کاربرد فویل",
    addInnerCoreDiameter: "ثبت قطر داخلی کور جدید",
    editInnerCoreDiameter: "ویرایش اطلاعات قطر داخلی کور",
    addCastingProduceOrder: "ثبت دستور تولید ریخته‌گری",
    completeOrderConfirm: "آیا از تکمیل سفارش‌های انتخاب شده مطمئن هستید؟",
    notCompleteOrderConfirm:
      "آیا از عدم تکمیل سفارش‌های انتخاب شده مطمئن هستید؟",
    control: "کنترل",
    notControl: "عدم کنترل",
    addLeadProperty: "ثبت ویژگی سرنخ (لید)",
    editLeadProperty: "ویرایش ویژگی سرنخ (لید)",
    addLeadType: "ثبت نوع سرنخ (لید)",
    editLeadType: "ویرایش نوع سرنخ (لید)",
    addLeadSource: "ثبت منبع سرنخ (لید)",
    editLeadSource: "ویرایش منبع سرنخ (لید)",
    addLeadEvaluationQuestion: "ثبت سوال ارزیابی سرنخ",
    editLeadEvaluationQuestion: "ویرایش سوال ارزیابی سرنخ",
    addSaleTeam: "ثبت تیم فروش",
    editSaleTeam: "ویرایش تیم فروش",
    teamMemberUnit: "عضو",
    addSaleRegion: "ثبت منطقه فروش",
    editSaleRegion: "ویرایش منطقه فروش",
    requiredAnswer: "الزامی",
    optionalAnswer: "اختیاری",
    requiredAnswerHint: "بدون پاسخ به این سوال، ارزیابی سرنخ ثبت نمی‌شود",
    optionalAnswerHint: "کارشناس می‌تواند این سوال را بی‌پاسخ بگذارد",
    addChance: "ثبت فرصت",
    editChance: "ویرایش فرصت",
    addChancePriority: "ثبت اولویت فرصت",
    editChancePriority: "ویرایش اولویت فرصت",
    addFailedSaleReason: "ثبت دلیل فروش ناموفق",
    editFailedSaleReason: "ویرایش دلیل فروش ناموفق",
    addCompetitor: "ثبت رقیب",
    editCompetitor: "ویرایش رقیب",
    addStrengthWeakness: "ثبت نقاط ضعف و قوت",
    editStrengthWeakness: "ویرایش نقاط ضعف و قوت",
    addColdRollingProduceOrder: "ثبت دستور تولید نورد سرد",
    addFoilRollingProduceOrder: "ثبت دستور تولید نورد فویل",
    cutWeightPercentages: "درصد وزن به کات نورد سرد",
    coldRolling: "نورد سرد",
    foilRolling: "نورد فویل",
    packaging: "بسته‌بندی",
    addFurnace: "ثبت کوره جدید",
    editFurnace: "ویرایش اطلاعات کوره",
    furnacePlacement: "جانمایی‌های کوره",
    editFurnacePlacement: "ویرایش اطلاعات جانمایی کوره",
    furnaceEmpty: "ابتدا کوره را انتخاب کنید",
    addProjectType: "ثبت نوع پروژه جدید",
    editProjectType: "ویرایش اطلاعات نوع پروژه",
    addWorkDescription: "ثبت شرح کار جدید",
    editWorkDescription: "ویرایش اطلاعات شرح کار",
    addProjectTeam: "ثبت تیم پروژه جدید",
    editProjectTeam: "ویرایش اطلاعات تیم پروژه",
    addGeneralEstimate: "ثبت برآورد عمومی جدید",
    editGeneralEstimate: "ویرایش اطلاعات برآورد عمومی",
    projectInfo: "اطلاعات پروژه",
    aggregateVoucherDetail: "تجمیع سرفصل‌ها",
    aggregateByDebtAndCreditRemain: "تجمیع براساس مانده بدهکار و بستانکار",
    aggregateRefreshConfirm:
      "با تغییر وضعیت تجمیع، لیست سرفصل‌ها دوباره از سرور خوانده می‌شود و ویرایش‌های دستی شما از بین می‌رود. آیا مایل به ادامه فرآیند می‌باشید؟",
    missingAccountRows: "برای ردیف‌های بدون حساب، حساب را انتخاب کنید.",
    eachSheetIsDocument: "هر برگه یک سند",
    eachDateIsDocument: "هر تاریخ یک سند",
    documentDateSameSheetDate: "تاریخ سند برابر با تاریخ برگه",
    teamInfo: "اطلاعات تیم",
    taskInfo: "اطلاعات وظیفه",
    communications: "ارتباطات",
    showMore: "نمایش بیشتر",
    taskTeam: "تیم فعالیت",
    executionTime: "زمان اجرا",
    executionAutomatic: "سیستمی",
    executionManual: "دستی",
    executionLoggedTotal: "زمان ثبت‌شده",
    executionLoggedAutomatic: "ثبت سیستمی",
    executionLoggedManual: "ثبت دستی",
    executionManualAdd: "ثبت دستی زمان",
    addTeam: "افزودن مدعو تیم",
    editTeam: "ویرایش مدعو تیم",
    addTaskCategory: "ثبت دسته بندی جدید",
    editTaskCategory: "ویرایش دسته بندی",
    addNoteCategory: "ثبت دسته بندی جدید",
    editNoteCategory: "ویرایش دسته بندی",
    addNoteSubject: "ثبت موضوع یادداشت جدید",
    addRequestType: "ثبت نوع درخواست جدید",
    editRequestType: "ویرایش نوع درخواست",
    editNoteSubject: "ویرایش موضوع یادداشت",
    addCallSubject: "ثبت موضوع تماس جدید",
    editCallSubject: "ویرایش موضوع تماس",
    addCallCategory: "ثبت دسته بندی تماس جدید",
    editCallCategory: "ویرایش دسته بندی تماس",
    addServiceSupportSubject: "ثبت موضوع پشتیبانی جدید",
    editServiceSupportSubject: "ویرایش موضوع پشتیبانی",
    addLeadAddress: "ثبت آدرس سرنخ (لید)",
    editLeadAddress: "ویرایش آدرس سرنخ (لید)",
    addLeadContact: "ثبت مخاطبین سرنخ (لید)",
    editLeadContact: "ویرایش مخاطبین سرنخ (لید)",
    addMeeting: "ثبت صورت‌جلسه",
    editMeeting: "ویرایش صورت‌جلسه",
    addMeetingGuest: "ثبت مدعو جلسه",
    editMeetingGuest: "ویرایش مدعو جلسه",
    addMeetingApproval: "ثبت مصوبه جلسه",
    editMeetingApproval: "ویرایش مصوبه جلسه",
    projectTeamInfo: "اطلاعات تیم پروژه",
    taxTableNonValid:
      "جدول مالیاتی نامعتبر وجود دارد (جهت مشاهده جزئیات کلیک نمایید)",
    error: "خطا",
    warning: "هشدار",
    importExcelPreview: "پیش‌نمایش ورود اطلاعات از اکسل",
    importExcelInsertCount: "درج جدید",
    importExcelUpdateCount: "بروزرسانی",
    importExcelIgnoreCount: "رد شده",
    importExcelActionInsert: "درج جدید",
    importExcelActionUpdate: "بروزرسانی",
    importExcelActionIgnore: "رد شده",
    importExcelPreviewHint:
      "ردیف‌های سبز درج می‌شوند، ردیف‌های نارنجی بروزرسانی می‌شوند و ردیف‌های قرمز به دلیل خطا رد می‌شوند.",
    importExcelPreviewConfirm:
      "همه‌ی ردیف‌ها به صورت درج جدید نیستند، برخی ردیف‌ها بروزرسانی یا رد می‌شوند. </br> آیا از ادامه‌ی عملیات اطمینان دارید؟",
    importExcelPreviewNoRow: "هیچ ردیفی در فایل اکسل یافت نشد.",
    importExcelPreviewNothingToApply:
      "هیچ ردیف قابل درج یا بروزرسانی وجود ندارد، ابتدا خطاهای فایل اکسل را برطرف نمایید.",
    confirmDeleteSelectedSheetDocument:
      "آیا از حذف سندِ برگه های انتخاب شده اطمینان دارید؟",
    benefitsAndDeduction: "مزایا و کسورات",
    sortConfirm: "آیا از مرتب سازی مطمئن هستید؟",
    addWorkingHour: "ثبت ساعت استاندارد کارکرد",
    editWorkingHour: "ویرایش ساعت استاندارد کارکرد",
    managementCartable: "مدیریت کارتابل",
    turnCartable: "کارتابل گردش اسناد",
    completeRequiredFieldsUploadExcelFile:
      "پس از تکمیل فایل اکسل، فیلدهای زیر را تکمیل کرده و فایل را بارگذاری نمایید.",
    enterExactNameTheSheetToImported:
      "توجه داشته باشید که نام شیت باید دقیقاً مطابق با نام شیتی باشد که قصد بارگذاری اطلاعات آن را دارید.",
    saveRecordBeforeExcel:
      "برای دانلود فایل اکسل با اطلاعات، ابتدا باید سند ثبت شده باشد.",
    checkList: "چک لیست",
    meetingSpecification: "مشخصات جلسه",
    relations: "ارتباطات",
    specifications: "مشخصات",
    messageTab: "پیام",
    reminder: "یادآوری",
    meetingGuests: "مدعوین",
    meetingApprovals: "مصوبات",
    projectSpecification: "مشخصات پروژه",
    location: "موقعیت",
    financial: "مالی",
    projectTeamTab: "تیم پروژه",
    effectiveFactors: "عوامل مؤثر",
    estimate: "برآورد",
    files: "فایل‌ها",
    filesUploadAfterSave: "فایل‌ها پس از ذخیره‌ی پروژه بارگذاری می‌شوند.",
    checkListAction: "در پایان با زدن کلید Enter چک لیست را ثبت کنید ...",
    addMinusConfirm:
      "در صورت تایید اضافات و کسورات درج شده حذف خواهند شد، </br> آیا مایل به ادامه‌ی درج اطلاعات می باشید؟",
    taxInformation: "اطلاعات مالیاتی",
    amountCalculation: "محاسبه مبلغ",
    itemFeatures: "ویژگی‌ها",
    insuranceAndTax: "بیمه و مالیات",
    insuranceSection: "بیمه",
    taxSection: "مالیات",
    accountParties: "طرف‌های حساب",
    templateSelect: "انتخاب شابلون",
    descriptionPreview: "پیش‌نمایش شرح سند",
    templateParts: "اجزای شرح",
    emptyTemplateParts:
      "هنوز جزئی برای این شابلون تعریف نشده؛ اولین فیلد را اضافه کنید.",
    selectTemplateFirst:
      "برای مشاهده و ویرایش اجزای شرح، یک شابلون انتخاب کنید.",
    templateField: "فیلد شرح",
    dragPartToReorder: "برای تغییر ترتیب، ردیف را بکشید و رها کنید",
    allFieldsUsed: "همهٔ فیلدها در این شابلون استفاده شده‌اند",
    savingOrder: "در حال ذخیرهٔ ترتیب...",
    taxTableTypeHint: "در حالت پلکانی، نوع نرخ مالیات قابل انتخاب نیست.",
    commodityList: "لیست کالاها",
    factorList: "لیست فاکتورها",
    addAgreementRow: "ثبت ردیف پیمان",
    editAgreementRow: "ویرایش ردیف پیمان",
    addDetail: "ثبت جزئیات",
    editDetail: "ویرایش جزئیات",
    excelSampleConfirm:
      "در صورت تایید موارد درج شده حذف خواهند شد، </br> آیا مایل به ادامه‌ی بارگذاری اطلاعات می باشید؟",
    addJobGroup: "ثبت گروه شغلی",
    editJobGroup: "ویرایش گروه شغلی",
    addDepartment: "افزودن دپارتمان",
    editDepartment: "ویرایش دپارتمان",
    addContractType: "افزودن نوع حکم کارگزینی",
    editContractType: "ویرایش نوع حکم کارگزینی",
    payerInfo: "اطلاعات پرداخت کننده",
    receiverInfo: "اطلاعات دریافت کننده",
    transferPaperInfo: "اطلاعات برگه انتقال",
    paymentPaperInfo: "اطلاعات پرداخت کننده",
    receivePaperInfo: "اطلاعات دریافت کننده",
    branchAndFiscalYearSelection: "انتخاب شعبه و سال مالی",
    controlledValues: "مقادیر کنترل شده",
    married: "متاهل",
    celibate: "مجرد",
    employmentInfo: "اطلاعات استخدامی",
    studyInfo: "اطلاعات تحصیلی",
    taxInsuranceInfo: "اطلاعات بیمه/مالیاتی",
    checksInReceivedOrReturnedStatus: "چک‌های دریافت‌شده و برگشتی",
    bankTransferredAndReceivedChecks: "چک‌های دریافت‌شده یا واگذارشده به بانک",
    ChecksWithLatestStatusOfBankPersonTransfer:
      "چک‌های واگذارشده به بانک یا شخص",
    receivedAndReturnedOrReclaimedChecks:
      "چک‌هایی در وضعیت دریافت، برگشت یا استرداد",
    checksWithReceivedOrReturnedStatus: "چک‌های دریافتی یا برگشتی",
    guaranteeDocumentReceiptChecks: "چک‌های دریافت اسناد ضمانتی",
    receivedChecksAndReturnedReceivablesChecks:
      "دریافت چک و برگشت اسناد دریافتنی",
    showDetails: "مشاهده جزئیات",
    contractDetails: "مزایا و کسورات",
    salaryAndBenefitsCalculationParameters: "پارامترهای محاسبات حقوق و مزایا",
    addContractDetail: "افزودن مزایا و کسورات",
    editContractDetail: "ویرایش مزایا و کسورات",
    closeTemporaryAccountsDeleteConfirm:
      "از حذف بستن حساب‌های موقت مطمئن هستید؟",
    closePermanentAccountDeleteConfirm:
      "از حذف بستن حساب‌های دائم مطمئن هستید؟",
    noCheque: "شماره چک واردشده یافت نشد.",
    doubleClickRowToSelectCheque:
      "برای انتخاب چک، روی سطر موردنظر دوبار کلیک کنید.",
    foundChequesForChequeNumber: " چکهای یافت شده برای شماره چک",
    addContract: "صدور حکم کارگزینی",
    personnelGroupEdit: "تغییر گروهی پرسنل",
    calculationBasedOn: "محاسبه براساس",
    withoutCounting: "بدون احتساب",
    addServiceCenter: "افزودن مرکز خدمت",
    editServiceCenter: "ویرایش مرکز خدمت",
    aggregatioBasedOnSelectedBanks: "تجمیع براساس بانک‌های انتخاب شده ",
    errorAndWarningList: "لیست خطاها/ هشدارها",
    addFormula: "افزودن فرمول",
    deleteWithChildConfirm:
      "درصورت حذف این مورد تمام زیرگروه‌های آن نیز حذف می‌شوند",
    editSalary: "ویرایش فیش حقوق",
    editSalaryList: "بروزرسانی لیست حقوق",
    editSalaryList2: "بروزرسانی حقوق با حکم",
    payslip: "فیش حقوق",
    psMonthlyWage: "جمع دستمزد ماهانه",
    psInsuranceMonthlyWage: "جمع دستمزد ماهانه بیمه",
    psInsuranceEmployerShare: "سهم بیمه کارفرما",
    psUnemploymentInsurance: "سهم بیمه بیکاری",
    psInsurance: "بیمه",
    psTotalPayable: "جمع قابل پرداخت",
    workedColumn: "کارکرد",
    workedDeductions: "کسر از کارکرد",
    workedBenefits: "مزایای کارکرد",
    calculated: "محاسبه‌شده",
    functions: "کارکردها",
    addSuite: "ثبت واحد جدید",
    editSuite: "ویرایش واحد",
    addParticipation: "ثبت مشارکت جدید",
    editParticipation: "ویرایش مشارکت",
    addAnnouncement: "ثبت اعلام جدید",
    editAnnouncement: "ویرایش اعلام",
    addEstimate: "ثبت برآورد جدید",
    editEstimate: "ویرایش برآورد",
    addRank: "ثبت رتبه‌بندی جدید",
    editRank: "ویرایش رتبه‌بندی",
    syncConfirm:
      "در صورت تایید برای حکم‌های فاقد فیش حقوقی، فیش حقوقی محاسبه و ثبت خواهدشد. </br> آیا مایل به ادامه فرآیند می‌باشید؟",
    contractList: "لیست قراردادها",
    editTaxRateType: "ویرایش اطلاعات نوع نرخ مالیاتی",
    contractsList: "لیست احکام صادر شده",
    editDetails: "جزئیات ویرایش",
    costsList: "لیست هزینه‌ها",
    addTransfer: "ثبت انتقال جدید",
    editTransfer: "ویرایش انتقال",
    workCalendar: "تقویم کاری",
    benefitsAndDeductionsForAdd: "موارد انتخابی برای افزودن به لیست",
    benefitsAndDeductionsForDelete: "موارد انتخابی برای حذف از لیست",
    addCrimesReward: "ثبت پاداش و جرائم",
    editCrimesReward: "ویرایش پاداش و جرائم",
    delCustomerAlert:
      "با حذف این مشتری اعتبار، امتیاز و کدهای تخفیف آن حذف می‌شوند.",
    workingHourOffDays: "لطفا فقط روزهای تعطیل این ماه را انتخاب نمایید.",
    addEstimationSubject: "ثبت موضوع برآورد جدید",
    editEstimationSubject: "ویرایش موضوع برآورد",
    breakdownOfBenefitsAndDeductions: "ریز مزایا و کسورات",
    projectRelatedParticipation: "مشارکت مربوط به پروژه",
    editCost: "ویرایش هزینه",
    setVoucherIssueType: "تعیین نحوه صدور سند",
    confirmDeletePayroll: "آیا از حذف سند حقوق ماه",
    chooseBranch: "شعبه مورد نظر را انتخاب نمایید",
    chooseMonth: "ماه مورد نظر را انتخاب نمایید",
    consolidatedSalaryWorkshopReport: "گزارش تجمیعی حقوق/کارگاه",
    notFoundSuite: "واحدی برای این پروژه وجود ندارد",
    notFoundParticipation: "هیچ مشارکتی برای این واحد وجود ندارد",
    confirmDeletePayrollPayment1:
      "در صورت تایید برگه پرداخت نقد/چک مربوط به سطرهای انتخابی حقوق",
    confirmDeletePayrollPayment2:
      "ماه و همچنین سند حسابداری مربوط حذف خواهد شد، آیا مایل به حذف سند مربوط به حقوق و مزایای این ماه هستید؟",
    addCrimesRewardSubject: "ثبت موضوع پاداش و جرائم",
    editCrimesRewardSubject: "ویرایش موضوع پاداش و جرائم",
    confirmPayrollEmployee: "آیا از قطعی کردن موارد انتخابی مطمئن هستید؟",
    disconfirmPayrollEmployee: "آیا از غیرقطعی کردن موارد انتخابی مطمئن هستید؟",
    confirmLeave: "آیا از تأیید مرخصی‌های انتخابی مطمئن هستید؟",
    disconfirmLeave: "آیا از عدم تایید مرخصی‌های انتخابی مطمئن هستید؟",
    confirmDeletePayrollDirectVoucher:
      "آیا مایل به حذف سند حسابداری به همراه برگه دریافت یا پرداخت نقد آن می‌باشید؟",
    sendSms: "ارسال پیامک",
    smsHistory: "تاریخچه پیامک",
    sendSmsConfirmPartOne: "شما در حال ارسال پیامک با قالب پیامک",
    sendSmsConfirmPartTwo: "هستید، آیا مایل به ادامه هستید؟",
    sendSmsConfirm: "آیا از ارسال پیامک برای موارد انتخابی مطمئن هستید؟",
    addBlock: "ثبت بلوک جدید",
    editBlock: "ویرایش بلوک",
    performance: "عملکرد",
    choosePersonsforInsurance: "انتخاب اشخاص برای بیمه",
    choosePersonsforTax: "انتخاب اشخاص برای مالیات",
    wageHistory: "خلاصه صورت دستمزد",
    copy: "کپی",
    insuranceEmployeeCopy:
      "تنها افرادی که در ماه و شعبه انتخابی وجود نداشته باشند، کپی خواهند شد.",
    insuranceFileInfo: "اطلاعات فایل بیمه",
    addConfirmPayrollEmployee:
      "اطلاعاتی برای این ماه ثبت نشده است،  آیا مایل به درج اطلاعات جدید می باشید؟",
    advancePerson: "‌دریافت کننده‌های مساعده",
    addSettingMessage: "ثبت تنظیمات پیامک",
    addRelationField: "ثبت رابطه جدید پایگاه داده",
    editRelationField: "ویرایش رابطه پایگاه داده",
    discoverRelation: "کشف خودکار روابط پایگاه داده",
    initializeRelationConfirm:
      "تمام روابط به صورت خودکار ثبت می‌شوند، آیا مطمئن هستید؟",
    editDeleteBehavior: "ویرایش رفتار حذف رابطه",
    voucherTemplateFilters: "فیلتر شابلون‌ها",
    addVoucherTemplate: "ثبت شابلون سند جدید",
    voucherTemplateEntity: "شابلون سند",
    selectSubSystemAndVoucherType:
      "برای مشاهده لیست، زیرسیستم و نوع سند را انتخاب کنید",
    firstSelectSubSystem: "ابتدا زیرسیستم را انتخاب کنید",
    firstSelectVoucherType: "ابتدا نوع سند را انتخاب کنید",
    currencyMonitoringAccounts: "حساب ها",
    currencyMonitoringArticles: "آرتیکل های حساب",
    currencyMonitoringNotProcessed:
      "هنوز پردازشی انجام نشده است، ابتدا دکمه پردازش را بزنید",
    currencyMonitoringNotProcessedTrialBalance:
      "هنوز پردازشی برای پایش ارزی حساب ها انجام نشده است، ابتدا در فرم «پایش ارزی حساب ها» دکمه پردازش را بزنید",
    currencyMonitoringGoToProcessForm: "فرم پایش ارزی حساب ها",
    currencyMonitoringOf: "از",
    currencyMonitoringRowsWithoutRate: "سطر بدون نرخ ارز",
    currencyMonitoringRateNotOfVoucherDate:
      "در تاریخ سند نرخی ثبت نشده؛ نرخ تاریخ {date} مبنا قرار گرفته است",
    currencyMonitoringNoRate:
      "برای تاریخ این سند و قبل از آن، نرخی برای این ارز ثبت نشده است",
    currencyMonitoringProcessedRange: "بازه پردازش شده",
    currencyMonitoringOpeningFromProcessStart:
      "مانده اول دوره از ابتدای بازه پردازش‌شده ({date}) محاسبه شده است و شامل مانده سال‌های قبل نیست.",
    currencyMonitoringRangeOutOfProcess:
      "بازه انتخابی باید داخل بازه پردازش شده پایش ارزی حساب ها باشد",
    currencyMonitoringInvalidFromDate: "از تاریخ نامعتبر است",
    currencyMonitoringCurrencyTypeRequired: "نوع ارز نامعتبر است",
    currencyTrialBalance: "تراز آزمایشی ارزی",
    currencyMonitoringPrintSelectedAccount:
      "چاپ فقط برای حساب انتخاب‌شده انجام می‌شود",
    lastLevel: "آخرین سطح",
    showPayrollEmployee: "مشاهده لیست حقوق",
    backupImport: "بازیابی آرشیو بکاپ روی یک شرکت/شعبه",
    backupExport: "گرفتن اسکریپت داده به تفکیک شرکت",
    backupArchiveHint:
      "فایل sql (اسکریپت یک شرکت) یا آرشیو zip/rar/7z (بکاپ bak یا چند فایل sql)؛ حجم فایل می‌تواند چند گیگابایت باشد.",
    backupZipTargetHint:
      "اگر zip چند شرکت دارد و شرکت/شعبه‌ی مقصد انتخاب شود، داده‌ی همه‌ی آن شرکت‌ها روی همان مقصد می‌رود؛ برای یک شرکت مشخص فقط فایل sql همان شرکت را آپلود کنید.",
    backupSourceHint:
      "اگر آرشیو چند شرکت/شعبه داشته باشد باید مبدأ را مشخص کنید؛ در غیر این صورت خالی بگذارید تا خودکار تشخیص داده شود.",
    backupDryRunHint:
      "توصیه می‌شود ابتدا با اجرای آزمایشی اجرا کنید، گزارش را ببینید و سپس اجرای واقعی بزنید.",
    backupDryRunDone:
      "این یک اجرای آزمایشی بود؛ هیچ داده‌ای ذخیره نشد. برای ثبت واقعی، دکمه‌ی «اجرای واقعی» را بزنید.",
    backupExportHint:
      "ساخت اسکریپت برای یک سال مالی چند ده ثانیه و برای همه‌ی شرکت‌ها ممکن است چند دقیقه طول بکشد؛ لطفاً تا پایان دانلود صفحه را نبندید.",
    backupScriptFilterHint:
      "هیچ موردی انتخاب نشود = همه‌ی شرکت‌ها. برای هر شرکت یک فایل جدا ساخته می‌شود.",
    backupFiscalYearIdsHint:
      "شناسه‌ی سال مالی را تایپ کنید و Enter بزنید؛ لیست سال‌های مالی در پنل پارسینا در دسترس نیست.",
    backupScriptError: "خطا در گرفتن اسکریپت",
    backupUploading: "در حال آپلود آرشیو",
    backupPending: "در انتظار شروع ...",
    backupRunning: "در حال اجرا ...",
    backupSucceeded: "بازیابی با موفقیت انجام شد",
    backupFailed: "بازیابی با خطا متوقف شد",
    backupPollingHint:
      "عملیات در پس‌زمینه اجرا می‌شود؛ می‌توانید این صفحه را باز نگه دارید تا وضعیت به‌روز شود.",
    backupLog: "لاگ اجرا",
    backupModules: "ماژول‌ها",
    backupFiscalYearMaps: "نگاشت سال مالی",
    backupTables: "جدول‌ها",
    backupWarnings: "هشدارها",
    backupNoLog: "هنوز لاگی ثبت نشده است",
    backupWillBeCreated: "ساخته می‌شود",
    winBackupImport: "انتقال بکاپ نرم‌افزار ویندوزی پارسینا به میتا",
    winBackupArchiveHint:
      "آرشیو rar/zip/7z شامل فایل‌های .bak (PBASE / PACNT / PSALE / PWHRS / PBANK)؛ حداکثر ۴ گیگابایت.",
    winBackupModeAllHint:
      "همه‌ی شعبه‌های داخل آرشیو منتقل می‌شوند و برای هر کدام شعبه‌ی جدید در شرکت مقصد ساخته می‌شود.",
    winBackupModeSelectHint:
      "شعبه‌ی مبدأ همان عدد بعد از پیشوند نام فایل است (مثلاً 4 در PSALE_4_1405_backup_…). اگر شعبه‌ی مقصد خالی باشد، شعبه‌ی جدید در شرکت مقصد ساخته می‌شود.",
    winBackupNewBranch: "ساخت شعبه‌ی جدید",
    winBackupBranchById: "شعبه {id}",
    winBackupNoRows: "هنوز شعبه‌ای اضافه نشده است.",
    winBackupDryRunHint:
      "در اجرای آزمایشی داده‌ها ذخیره نمی‌شوند؛ ولی شعبه‌ای که خودکار ساخته شود باقی می‌ماند و در اجرای واقعی دوباره استفاده می‌شود.",
    winBackupPrefilled:
      "شعبه‌های مقصد از نتیجه‌ی اجرای قبلی پر شدند؛ می‌توانید آن‌ها را تغییر دهید یا خالی کنید (خالی = ساخت شعبه‌ی جدید).",
    winBackupReselectArchive:
      "فایل آرشیو بعد از هر اجرا روی سرور پاک می‌شود؛ برای اجرای بعدی آرشیو دوباره آپلود می‌شود.",
    winBackupBusyHint:
      "تا پایان یا لغو ایمپورت جاری، شروع ایمپورت جدید غیرفعال است.",
    winBackupUploading: "در حال آپلود آرشیو",
    winBackupPending: "در صف؛ در انتظار شروع ...",
    winBackupRunning: "در حال اجرا ...",
    winBackupSucceeded: "انتقال با موفقیت انجام شد",
    winBackupFailed: "انتقال با خطا متوقف شد",
    winBackupCanceled: "ایمپورت لغو شد",
    winBackupNotFound:
      "وضعیت این ایمپورت در دسترس نیست (شناسه نامعتبر است یا سرور ری‌استارت شده است).",
    winBackupPollingHint:
      "عملیات در پس‌زمینه اجرا می‌شود و ممکن است ده‌ها دقیقه طول بکشد؛ می‌توانید صفحه را ببندید و بعداً با همین لینک وضعیت را ببینید (تا وقتی سرور ری‌استارت نشده).",
    winBackupDryRunBadge: "آزمایشی",
    winBackupDryRunDone:
      "اجرای آزمایشی بود؛ هیچ داده‌ای ذخیره نشد. برای ثبت واقعی، «اجرای واقعی» را بزنید.",
    winBackupStartedAt: "شروع",
    winBackupFinishedAt: "پایان",
    winBackupDuration: "مدت اجرا",
    winBackupCurrentStep: "مرحله‌ی جاری",
    winBackupBranchMaps: "نگاشت شعبه‌ها",
    winBackupUnits: "گزارش شعبه‌ها",
    winBackupUnitTitle: "شعبه‌ی مبدأ {source} ← شعبه {target}",
    winBackupNew: "جدید",
    winBackupCreated: "ساخته‌شده",
    winBackupDeleted: "حذف شد",
    winBackupRowsInserted: "درج",
    winBackupRowsUpdated: "به‌روزرسانی",
    winBackupLogUtcHint: "زمان‌ها به ساعت محلی نمایش داده شده‌اند.",
    winBackupCancelConfirm: "ایمپورت لغو شود؟",
    winBackupCancelConfirmReal:
      "ایمپورت لغو شود؟ شعبه‌هایی که انتقالشان کامل شده ذخیره می‌مانند.",
    winBackupDeleteConfirm: "شعبه‌های {ids} که این ایمپورت ساخته حذف شوند؟",
    winBackupBranchesDeleted: "شعبه‌های ساخته‌شده حذف شدند",
    winBackupCanceledSent: "درخواست لغو ثبت شد",
    winBackupErrorCopied: "متن خطا کپی شد",
    winBackupModuleBase: "اطلاعات پایه",
    winBackupModuleSply: "انبار و تدارکات",
    winBackupModuleFinc: "مالی",
    winBackupModuleSale: "فروش",
    winBackupArchiveRequired: "آرشیو بکاپ را انتخاب کنید.",
    winBackupRowsRequired: "حداقل یک شعبه اضافه کنید.",
    winBackupSourceInvalid: "شماره‌ی شعبه‌ی مبدأ را وارد کنید.",
    winBackupDuplicate:
      "هر شعبه‌ی مبدأ و هر شعبه‌ی مقصد فقط یک بار می‌تواند انتخاب شود.",
    winBackupCompanyRequired:
      "برای ساخت شعبه‌ی مقصد، شرکت مقصد را انتخاب کنید.",
    foreignKeyFreeText:
      "می‌توانید از لیست انتخاب کنید یا نام کلید خارجی را دستی بنویسید.",
    foreignKeyFreeTextMultiple:
      "می‌توانید از لیست انتخاب کنید یا نام کلید خارجی را بنویسید و Enter بزنید.",
    notProcessedMessage: "ابتدا دکمه پردازش را بزنید",
    permanentAccountDes: "سند بستن حساب های دائم (اختتامیه)",
    openingVoucherDes: "سند افتتاحیه",
    openingAccountDes: "سند افتتاحیه ابتدای دوره",
    temporaryAccountDes: "سند بستن حساب های موقت به سود/زیان سال جاری",
    voucherArticles: "ردیف‌های سند",
    mergeVoucher: "ادغام اسناد",
    mergeSetting: "تنظیمات ادغام",
    mergeResult: "نتیجه ادغام",
    mergeIrreversible: "این عملیات قابل بازگشت نیست.",
    mergeAllInRange: "همه اسناد بازه",
    mergeConfirmText: "{source} به {target} منتقل می‌شود. ادامه می‌دهید؟",
    mergeTargetByNumber: "سند شماره {number}",
    mergeTargetNewVoucher: "سند جدید به تاریخ {date}",
    mergeTargetFirstOfDate: "اولین سند هر روز در بازه {fromDate} تا {toDate}",
    mergeTargetLastOfDate: "آخرین سند هر روز در بازه {fromDate} تا {toDate}",
    mergeTargetNewPerDate: "سند جدید هر روز در بازه {fromDate} تا {toDate}",
    mergeVoucherCount: "{count} سند",
    mergeDetailCount: "{count} ردیف",
    automaticRow: "اتوماتیک",
    sameReferenceHint:
      "ردیف‌های اتوماتیکِ هم‌مرجع باید با هم منتقل شوند و خودکار با هم انتخاب می‌شوند.",
    addService: "ثبت خدمات جدید",
    editService: "ویرایش اطلاعات خدمات",
    productionCoefficient:
      "ضریب تولید برابر است با تعداد تکرار فرمول جهت تولید؛ به عنوان مثال اگر فرمول برای 100 عدد محصول تعریف شده و شما 3 را وارد کنید، 300 عدد محصول و مواد مصرفی و هزینه ها سه برابر ثبت خواهد شد",
    operationalCurrency: "ارز عملیاتی",
    mergeSelectionCountHint:
      "سمت راست: تعداد سندهای انتخاب‌شده از جدول بالا، سمت چپ: تعداد ردیف‌های انتخاب‌شده از جدول پایین",
    saltCalculation: "راس گیری",
    salt: "راس",
    saltDetails: "نمایش ریز محاسبه",
    saltRowWithoutEffectiveDate:
      "این سطر تاریخ موثر ندارد، تاریخ سند آن مبنا قرار گرفته است",
    saltEffectiveDateFallback:
      "{count} سطر از {total} سطر انتخابی تاریخ موثر نداشتند و تاریخ سند آن‌ها مبنا قرار گرفت.",
    saltRowsNotFound:
      "{count} سطر از {total} سطر انتخابی یافت نشد. گزارش را دوباره بگیرید.",
    salesPipelineHint: "تعریف مسیرهای متفاوت فروش و فعالیت‌های خودکار هر مرحله",
    activeSalesPipelines: "خطوط فروش فعال",
    salesPipelineStages: "مراحل خط فروش",
    stageClickHint: "برای ویرایش فعالیت‌ها روی هر مرحله کلیک کنید",
    addNewStage: "افزودن مرحله جدید",
    stageDefaultActivities: "فعالیت‌های پیش‌فرض مرحله",
    stageActivitiesHint:
      "با ورود فرصت به این مرحله، فعالیت‌ها خودکار در کارتابل مسئول ساخته می‌شوند.",
    stageRules: "قواعد ورود و خروج مرحله",
    stageProbability: "احتمال",
    stageUnit: "مرحله",
    autoActivityUnit: "فعالیت خودکار",
    addSalesPipelineTitle: "تعریف خط فروش جدید",
    editSalesPipelineTitle: "ویرایش خط فروش",
    salesPipelineTitleHint: "مثلاً فروش نمایندگان",
    initialStages: "مراحل اولیه",
    initialStagesHint: "ترتیب مراحل با جابه‌جایی ردیف‌ها تعیین می‌شود.",
    noInitialStage: "هنوز مرحله‌ای تعریف نشده است",
    addSaleStageTitle: "تعریف مرحله فروش جدید",
    editSaleStageTitle: "ویرایش مرحله فروش",
    noTaskTemplate: "فعالیتی برای این مرحله تعریف نشده است",
    noStageRules: "قاعده‌ای برای این مرحله ثبت نشده است",
    defaultProbability: "احتمال پیش‌فرض",
    stageActivity: "فعالیت",
    editableStage: "قابل ویرایش",
    customerRelation: "ارتباط با مشتری",
    salesManagement: "مدیریت فروش",
    followUpCartableHint: "تمام تماس‌ها، جلسات و اقدامات لازم در یک فهرست کاری",
    cartableFilter: "فیلتر کارتابل",
    overdue: "عقب‌افتاده",
    upcoming: "آینده",
    assignedToMe: "واگذارشده به من",
    completed: "تکمیل‌شده",
    thisWeek: "این هفته",
    completedThisWeek: "تکمیل این هفته",
    needsUrgentAction: "نیازمند اقدام فوری",
    doneItemsUnit: "مورد انجام شده",
    vsPrevious: "نسبت به قبل",
    overdueDaysUnit: "روز",
    doneAt: "انجام شد",
    activityCall: "تماس",
    activityMeeting: "جلسه",
    activityProposal: "پیشنهاد",
    activityTask: "وظیفه",
    activityProposalFilter: "ارسال پیام/پیشنهاد",
    noCartableActivity: "فعالیتی با این فیلتر وجود ندارد",
    millionUnit: "میلیون",
    billionUnit: "میلیارد",
    thousandUnit: "هزار",
    salesChancesHint: "مدیریت قیف و حرکت فرصت‌ها در مراحل خط فروش",
    moveChanceHint: "برای تغییر مرحله، کارت فرصت را در ستون دلخواه رها کنید",
    chanceUnit: "فرصت",
    withoutStage: "بدون مرحله",
    noStageChance: "فرصتی در این مرحله نیست",
    otherSaleLineStage: "این مرحله متعلق به خط فروش این فرصت نیست",
    saleFailed: "فروش ناموفق",
    saleFailedReason: "دلیل فروش ناموفق",
    saleFailedDescription: "توضیحات",
    saleFailedStageHint:
      "مرحله‌ی انتخاب‌شده از نوع «فروش ناموفق» است؛ دلیل ناموفق شدن فروش را مشخص کنید.",
    moveTaskHint: "برای تغییر وضعیت، کارت وظیفه را در ستون دلخواه رها کنید",
    taskUnit: "وظیفه",
    withoutStatus: "بدون وضعیت",
    noStatusTask: "وظیفه‌ای با این وضعیت نیست",
    overdueTask: "عقب‌افتاده",
    moveProjectHint: "برای تغییر مرحله، کارت پروژه را در ستون دلخواه رها کنید",
    projectUnit: "پروژه",
    withoutPhase: "بدون مرحله",
    noPhaseProject: "پروژه‌ای در این مرحله نیست",
    leadsHint: "ثبت، ارزیابی، تخصیص و تبدیل سرنخ‌ها به فرصت فروش",
    evaluateNeedsAssignHint:
      "برای ارزیابی سرنخ، ابتدا باید تخصیص به مسئول فروش انجام شود",
    evaluationCartableHint:
      "(لیست سرنخ‌هایی که به مسئول فروش ارجاع داده شده است)",
    searchLeadHint: "جستجوی نام، شرکت یا کد سرنخ...",
    convertedToChance: "تبدیل به فرصت",
    notConvertedToChance: "تبدیل‌نشده",
    noLeadFound: "سرنخی با این فیلترها یافت نشد",
    newLeadsThisMonth: "سرنخ جدید این ماه",
    growth: "رشد",
    qualifiedLeads: "واجد شرایط",
    qualifiedRate: "نرخ",
    waitingLeads: "سرنخ‌های در انتظار",
    needsAssignment: "نیازمند تخصیص",
    inSalesManagerQueue: "در صف مدیر فروش",
    addLeadTitle: "ثبت سرنخ جدید",
    editLeadTitle: "ویرایش سرنخ",
    leadInfoTab: "اطلاعات سرنخ",
    needAssessmentTab: "نیاز و ارزیابی",
    marketingTab: "بازاریابی",
    leadMobile: "موبایل",
    leadPhone: "تلفن",
    leadEmail: "ایمیل",
    leadSourceField: "منبع سرنخ",
    interestedProduct: "محصول مورد علاقه",
    responsibleExpert: "کارشناس مسئول",
    autoAssign: "تخصیص خودکار",
    needDescription: "شرح نیاز",
    purchaseTimeframe: "زمان احتمالی خرید",
    purchaseWithinMonth: "تا ۱ ماه آینده",
    purchaseWithin3Months: "تا ۳ ماه آینده",
    purchaseWithin6Months: "تا ۶ ماه آینده",
    purchaseAfter6Months: "بیش از ۶ ماه",
    campaignsHint: "اندازه‌گیری سرنخ، فرصت، فروش و بازگشت سرمایه هر کانال",
    campaignBudget: "بودجه",
    campaignLeadsStat: "سرنخ",
    campaignChancesStat: "فرصت",
    campaignSalesStat: "فروش",
    campaignInfoTab: "اطلاعات کمپین",
    campaignAudienceTab: "مخاطبان هدف",
    campaignScheduleTab: "زمان‌بندی",
    campaignBudgetTab: "بودجه و اطلاع‌رسانی",
    customer360: "نمای ۳۶۰ درجه مشتری و فرصت",
    accountOwner: "مسئول حساب",
    totalSalesValue: "ارزش کل فروش",
    openChanceValue: "فرصت باز",
    lastInteraction: "آخرین تعامل",
    summaryTab: "خلاصه",
    activitiesTab: "فعالیت‌ها",
    chancesTab: "فرصت‌ها",
    activeChance: "فرصت فعال",
    communicationTimeline: "خط زمانی ارتباطات",
    noActiveChance: "فرصت بازی برای این سرنخ نیست",
    noLeadActivity: "فعالیتی برای این سرنخ ثبت نشده است",
    noLeadChance: "فرصتی برای این سرنخ ثبت نشده است",
    chanceDetail: "جزئیات فرصت",
    taskDetail: "جزئیات وظیفه",
    projectDetail: "جزئیات پروژه",
    callDetail: "جزئیات تماس",
    linkedChance: "فرصت فروش",
    moreDetails: "جزئیات بیشتر",
    lessDetails: "بستن جزئیات",
    chancePreFactorsTab: "پیش فاکتورها",
    chanceOrdersTab: "سفارشات",
    chanceSaleFactorsTab: "فاکتورهای فروش",
    chanceContractsTab: "قراردادها",
    chanceOrderDoc: "سفارش",
    docNumber: "شماره",
    noChanceDocument: "سندی از این نوع برای این فرصت ثبت نشده است",
    meetingsTab: "جلسات",
    noChanceActivity: "فعالیتی برای این فرصت ثبت نشده است",
    noChanceMeeting: "جلسه‌ای برای سرنخ این فرصت ثبت نشده است",
    chanceCallsTab: "تماس‌ها",
    noChanceCall: "تماسی برای سرنخ این فرصت ثبت نشده است",
    noProjectActivity: "فعالیتی برای این پروژه ثبت نشده است",
    noProjectMeeting: "جلسه‌ای برای این پروژه ثبت نشده است",
    noProjectCall: "تماسی برای این پروژه ثبت نشده است",
    projectsTab: "پروژه‌ها",
    noTaskProject: "پروژه‌ای به این فعالیت متصل نیست",
    noTaskMeeting: "جلسه‌ای برای این فعالیت ثبت نشده است",
    noTaskCall: "تماسی برای این فعالیت ثبت نشده است",
    noCallActivity: "فعالیتی برای این تماس ثبت نشده است",
    noCallProject: "پروژه‌ای به این تماس متصل نیست",
    noCallMeeting: "جلسه‌ای به این تماس متصل نیست",
    probability: "احتمال",
    salesStage: "مرحله",
    tomanUnit: "تومان",
    yesterday: "دیروز",
    daysAgo: "روز پیش",
    leadEvaluation: "ارزیابی سرنخ",
    evaluationQuestions: "سوالات ارزیابی",
    questionsAnswered: "سوال پاسخ داده شده",
    requiredUnanswered: "سوال الزامی بی‌پاسخ",
    allRequiredAnswered: "همه‌ی سوال‌های الزامی پاسخ داده شده‌اند",
    answerPlaceholder: "پاسخ را بنویسید...",
    evaluationKeyboardHint:
      "Enter: سوال بعدی • Shift+Enter: خط جدید • Ctrl+Enter: ثبت",
    newQuestionPlaceholder: "متن سوال جدید را بنویسید",
    answerIsRequired: "پاسخ به این سوال الزامی است",
    noEvaluationQuestion: "هنوز سوال ارزیابی تعریف نشده است",
    noEvaluationQuestionHint: "با «سوال جدید» اولین سوال را همین‌جا بسازید",
    resultQualified: "واجد شرایط",
    resultSuspended: "معلق",
    resultUnqualified: "فاقد شرایط",
    lastEvaluation: "آخرین ارزیابی",
    answerRequiredQuestions: "پاسخ سوال‌های الزامی را کامل کنید",
    chooseEvaluationResult: "نتیجه ارزیابی را انتخاب کنید",
    evaluationLoadFailed: "اطلاعات ارزیابی این سرنخ دریافت نشد",
    marketingDashboardHint:
      "فروش، فرصت‌ها، سرنخ‌ها و فعالیت‌های ماه جاری در یک نگاه",
    confirmedSales: "فروش قطعی این ماه",
    saleFactorUnit: "فاکتور فروش",
    averageInvoice: "میانگین هر فاکتور",
    chancesValue: "ارزش فرصت‌ها",
    inProgressChances: "فرصت‌های در جریان",
    leadConversionRate: "نرخ تبدیل سرنخ به فرصت",
    newLeadUnit: "سرنخ جدید",
    overdueFollowUps: "پیگیری‌های عقب‌افتاده",
    allFollowUpsOnTime: "همه‌ی پیگیری‌ها به‌موقع انجام شده‌اند",
    leadUnit: "سرنخ",
    salesFunnel: "قیف فروش",
    salesFunnelHint: "فرصت‌های ثبت‌شده‌ی این ماه به تفکیک مرحله‌ی فعلی",
    byCount: "تعداد",
    byValue: "ارزش",
    chancesCount: "تعداد فرصت‌ها",
    totalValue: "ارزش کل",
    weightedForecast: "پیش‌بینی وزنی",
    lastStage: "مرحله آخر",
    noSaleLine: "هنوز خط فروشی تعریف نشده است",
    noSaleStage: "برای این خط فروش مرحله‌ای تعریف نشده است",
    noFunnelChance: "این ماه فرصتی در این خط فروش ثبت نشده است",
    upcomingActivities: "فعالیت‌های نزدیک",
    upcomingActivitiesHint: "امروز تا ۳ روز آینده",
    tomorrow: "فردا",
    noUpcomingActivity: "تا ۳ روز آینده فعالیتی ندارید",
    deadline: "مهلت",
    activityPriority: "اولویت",
    responsiblePerformance: "عملکرد مسئولین فروش",
    responsiblePerformanceHint:
      "درصد تحقق هدف: سهم فرصت‌های به مشتری رسیده از فرصت‌های ثبت‌شده‌ی این ماه",
    achievement: "تحقق هدف",
    successfulChances: "فرصت موفق",
    ranking: "رتبه‌بندی",
    noResponsiblePerformance: "این ماه برای هیچ مسئول فروشی فرصتی ثبت نشده است",
    dashboardLoadFailed: "اطلاعات داشبورد دریافت نشد",
    ofWord: "از",
    untilWord: "تا",
    followUpCartableLoadFailed: "اطلاعات کارتابل پیگیری دریافت نشد",
    previousWeek: "هفته قبل",
    itemsUnit: "مورد",
    activityCalendarHint:
      "جلسه‌ها، وظیفه‌ها و تماس‌های فروش روی تقویم ماه، هفته و روز",
    calendarMonthView: "ماه",
    calendarWeekView: "هفته",
    calendarDayView: "روز",
    calendarDayViewTitle: "نمای این روز",
    calendarAllDay: "تمام روز",
    calendarNoTime: "بدون ساعت",
    calendarMoreItems: "مورد دیگر",
    calendarActivityUnit: "فعالیت",
    calendarSalesOnly: "فقط سرنخ و فرصت",
    calendarSearchHint: "جستجو در عنوان فعالیت‌ها...",
    calendarNoDayActivity: "برای این روز فعالیتی ثبت نشده است",
    calendarNoActivity: "در این بازه فعالیتی ثبت نشده است",
    calendarLoadFailed: "فعالیت‌های تقویم دریافت نشد",
    leadChanceConversionHint: "بر اساس تاریخ ثبت فرصت؛ از سرنخ تا فروش قطعی",
    leadToChance: "سرنخ به فرصت",
    leadToCustomer: "سرنخ به مشتری",
    chanceToStage: "فرصت به مرحله",
    stageToLastStage: "از این مرحله به مرحله آخر",
    leadToSaleRate: "نرخ تبدیل سرنخ به فروش",
    conversionStages: "تبدیل فرصت‌ها در مراحل فروش",
    conversionStagesHint:
      "تعداد فرصت‌های رسیده به هر مرحله و تعداد رسیده از همان مرحله به مرحله آخر",
    reachedStage: "رسیده به مرحله",
    reachedLastStage: "رسیده به مرحله آخر",
    stageToLastRate: "نرخ رسیدن به مرحله آخر",
    conversionDetailHint: "سرنخ‌های همین ردیف در بازه‌ی انتخاب‌شده",
    conversionClickHint: "برای دیدن جزئیات، روی هر عدد کلیک کنید",
    reportLoadFailed: "اطلاعات گزارش دریافت نشد",
    detailLoadFailed: "جزئیات این ردیف دریافت نشد",
    noReportData: "در این بازه داده‌ای برای نمایش نیست",
    noDetailData: "برای این ردیف سرنخی ثبت نشده است",
    noStageStatistics: "در این بازه فرصتی در مراحل این خط فروش ثبت نشده است",
    periodFilter: "بازه زمانی",
    previousMonth: "ماه گذشته",
    lastThreeMonths: "۳ ماه اخیر",
    currentYear: "امسال",
    leadsCount: "تعداد سرنخ",
    totalCount: "مجموع تعداد",
    serviceSupportInfoTab: "اطلاعات پشتیبانی",
    serviceSupportCustomerTab: "مشتری و محل",
    serviceSupportDoneTab: "پیگیری و نتیجه",
    contractInfoTab: "اطلاعات قرارداد",
    contractCommoditiesTab: "کالا و خدمات",
    contractAddMinusTab: "اضافات و کسورات",
    contractCommodityTotal: "جمع کالا و خدمات",
    contractAddTotal: "جمع اضافات",
    contractMinusTotal: "جمع کسورات",
    contractTotal: "مبلغ نهایی",
    contractAddition: "اضافه",
    contractDeduction: "کسر",
    contractPriceFromPercent: "مبلغ از درصد روی جمع کالا و خدمات حساب می‌شود",
    saleFunnelReportHint:
      "مراحل هر خط فروش با تعداد، سهم، ارزش و ارزش وزنی فرصت‌ها",
    funnelFilters: "فیلتر گزارش",
    countShare: "سهم تعداد",
    stageChances: "فرصت‌های این مرحله",
    noFunnelStage: "برای این خط فروش مرحله‌ای با فرصت ثبت‌شده نیست",
    analyticView: "نمای تحلیلی",
    tableView: "نمای جدولی",
    hamyarDashboardHint:
      "فعالیت‌ها، پروژه‌ها، جلسه‌ها و تیکت‌های باز در یک نگاه",
    openTaskCard: "فعالیت‌های باز",
    openTaskCardHint: "انجام‌نشده‌ی شما",
    activeProjectCard: "پروژه‌های فعال",
    activeProjectCardHint: "در جریان",
    attendedMeetingCard: "جلسات شرکت‌کرده",
    dateRangeTo: "تا",
    openTicketCard: "تیکت‌های باز",
    openTicketCardHint: "پشتیبانی شعبه",
    upcomingTasksCard: "فعالیت‌های پیش‌رو",
    upcomingTasksCardHint: "نزدیک‌ترین مهلت‌ها",
    scheduledMeetingsCard: "جلسات برنامه‌ریزی‌شده",
    scheduledMeetingsCardHint: "از امروز به بعد",
    noUpcomingTask: "فعالیتی در پیش ندارید",
    noScheduledMeeting: "جلسه‌ای برنامه‌ریزی نشده است",
    daysLater: "روز دیگر",
    openRecordHint: "برای دیدن جزئیات کلیک کنید",
    saltDate: "تاریخ راس",
    quickAccess: "دسترسی سریع",
    quickTasks: "فعالیت‌ها",
    quickMeetings: "جلسات",
    quickCalendar: "تقویم کاری",
    quickSupport: "پشتیبانی",
    priorityLow: "کم",
    priorityMedium: "متوسط",
    priorityHigh: "زیاد",
    priorityCritical: "بحرانی",
    profileHint:
      "اطلاعات حساب، رمز عبور و نشست‌های فعال خود را از اینجا مدیریت کنید",
    profilePersonal: "اطلاعات شخصی",
    profilePersonalHint:
      "این اطلاعات در بخش‌های مختلف سامانه کنار نام شما نمایش داده می‌شود",
    profileSecurity: "امنیت حساب",
    profileSecurityHint:
      "برای امنیت بیشتر، رمز عبور را هر چند وقت یک‌بار عوض کنید",
    profileChangePhoto: "تغییر تصویر",
    profilePhotoHint: "JPG یا PNG، مربعی، حداکثر ۱ مگابایت",
    profilePhotoDrop: "تصویر را اینجا رها کنید",
    profilePhotoTooLarge: "حجم تصویر بیشتر از ۱ مگابایت است",
    profilePhotoBadType: "فقط تصویر JPG یا PNG قابل انتخاب است",
    profileUnsaved: "تغییرات ذخیره نشده",
    profileSaved: "همهٔ تغییرات ذخیره شده است",
    profileMobileRequired: "تلفن همراه الزامی است",
    profileMobileInvalid: "تلفن همراه باید ۱۱ رقم باشد و با ۰۹ شروع شود",
    profileNameRequired: "نام و نام خانوادگی الزامی است",
    profilePwStrength: "قدرت رمز عبور",
    profilePwWeak: "ضعیف",
    profilePwMedium: "متوسط",
    profilePwGood: "خوب",
    profilePwStrong: "قوی",
    profilePwRuleLength: "حداقل ۳ کاراکتر",
    profilePwRuleLetter: "شامل حرف",
    profilePwRuleDigit: "شامل عدد",
    profilePwRuleSymbol: "شامل نماد مثل ! @ #",
    profilePwTooShort: "رمز عبور باید حداقل ۳ کاراکتر باشد",
    profilePwMismatch: "تکرار رمز عبور با رمز جدید یکسان نیست",
    profilePwSameAsOld: "رمز جدید نباید با رمز فعلی یکسان باشد",
    profileShowPassword: "نمایش رمز عبور",
    profileHidePassword: "پنهان کردن رمز عبور",
    profileSessions: "نشست‌های فعال",
    profileSessionsHint: "دستگاه‌هایی که الان با حساب شما وارد شده‌اند",
    profileSessionsCount: "نشست فعال",
    profileManageSessions: "مدیریت نشست‌ها",
    profileNoSession: "نشست فعالی یافت نشد",
    profileThisDevice: "همین دستگاه",
    profileCurrentLogin: "ورود این نشست",
    profileMoreSessions: "نشست دیگر",

    feedBackManagementHint:
      "ساخت نظرسنجی باشگاه مشتریان، تعریف سوال‌ها و گزینه‌های پاسخ",
    feedBackCount: "کل نظرسنجی‌ها",
    feedBackActiveCount: "فعال",
    feedBackExpiredCount: "منقضی‌شده",
    feedBackViewCount: "مجموع بازدید",
    feedBackEmpty: "هنوز نظرسنجی‌ای ثبت نشده است",
    feedBackEmptyHint:
      "برای شروع یک نظرسنجی جدید بسازید و سپس سوال‌های آن را تعریف کنید",
    feedBackNoResult: "نظرسنجی‌ای با این فیلترها پیدا نشد",
    feedBackNoResultHint: "عبارت جستجو یا فیلترها را تغییر دهید",
    editFeedBack: "ویرایش نظرسنجی",
    expired: "منقضی",
    noExpireDate: "بدون انقضا",
    untilExpire: "تا انقضا",
    sortNewest: "جدیدترین",
    sortMostViewed: "بیشترین بازدید",
    sortExpireSoon: "نزدیک‌ترین انقضا",
    sortTitle: "عنوان (الفبا)",
    questionCount: "سوال",
    delFeedBackConfirm: "آیا از حذف نظرسنجی «{title}» مطمئن هستید؟",
    confirmed: "تایید شده",
    notReviewed: "بررسی نشده",
    currentTaxCertificate: "گواهی امضای فعلی",
    taxInquiryResult: "نتیجه استعلام از سامانه مودیان",
    taxSendResult: "نتیجه ارسال به سامانه مودیان",
    taxKeyFileHint:
      "در صورت انتخاب فایل، متن داخل فایل جایگزین متن کلید می‌شود",
    taxKeyKeepHint: "در صورت عدم تغییر، کلید قبلی حفظ می‌شود",
    taxResultSuccessCount: "موفق",
    taxResultFailCount: "ناموفق",
    taxSettingNotRegistered:
      "هنوز تنظیماتی برای سامانه مودیان این شعبه ثبت نشده است؛ اطلاعات شرکت از روی شعبه پر شده است.",
    taxCommodityIdMissing: "بدون شناسه کالا",
    taxNotSent: "ارسال نشده",
    taxExportNeedsCurrency:
      "در الگوی صادرات، نوع ارز و نرخ برابری الزامی است. فاکتورهای:",
    taxNeedsCashPrice:
      "در روش تسویه «نقد و نسیه»، مبلغ نقد الزامی است. فاکتورهای:",
    taxPatternNotSupported:
      "ارسال فقط با الگوی فروش کالا و خدمات یا صادرات (نوع اول) امکان‌پذیر است. فاکتورهای:",
    taxOneFactorFilter: "فقط صورتحساب‌های یک فاکتور",
    taxFromExcel: "اکسل",
    taxFromSaleFactor: "فاکتور فروش",
    taxImportExcelResult: "نتیجه ورود صورتحساب از اکسل",
    taxImportExcelAllOrNothing:
      "اگر حتی یک ردیف فایل خطای داده داشته باشد، هیچ صورتحسابی ارسال نمی‌شود؛ خطاها را در فایل اصلاح و دوباره بارگذاری کنید.",
    taxImportExcelContinueOnError:
      "اگر فایل سالم باشد، خطای سامانه مودیان در یک ردیف مانع ارسال بقیه ردیف‌ها نمی‌شود.",
    taxImportExcelRetryHint:
      "ردیف‌های ناموفق ثبت نشدند. پس از اصلاح، همان فایل را دوباره بارگذاری کنید؛ ردیف‌هایی که قبلاً ارسال شده‌اند دوباره ارسال نمی‌شوند.",
    taxImportExcelTimeout:
      "پاسخ سرور به‌موقع دریافت نشد، اما ارسال صورتحساب‌ها در سرور ادامه دارد. چند دقیقه بعد لیست صورتحساب‌ها را ببینید یا همان فایل را دوباره بارگذاری کنید.",
    taxImportExcelLongWait:
      "ورود فایل‌های بزرگ ممکن است چند دقیقه طول بکشد؛ تا دریافت نتیجه صفحه را نبندید.",
    taxExcelRowSent: "ارسال شد",
    taxExcelRowAlreadySent: "قبلاً ارسال شده",
    taxExcelRowFailed: "ناموفق",
    taxExcelOnlyFailed: "فقط ناموفق‌ها",
    taxImportExcelSameHeader:
      "نوع، الگو و موضوع انتخاب‌شده برای همه صورتحساب‌های فایل یکسان است.",
    taxImportExcelSerial:
      "سریال صورتحساب در هر فایل نباید تکراری باشد؛ سریالی که قبلاً با موفقیت ارسال شده، در بارگذاری دوباره رد می‌شود و دوباره ارسال نمی‌شود.",
    taxImportExcelReference:
      "در موضوع اصلاحی، ابطال و برگشت از فروش، «شماره منحصر به فرد مالیاتی صورتحساب مرجع» (ستون D شیت Bill) الزامی است و صورتحساب مرجع باید قبلاً از همین سامانه و همین شعبه ارسال شده باشد.",
    taxImportExcelSheets:
      "فایل نمونه شامل شیت‌های Bill (سربرگ)، Detail (اقلام) و Payment (پرداخت‌ها) است؛ ستون اول Detail و Payment همان سریال صورتحساب در شیت Bill است.",
    taxImportExcelPatternHint:
      "فعلاً فقط الگوی فروش کالا و خدمات و الگوی صادرات (نوع اول) قابل ارسال است.",
    csrDownload: "درخواست گواهی (CSR)",
    publicKeyDownload: "کلید عمومی",
    privateKeyDownload: "کلید خصوصی",
    legalPerson: "شخص حقوقی",
    nonLegalPerson: "شخص حقیقی",
    privateKeyWarning: "محرمانه",
    taxKeyEmpty: "مقداری برای این کلید ثبت نشده است",
    privateKeyConfirm:
      "کلید خصوصی محرمانه است، آن را فقط در جای امن نگه دارید. </br> آیا مایل به ادامه فرآیند می‌باشید؟",
    addSettlementType: "ثبت نوع تسویه جدید",
    editSettlementType: "ویرایش اطلاعات نوع تسویه",
    orderSettlement: "تسویه سفارش",
    settlementTotalAmount: "مبلغ کل",
    settlementCheques: "چک",
    settlementCashes: "نقد",
    settlementDiscountCredits: "تخفیف / اعتبار",
    settlementRow: "ردیف تسویه",
    settlementRowsTotal: "جمع ردیف‌ها",
    settlementDifference: "مغایرت با مبلغ کل",
    newVoucher: "سند جدید",
    addToLastVoucher: "اضافه به آخرین سند",
    addToVoucherNumber: "اضافه به سند شماره",
    voucherIssuePreview: "پیش نمایش صدور سند",
    deleteOrderSettlementConfirm:
      "تسویه و سند حسابداری آن حذف می‌شود. ادامه می‌دهید؟",
    deleteOrderSettlementVoucherConfirm:
      "فقط سند حسابداری تسویه حذف می‌شود و تسویه باقی می‌ماند. ادامه می‌دهید؟",
    specificPriority: "انتقال به الویت مشخص",
    cartableAuxInfo: "اطلاعات کمکی",
    cartableAuxInfoNoAccess: "دسترسی به اطلاعات کمکی کارتابل ندارید",
    customerSpecifications: "مشخصات مشتری",
    receivableDocuments: "اسناد دریافتنی",
    customerAccountBalance: "مانده حساب",
    commodityStock: "موجودی کالاها",
    stockIsEnough: "موجودی همه کالاهای سفارش کافی است",
    reminderCreatesTasks: "کپی در تقویم کاری",
    taskDeleteScopeTitle: "کدام موارد حذف شوند؟",
    taskSeriesHint: "این وظیفه عضو یک سری تکرارشونده (یادآور) است.",
    taskReferral: "ارجاع وظیفه",
    taskReferrals: "تاریخچه ارجاع",
    referralSeen: "دیده شد",
    referralNotSeen: "دیده نشده",
    referOthersHint: "ارجاع وظیفه‌ی دیگران فقط برای مدیر همان بخش مجاز است.",
    referTimerRunning:
      "زمان اجرای این وظیفه در حال ثبت است؛ با ثبت ارجاع، زمان اجرا همین لحظه پایان می‌یابد.",
    referTimerChecking: "در حال بررسی زمان اجرای وظیفه...",
    referCurrentResponsible: "مسئول فعلی",
    referSelectedTasks: "وظایف انتخاب‌شده",
    taskFilterKeyword: "فیلتر بر اساس عنوان...",
    projectFilterKeyword: "فیلتر بر اساس عنوان یا کد پروژه...",
    taskFilterSearch: "جستجو...",
    taskFilterNoResult: "موردی یافت نشد",
    taskFilterMe: "من",
    taskFilterAll: "همه",
    taskFilterDefault: "پیش‌فرض",
    taskFilterClearAll: "پاک کردن فیلترها",
    taskFilterDateRange: "بازه‌ی زمانی",
    taskFilterQuickRange: "انتخاب سریع",
    taskFilterCustomRange: "بازه‌ی دلخواه",
    taskFilterToday: "امروز",
    taskFilterThisWeek: "این هفته",
    taskFilterThisMonth: "این ماه",
    taskFilterLast30Days: "۳۰ روز اخیر",
    taskFilterFiscalYear: "سال مالی",
    recurringTask: "تکرارشونده",
    workspaceTitle: "انتخاب فضای کاری",
    workspaceDescription: "شعبه و سال مالی موردنظر برای ورود را انتخاب کنید.",
    currentBranch: "شعبه جاری",
    fiscalYear: "سال مالی",
    fiscalYearCount: "سال مالی",
    noFiscalYear: "سال مالی برای این شعبه ثبت نشده است",
    enterSystem: "ورود به سیستم",
    version: "نسخه",
    companyName: "شرکت پارسینا پردازان آریا",
    forgotPasswordTitle: "فراموشی رمز عبور",
    forgotPasswordDescription:
      "ایمیل ثبت‌شده در حساب خود را وارد کنید تا لینک بازیابی برایتان ارسال شود.",
    mitaOwnership:
      "میتا محصولی از شرکت پارسینا پردازان آریا است. کلیه حقوق مادی و معنوی آن محفوظ است.",
    mitaTitle: "میتا",
    loginHeadline1: "مدیریت یکپارچه،",
    loginHeadline2: "توسعه آسان",
    changeTheme: "تغییر تم",
    loginDescription: "برای ورود، نام کاربری و رمز عبور خود را وارد کنید.",
    usernamePlaceholder: "نام کاربری یا کد پرسنلی",
    rememberMe: "مرا به خاطر بسپار",
    forgotPasswordLink: "فراموشی رمز عبور؟",
    loginSlide1Title: "فراتر از یک نرم افزار",
    loginSlide1Desc: "برای سازمان هایی که به دقت و سرعت اهمیت می دهند",
    loginSlide2Title: "مدیریت هوشمند",
    loginSlide2Desc: "تصمیم‌گیری سریع با داده‌های دقیق",
    loginSlide3Title: "توسعه‌پذیر و امن",
    loginSlide3Desc: "آماده رشد همراه با سازمان شما",
    issuedDrafts: "شماره حواله های صادر شده",
    issuedSaleFactors: "شماره فاکتورهای فروش صادر شده",
    stockWarning: "هشدار موجودی",
    orderWarnings: "هشدارهای سفارش",
    orderWarningsConfirm: "با وجود هشدارهای زیر، آیا ثبت سفارش انجام شود؟",
    stockChecking: "در حال بررسی موجودی...",
    issuePermitRows: "تعداد سطرهای مجوز",
    issueDraftRows: "تعداد سطرهای حواله",
    issueReceiptRows: "تعداد سطرهای رسید",
    deleteWholeDraft: "همه ردیف‌های انتخاب شده حذف می شوند.",
    isFinancialDraft: "حواله مالی",
    pbaseDashActiveUsers: "کاربران فعال",
    pbaseDashOfTotal: "از مجموع",
    pbaseDashUserUnit: "کاربر تعریف‌شده",
    pbaseDashPersons: "اشخاص ثبت‌شده",
    pbaseDashNewThisMonth: "مورد جدید در این ماه",
    pbaseDashBranches: "شعبه‌های فعال",
    pbaseDashBranchesCard: "شعبه‌ها",
    pbaseDashActive: "فعال",
    pbaseDashInactive: "غیرفعال",
    pbaseDashTaxPending: "بدون تنظیمات مالیاتی",
    pbaseDashTaxSetting: "تنظیمات مالیاتی",
    pbaseDashCentralBranch: "مرکزی",
    pbaseDashCurrentBranch: "شعبه جاری",
    pbaseDashUsersUnit: "کاربر",
    pbaseDashPersonsUnit: "شخص",
    pbaseDashNoBranch: "شعبه‌ای ثبت نشده است",
    pbaseDashIntroducePersons: "معرفی اشخاص",
    pbaseDashIntroduceBranches: "معرفی شعبه‌ها",
    pbaseDashSbuUnit: "واحد سازمانی",
    pbaseDashPositionUnit: "سِمت",
    pbaseDashSessions: "نشست‌های فعال",
    pbaseDashSessionsHint: "آخرین ورود کاربران به سامانه",
    pbaseDashCurrentSession: "شما",
    pbaseDashNoSession: "نشست فعالی وجود ندارد",
    pbaseDashMap: "نقشه اطلاعات پایه",
    pbaseDashMapHint: "همه بخش‌های اطلاعات پایه و حجم داده‌ی هر بخش",
    pbaseDashSearch: "جستجوی بخش...",
    pbaseDashNoSection: "بخشی با این عنوان پیدا نشد",
    pbaseDashRecord: "رکورد",
    pbaseDashConfigured: "تنظیم شده",
    pbaseDashNotConfigured: "تنظیم نشده",
    pbaseDashPersonGroups: "اشخاص به تفکیک گروه",
    pbaseDashNoPerson: "هنوز شخصی ثبت نشده است",
    pbaseDashRates: "آخرین نرخ ارزها",
    pbaseDashRatesHint: "تغییر نسبت به روز قبل",
    pbaseDashRatesUpdated: "به‌روزرسانی",
    pbaseDashNoRate: "نرخ ارزها در دسترس نیست",
    pbaseDashRatesPick: "انتخاب نمادها",
    pbaseDashRatesSelected: "نماد انتخاب شده",
    pbaseDashRatesSearch: "جستجوی نماد...",
    pbaseDashRatesNoMatch: "نمادی با این عنوان پیدا نشد",
    pbaseDashRatesClear: "پاک کردن همه",
    pbaseDashRatesDefault: "بدون انتخاب، نمادهای پیش‌فرض نمایش داده می‌شوند",
    pbaseDashRatesApply: "اعمال",
    pbaseDashModules: "ماژول‌های فعال سازمان",
    pbaseDashModulesHint: "زیرسیستم‌هایی که در اشتراک سازمان شما فعال است",
    pbaseDashNoModule: "ماژول فعالی برای سازمان ثبت نشده است",
    pbaseDashShowLess: "نمایش کمتر",
    pbaseDashRial: "ریال",
    pbaseDashJustNow: "همین حالا",
    pbaseDashMinutesAgo: "دقیقه پیش",
    pbaseDashHoursAgo: "ساعت پیش",
    pbaseDashDaysAgo: "روز پیش",
    crmDashTitle: "داشبورد باشگاه مشتریان",
    crmDashHint: "اعضا، فروش، وفاداری و رضایت مشتریان در یک نگاه",
    crmDashPeriod3: "۳ ماه",
    crmDashPeriod6: "۶ ماه",
    crmDashPeriod12: "۱۲ ماه",
    crmDashRecent: "اخیر",
    crmDashMembers: "اعضای باشگاه",
    crmDashMonthSales: "فروش خالص این ماه",
    crmDashNoLastMonth: "ماه قبل فروشی ثبت نشده",
    crmDashMonthOrders: "خریدهای این ماه",
    crmDashAvgBasket: "میانگین سبد",
    crmDashNoAtRisk: "مشتری در معرض ریزش ندارید",
    crmDashSalesTrend: "روند فروش ماهانه",
    crmDashSalesTrendHint: "جمع مبلغ خالص خریدهای ثبت‌شده در هر ماه",
    crmDashByAmount: "مبلغ",
    crmDashByOrders: "تعداد خرید",
    crmDashPeriodTotal: "جمع دوره",
    crmDashMonthlyAvg: "میانگین ماهانه",
    crmDashBestMonth: "بهترین ماه",
    crmDashNoSales: "در این بازه خریدی ثبت نشده است",
    crmDashOrderUnit: "خرید",
    crmDashMemberUnit: "عضو",
    crmDashComposition: "ترکیب اعضا",
    crmDashCompositionHint: "سهم هر دسته از کل اعضای باشگاه",
    crmDashByGrade: "درجه",
    crmDashByGroup: "گروه",
    crmDashByGender: "جنسیت",
    crmDashUnknown: "نامشخص",
    crmDashNoMember: "هنوز عضوی در باشگاه ثبت نشده است",
    crmDashAddMember: "افزودن عضو",
    crmDashHealth: "سلامت مشتریان",
    crmDashHealthHint: "وضعیت اعضا بر اساس سابقه‌ی خرید",
    crmDashAtRisk: "در معرض ریزش",
    crmDashBehavior: "رفتار خرید",
    crmDashBehaviorHint: "فروش خالص، تخفیف و اعتبار در بازه‌ی انتخابی",
    crmDashCreditUsed: "اعتبار مصرف‌شده",
    crmDashOccasions: "مناسبت‌های پیش‌رو",
    crmDashOccasionsHint: "تولد و سالگرد ازدواج اعضا در روزهای پیش‌رو",
    crmDashBirthday: "تولد",
    crmDashAnniversary: "سالگرد ازدواج",
    crmDashYearsUnit: "سال",
    crmDashNoOccasion: "در روزهای پیش‌رو مناسبتی نیست",
    crmDashTopCustomers: "مشتریان برتر",
    crmDashTopCustomersHint: "بیشترین مبلغ خرید",
    crmDashNoTopCustomer: "هنوز خریدی ثبت نشده است",
    crmDashAtRiskList: "نیازمند پیگیری",
    crmDashAtRiskListHint: "مشتریانی که مدتی است خرید نکرده‌اند",
    crmDashDaysSinceBuy: "روز از آخرین خرید",
    crmDashSurveys: "نظرسنجی‌ها",
    crmDashSurveysHint: "نرخ پاسخ مشتریان به نظرسنجی‌های ارسال‌شده",
    crmDashAnswers: "پاسخ",
    crmDashQuestions: "سوال",
    crmDashNoSurvey: "هنوز نظرسنجی ثبت نشده است",
    crmDashUserPerformance: "عملکرد کاربران",
    crmDashUserPerformanceHint: "بیشترین ثبت عضو جدید توسط کاربران",
    crmDashNoUserPerformance: "هنوز عضوی توسط کاربران ثبت نشده است",
    crmDashSectionFailed: "اطلاعات این بخش دریافت نشد",
    crmDashQuickOrder: "ثبت خرید",
    crmDashQuickDiscount: "کد تخفیف",
    crmDashQuickSurvey: "نظرسنجی",
    crmDashQuickProcess: "فرآیند خودکار",
    crmDashQuickMessage: "پیام تبریک",
    crmDashQuickReport: "گزارش جامع",
    crmDashCurrentMonthTag: "ماه جاری",
    crmDashLastMonth: "ماه قبل",
    crmDashCustomerUnit: "مشتری",
    crmDashPeriodSales: "فروش خالص دوره",
    crmDashDiscountShare: "سهم تخفیف از مبلغ فروش",
    hmsDashSectionFailed: "این بخش دریافت نشد",
    hmsDashProjects: "پروژه‌ها",
    hmsDashSuites: "واحدها",
    hmsDashUsefulArea: "مساحت مفید",
    hmsDashSquareMeter: "مترمربع",
    hmsDashParticipations: "مشارکت‌ها",
    hmsDashMonthDue: "سررسید این ماه",
    hmsDashNotificationUnit: "اعلامیه",
    hmsDashUnitUnit: "واحد",
    hmsDashCashflow: "جریان سررسید اعلامیه‌ها",
    hmsDashCashflowHint: "مبلغ اعلامیه‌های پرداخت بر اساس ماه سررسید",
    hmsDashPastMonths: "ماه‌های گذشته",
    hmsDashNextMonths: "این ماه و بعد",
    hmsDashTotalNotified: "کل مبلغ اعلامیه‌ها",
    hmsDashNoNotification: "هنوز اعلامیه‌ای ثبت نشده است",
    hmsDashAddNotification: "ثبت اعلامیه",
    hmsDashShare: "سهم پروژه‌ها",
    hmsDashShareHint: "مقایسه‌ی پروژه‌ها با هم",
    hmsDashByParticipation: "مشارکت",
    hmsDashByAmount: "مبلغ",
    hmsDashBySuite: "واحد",
    hmsDashOther: "سایر",
    hmsDashProjectProgress: "پیشرفت زمانی پروژه‌ها",
    hmsDashProjectProgressHint: "زمان سپری‌شده از شروع تا پایان هر پروژه",
    hmsDashNoProject: "هنوز پروژه‌ای تعریف نشده است",
    hmsDashAddProject: "پروژه‌ی جدید",
    hmsDashNotStarted: "شروع نشده",
    hmsDashFinished: "پایان یافته",
    hmsDashNoSchedule: "بدون زمان‌بندی",
    hmsDashDaysLeft: "روز مانده",
    hmsDashUpcomingDue: "سررسیدهای نزدیک",
    hmsDashUpcomingDueHint: "اعلامیه‌های ۳۰ روز گذشته تا ۳۰ روز آینده",
    hmsDashNoUpcomingDue: "سررسیدی در ۳۰ روز آینده نیست",
    hmsDashCrimesReward: "جرائم و پاداش‌ها",
    hmsDashCrimesRewardHint: "جمع مبالغ به تفکیک نوع",
    hmsDashNoCrimesReward: "جریمه یا پاداشی ثبت نشده است",
    hmsDashRecentTransfers: "آخرین انتقال‌ها",
    hmsDashRecentTransfersHint: "واگذاری سهم بین مشارکت‌کنندگان",
    hmsDashNoTransfer: "انتقالی ثبت نشده است",
    hmsDashRecentParticipations: "آخرین مشارکت‌ها",
    hmsDashRecentParticipationsHint: "جدیدترین قراردادهای مشارکت",
    hmsDashNoParticipation: "مشارکتی ثبت نشده است",
    hmsDashNoProjectSuite: "برای پروژه‌ها واحدی ثبت نشده است",
    hmsDashAddParticipation: "مشارکت جدید",
    hmsDashQuickEstimate: "برآورد هزینه",
    hmsDashQuickSuite: "واحدها",
    hmsDashQuickCrimesReward: "جریمه و پاداش",
    hmsDashQuickTransfer: "انتقال سهم",
    hmsDashQuickRanking: "گزارش رتبه‌بندی",
    hmsDashShareMeter: "متر سهم",
    hmsDashCount: "تعداد",
    hmsDashDuePassed: "روز از سررسید گذشته",
    hmsDashDueToday: "سررسید امروز",
    hmsDashNoProjectSchedule: "پروژه‌ای با تاریخ شروع و پایان ثبت نشده است",
    hmsDashOverdueDays: "روز از پایان گذشته",
    hmsDashShareUnit: "سهم",
    totalNumberOfEntrySum: "جمع تعداد ورودی",
    totalNumberOfOutputSum: "جمع تعداد خروجی",
    totalValueOfEntrySum: "جمع ارزش ورودی",
    totalValueOfOutputSum: "جمع ارزش خروجی",
    totalValueSum: "جمع ارزش کل",
    organizationChart: "چارت سازمانی",
    showPersonsInChart: "نمایش اشخاص در چارت",
    noPersonInPosition: "شخصی منتسب نشده",
    zoomIn: "بزرگ‌نمایی",
    zoomOut: "کوچک‌نمایی",
    resetZoom: "اندازهٔ اصلی",
    byDate: "براساس تاریخ",
    byNumber: "براساس شماره",
    reReadPreFactor: "فراخوانی از پیش فاکتور",
    reReadSaleFactor: "فراخوانی از فاکتور فروش",
    addPreFactorNo: "شماره پیش فاکتور مورد نظر را وارد کنید",
    addFactorNo: "شماره فاکتور مورد نظر را وارد کنید",
    reReadBuyRequest: "فراخوانی از درخواست خرید",
    reReadBuyFactor: "فراخوانی از فاکتور خرید",
    newDraft: "حواله جدید",
    eachFactorOneDraft: "هر فاکتور یک حواله",
    eachDateOneDraft: "هر تاریخ یک حواله",
    addToDraft: "اضافه به حواله",
    addToFactorDateDraft: "اضافه به حواله موجود در تاریخ فاکتور",
    newReceipt: "رسید جدید",
    eachFactorOneReceipt: "هر فاکتور یک رسید",
    eachDateOneReceipt: "هر تاریخ یک رسید",
    addToReceipt: "اضافه به رسید",
    addToFactorDateReceipt: "اضافه به رسید موجود در تاریخ فاکتور",
    byLinearNet: "براساس خالص خطی",
    byCommodityAccount: "براساس سرفصل‌های کالا",
    newFactor: "فاکتور جدید",
    eachReceiptOneFactor: "هر رسید یک فاکتور",
    eachDraftOneFactor: "هر حواله یک فاکتور",
    eachDateOneFactor: "هر تاریخ یک فاکتور",
    addToFactor: "اضافه به فاکتور",
    addToReceiptDateFactor: "اضافه به فاکتور موجود در تاریخ رسید",
    addToDraftDateFactor: "اضافه به فاکتور موجود در تاریخ حواله",
    selectedReceiptsCount: "تعداد رسیدهای انتخاب‌شده",
    selectedDraftsCount: "تعداد حواله‌های انتخاب‌شده",
  },

  prepositions: {
    and: "و",
    or: "یا",
    for: "برای",
    from: "از",
  },
  // مدیریت منوها (پنل پارسینا)
  menuManager: {
    intro:
      "عنوان، آیکون، آدرس، ترتیب و دسترسی منوها را تنظیم کنید؛ تغییرات بعد از ذخیره در پرتال دیده می‌شود.",
    subSystem: "زیرسیستم",
    reload: "به‌روزرسانی",
    search: "جستجو در عنوان، آدرس یا دسترسی",
    expandAll: "باز کردن همه",
    collapseAll: "بستن همه",
    expand: "باز کردن",
    collapse: "بستن",
    groups: "گروه",
    items: "منو",
    childCount: "{count} زیرمنو",
    loadFailed: "دریافت منوها ناموفق بود",
    editorLoadFailed: "دریافت اطلاعات منو ناموفق بود",
    retry: "تلاش دوباره",
    empty: "برای این زیرسیستم منویی ثبت نشده است",
    noResult: "منویی با این عبارت پیدا نشد",
    noUrl: "بدون آدرس",
    noUrlHint: "منوی بدون آدرس در پرتال نمایش داده نمی‌شود",
    permissionFromChildren: "از زیرمنوها",
    permissionNotSet: "تعیین نشده",
    moveUp: "انتقال به بالا",
    moveDown: "انتقال به پایین",
    reorderHint:
      "با فلش‌های کنار هر ردیف ترتیب را عوض کنید؛ بلافاصله ذخیره می‌شود",
    reorderDisabledSearch: "برای جابه‌جایی منوها جستجو را پاک کنید",
    reorderSaved: "ترتیب منوها ذخیره شد",
    startPage: "صفحه‌ی شروع",
    startPageHint:
      "پرتال بعد از ورود، کاربر را به اولین منویی که به آن دسترسی دارد می‌برد",
    unsaved: "ذخیره نشده",
    selectTitle: "یک منو را انتخاب کنید",
    selectHint: "برای ویرایش، روی یکی از منوهای فهرست کلیک کنید.",
    group: "گروه",
    item: "منو",
    sectionAppearance: "نمایش",
    sectionBehavior: "آدرس و دسترسی",
    title: "عنوان",
    titleRequired: "عنوان را وارد کنید",
    maxLength: "حداکثر ۱۰۰ کاراکتر",
    icon: "آیکون",
    iconPlaceholder: "dashboard",
    iconHint: "نام آیکون Material یا PrimeIcons (مثل pi-home)",
    iconUnknown:
      "این آیکون در پرتال شناخته نمی‌شود و به جایش دایره نمایش داده می‌شود",
    iconNestedHint:
      "در منوی پرتال آیکون فقط برای منوهای سطح اول نمایش داده می‌شود",
    pickIcon: "انتخاب",
    iconSearch: "جستجوی آیکون (فارسی یا انگلیسی)",
    suggestedIcons: "آیکون‌های پیشنهادی",
    searchResults: "نتایج",
    moreResults: "{count} آیکون دیگر هم هست؛ عبارت دقیق‌تری جستجو کنید",
    noIcon: "آیکونی پیدا نشد",
    clearIcon: "بدون آیکون",
    url: "آدرس",
    urlPlaceholder: "/club/dashboard",
    urlHint: "مسیر صفحه در پرتال",
    urlSlash: "آدرس باید با / شروع شود",
    groupUrl: "منوی گروه آدرس ندارد؛ با کلیک روی آن زیرمنوهایش باز می‌شود.",
    permission: "دسترسی",
    permissionPlaceholder: "تعیین نشده",
    permissionGroupHint:
      "منوی گروه معمولاً دسترسی ندارد و با دسترسی زیرمنوهایش نمایش داده می‌شود",
    permissionReadonly:
      "دسترسی منوهای این زیرسیستم از این صفحه قابل تغییر نیست",
    preview: "پیش‌نمایش در منوی پرتال",
    previewHint: "هر کاربر فقط منوهایی را می‌بیند که به آن‌ها دسترسی دارد.",
    hiddenInPortal: "نمایش داده نمی‌شود",
    save: "ذخیره تغییرات",
    saved: "تغییرات منو ذخیره شد",
    discard: "بازگردانی",
    unsavedTitle: "تغییرات ذخیره نشده",
    unsavedText: "تغییرات منوی «{title}» هنوز ذخیره نشده است.",
    saveAndContinue: "ذخیره و ادامه",
    dropChanges: "دور ریختن تغییرات",
    stay: "ماندن",
  },
  // نمادهای بازار (پنل پارسینا) - درخت ویجت قیمت tgju
  marketItemManager: {
    intro:
      "درخت نمادهای بازار برای ویجت قیمت میتا؛ همه‌ی شرکت‌ها همین درخت را می‌بینند. کاربر میتا فقط نمادها را انتخاب می‌کند و پوشه‌ها برای دسته‌بندی‌اند.",
    reload: "به‌روزرسانی",
    addRoot: "افزودن",
    addFolder: "پوشه جدید",
    rootTitle: "نمادهای بازار",
    addChild: "افزودن زیرمجموعه",
    edit: "ویرایش",
    search: "جستجو در عنوان یا کد ویجت",
    expandAll: "باز کردن همه",
    collapseAll: "بستن همه",
    expand: "باز کردن",
    collapse: "بستن",
    folders: "پوشه",
    leaves: "نماد",
    childCount: "{count} زیرمجموعه",
    emptyFolder: "پوشه خالی",
    hiddenInMita: "بدون نماد؛ در میتا دیده نمی‌شود",
    loadFailed: "دریافت نمادهای بازار ناموفق بود",
    editorLoadFailed: "دریافت اطلاعات نود ناموفق بود",
    retry: "تلاش دوباره",
    empty: "هنوز نمادی تعریف نشده است",
    emptyHint:
      "از فرم کنار اولین پوشه یا نماد را ثبت کنید؛ مثلاً پوشه‌ی «بازار طلا».",
    noResult: "نودی با این عبارت پیدا نشد",
    moveUp: "انتقال به بالا",
    moveDown: "انتقال به پایین",
    reorderHint:
      "با فلش‌های کنار هر ردیف ترتیب را عوض کنید؛ بلافاصله ذخیره می‌شود",
    reorderDisabledSearch: "برای جابه‌جایی جستجو را پاک کنید",
    reorderSaved: "ترتیب ذخیره شد",
    unsaved: "ذخیره نشده",
    selectTitle: "یک نود را انتخاب کنید",
    selectHint:
      "برای ویرایش روی یکی از نودهای درخت کلیک کنید، یا یک نود تازه بسازید.",
    newTitle: "نود جدید",
    newIn: "در «{title}»",
    newInRoot: "در ریشه",
    folder: "پوشه",
    leaf: "نماد",
    kind: "نوع",
    kindFolderHint: "فقط برای دسته‌بندی است و قابل انتخاب نیست.",
    kindLeafHint:
      "کاربر میتا آن را انتخاب می‌کند و ویجت قیمتش نمایش داده می‌شود؛ زیرمجموعه نمی‌گیرد.",
    kindLocked: "این پوشه زیرمجموعه دارد و نمی‌تواند نماد شود.",
    sectionInfo: "مشخصات",
    sectionPlace: "جایگاه در درخت",
    title: "عنوان",
    titleRequired: "عنوان را وارد کنید",
    titleMax: "حداکثر ۲۰۰ کاراکتر",
    titleDuplicate: "نود دیگری با همین عنوان در این سطح هست",
    code: "کد ویجت",
    codeRequired: "کد ویجت نماد را وارد کنید",
    codeInvalid: "کد ویجت باید عدد صحیح بزرگ‌تر از صفر باشد",
    codeDuplicate: "این کد قبلاً برای «{title}» ثبت شده است",
    codeHint:
      "از فیلد item_id سرویس tgju؛ نه id. با دکمه «جستجو در tgju» مطمئن‌تر است.",
    findCode: "جستجو در tgju",
    parent: "والد",
    parentRoot: "ریشه (بدون والد)",
    parentHint: "فقط پوشه‌ها می‌توانند والد باشند.",
    priority: "اولویت نمایش",
    priorityHint:
      "عدد کمتر بالاتر نمایش داده می‌شود؛ هم‌اولویت‌ها بر اساس عنوان مرتب می‌شوند.",
    priorityInvalid: "اولویت باید عدد صحیح باشد",
    isDefault: "نماد پیش‌فرض",
    isDefaultHint:
      "برای کاربرانی که خودشان نمادی انتخاب نکرده‌اند در داشبورد نمایش داده می‌شود.",
    defaultBadge: "پیش‌فرض",
    audit: "ثبت: {created} · {creator}",
    auditUpdate: "آخرین ویرایش: {date} · {user}",
    save: "ذخیره",
    create: "ثبت",
    saved: "تغییرات ذخیره شد",
    created: "نود جدید ثبت شد",
    discard: "بازگردانی",
    cancel: "انصراف",
    delete: "حذف",
    deleteLocked:
      "نودی که زیرمجموعه دارد حذف نمی‌شود؛ اول زیرمجموعه‌ها را حذف کنید.",
    deleteTitle: "حذف نود",
    deleteText: "«{title}» حذف شود؟ این کار برگشت‌پذیر نیست.",
    deleted: "نود حذف شد",
    unsavedTitle: "تغییرات ذخیره نشده",
    unsavedText: "تغییرات «{title}» هنوز ذخیره نشده است.",
    saveAndContinue: "ذخیره و ادامه",
    dropChanges: "عدم ذخیره‌سازی",
    stay: "انصراف",
    modeNew: "جدید",
    modeEdit: "ویرایش",
    editLeafNote:
      "این نماد قبلاً ثبت شده؛ انتخاب نماد دیگر از tgju کد و عنوان همین نود را عوض می‌کند و نود جدیدی نمی‌سازد.",
    addLeafIn: "افزودن نماد جدید در «{title}»",
    addLeafInRoot: "افزودن نماد جدید در ریشه",
    finderTitle: "انتخاب نماد از tgju",
    finderRoot: "tgju",
    finderSearch: "جستجو در همین دسته",
    finderFailed: "دریافت فهرست tgju ناموفق بود",
    finderEmpty: "موردی در این سطح نیست",
    finderSelectRoot: "یکی از دسته‌ها را انتخاب کنید",
    finderUsed: "ثبت‌شده: {title}",
    finderPick: "انتخاب",
    finderHint:
      "پوشه‌ها را باز کنید تا به نماد برسید؛ کد ویجت از item_id نماد برداشته می‌شود.",
    close: "بستن",
  },
  bankExport: {
    templateList: "قالب‌های فایل بانک",
    // صدور فایل بانک
    bankExportTemplateList: "قالب‌های فایل بانک",
    fileSpecification: "مشخصات فایل",
    recordDesigner: "طراحی رکوردها",
    fieldMapping: "نگاشت فیلدها",
    validationRules: "قواعد اعتبارسنجی",
    transformRules: "قواعد تبدیل",
    variableBrowser: "مرورگر متغیرها",
    expressionEditor: "ویرایشگر عبارت",
    previewPanel: "پیش‌نمایش فایل",
    exportDetail: "جزئیات صدور",
    bankExportDesigner: "طراح قالب فایل بانک",
    fileSettings: "تنظیمات فایل",
    fileNamePattern: "الگوی نام فایل",
    fileStructure: "ساختار فایل",
    firstRow: "سطر اول",
    employeeRows: "سطرهای پرسنل",
    lastRow: "سطر آخر",
    firstRowHint: "یک بار در ابتدای فایل نوشته می‌شود",
    employeeRowsHint: "به ازای هر پرسنل تکرار می‌شود",
    lastRowHint: "یک بار در انتهای فایل نوشته می‌شود",
    optional: "اختیاری",
    noFields: "هنوز فیلدی تعریف نشده است",
    noFieldsHint: "با «افزودن فیلد» اولین ستون خروجی را بسازید",
    fieldSettings: "تنظیمات فیلد",
    dragToReorder: "برای جابه‌جایی بکشید",
    sourceVariable: "متغیر",
    sourceConstant: "مقدار ثابت",
    sourceExpression: "عبارت",
    formatSection: "قالب و چیدمان",
    behaviorSection: "رفتار مقدار",
    livePreview: "پیش‌نمایش زنده",
    livePreviewHint:
      "با داده نمونه ساخته می‌شود؛ خروجی نهایی در صفحه صدور فایل",
    previewLineLength: "طول سطر",
    previewEmpty: "برای دیدن پیش‌نمایش، فیلدها را تعریف کنید",
    noIssues: "ایرادی یافت نشد",
    issueCount: "ایراد",
    freeText: "متن ثابت",
    tokenYear: "سال",
    tokenMonth: "ماه",
    tokenMonth2: "ماه دو رقمی",
    tokenDate: "تاریخ (میلادی فشرده)",
    tokenTime: "ساعت",
    tokenCompany: "نام شرکت",
    tokenBankKey: "کلید بانک",
    tokenPayrollCode: "کد لیست حقوق",
    tokenDatePattern: "تاریخ شمسی",
    unknownToken: "توکن ناشناخته",
    templateIdentity: "شناسه قالب",
    unsavedNote: "تغییرات تا زمان ذخیره اعمال نمی‌شوند",
    wholeFile: "کل فایل",
    expressionFunctions: "توابع",
    fileNamePreview: "پیش‌نمایش نام فایل",
    limitation: "محدودیت",
    totalLineCount: "تعداد کل سطرها",
    issues: "مشکلات",
    excelIgnoredSettings:
      "در خروجی اکسل، جداکننده، انکدینگ و پایان سطر کاربردی ندارند و نادیده گرفته می‌شوند",
    fixedLengthNoDelimiter:
      "در فایل طول ثابت، جداکننده قابل انتخاب نیست و روی «بدون جداکننده» قفل است",
    overlapError: "هم‌پوشانی موقعیت فیلدها",
    gapInfo: "شکاف (با فاصله پر می‌شود)",
    rulerTitle: "خط‌کش موقعیت",
    noOverlap: "بدون هم‌پوشانی",
    deleteHasHistory:
      "این قالب سابقه صدور دارد و قابل حذف نیست؛ می‌توانید آن را غیرفعال کنید",
    saveReloadNote:
      "ذخیره، جایگزینی کامل ساختار است؛ پس از ذخیره شناسه فیلدها تغییر می‌کند",
    ibanNotAvailable:
      "شماره شبا فعلاً از سرویس پرسنل منتشر نشده و تهی برمی‌گردد؛ از شماره حساب یا شماره کارت استفاده کنید",
    onlyConfirmedPayroll: "فقط لیست حقوق تاییدشده قابل صدور است",
    previewHasError: "پیش‌نمایش دارای خطاست؛ صدور فایل ممکن نیست",
    needPreviewFirst: "ابتدا پیش‌نمایش بگیرید",
    fileNameTokensHelp:
      "توکن‌های مجاز: {Year} {Month} {Month:00} {Company} {BankKey} {PayrollCode} {Date} {Time} و الگوهای تاریخ شمسی مانند {yyyyMMdd}. توکن ناشناخته دست‌نخورده باقی می‌ماند.",
    expressionHelp:
      "رشته‌ها با کوتیشن دوتایی، عملگر تساوی «=» و همه آرگومان‌های عددی اعشاری هستند. در عبارت از «نام در عبارت» متغیر استفاده کنید نه کلید آن.",
    columnNumbers: "شماره ستون",
    copied: "کپی شد",

    // نگاشت مدیران
    wares: "انبارها",
    voucherTypes: "انواع سند",
    directionReceipt: "رسید",
    directionDraft: "حواله",
    modiranSideLoading: "در حال خواندن از سیستم مدیران ...",
    modiranSideNotFound: "(دیگر در مدیران موجود نیست)",
    alreadyMapped: "قبلاً نگاشت شده",
    noMapping:
      "هنوز نگاشتی ثبت نشده است. برای اینکه اسناد انبار در سیستم مدیران هم ثبت شوند، ابتدا انبارها و انواع سند را نگاشت کنید.",
    kindNotEditable: "نوع نگاشت پس از ثبت قابل تغییر نیست",
    mitaSideNotEditable:
      "سمت میتا قابل ویرایش نیست؛ برای تغییر آن، نگاشت را حذف و دوباره ثبت کنید",
    deleteMappingConfirm: "آیا از حذف نگاشت‌های انتخاب‌شده مطمئن هستید ؟",
    on: "روشن",
    off: "خاموش",
  },
  // سیاست‌های قیمت‌گذاری فروش
  pricePolicy: {
    newPolicy: "سیاست جدید",
    all: "همه",
    active: "فعال",
    upcoming: "شروع نشده",
    expired: "منقضی",
    status: "وضعیت",
    groupChange: "تغییر گروهی قیمت",
    stepPolicy: "سیاست قیمت‌گذاری",
    targetPolicy: "سیاست مورد تغییر",
    choosePolicyFirst: "ابتدا سیاست قیمت‌گذاری را انتخاب کنید",
    stepMethod: "روش تغییر قیمت",
    stepValue: "مقدار تغییر",
    stepCommodities: "انتخاب کالاها",
    method1Title: "درصد روی قیمت یک سیاست دیگر",
    method1Hint:
      "قیمت کالا از سیاستی که انتخاب می‌کنید خوانده می‌شود و درصد واردشده به آن اضافه می‌شود.",
    method2Title: "مبلغ ثابت روی قیمت یک سیاست دیگر",
    method2Hint:
      "قیمت کالا از سیاستی که انتخاب می‌کنید خوانده می‌شود و مبلغ واردشده به آن اضافه می‌شود.",
    method3Title: "درصد روی قیمت فعلی",
    method3Hint:
      "درصد واردشده به قیمت فعلی کالاهای انتخابی در همین سیاست اضافه می‌شود.",
    method4Title: "مبلغ ثابت روی قیمت فعلی",
    method4Hint:
      "مبلغ واردشده به قیمت فعلی کالاهای انتخابی در همین سیاست اضافه می‌شود.",
    basePolicy: "دریافت قیمت از سیاست",
    chooseMethodFirst: "ابتدا روش تغییر قیمت را انتخاب کنید",
    selected: "انتخاب‌شده",
    noCommoditySelected: "هیچ کالایی انتخاب نشده است",
    applyChange: "اعمال تغییر",
    currentPrice: "قیمت فعلی",
    priceIn: "قیمت در",
    pricesSection: "قیمت کالاها",
    pricesHint:
      "کالا را انتخاب و قیمت را وارد کنید، سپس با زدن Enter کالا در جدول درج می‌شود.",
    saveFirst:
      "ابتدا مشخصات سیاست را ذخیره کنید؛ پس از ذخیره، بخش قیمت کالاها فعال می‌شود.",
    editingCommodity: "در حال ویرایش قیمت کالا",
    commodity: "کالا",
    noPrices: "هنوز قیمتی برای کالاها ثبت نشده است",
    extraParams: "پارامترهای تکمیلی کالا",
    unlimited: "بدون محدودیت",
    scopeAll: "همه کالاها",
    scopeInPolicy: "دارای قیمت در این سیاست",
    scopeNotInPolicy: "بدون قیمت در این سیاست",
    priceInThisPolicy: "قیمت در این سیاست",
    newPrice: "قیمت جدید (پیش‌نمایش)",
    selectAll: "انتخاب همه",
    commodityGroupCode: "کد گروه کالا",
    clearSelection: "لغو همه انتخاب‌ها",
    groupPageHint:
      "روش و مقدار تغییر را مشخص کنید، کالاها را از جدول انتخاب کنید و «اعمال تغییر» را بزنید.",
  },
  validation: {
    discountPercentageRange: "درصد باید بین ۰ تا ۱۰۰ باشد",
    moreThanCreditBalance: "مبلغ از مانده اعتبار بیشتر است",
    required: "الزامی",
    maxLength200: "حداکثر ۲۰۰ کاراکتر مجاز است",
    maxLength500: "حداکثر ۵۰۰ کاراکتر مجاز است",
    maxLength1500: "حداکثر ۱۵۰۰ کاراکتر مجاز است",
    email: "ایمیل را بصورت صحیح وارد کنید",
    webSite: "به شکل صحیح وارد کنید",
    length: "تعداد مجاز 4 رقم می‌باشد",
    economicCodeLength: "تعداد مجاز 14 رقم می‌باشد",
    zipCodeLength: "تعداد مجاز 10 رقم می‌باشد",
    confirmPasswordError: "رمز عبور و تکرار یکسان نمی‌باشند",
    invalidDuration: "دقیقه باید بین ۰۰ تا ۵۹ باشد",
    technicalNameRequired: "نام فنی لازم است",
    variableRequired: "متغیر انتخاب نشده است",
    expressionRequired: "عبارت خالی است",
    lengthRequired: "طول فیلد لازم است",
    atLeastOneDetail: "حداقل یک رکورد «سطر پرسنل» لازم است",
    onlyOneHeader: "حداکثر یک رکورد هدر مجاز است",
    onlyOneTrailer: "حداکثر یک رکورد تریلر مجاز است",
    deleteMappingConfirm: "آیا از حذف نگاشت‌های انتخاب‌شده مطمئن هستید ؟",
    on: "روشن",
    off: "خاموش",
    requiredDirection: "جهت سند (رسید/حواله) مشخص نیست.",
    directionMismatch:
      "نوع سند رسید را نمی‌توانید به حواله‌ی مدیران نگاشت کنید.",
    descriptionMaxLength: "توضیحات حداکثر ۵۰۰ کاراکتر است.",
    economicCodeTaxLength: "کد اقتصادی باید بین ۱۰ تا ۲۰ رقم باشد",
    exactLength6: "دقیقا ۶ کاراکتر مجاز است",
    maxLength50: "حداکثر ۵۰ کاراکتر مجاز است",
    nationalIdLength: "شناسه ملی باید ۱۰ یا ۱۱ رقم باشد",
    onlyDigits: "فقط عدد مجاز است",
    taxKeyRequired: "متن یا فایل کلید الزامی است",
    englishNameOnly:
      "فقط حروف انگلیسی، عدد، فاصله و کاراکترهای . , & ( ) - مجاز است",
    englishLettersOnly: "فقط حروف انگلیسی مجاز است",
  },
};

export default labeltems;
